angular.module('ui2.0Controllers').controller('showPageController', ['$scope', '$uibModal', 'entityFactory', '$rootScope', '$location', '$templateCache', '$compile', '$timeout', '$http', '$window', '$anchorScroll', 'urlFactory', '$routeParams', '$sce', 'formService', 'dataManipulationService','filterService', 'searchableFieldService', 'clauseSelectionService', 'fileService', 'documentVersioningService', 'docuSignService', 'showPage2DataTransformationService', 'showPageService','$document','$route','$filter','delegationService', 'showPageBulkActionService','docTreeService','listService','showPageTileService','$q','showPageBtnClickService','aeService','$ocLazyLoad','communicationService','contractLineItemService','cliCommonService','externalContactService',function($scope, $modal, entityFactory, $rootScope, $location, $templateCache, $compile, $timeout, $http, $window, $anchorScroll, urlFactory, $routeParams, $sce, formService, dataManipulationService,filterService, searchableFieldService, clauseSelectionService, fileService, documentVersioningService, docuSignService, showPage2DataTransformationService, showPageService,$document,$route,$filter,delegationService,showPageBulkActionService,docTreeService,listService,showPageTileService,$q,$showPageBtnClickService, aeService,$ocLazyLoad,communicationService,contractLineItemService,cliCommonService,externalContactService,myTableDirective) {
    $scope.$on('$destroy', function() {
        loadMDSearchFieldsEvt();
        updateExpandAllEvt();
        updateTagsDefnCountEvt();
        updateTagsCountEvt();
        updateDefnCountEvt();
        updateSelectedDocEvt();
        loadWorkSpaceShowPage();
        clearCloseDatePicker();
        clearcalculateCreditEarnBack();
        updateWFstepValidation();
        changeShowpageGraph();
        cleartermObjDates();
        getSelectedCheckboxes();
        openLinkLanguageModal();
        openSendForSig();
        openESignAccountSelector();
        $document.off('keydown', keyDownHandler);
        delete $rootScope.invoiceBtns;
        delete $rootScope.isInvoiceViewerActive;
        delete window.docViewerParams;
        window.pdfJsPermissionFlags = {};
        delete $rootScope.contractDocTabDataUrl;
        clearInterval($rootScope.polling);
        mountPlaybook();
        mountProjectComponent();
        fixCommentSectionAndInitialize();
        delete $rootScope.hideCommentToggle;
        delete $rootScope.aeContractCreationLinks;
        delete $rootScope.hideProjectDetails;
        delete $rootScope.showProjectConfig;
        delete $rootScope.showBaseClauseTexts;
        delete $rootScope.firstPolling;
        delete $rootScope.prevPollingData;
        delete $rootScope.continuePolling;
        delete $rootScope.isAEProjectShowPage;
        delete $scope.createFieldsObjTemplate;
        delete $rootScope.docTreeScpCompiled;
        if($rootScope.suggestRefreshScope) {
            const prevEntityId = _.get($rootScope.suggestRefreshScope,"prevPollingData.prevCData.id.values");
            const entityIdNotSame = window.location.href.includes('/tblcdr/') && prevEntityId != SirionUtils.getEntityIdFromUrl();
            const allowDelete = prevEntityId != _.get($scope.data,"id.values") || entityIdNotSame;

            if(allowDelete) {
                delete $rootScope.suggestRefreshScope.firstPolling;
                delete $rootScope.suggestRefreshScope.prevPollingData;
                if(entityIdNotSame) {
                    delete $rootScope.suggestRefreshScope;
                }
            }
        }
        delete $rootScope.continuePolling;
        window.sarc.channelUnsubscription('showPageChannel','showPageChannelSubscription');
        showPageService.retObj.docTreeFilterRendered = false;
        filterDataJson = {};
    });
    var getData;
    $scope.miraScope = {
        allowedEntityPagesForMira: ['/show/tblcontracts/'],
        selectedDocInMiraView:null,
        activeSessions: {}
    }
    $scope.validMiraViewRoute = () => !!$scope.miraScope.allowedEntityPagesForMira.find(route => window.location.href.includes(route));
    if(!sessionStorage.getItem('raiserequestWFListUrl')){
        sessionStorage.removeItem('previousFormData');
    }
    $rootScope.continuePolling = _.has($rootScope,'continuePolling') ? $rootScope.continuePolling : true;
    $rootScope.firstPolling = _.has($rootScope,'firstPolling')  ? $rootScope.firstPolling : true;
    $rootScope.prevPollingData = _.has($rootScope,'prevPollingData') ? $rootScope.prevPollingData : {};
    $rootScope.polling = _.has($scope,'polling') ? $rootScope.polling : null;
    $scope.noOfFilesUploaded = 0;
    $rootScope.currentEntityId = window.urlToCodeMapper[$routeParams.entityName];
    $scope.bulkLlistDownloadDD = false;
    $scope.isCloneCLIFrom = false;
    $scope.toggleBulkListDownloadDD = function(flag,val){
        $scope.bulkLlistDownloadDD = val;
    };
    $scope.init = function() {
        showPageService.renderPageInbound($scope);
    };
    $scope.highlightComment = window.location.href.indexOf('commentId') > -1;
    $scope.doNotOpenDocTreeByDefault = (window.location.href.indexOf('tblcontracts') == -1 && window.location.href.indexOf('tblrelations') == -1 && window.location.href.indexOf('tblsurvey') == -1) || $scope.highlightComment;
    $scope.tilesCount = {"obligation":0,"serviceLevels":0,"interpretations":0,"changeRequests":0,"workOrderRequests":0,"documentHistory":0};
    $scope.showPageTileService = showPageTileService;
    $scope.excludeTimelineFeedFor = ['clone','create','edit','update'];
    $scope.timeline={};
    $scope.timeline.showContent=false;
    $scope.rawDataCommentBox = false;
    $scope.showCommentBox=false;
    $scope.radioButtonValue = 'bulk';
    $scope.analyticsStatsData = [];
    $scope.errorBtnClick = false;
    $scope.timelineInitialLoad = true;
    $scope.showEsignIcon = false;
    $rootScope.invoiceCopyActionBtns = [];
    $rootScope.lazyLoadForLocalListing = false;
    $scope.createFieldsObjTemplate = {};
    $scope.wopiEnabledEntity = {};
    var pageTypeArr ={'1':'create','2':'show','3':'edit','4':'clone','10':'bulkEdit','7':'mdSearchPage','11':'bulkAction','14':'bulkAction','34':'bulkAction'};
    entityNameStirng = $routeParams.entityName;
    isCreate = false;
    formService.buttonMapper = {};
    $scope.showIntermediateIcon = false;
    angular.element("li[tab] a:visible").closest("#mainContainer").addClass("fixedButtons");
    var prevRoute = $scope.previousRoute;
    let provisioningId = null; //used in case of bulk create update
    $scope.sce = $sce;
    $scope.jsonApi = "";
    $scope.showInWorkspace=false;
    $scope.showInWorkSpaceData={};
    $scope.tabIndex = sJq.$.urlParam("sourceId");
    $scope.hasWorkflowId = '';
    $scope.clauseTagSection = false;
    $rootScope.highlightPermission = {};
    $rootScope.otherListName = null;
    $rootScope.bulkedit = false;
    $rootScope.contractLineItemLoaded = false;
    $rootScope.selectedClausesCount = 0;
    $rootScope.definitionsCount = 0;
    $rootScope.clauseSelectionService = clauseSelectionService;
    $rootScope.selectedTemplatesCount = 0;
    $rootScope.selectTemplatesNotification = false;
    $scope.showTagTabOnClause = false;
    $scope.showTagTabOnTemplate = false;
    $rootScope.backButtonToCSLActive = false;
    $rootScope.contractRateCardLoaded = false;
    $scope.hasBorderBox=function(tabs){
        return tabs.fields.filter(function(o){ if(o.type=='borderedBox'){return true;}}).length;
    }
    $scope.basePageIndex = 0;
    var breadCrumbHistory;
    var stateToggle = true;
    window.htmlEditorList = [];
    window.globalUploadButtonActive="";
    $scope.showFreeFormContract = false;
    $scope.showSourceNameTitle = true;
    $scope.showLinkModal = false;
    $scope.bulkEntityId = [];
    //Variable to hold permissions of the show page controllers.
    $rootScope.showPagePermissionObj = {};
    $rootScope.showPagePermissionObj.showPageBulkAction = false;
    $rootScope.showPageBulkActionData = {};
    $scope.showRawDataPopup={};
    $rootScope.docTree=[];
    $rootScope.bulkNovation=false;
    $scope.bulkNovationData=[];
    $scope.showlineItemPopup={};
    $scope.showRawDataPopup.visible=false;
    $scope.showlineItemPopup.visible=false;
    $scope.showlineItemCommentBox=false;
    $scope.newShowPage = true;
    $scope.feedbackNeeded = false;
    $scope.showAdditionalTabsList = false;
    $scope.forceHideRightPanel = true;
    $rootScope.newShowPage = true;
    $scope.FilePropHdrMsg = $rootScope.intl_msg[26659];
    $scope.trustedFilePropHdrMsg = $sce.trustAsHtml($scope.FilePropHdrMsg);
    $scope.localListingSwitch = false;
    $scope.showPageInvoiceView = false;
    $scope.showPageService = showPageService;
    $scope.showPage2DataTransformationService = showPage2DataTransformationService;
    $scope.showPage2DataTransformationService.doNotOpenDocTreeByDefault = $scope.doNotOpenDocTreeByDefault;
    $scope.docTreeService = docTreeService;
    $scope.delegationService = delegationService;
    $scope.docTreeService.showDoctreeTemplate = false;
    $scope.docTreeService.contractToCdr = false;
    $scope.docTreeService.showImportFromCdr = false;
    $scope.currentRowId = 0;
    $scope.meshColValue = 1;
    $scope.effStartdate = null;
    $scope.effEnddate = null;
    $scope.initLoadComments = true;
    $scope.selectedLineItems = [];
    $scope.selectedCheckBoxes = [];
    $scope.errorSolvedLength = 0;
    $rootScope.invoiceBtns = [];
    $scope.isInvoicePage = false;
    $scope.classificationOpen = false;
    $scope.docTagsOpen = false;
    $scope.commentDataScope;
    $scope.tagsDataScope;
    $scope.showFileFilter = false;
    $scope.showToolsBox = false;
    $scope.contractClauseTab = {
        isVisible: false
    }
    $scope.showVersionHistoryIcon = false;
    $scope.showTagsIcon = false;
    $scope.isShowPage = window.location.href.indexOf('show') > -1;
    $scope.isEditPage = window.location.href.indexOf('update') > -1;
    $scope.downloadTreeFolder = window.downloadTreeFolder;
    $scope.feedsResponse = null;
    $scope.rightPanelAvailable = true;
    $scope.reactDocTreePermission = {enabled: true};
    $scope.showEditButton = {enabled: true};
    $scope.highlightedTabsMap = {};
    $rootScope.updatedFieldsArray = [];
    $scope.showVersionLabel = false;
    $scope.isPdfViewerLoaded = false;
    $rootScope.documents = [];
    $scope.contractDocumentTabUpload = false;
    $scope.commSkeltonAttachment = false;
    $scope.fromTagsOutlineComp = false;
    $scope.previewTab = {
        isActive : false,
        hasContractDocument: false
    }
    $scope.emailTokenValidation = window.emailTokenValidation;
    $scope.isClauseShowPage = window.location.href.indexOf('show/tblclause') > -1;
    $scope.showPagePreviewView = false;
    $scope.showPagePreviewViewSubDoc = false;
    $scope.isSupplierShowPage = window.location.href.indexOf('show/tblrelations') > -1;
    $scope.originalCreditSelected = [];
    $scope.playbook = {};
    $scope.project = {};
    $scope.eSignStatusIds = {
        showPageAPI : [1,2,7,4,3],
        eSignAPI: [25,8,23,16,6],
    };
    $scope.uploadingDocumentData = {};
    $scope.parentId = null;
    $rootScope.parentFldIds = [];
    $scope.showPlaybookBreadCrumb = false;
    $scope.launchViewEnabled = false;
    if($location.search()['mergeDir']){
        $scope.mergeDir = ($location.search()['mergeDir'])
        let mergeDirectoryData = sessionStorage.getItem('mergeDirectoryData') && JSON.parse(sessionStorage.getItem('mergeDirectoryData') )
        $scope.mergeDirName = _.get(mergeDirectoryData,'mergeDirName');
    } else {
        if(sessionStorage.getItem('mergeDirectoryData')){
           sessionStorage.removeItem('mergeDirectoryData')
        }
    }

    const sc = $("#filterDiv").scope();
    $scope.vendorNonMandatory = sc && sc.vendorNonMandatory;

    $scope.isNewUX = true;
    $scope.docTreeService.showPlaybook = false;
    $rootScope.hideProjectDetails = false;
    $rootScope.showProjectConfig = false;
    $rootScope.showBaseClauseTexts = false;
    $scope.showSupplierDD = false;
    $scope.showStatusInfoProgressBar=false;
    window._lastToastStatus = '';
    $scope.isStakeHolderInlineEdit = false;
    $scope.hideCrossModalButton = false;
    $scope.initialBulkDownloadFileType = $scope.tempFileType = JSON.parse(localStorage.getItem("sideLayoutData"))?.data.bulkActivitiesTemplateFileType?.toLowerCase() || "excel";
    $scope.bulkDownloadFileType = $scope.tempFileType == "both" ? $scope.tempFileType.replace('both', 'excel') : $scope.tempFileType;
    
    setTimeout(()=>{
        $scope.isCreateRoute = !!['/create/','/clone/'].find(str => window.location.href.indexOf(str) > -1);
        $scope.isNewCrudPage = !!['/update/','/create/','/clone/'].find(str => window.location.href.indexOf(str) > -1);
        $scope.hasTimeLineFeed = !$scope.isNewCrudPage;
    },0)
    // `isCommonRouteCrudPage` array will contain routes that contain other crud page route as a substring.
    $scope.isCommonRouteCrudPage = !!['create/tblcontracttemplatestructure','clone/contracttemplatestructure'].find(str => window.location.href.indexOf(str) > -1);
    $scope.isCloneTemplate = (window.location.href.indexOf('clone/contracttemplate') > -1) && !$scope.isCommonRouteCrudPage;
    $scope.exceptionalInNewUx = {
        crudPage:  !!['create/tblcontracttemplate','create/tblclause','clone/contracttemplate','clone/clause','update/tblcontracttemplate','update/tblclause'].find(str => window.location.href.indexOf(str) > -1) && !$scope.isCommonRouteCrudPage,
        apiSubStrings: ['addRequest'],
        popupToBasic: ['clone/','addRequest'],
        isSpecialDataAPI: function(api) {
            if(this.apiSubStrings.find(substr => api && api.includes(substr)))
                return api;
            return false;
        },
        specialViewerPages: !!['tblcontractdocuments'].find(str => window.location.href.indexOf(str) > -1)
    }
    window.isPopupOpen && (window.isOnShowpageViaPopup = true);
    if(_.get($scope,"showInvoiceUploadDialog.visible")) {
        $scope.showPageModalOpen = true;
    }
    $scope.isShowPage && SirionUtils.clearSessionStorage();
    $scope.isInvoicePage = !!['/tblinvoicelineitem'].find(str => window.location.href.indexOf(str) > -1);
    if(window.location.href.indexOf('listRender/10') > -1 || window.location.href.indexOf('tblbaseinvoice') > -1){
        $scope.isInvoicePage = true;
        $rootScope.isInvoiceViewerActive = false;
    }
    $scope.excludeUrlHaving = ['tblcontracttemplatestructure'];
    if($scope.excludeUrlHaving.findIndex(y => window.location.href.indexOf(y) > -1) == -1) {
        if(window.location.href.indexOf('tblcontracttemplate') > -1) {
            $scope.isContractTempShowPage = true;
        }
        $scope.isValidCheck = ['tblclause','tblcontracttemplate'].findIndex(x => {
                return window.location.href.indexOf(x) > -1
            }) > -1;
    }
    if($scope.isValidCheck){
        $scope.omitRightPanelToggle = true;
    }
    $rootScope.returnCommaSeparatedValues = function (dataJson) {
        if (dataJson != null && typeof(dataJson) == "object") {
            var d = "";
            for (var i = 0; i < dataJson.length; i++) {
                d = d + dataJsonopenInvoiceUploadForm[i].name + ", ";
            }
            d = d.replace(/, $/m, ' ');
            return d;
        } else {
            return dataJson;
        }
    }
    var getSelectedCheckboxes = $scope.$on('getSelectedCheckboxes', function (e, selectedData) {
        $scope.selectedLineItems = selectedData;
        $scope.selectedCheckBoxes = selectedData;
        $scope.creditItemSelected();
    });

    var updateCreditCalculate = $scope.$on('updateCreditCalculate', function (e, selectedData) {
        if($scope.creditCalculation?.creditCalculateTable){
            $scope.selectedCheckBoxes = selectedData;
            $scope.creditItemSelected();
        }
    });

    var clearcalculateCreditEarnBack = $scope.$on("calculateCreditEarnBack",function(data){
        $scope.$broadcast("updateTabsData");
    });
    var clearCloseDatePicker = $scope.$on("closeDatePicker",function(data){
        $scope.datepicker.opened = {};
    });

    var cleartermObjDates = $scope.$on('updateTermDate',function(event,data,dtType){
        if(dtType == 'startDate'){
            $scope.effStartdate = moment(data, $scope.formatDate);
        }
        if(dtType == 'endDate'){
            $scope.effEnddate = moment(data, $scope.formatDate);
        }
    });

    const getUrlOpts = () => {
        let urlOpts = $location.path().split("/");
        if($location.path().indexOf("_t") > -1){
            urlOpts = $location.path().split("_t")[0];
        }
        return urlOpts;
    }

    var checkUploadDocAllowed = function(data) {
        // If stepper exists for cdrDocUpload
        $scope.showContractUploadStepper = false;

        // If stepper exists for cdrDocUpload- contractToCdr case
        $scope.showContractUploadStepperAmmendmentCase = false;
        if(_.get(data,"body.data.uploadAllowedOnCreate.values")) {
            !$scope.showAmendment && ($scope.showContractUploadStepper = true);
            $scope.showAmendment && ($scope.showContractUploadStepperAmmendmentCase = true);
        }
    }

    $scope.$on("commentsLoaded",function(event,commentsLength){
        if(commentsLength && $scope.pageType=="show")
            if(!$scope.hasCommentErrors) {
                !$scope.commentVisibilityMandatory && !$scope.doNotCloseCommentBox && ($scope.showCommentBox=false);
                setTimeout(() => {
                    delete $scope.commentVisibilityMandatory;
                },3000)
            }
    });

    $scope.goToPreviousRoute = function () {
        const previousURL = sessionStorage.getItem('previousURL');
        if(previousURL) {
            if($scope.isNewEntityCreate) {
                const hash = previousURL.indexOf('#') > -1? '' : '#';
                window.location.replace(hash + previousURL);
                setTimeout(() => {
                    if(previousURL.includes('/show') && window.location.href.includes('/show')) {
                        history.back();
                    }
                },100);
            }else $location.path(previousURL).search({});
        }
    }

    $scope.getCommunicationTitle = function() {
        return $scope.commentDataScope == 3 ? "Attachments" : $scope.showCommentPanelInRightSec ? intl_msg[32319] || 'Add Comment': (intl_msg[32318]);
    }

    $scope.toggleTimelineContent=function($event){
        $scope.timeline.showContent= (!$scope.timeline.showContent);
        if($scope.timeline.showContent){
            $($event.currentTarget).html("<span class='icon-Collapsed'></span>"+intl_msg[28054]);
        }
        else{
            $($event.currentTarget).html("<span class='icon-Expand'></span>"+intl_msg[28055]);
        }
    }

    $scope.filterAttachmentsList = function (fileType,LIST_TYPE) {
        $scope.commentListScope.appliedFilter = true;
        var intl_file_type = {
            'financial':4566,
            'legal':4567,
            'business case':4568
        }
        var classificationOpts = ['Financial', 'Legal', 'Business Case'];
        var CLASSIFICATION_STR = 'Classification';
        var DOC_TAG_STR = "docTag";
        fileType = !fileType ? '' : fileType;
        $scope.commentListScope.selectedFileType = fileType == '' ? 'All Files' : intl_msg[intl_file_type[fileType.toLowerCase()]];
        if ($scope.commentListScope.selectedFileType == 'All Files') {
            $scope.commentListScope.flatattachmentsList = $scope.commentListScope.filteredAttachmentsList;
        }
        else if (LIST_TYPE== CLASSIFICATION_STR  && classificationOpts.indexOf(fileType) > -1) {
            $scope.commentListScope.flatattachmentsList = $filter('filter')($scope.filteredAttachmentsList, {'classification': $scope.commentListScope.selectedFileType});
        }
        else if(LIST_TYPE == DOC_TAG_STR){
            $scope.commentListScope.flatattachmentsList = $filter('filter')($scope.filteredAttachmentsList, {'documentTags': $scope.commentListScope.selectedFileType});
        }
    };
    $scope.openTimelinePopup = function(){
        $scope.timelinePopup=$modal.open({
            templateUrl: $rootScope.createHtmlUrl("ui2.0/directiveTemplates/timelinePopupTemplate.html"),
            modal: true,
            size: "lg",
            keyboard: false,
            backdrop: "static",
            windowClass: "timelinePopup",
            scope:$scope
        });
        $timeout(function(){
            $(".timelinePopup .modal-body").on("scroll",function(e){
                if($(this).scrollTop() > 0)
                    $(this).find(".body-header").addClass("setBoxShadow");
                else
                    $(this).find(".body-header").removeClass("setBoxShadow");
            });
        },10);
    }

    $scope.toggleOBLists = function (tab) {
        tab.fields.forEach(function (field) {
            field.hiddenTable = !field.hiddenTable;
            if (field.hiddenTable == true) {
                $scope.otherListName = field.label;
            }
        })
    };
    $scope.openBulkEditForm = function () {
        $rootScope.searchableFields = true;
        $rootScope.fieldHierarchy = {
            "fields": []
        };
        $scope.jsonApi = "";
        $rootScope.fieldMapper = {};
        $rootScope.fieldMapper2 = {};
        $rootScope.bulkRequiredFldMapper = {};
        $rootScope.bulkedit = true;
        $scope.pageType = null;
        $scope.configOptionFromServer(true);
    };

    $scope.openGlobalCreate = function () {
        $scope.pageType = "globalCreate";
        $rootScope.pageType = $scope.pageType; // Sync to rootScope for drawer access
        $scope.createHeaderStageTwo = false;
        $scope.jsonApi = "";
        $scope.documentTypeId = 4;
        $scope.configOptionFromServer();
    };

    $scope.openDelegationPopup = function(){
        $scope.pageType = "delegationCreate";
        $scope.jsonApi = "";
        $scope.configOptionFromServer();
    }

    $scope.getExistingMetadata = function(id,typeId){
        $scope.pageType = "show";
        $rootScope.pageType = $scope.pageType; // Sync to rootScope for drawer access
        startLoader();
        if(typeId == 316 || typeId == 61){
            $scope.jsonApi = "/autoextraction/v1/show/" + id + '?version=2.0';
        }else{
            var urlOp = "cdr";
            $scope.jsonApi = "/"+urlOp+"/show/"+id+"?version=2.0";
        }
        $scope.configOptionFromServer();
    }

    $scope.loadTemplateInWizard = function(id){
        $scope.pageType = "show";
        $rootScope.pageType = $scope.pageType; // Sync to rootScope for drawer access
        startLoader();
        $scope.jsonApi = "/contracttemplate/show/"+id+"?version=2.0";
        $scope.configOptionFromServer();
    }

    var loadMDSearchFieldsEvt=$scope.$on('loadMDSearchFields',function(event,entId){
        $scope.setMetaDataSearchVal(entId);
    });
    $rootScope.$formService = formService;
    $scope.routeParams = $routeParams; // initFormService
    $scope.docViewerTab = {};
    $scope.popupOpen = false;
    $scope.originalDataFromServer = null;
    $rootScope.fieldHierarchy = {
        "fields": []
    };
    $rootScope.fieldMapper = {};
    $rootScope.searchText = "";
    $rootScope.metadatasearchPage = false;
    $rootScope.searchableFields = false;

    $rootScope.updateParentBox = function (field) {
        if (field.id == 3561 && field.type == "optionalFields" && $rootScope.metadatasearchPage) {
            var dummyField = field;
            angular.forEach(field.fields, function (childField) {
                childField.checkedInSearch = dummyField.checkedInSearch;
                searchableFieldService.updateParentBox(childField, $scope);
            });
        }

        searchableFieldService.updateParentBox(field, $scope);
        $rootScope.checkedFieldsForMDSearch = {'clist':[]};
        for(var i =0; i<$rootScope.fieldHierarchy.fields.length;i++){
            $rootScope.checkedFieldsForMDSearch.clist= _.concat($rootScope.checkedFieldsForMDSearch.clist,findcheckedfields($rootScope.fieldHierarchy.fields[i]));
        }
    }

    function findcheckedfields(fs){
        var temp1 = _.filter(fs.children,function(o){return o.checkedInSearch;});
        return temp1;
    }
    // searchableFieldService Service
    $rootScope.atleastOneFieldSelected = searchableFieldService.atleastOneFieldSelected;

    // searchableFieldService Service
    $rootScope.updateChildBoxes = function (field) {
        searchableFieldService.updateChildBoxes(field, $scope);
        $rootScope.checkedFieldsForMDSearch = {'clist':[]};
        for(var i =0; i<$rootScope.fieldHierarchy.fields.length;i++){
            $rootScope.checkedFieldsForMDSearch.clist= _.concat($rootScope.checkedFieldsForMDSearch.clist,findcheckedfields($rootScope.fieldHierarchy.fields[i]));
        }
    }
    // searchableFieldService Service
    $rootScope.searchInFields = searchableFieldService.searchInFields;

    $scope.customFileUpload = function (elem) {
        var fieldId = $(elem).attr("fieldId");
        var uploadButton = formService.buttonMapper[fieldId].filter(function (d) {
            return d.properties.buttonType == 'upload' && d.active;
        });
        formService.listFileUpload(uploadButton[0], elem,null,this);
    }

    $scope.getIfNotGlobalCreateStep1 = function () {
        if(($scope.header && $scope.header.source && $scope.header.source.indexOf("contractFreeCreate")!=-1)){
            return false;
        }
        if (_.has($scope.data, 'entityTypeId.values') && [3,160,139].indexOf($scope.data.entityTypeId.values) != -1) {
            return true;
        } else if ($scope.pageType == "globalCreate" && !$scope.createHeaderStageTwo) {
            return false;
        }
        return true;
    }

    $scope.newCommentAdded = (parentCommentId) => {
        window.sarc.channelBroadcast("communicationChannel",{
            actionType:'newCommentAdded',
            parentCommentId: parentCommentId

        },'communicationChannel')
    }

    $scope.documentContractUpload = function (elem, isServiceDataReq, files, showContractUpload) {
        $scope.files = files || elem.files;
        $scope.serviceDataReqFieldId = null;
        var fileSize = $scope.calculateFilesSize(elem, $scope.files);
        var fieldId = $(elem).attr("fieldId") || $(elem).attr("fieldid");
        var isFromGlobalUploadCdr = $(elem).attr("fieldId") == 241473 ? true : false; //check of hardcoded customID  when cdrDoc upload is done form createPage
        if(isServiceDataReq){
            $scope.files = $scope.fileProperties;
            $scope.serviceDataReqFieldId = 3910 || _.keys(formService.buttonMapper)[0];
            var fieldId = $scope.serviceDataReqFieldId;
        } else{
            $scope.serviceDataRequest = false;
        }

        if($scope.feedDraftUploadData && $scope.feedDraftUploadData.files) {
            $scope.files = $scope.feedDraftUploadData.files;
            fileSize = $scope.calculateFilesSize(elem,$scope.files);
        }

        if( !showContractUpload && ( $scope.files?.length === 0 ) ) {
            return;
        }

        var that = $scope;
        if(globalUploadButtonActive!=""){
            var uploadButton = formService.buttonMapper[fieldId].filter(function(d){
                return d.properties.buttonType == 'upload'
            });
        }
        else{
            var uploadButton = formService.buttonMapper[fieldId].filter(function(d){
                return d.properties.buttonType == 'upload' && d.active
            });
        }

        if(isServiceDataReq){
            if (uploadButton[0] && !uploadButton[0].api)
                uploadButton[0].api = '/file/upload/draft';
        }

        $(elem).attr("action", uploadButton[0].api);
        if(sessionStorage.getItem('drsEnabled')) {
            if(sessionStorage.getItem('drsPathBasedRouting') === 'true'){
                $scope.uploadFilesForDraft(elem, isServiceDataReq, isFromGlobalUploadCdr,showContractUpload);
            }else{
                $scope.getAccessToken().then(res =>{
                    sessionStorage.setItem('accessToken', res.data.token);
                    $scope.uploadFilesForDraft(elem, isServiceDataReq, isFromGlobalUploadCdr,showContractUpload);
                })
            }
        } else{
            $scope.uploadFilesForDraft(elem, isServiceDataReq, isFromGlobalUploadCdr,showContractUpload);
        }

    };

    $scope.uploadFilesForDraft = function(elem, isServiceDataReq, isFromGlobalUploadCdr,showContractUpload){
        fileService.uploadMultipleFilesForDrafts.call($scope, elem, function (keyListData, keyList, fromDrs = false) {
            let hasKeyLists = keyListData && keyListData.length > 0;
            if(isServiceDataReq){
                $scope.openDialogForDocumentVersioning(keyListData, elem);
                return;
            }
            if(hasKeyLists && keyListData[0].error){
                Toaster.create(keyListData[0].error,{iconClass:"icon-Information_filled"});
            } else if(hasKeyLists){
                if(fromDrs){
                    $scope.openDialogForDocumentVersioning(keyListData, elem, isFromGlobalUploadCdr,showContractUpload);
                } else {
                    var fileSizeOnBackend = keyListData.reduce(function (acc, ele) {
                        if (ele.documentSize) {
                            acc += ele.documentSize;
                        }
                        return acc;
                    }, 0);
                    let fileSizeDiff = Math.abs(fileSize - fileSizeOnBackend);
                    if (fileSizeDiff < 100) {
                    that.openDialogForDocumentVersioning(keyListData, elem,isFromGlobalUploadCdr, showContractUpload);
                    } else {
                        toggleServerErrorNotification(true);
                    }
                }
            }
        });
    }

    $rootScope.fieldsToCheckForAutocomputaion = ["finalNumerator", "finalDenominator", "finalPerformance"];
    $rootScope.fieldsToCheckForAutocomputaionSupplier = ["supplierNumerator", "supplierDenominator", "supplierCalculation"];
    $rootScope.fieldsToCheckForAutocomputaionActualPerf = ["actualNumerator", "actualDenominator", "actualPerformance"];
    $rootScope.autoPopulateValue = function(numerator,denominator,computation){
        $scope.$$postDigest(function(){
            if($rootScope.data.measurementUnit.values && $rootScope.data.measurementUnit.values.id == 1){//for percentage
                if(($scope.data[numerator].values != "") && (!isNaN($scope.data[numerator].values)) && !isNaN($scope.data[denominator].values) && $scope.data[denominator].values != 0){
                    var returnedValue = SirionUtils.findSpecificFieldProperty($scope.layout,$scope.data[computation].id,computation,'validations[1].properties.length');
                    $scope.data[computation].values = (100*($scope.data[numerator].values/$scope.data[denominator].values)).toFixed(returnedValue?returnedValue:2);
                } else {
                    $scope.data[computation].values = "";
                }
            } else if($scope.data.measurementUnit.values){
                $scope.data[computation].values  = $scope.data[numerator].values;
            }
            $(".updateSlMetField").trigger("change");
            $(".updateSlMetField").trigger("focusout");
        })
    }
    $scope.hideCommentAndShowDocument = function (name) {
        if ($scope.previewTab && $scope.previewTab.isActive) {
            $scope.previewTab.isActive = false;
        }
        $scope.expandLeftSection = true;
        $scope.miraDocSecActive = false;
        $scope.documentOpenWithForm = true;
        $scope.currentDocumentName = name;
        $timeout(function () {
            $scope.$broadcast('updateTabLength');
        }, 100);
    }

    $scope.closeDocViewer = function (e) {
        /*if(!$scope.showInWorkspace)
            $scope.expandLeftSection = false;*/
        $scope.documentOpenWithForm = false;
        if(e && !_.isEmpty(window.docViewerParams)) {
            window.docViewerParams = {};
        }
        $scope.isPdfJsViewer = false;
        $(".highlightedReference").removeClass("highlightedReference");
        $timeout(function () {
            $scope.$broadcast('updateTabLength');
        }, 100);

        if(typeof(Event) === 'function') {
            window.dispatchEvent(new Event('closeDocViewer'));
        }else{ // IE 11 specific
            var event = document.createEvent('Event');
            event.initEvent("closeDocViewer", false, true);
            window.dispatchEvent(event);
        }
    }

    $scope.minimizeLeftSectionDocForm = function () {
        $scope.togglePropValue('minimizeLeftSectionDocFormView');
        $scope.expandLeftSectionDocFormView = false;
        $timeout(function () {
            $scope.$broadcast('updateTabLength');
        }, 100);
    };

    $scope.showDocumentViewOnShowPage = function () {
        $scope.minimizeLeftSectionDocFormView = false;
        $timeout(function () {
            $scope.$broadcast('updateTabLength');
        }, 100);
    };

    $scope.openInheritModal = function () {
        showPageService.openInheritModal.call($scope);
    };

    $scope.openMoveToTreeModal = function (fieldObj) {
        showPageService.openMoveToTreeModal.call($scope);
    };

    $scope.openSendToSigModal = function (fieldObj, calledFromContractDocument,reqId) {
        showPageService.openSendToSigModal.call($scope,fieldObj, calledFromContractDocument,reqId);
    };

    $scope.downloadCommentData = function (payload) {
        showPageService.downloadCommentData.call($scope, payload)
    }

    $scope.downloadCommentAttachmentData = function (payload) {
        showPageService.downloadCommentAttachmentData.call($scope, payload)
    }

    $scope.isdocTreeVisible = function(){
        if(!$scope.mobileView && $scope.showDocTree && ($routeParams.entityName == 'tblcontractdocuments' || $routeParams.entityName == 'tblrelations' || $routeParams.entityName == 'tblcontracts')){
            return true;
        }
    }

    $scope.expandRightSection = function() {
        if($scope.docViewerPage){
            $scope.togglePropValue('expandLeftSection', false)
        }
    }

    $scope.adhocChildOB = function (elem) {

        var dialogObject = {}
        //<input timewidget="false" date-range name="dueDate" ng-keydown="removeDP($event)" ng-model="requestModel.dueDate" date-format type="text" class="hasDatepicker"/>
        dialogObject["templateURL"] = '<div class="adhocgb-create"><div class="adhocGBDiv"><label><span class="fieldLabel">'+intl_msg[25533]+' :  </span><span ng-model="requestModel.shortCodeId" class="content-left">{{requestModel.shortCodeId}}</span></label>' +
            '<label class="error_holder adhocGBDueDate" ng-class="{error_text:showError && !requestModel.dueDate}" ng-click="$event.preventDefault();"><span class="fieldLabel">'+intl_msg[25534]+' : </span>' +
            /*'<input  name="dueDate"  ng-keydown="removeDP($event)" ng-model="requestModel.dueDate" date-format load-datepicker  type="text" class="useDatepicker" readonly/>'+*/
            '<span class="label-height"><input type="text" class="ang-datepicker"  datetime-picker="{{formatDate}}" name="dueDate" ng-model="requestModel.dueDate" ng-click="openCalendarPopup($event,\'dueDate\',true)" is-open="datepicker.opened.dueDate" datepicker-options="datepicker.datepickerOptions.dueDate" button-bar="datepicker.buttonBaroptions" readonly="true" close-on-date-selection="true" enable-time="false"/></span><div ng-if="showError && !requestModel.dueDate" class="error_span_text">'+intl_msg[25530]+'</div>' +
            '</label></div>' +
            '<div class="submit" >' +
            '<a href="javascript:void(0)" ng-click="callCreateAdhocOB()" class="submit-buttons create-gb-btn">'+intl_msg[25535]+'</a><a id="adhocCOBCancel" href="javascript:void(0)"  ng-click="removeDocumentDialog($(event))" class="submit-buttons">'+intl_msg[23731]+'</a></div></div>';
        dialogObject["idMapping"] = "#showCreateAdhocChildOB";
        dialogObject["parentScope"] = $scope;
        dialogObject["fieldId"] = elem.field.id;
        formService.createAdhocDNOChild(dialogObject);

    }
    
    $scope.$watch('routeParams', function (newVal, oldVal) {
        if($scope.shortCodeIdPresent())
            return;
        
        if($scope.rawDataCommentBox || $scope.showlineItemCommentBox || window.isExceptionalPage || _.get($scope,"showBulkAmendmentDialog.visible")){
            return;
        }
        if (newVal.metadatEntityTypeId) {
            $scope.metadatasearchPage = true;
            $rootScope.metadatasearchPage = true;
            $rootScope.searchableFields = true;
        }
        if ($scope.dataPromise && $scope.dataPromise.promise && !window.emailTokenValidation) {
            $scope.dataPromise.promise.then(function (sc) {
                startLoader();
                //$scope.data = null;
                $scope.header = null;
                $scope.nonWorkFlowButtons = null;
                $scope.workFlowButtons = null;
                $scope.showPlusSign = false;
                $scope.actionHistory = null;
                $scope.errors = null;
                $scope.originalDataFromServer = null;
                if(!($scope.showInvoiceUploadDialog && $scope.showInvoiceUploadDialog.visible)) {
                    showPage2DataTransformationService.returnObj.leftTabList = null;
                    showPage2DataTransformationService.returnObj.leftTabInfo = null;
                    showPage2DataTransformationService.returnObj.rightTabInfo = null;
                    showPage2DataTransformationService.returnObj.allleftTabInfo = null;
                }
                if ($('[aria-describedby="showdialog"]').find("#showdialog:first").hasClass('ui-dialog-content') && $('[aria-describedby="showdialog"]').find("#showdialog:first").dialog("isOpen")) {
                    $('[aria-describedby="showdialog"]').find("#showdialog:first").dialog("close");
                }
                $scope.cancelPp();
                if (angular.isFunction($scope.cancel)) {
                    $scope.cancel();
                }
                if ($rootScope.myModelInstance) {
                    $rootScope.myModelInstance.opened.then(function () {
                        $rootScope.myModelInstance && $rootScope.myModelInstance.close();
                        $rootScope.myModelInstance = null;
                    });
                }
                $scope.apiName = newVal.entityName;
                $rootScope.contractId = newVal.contractId || "";
                $rootScope.relationId = newVal.relationId || "";
                $rootScope.vendorId = newVal.vendorId || "";
                $rootScope.docViewerId = null;
                $rootScope.treeHtml = $sce.trustAsHtml("<p></p>");
                $rootScope.showBackNavigation = false;
                if (newVal.metadatEntityTypeId) {
                    startLoader();
                    $scope.jsonUrl = "/metadatasearch/" + newVal.metadatEntityTypeId;
                    startLoader();
                    entityFactory.getJson("/searchLayout/entityTypes", "get").success(function (res) {
                        $(".searchDropdownEntity select").prop("disabled", true);
                        $rootScope.selectedEntityForSearch = Number(newVal.metadatEntityTypeId);
                        $rootScope.selectedSearchType = 3;
                        $rootScope.searchDropdownEntity = res.searchEntityTypes;
                        $rootScope.searchTypeDropdown = res.searchTypes;
                        $rootScope.getDropDownTitle = function(model,property){
                            for(var i=0;$rootScope[property] && i<$rootScope[property].length;i++){
                                if($rootScope[model] == $rootScope[property][i].id){
                                    return $rootScope[property][i].name;
                                }
                            }
                        }
                        angular.element(".searchDropdown select").val(2);
                        angular.element(".searchDropdown select").val(Number(newVal.metadatEntityTypeId));

                    })
                    return;
                }
                $scope.docViewerPage = false;
                $rootScope.entityTypeIdJS = undefined;
                if (newVal.entityName == "tblcontractservicedatas") {
                    $rootScope.showBackNavigation = false;
                } else if (newVal.entityName == "tblcontracts") {
                    $rootScope.contractId = newVal.entityId;
                    $rootScope.showButton = true;
                    $rootScope.entityTypeIdJS = 61;
                    $rootScope.treeHtml = $sce.trustAsHtml(window.treeHtmlForLoader);
                } else if (newVal.entityName == "tblrelations") {
                    $rootScope.relationId = newVal.entityId;
                    $rootScope.showButton = true;
                    $rootScope.entityTypeIdJS = 1;
                    $rootScope.treeHtml = $sce.trustAsHtml(window.treeHtmlForLoader);
                } else if (newVal.entityName == "tblvendors") {
                    $rootScope.vendorId = newVal.entityId;
                    $rootScope.showButton = true;
                    window.treeHtmlForLoader = ""
                } else if (newVal.entityName == "tblcontractdocuments") {
                    $rootScope.entityTypeIdJS = 23;
                    $rootScope.docViewerId = newVal.entityId;
                    $scope.docViewerPage = true;
                    $rootScope.treeHtml = $sce.trustAsHtml(window.treeHtmlForLoader);
                } else if (newVal.entityName == "tblsurvey") {
                    $scope.surveyShowPage = true;
                } else if (newVal.entityName == "tbltemplate") {
                    $scope.templateShowPage = true;
                } else {
                    window.treeHtmlForLoader = "";
                }
                if($scope.isdocTreeVisible()){
                    $scope.expandLeftSection = true;
                }
                entityFactory.entityNameMapper.forEach(function (d, i) {
                    if (d.urlName == newVal.entityName || d.apiName == $scope.apiName || d.entityName == newVal.entityName || (d.entityName && newVal.entityName?.includes(d.urlName))) {
                        var jsonUrl;
                        if (newVal.action == "show") {

                            if(!newVal.entityId){
                                console.log("EntityId not found, redirecting to previous page! ");
                                $rootScope.goToPreviousPage();
                                return false;
                            }

                            if(SirionUtils.validateEntityId(newVal.entityId) || newVal.entityId == "first")
                            {
                                jsonUrl = "/" + d.apiName + "/" + newVal.action + "/" + newVal.entityId;
                                if ($scope.entityEventNotificationEnabled) {
                                    const _entityTypeId = urlToCodeMapper[newVal.entityName];
                                    if (_entityTypeId) {
                                        integrateSSEServiceDetail(newVal.entityId, _entityTypeId);
                                    }
                                }
                            }
                            else{
                                console.log("EntityId is not valid,it has to be a integer so redirecting to previous page! ");
                                Toaster.create(intl_msg[6419],{iconClass:"icon-Information_filled"});
                                $rootScope.goToPreviousPage();
                            }
                            if (d.apiName.toLowerCase() != "contracts") {//Done this change for url filter param only.
                                $timeout(function () {
                                    //$rootScope.$emit("updateTasks");
                                },timeoutForIE);
                            }
                        } else if (newVal.action == "update") {
                            jsonUrl = "/" + d.apiName + "/" + "edit" + "/" + newVal.entityId;
                            if ($scope.entityEventNotificationEnabled) {
                                const _entityTypeId = urlToCodeMapper[newVal.entityName];
                                if (_entityTypeId) {
                                    integrateSSEServiceDetail(newVal.entityId, _entityTypeId);
                                }
                            }
                        } else if (newVal.action == "create") {
                            jsonUrl = "/" + d.apiName + "/" + "new";
                            if(!$scope.exceptionalInNewUx.crudPage && $scope.isNewUX) {
                                const api = sessionStorage.getItem('api');
                                if(!api) {
                                    /*
                                    * Redirect to listing page if api does not exist in session storage.
                                    * If entityListId not found in mapper then redirect to dashboard for safe side
                                    * */
                                    const entityType = SirionUtils.appendTblToUrl(SirionUtils.getEntityTypeFromUrl());
                                    const entityListId = _.get(urlToEntityDataMapper,`[${entityType}].listId`);
                                    window.location.href = entityListId ? `#/listRender/${entityListId}` : "#/dashboard";
                                    return ;
                                }
                                jsonUrl =  decodeURIComponent(sessionStorage.getItem('api'));
                            }
                            if (!$scope.isCommonRouteCrudPage && jsonUrl.indexOf('contracttemplate') > -1 && sc.clientId) {
                                jsonUrl = jsonUrl + "/2/" + sc.clientId;
                            }
                        } else if (newVal.action == "clone") {
                            jsonUrl = "/" + d.apiName + "/" + "clone" + "/" + newVal.entityId;
                            if(d.cloneV2)
                                jsonUrl = '/v2'+jsonUrl;
                        }

                        // $scope.$broadcast("updateForm",jsonUrl);
                        // $("#loadingMsg").hide();

                        $scope.jsonUrl = "";
                        if($scope.showInvoiceUploadDialog && $scope.showInvoiceUploadDialog.visible) {
                            jsonUrl = "";
                        }
                        $scope.jsonUrl = jsonUrl;
                        return;
                    }
                });

                if(newVal.entityName == "project" && newVal.action == "show") {
                    $scope.jsonUrl = '/auto-extraction/v3/project/show' + "/" + newVal.entityId;
                    $rootScope.isAEProjectShowPage=true;
                }

                if(newVal.entityName === "project" && newVal.action !== "show") {
                    $scope.isAEProjectAction = true;
                    $scope.iconClassName= $rootScope.NumToSPClassNameMapping[$rootScope.currentEntityId];
                    switch (newVal.action) {
                        case "create":
                            handleProjectCreateAction();
                            break;
                        case "update":
                            handleProjectEditAction(newVal);
                            break;
                        case "clone":
                            handleProjectCloneAction(newVal);
                            break;
                        default:
                            console.error("Invalid action received for project entity. Action: " + newVal.action);
                    }
                }

                $scope.jsonUrl && ($scope.pageType = null);

                $timeout(()=>{
                    if($scope.isCreateRoute) {
                        $scope.iconClassName= $rootScope.NumToSPClassNameMapping['61'];

                        const label = sessionStorage.getItem('pageLabel');
                        label && ($scope.titlebartext = label);
                    }
                },0)
            })
        }
        ;
    });

    /*************************START PROJECT CREATE*********************************** */

    function handleProjectCreateAction() {
        $scope.jsonUrl = '/auto-extraction/v3/project/new';
        $scope.pageType = "create";
    }

    function handleProjectEditAction(newVal) {
        $scope.jsonUrl = `/auto-extraction/v3/${newVal.entityName}/edit/${newVal.entityId}`;
        $scope.pageType = "edit";
    }

    function handleProjectCloneAction(newVal){
        $scope.jsonUrl = `/auto-extraction/v3/${newVal.entityName}/clone/${newVal.entityId}`;
        $scope.pageType = "clone";
    }

    var mountProjectComponent = $rootScope.$on("mountProjectComponent", function (e, selectedTab) {
        let mountAt = selectedTab.label == intl_msg[35463] ? '#baseclausetexts_main' : '#projectconfig_main';
        let componentToMount =  selectedTab.label == intl_msg[35463] ? 'BaseClauseTexts' : 'ProjectConfiguration';

        let propsToPass = {
            cData: {...$scope.project},
            layout: {...$scope.layout.fields[selectedTab.idx]},
        };

        $rootScope.showProjectConfig = selectedTab.label == intl_msg[35462] ? true : false;
        $rootScope.showBaseClauseTexts = selectedTab.label == intl_msg[35463] ? true : false;
        let interval = setInterval(() => {
            if ($(mountAt).length) {
                clearInterval(interval);
                if (!$(mountAt).children().length) {
                    window.reactComponents.mountDynamicComponent(mountAt, componentToMount, propsToPass);
                }
            }
        }, 10)
    });

    /*************************END PROJECT CREATE*********************************** */

    $scope.handleSummaryLayoutPromise = function(newVal){
        $scope.summarLayoutPromise.then(function () {
            var newValArr = newVal.split(":;");
            if (!newValArr[1]) {
                window.navigationTriggered = true;
                window.cognitivetablenagivationtriggered = true;
                $scope.getJson(newVal, 'get');
            }else if(newValArr[1] && newValArr[1]=="post"){
                window.navigationTriggered = true;
                window.cognitivetablenagivationtriggered = true;
                const savedBodyReq = $scope.savedBodyReq || JSON.parse(sessionStorage.savedBodyReq);
                $scope.getJson(newValArr[0],newValArr[1],null,null,savedBodyReq,false);
                delete $scope.savedBodyReq;
            }
            $scope.jsonUrl = null;
        });
    }
    $scope.$watch('jsonUrl', function (newVal, oldVal) {

        let shortCodeId = $scope.shortCodeIdPresent();
        if(shortCodeId){
            $timeout(function(){
                showPageService.handleRedirectionFromShortCodeId(shortCodeId,$routeParams.action, newVal, $scope.handleSummaryLayoutPromise);
            },500);
        } else{
            if(newVal){
                $scope.handleSummaryLayoutPromise(newVal);
            }
        }
        
    });
    var jsonUrl = "";
    var callMethod = "get";
    var entity = "contractCreate";
    var olderScope = {};
    $scope.olderScope = olderScope;
    var ngPopupOlderScope = {};
    var olderinvoiceDynamicData = {};
    externalContactService.attachToScope($scope, {
        resetPopupScopes: function () {
            olderScope = {};
            ngPopupOlderScope = {};
            $scope.olderScope = olderScope;
        },
        ensurePopupScopesForClone: function () {
            if (!olderScope || !olderScope.layoutInfo) {
                olderScope = {};
                ngPopupOlderScope = {};
                $scope.olderScope = olderScope;
            }
        },
        prepareEcRestore: function () {
            // Avoid edit-restore remount path after EC cancel/close on CDR create.
            if (olderScope) {
                olderScope.fromExternalUserOld = false;
            }
            $scope.fromExternalUserOld = false;
        },
        setIsCreate: function (val) {
            isCreate = val;
        }
    });
    $scope.testScope = "sfedf";
    $scope.modalInstances = [];
    $scope.isWorkFlowBug = false;
    $scope.modiFiedData; // to contain clone of the data part to be sent to
    // server
    $scope.currentOuterPopup = null;
    // $scope = $rootScope;
    $scope.zeroStates = true;
    $scope.lastStateStatus = false;
    $scope.validity = {};
    $scope.tabLabelName = [];

    /***** NEW variables written for show page ui2.0 ******/
    var datepicker = {
        'opened': {},
        'whenClosed': function (obj, fname, tObj, fmodel, isDynamicTableElement) {
            if(angular.element('[name='+fname+']').closest('.scrollTbody').attr('style') && angular.element('[name='+fname+']').closest('.scrollTbody').attr('style').indexOf('overflow')>-1){
                angular.element('[name='+fname+']').closest('.scrollTbody').css('overflow','');
            }

            if (tObj.termObj) {
                if (tObj.isStartDate) {
                    //todo impact areas to be checked
                    if($scope.data[fname].values){$scope.effStartdate = $filter('date')(new Date($scope.data[fname].values), SirionUtils.getDateTimeFormat())}else{
                        $scope.effStartdate = null;
                    }
                } else if (tObj.isEndDate) {
                    if($scope.data[fname].values){
                        $scope.effEnddate = $filter('date')(new Date($scope.data[fname].values), SirionUtils.getDateTimeFormat())
                    }else{
                        $scope.effEnddate = null;
                    }


                }
                $scope.updateTermTableVal();
            }
        },
        datepickerOptions: {},
        format: function (dateformat) {
            dateformat = dateformat == 'undefined' ? 'dateFormatToShow' : dateformat;
            if ($scope.formatDate != undefined) {
                return $scope.globalData[dateformat].replace(/z/, "");
            }
            return $scope.globalData[dateformat];
        },
        buttonBaroptions: {
            show: true,
            now: {
                show: false,
                text: 'Now',
                cls: 'btn-sm btn-default'
            },
            today: {
                show: true,
                text: 'Today',
                cls: 'btn-sm btn-default'
            },
            clear: {
                show: true,
                text: 'Clear',
                cls: 'btn-sm btn-default'
            },
            date: {
                show: false,
                text: 'Date',
                cls: 'btn-sm btn-default'
            },
            time: {
                show: false,
                text: 'Time',
                cls: 'btn-sm btn-default'
            },
            close: {
                show: true,
                text: 'Done',
                cls: 'btn-sm btn-default'
            },
            cancel: {
                show: false,
                text: 'Cancel',
                cls: 'btn-sm btn-default'
            }
        },
        buttonBaroptionsenabled:{
            show: true,
            now: {
                show: true,
                text: 'Now',
                cls: 'btn-sm btn-default'
            },
            today: {
                show: true,
                text: 'Today',
                cls: 'btn-sm btn-default'
            },
            clear: {
                show: true,
                text: 'Clear',
                cls: 'btn-sm btn-default'
            },
            date: {
                show: true,
                text: 'Date',
                cls: 'btn-sm btn-default'
            },
            time: {
                show: true,
                text: 'Time',
                cls: 'btn-sm btn-default'
            },
            close: {
                show: true,
                text: 'Done',
                cls: 'btn-sm btn-default'
            },
            cancel: {
                show: false,
                text: 'Cancel',
                cls: 'btn-sm btn-default'
            }
        },
        openCalendarPopup: function(args,name,calculatePos){
            $scope.openCalendarPopup(args.event,name,calculatePos);
        }
    };
    $scope.datepicker = datepicker;
    $scope.modernView = true;
    $scope.selectedLeftTabIndex = 0;
    $scope.selectedRightTabIndex = 0;
    $scope.selectedDelIndex = 4174;
    $scope.showDocTree = (conditionCheck?.isValidShowPage() && !conditionCheck?.isViaMiraDocTree()) || showPage2DataTransformationService.setVisiblityOfDocTree();
    $scope.expandDocTree = false;
    $scope.selectedButton = '';
    $scope.showpageDataLoaded = false;
    $scope.leftTabInfo = [];
    $scope.rightTabInfo = [];
    $scope.hideErrorListDiv = false;
    $scope.expandLeftSection = true;
    $scope.showCreateLinkDD = false;
    $scope.showInvoiceLinkDD = false;
    $scope.showUploadLinkDD = false;
    $scope.showFilePropertiesDD = false;
    $scope.showcustomNumberingDD = false;
    $scope.showMoreBtnDD = false;
    $scope.hideAdditionalCommentFieldsArr = [87, 88, 89, 10022];
    /** temporary array for hiding the fields **/
    $scope.hideAdditionalCommentFields = true;
    $scope.fixedCommentData = false;
    $scope.toggleAllGroupsVal = 0;
    $scope.showExpandAllInHeader = false;
    $scope.enableAddComment = false;
    $scope.documentEditPermission = false;
    $scope.showNextWFStepBtn = false;
    $scope.showTimelineLink = false;
    $scope.noSummaryGroup = false;
    $scope.skipWFStepPopup = false;
    $scope.skipStopLoader = false;
    $scope.linkedFieldsGroup = [ [4903, 4904], [508,509], [11697,11698], [360,316], [297,240], [208,210,211], [4898,4899]];
    //$scope.showDoctreeTemplate= false;
    $scope.removeLabelForCommentSec = {
        'id': 86,
        'newLabel': intl_msg[28056]
    };
    $scope.isCommPanelOpened = false; //(localStorage.getItem('commPanel') ) ? JSON.parse(localStorage.getItem('commPanel') ).opened : false;
    $scope.showCommNotification = false;
    $scope.closeThis = function (propName) {
        if( typeof $scope[propName] != 'undefined'){
            if(propName == 'showCreateLinkDD' && $scope[propName] ) {
                angular.element('#jx-createBtn').find('.jx-create-subDD').slideUp();
                angular.element('#jx-createBtn').find('.jx-createLinkAnchor').removeClass('active');
            }
            $scope[propName] = false;
            if(propName=="showAdditionalTabsList"){
                angular.element(".addTabs").removeClass("whiteBg");
                angular.element(".tabs-wrapper").removeClass("overflowVisible");
            }
        }
    };
    $scope.openCalendarPopup = function (e, which, calculatePos) {
        var calPromise = new Promise(function (res, rej) {
            e.preventDefault();
            e.stopPropagation();

            // $scope.datepicker ={'opened' :true};
            if($scope.pageType=='bulkEdit'){
                $('.selectDDbox').hide();
            }

            $('.datetime-picker-dropdown').remove();

            if($scope.datepicker.opened[which] == true){
                $scope.datepicker.opened = {};
            }else{
                $scope.datepicker.opened = {};
                $scope.datepicker.opened[which] = true;
                $scope.$broadcast('closeMsDD');

            }



            var resObj = {'evt': e, 'calPos': calculatePos}
            //if(calculatePos){
            res(resObj);
            //}

        });
        calPromise.then(function (resObj) {
            if (resObj.calPos || $scope.metadatasearchPage) {
                showPageService.setPositionOfDatepicker(resObj.evt.target);
                const $pickers = $('.datetime-picker-dropdown');
                if ($pickers.length > 1) {
                    $pickers.slice(0, -1).remove();
                }

            }


        });



    };
    var loadWorkSpaceShowPage= $scope.$on("loadWorkSpaceShowPage",function(e,data){
        treeeJson={};
        var itemLinkURL=data['itemIdLink'];
        $scope.showInWorkSpaceData.jsonOptUrlLink=data['jsonUrlOptLink'];
        $scope.jsonApi="/"+itemLinkURL;
        $scope.pageType = null;
        $rootScope.searchableFields = false;
        $rootScope.fieldHierarchy = {
            "fields": []
        };
        $rootScope.fieldMapper = {};
        $rootScope.bulkedit = false;
        $scope.showInWorkspace=true;
        $scope.docViewerPage = false;
        $scope.toggleAllGroupsVal = false;
        var newValEntity=$scope.showInWorkSpaceData.jsonOptUrlLink[2];
        var newValEntityId=$scope.showInWorkSpaceData.jsonOptUrlLink[3];
        if (newValEntity == "tblcontractservicedatas") {
            $rootScope.showBackNavigation = true;
        } else if (newValEntity == "tblcontracts") {
            $rootScope.contractId = newValEntityId;
            $rootScope.showButton = true;
            $rootScope.entityTypeIdJS = 61;
            $rootScope.treeHtml = $sce.trustAsHtml(window.treeHtmlForLoader);
        } else if (newValEntity == "tblrelations") {
            $rootScope.relationId = newValEntityId;
            $rootScope.showButton = true;
            $rootScope.entityTypeIdJS = 1;
            $rootScope.treeHtml = $sce.trustAsHtml(window.treeHtmlForLoader);
        } else if (newValEntity == "tblvendors") {
            $rootScope.vendorId = newValEntityId;
            $rootScope.showButton = true;
            window.treeHtmlForLoader = ""
        } else if (newValEntity == "tblcontractdocuments") {
            $rootScope.entityTypeIdJS = 23;
            $rootScope.docViewerId = newValEntityId;
            $scope.docViewerPage = true;
            $rootScope.treeHtml = $sce.trustAsHtml(window.treeHtmlForLoader);
        } else {
            window.treeHtmlForLoader = "";
        }
        $scope.expandLeftSection=true;
        $scope.configOptionFromServer(true);
    });
    $scope.showAutoExtractionResultTile = function(ae){
        $scope.showAutoExtractionTile = !!ae;
        $scope.autoExtraction = ae && ae.active;
        if(ae && ae.url){
            var parts = ae.url.split("/");
            $scope.autoExtractionShowPageUrl = "/autoExtraction/document/"+parts[parts.length-1];
        }
        $scope.applyScope($scope);
    }
    $scope.setMetaDataSearchVal = function (entId) {
        startLoader();
        $rootScope.searchableFields = true;
        $rootScope.fieldHierarchy = {
            "fields": []
        };
        $rootScope.fieldMapper = {};
        $rootScope.metadatasearchPage = true;
        $scope.supplierListingPage = false;
        $scope.jsonApi = "/metadatasearch/" + entId;
        $scope.pageType = null;
        $scope.configOptionFromServer(true);
    };
    $scope.updateTermTableVal = function () {
        var datedifference = {};
        var dateeff = (typeof $scope.effStartdate)!=='string'?moment($scope.effStartdate._i,$scope.formatDate.toUpperCase()).format(SirionUtils.getActualDateFormat()) : $scope.effStartdate;
        var dateexp =  (typeof $scope.effEnddate)!=='string'? moment($scope.effEnddate._i,$scope.formatDate.toUpperCase()).format(SirionUtils.getActualDateFormat()) : $scope.effEnddate;;
        if ($scope.effStartdate && $scope.effEnddate  && Date.parse(dateexp) >= Date.parse(dateeff)) {
            var a = moment(dateeff,SirionUtils.getActualDateFormat());
            var b = moment(dateexp,SirionUtils.getActualDateFormat()).add(1,'days');
            var dy = b.diff(a, 'years');
            var dm =b.diff(a,'months')- (dy*12);
            var temp =  a;
            // to find previous month and then subtract it to get days
            temp = temp.add(dy, 'years').add(dm, 'months');
            var dd  = b.diff(temp,'days');
            if(dd == -1 && dm == 0){
                dy =  dy-1;
                dm = 11;
                dd = b.date() - 1;

            }
            datedifference['days'] = dd;
            datedifference['months'] = dm;
            datedifference['years'] = dy;


            if ($(".termTableSpan").find("input").size() == 0) {
                $(".termTableSpan").find("[ng-model='data.days.values']").html(dd);
                $(".termTableSpan").find("[ng-model='data.months.values']").html(dm);
                $(".termTableSpan").find("[ng-model='data.years.values']").html(dy);
            }
            var dateDiff;
            angular.forEach(entityFactory.term, function (v, k) {
                dateDiff = v.split('.');
                $scope[dateDiff[0]][dateDiff[1]][dateDiff[2]] = datedifference[dateDiff[1]];
            });
        }else{
            datedifference['days'] = 0;
            datedifference['months'] = 0;
            datedifference['years'] = 0;
            if ($(".termTableSpan").find("input").size() == 0) {
                $(".termTableSpan").find("[ng-model='data.days.values']").html(dd);
                $(".termTableSpan").find("[ng-model='data.months.values']").html(dm);
                $(".termTableSpan").find("[ng-model='data.years.values']").html(dy);
            }
            angular.forEach(entityFactory.term, function (v, k) {
                dateDiff = v.split('.');
                $scope[dateDiff[0]][dateDiff[1]][dateDiff[2]] = datedifference[dateDiff[1]];
            });

        }
    };
    $scope.isScrollDisabled = false;

    $scope.mssettings = {
        displayProp: "name",
        "selectedToTop": true,
        scrollableHeight: '200px',
        scrollable: true,
        "externalIdProp": '',
        'enableSearch': true,
        'parentElmClass': 'jx-parentForm'
    };
    /***** End of new variables*****/
    var updateExpandAllEvt=$scope.$on('updateExpandAll', function (event, objVal){
        //alert(objVal);
        $scope.showExpandAllInHeader = objVal;
        $timeout(function () {
            $scope.$applyAsync();
        }, 0);
    });
    $scope.expandedTables = document.getElementsByClassName('expandedTables')[0];
    $scope.breadCrumbState = function (history, breadObj, init) {
        if (stateToggle == true) {
            $scope.breadCrumbStateBack(history, breadObj, 0);
            return;
        }
        $scope.breadArrObj = [];
        if (!init) {
            $scope.actionHistory.history = [];
            $scope.actionHistory.history.push(angular.copy(history));
            var tempId = breadObj.states[breadObj.states.length - 1].id;
        }
        if (history && history.status) {
            $scope.breadArrObj = angular.copy(history.statuses);
            if (history == breadObj.states[breadObj.states.length - 1]) {
                $scope.lastStateStatus = true;
            } else {
                $scope.lastStateStatus = false;
            }
        }
        if (init) {
            $scope.breadArrObj[0].label = "...";
        }
        stateToggle = !stateToggle;
        if (stateToggle) {
            setTimeout(function () {
                $(".wf-grn2").css("cursor", "pointer");
                $(".wf-grey2").css("cursor", "pointer");
                $(".wf-green2last").css("cursor", "pointer");
            }, 500);
        }
    }
    $scope.breadCrumbStateBack = function (history, breadObj, index, statusPos) {
        if (!statusPos) {
            $scope.lastStateStatus = false;
        }
        if (history && history.label == "...") {
            $scope.breadCrumbState(breadObj.states[breadObj.states.length - 1], breadObj);
            return;
        }
        if (statusPos && stateToggle) {
            $scope.breadCrumbState(breadObj.states[breadObj.states.length - 1], breadObj);
            setTimeout(function () {
                $(".wf-grn2").css("cursor", "text");
                $(".wf-grey2").css("cursor", "text");
                $(".wf-green2last").css("cursor", "text");
                return;
            }, 500);
        }
        if (index == 0) {
            $scope.breadArrObj = [];
            $scope.actionHistory.history = breadObj.states;
            var lastState = angular.copy(breadObj.states[breadObj.states.length - 1]);
            $scope.breadArrObj = angular.copy(lastState.statuses);
            /*if ($scope.breadArrObj && $scope.breadArrObj.length > 3) {
                $scope.breadArrObj = $scope.breadArrObj.slice($scope.breadArrObj.length - 4, $scope.breadArrObj.length);
                $scope.breadArrObj[0].label = "...";
            }*/

            stateToggle = !stateToggle;
            $scope.lastStateStatus = true;
        }
        //breadObj.status[history.status[2]]
    }
    $scope.clientCurrency = "default currency";
    $scope.asd = function (url, callMethod, entity) {
        entityFactory.performButtonAction(url);
    };
    $scope.chartResourcesLoaded = false;

    // linkChartService
    // $scope.showLinkChart function to come here
    // listService
    window.deleteLink = function (link, a1, tableId) {

        var requestUrl = link;
        var parentId = $scope.data.id.values;
        var requestData = {
            "linkId": {
                "name": "linkId",
                "values": a1
            },
            "parentEntityId": {
                "name": "parentEntityId",
                "values": $scope.data.id.values
            },
            "parentEntityTypeId": {
                "name": "parentEntityTypeId",
                "values": $scope.data.entityTypeId.values
            }
        };
        var promise = entityFactory.getJson(requestUrl, "POST", entity, requestData);
        promise.success(function (d, i) {
            if (d.header.response.status == "success") {
                Toaster.create(intl_msg[6494]);
                var selector = "table#" + tableId;
                $(selector).dataTable().fnDraw();
            } else {
                const args = {
                    popupType: 'alert',
                    str: d.header.response.errorMessage != null ? (d.header.response.errorMessage).toString() : "Unable to Delete",
                    heading: intl_msg[24153],
                    yesCbFn: cancelString,
                    yesName: intl_msg[24184]
                }
                SirionUtils.openSirionDialogs(args);
            }
            stopLoader();
        });
    }
    // listService
    globalFunctions.openModalWithJson = function (id, button) {
        $rootScope.documentId = id;
        if (button) {
            $rootScope.popupButtonDetails = button;
        } else {
            $rootScope.popupButtonDetails = null;
        }
        $rootScope.myModelInstance = $modal.open({

            templateUrl: $rootScope.createHtmlUrl("popupTemplate.html"),
            modal: true,
            size: "lg",
            keyboard: false,
            backdrop: "static",
            controller: "popupController",
            windowClass: "clonepopup structured_data"
        });
        if ($scope.modalInstances) {
            $scope.modalInstances.push($rootScope.myModelInstance);
        } else {
            $scope.modalInstances = [];
            $scope.modalInstances.push($rootScope.myModelInstance);
        }
    }

    $scope.showStakeHolderGroup = function(evt, e,fieldinfo){

        if(e.target.className=="userGroupAnchor") {
            var requestUrl = "/usergroups/" + evt + "/users/" + this.data.entityTypeId.values + "/" + this.data.id.values;
            var element = $(e.currentTarget);
            var nameVar = $(e.target).text().trim().replace(',','');
            entityFactory.getJson(requestUrl, "GET").success(function (d, i) {
                stopLoader();
                $("#showStakeHolderDetails").remove();
                var iconDisplayClass='';
                if(d.length>0) {
                    if ($('#showStakeHolderDetails').length == 0) {
                        $("body").append(angular.element('<div id="showStakeHolderDetails"></div>'));
                    }
                    $("#showStakeHolderDetails").dialog({
                        autoOpen: true,
                        height: 500,
                        width: 420,
                        modal: true,
                        title: intl_msg[27846],
                        open: function( event, ui ) {
                            $('[aria-describedby="showStakeHolderDetails"] .ui-dialog-titlebar-close').attr('title',intl_msg[24237]);
                            $("#showStakeHolderDetails").css({"height":"auto", "max-height":"460px"})
                            resetDialogPosition(this);
                        }
                    });
                    $('#showStakeHolderDetails').append(angular.element('<div class="showUserDetails topGroupInfo"></div>')
                        .append(angular.element("<div class='infoHeader'></div>")
                            /*.append('<div  class="display_inline_block initials"><letter-avatar initials="'+globalFunc.getUserInitials(nameVar)+'" round-shape="true" auto-color="true" width="40"></letter-avatar></div>')*/
                                .append('<div  class="display_inline_block initials"><i class="icon-usergroup"></i></div>')
                                .append('<div class="display_inline_block nameInfoDiv"><div class="userDesDiv">'+fieldinfo.label+'</div><div class="userNameDiv">'+nameVar+'</div></div>')
                        )
                        .append('<span class="memberLengthInfo">'+d.length+' Members</span>'));
                    for (var i = 0; i < d.length; i++) {
                        var divEle = angular.element('<div class="showUserDetails memberGroupInfo"></div>');
                        if (d[i].properties && Object.keys(d[i].properties).length > 0) {

                            var ulEle = angular.element('<ul class="jx-memberInfoDetails hidden"></ul>');
                            angular.forEach(d[i].properties, function (a, b) {
                                if (a != "User Department")
                                    ulEle.append("<li><span class = 'fieldName'>" + b + " : </span><span class='fieldValue'>" + a + "</span></li>");
                                else
                                    ulEle.append("<li><span class = 'fieldName'>" + b + " : </span><span class='fieldValue'>" + a.join() + "</span></li>");
                            });
                            iconDisplayClass = '';
                        }else{
                            iconDisplayClass = 'hidden';
                        }
                        //var infoHeader = "<span class='infoHeader'>" + d[i].name + "</span>";
                        var infoHeader = angular.element("<div class='infoHeader'></div>");
                        infoHeader.append('<div  class="display_inline_block initials"><letter-avatar initials="'+globalFunc.getUserInitials(d[i].name)+'" round-shape="true" auto-color="true" width="40"></letter-avatar></div>');
                        infoHeader.append('<div class="display_inline_block nameInfoDiv"><div class="userDesDiv">Contract Manager</div><div class="userNameDiv">'+d[i].name+'</div></div><i class="icon-down-arrow jx-toggleMemberInfo '+iconDisplayClass +'" ng-click="toggleMemberInfo($event)"></i>');
                        divEle.append(infoHeader);
                        divEle.append(ulEle);
                        $("#showStakeHolderDetails").append(divEle);

                    }
                    $compile($("#showStakeHolderDetails").contents())($scope);
                    $("#showStakeHolderDetails").dialog("open");
                }

            });
        }

    };
    $scope.toggleMemberInfo = function(e){
        e.stopPropagation();
        //if(angular.element(e.target).hasClass('icon-down-arrow')){
        angular.element(e.target).toggleClass('icon-down-arrow');
        angular.element(e.target).toggleClass('icon-up-arrow');
        angular.element(e.target).closest('.memberGroupInfo').find('.jx-memberInfoDetails').toggleClass('hidden');
        /* }else if(angular.element(e.target).hasClass('icon-up-arrow')){
             angular.element(e.target).removeClass('icon-up-arrow');
             angular.element(e.target).addClass('icon-down-arrow');
             angular.element(e.target).closest('.memberGroupInfo').find('.jx-memberInfoDetails').show();
         }*/



    }

    // listService
    var changeShowpageGraph =  $scope.$on('changeShowpageGraph',function(e,data){
        $scope.renderShowPageGraph(data);
    });
    $scope.renderShowPageGraph = function (data, cont, elemId) {
        FusionCharts.setScriptBaseURI("src/scripts/library/fusioncharts-xt-ol/js/");
        /*var a = $("<script />");
        a.attr("src", appName + "/resources/frontend/src/scripts/jquery/fusioncharts.js?_v=" + appVersion);
        $("body").prepend(a);*/
        var loadLayout = function (url) {
            var promise = $http.get($scope.appBaseApiUrl + url).then(function (response) {
                return response.data;
            });
            return promise;
        };
        var url = data.dataURL;
        if ($rootScope.showcalenderPeriod) {
            url = data.dataURL + "?calendarType=" + defaultCalendar.id;
        }
        var graphData = loadLayout(addtStamp(url));
        graphData.then(function (gData) {
            if (gData != "" && $.isEmptyObject(gData) == false) {
                if (data.properties && data.properties.singleSeriesGraph) {
                    renderChart(gData, cont);
                } else {
                    if ($rootScope.showcalenderPeriod) {
                        showPerformanceGraphForSla(gData, true, data.dataURL);
                    } else {
                        showPerformanceGraphForSla(gData);
                    }
                }
            } else {
                $("#"+cont).html('<div class="noDataToDisplay"><div class="no-data-image"><img loading="lazy" alt="No Data Image" src="https://www.sirioncdn.com/src/images/no-data.svg" height="115px"/></div>' +  '<span class="no-data-text">'+intl_msg[23626]+'</span></div>');
            }
        });
    };
    // formServcie
    $scope.createCloneOfProperty = function (arrayObj, propToCreate, propToClone, modelString) {
        formService.createCloneOfProperty(arrayObj, propToCreate, propToClone, modelString, $scope);
    }
    $scope.createCloneOfScope = function () {
        const sc = $('.contractDocUploadDir').scope();
        $scope.angularPopUp = true;
        if ($.isEmptyObject(olderScope) && $.isEmptyObject(ngPopupOlderScope) && !$.isEmptyObject($scope.myJson)) {
            $scope.oldFactory = {};
            $scope.oldFactory.fieldsToBeConvertValueToJson = angular.copy(entityFactory.fieldsToBeConvertValueToJson);
            entityFactory.fieldsToBeConvertValueToJson = [];
            olderScope = angular.copy($scope.myJson);
            olderScope.showCommentBox=$scope.showCommentBox;
            $scope.showCommentBox=false;
            olderScope.errors = angular.copy($scope.errors);

            // showPageService.manageTimeLineCommentOldScope.call($scope,olderScope,true);

            olderScope.falseIds = $scope.falseIds;
            olderScope.showPageUrl = $scope.showPageUrl;
            olderScope.createLink = angular.copy($scope.createLink);
            olderScope.updatedData = $scope.myJson.data;
            olderScope.showStatusInfoProgressBar = $scope.myJson.data?.statusInfoMessages?.values?.length >= 2
            olderScope.fromExternalUserOld = $scope.fromExternalUser;
            olderScope.fromSupplierDropdownOld = $scope.fromSupplierDropdown;
            // Persist mandatory-fields toggle (and related UI) across nested create modals
            // (external contact + add new counterparty) so parent form remount keeps prior state.
            if (($scope.fromExternalUser || $scope.fromSupplierDropdown) && $scope?.globalData?.dynamicFormId) {
                window.sarc.channelBroadcast("reactDynamicForms", {
                    actionType: "saveFormUiState",
                    payload: { type: 'createPatch' }
                }, `dfSubscriptions_${$scope.globalData.dynamicFormId}`);
                // Must run before fromExternalUser is reset and the popup replaces the parent form
                if ($scope.fromExternalUser) {
                    window.sarc.channelBroadcast("reactDynamicForms", {
                        actionType: "savePartialEditState",
                        payload: { type: 'createPatch', source: 'externalContact' }
                    }, `dfSubscriptions_${$scope.globalData.dynamicFormId}`);
                }
            }
            $scope.fromExternalUser = false;
            $scope.fromExternalUserOld = false;
            olderScope.isWorkflowCompleted = $scope.isWorkflowCompleted;
            olderScope.timeLineFeedSecActive = $scope.timeLineFeedSecActive;
            olderScope.commentDataScope = $scope.commentDataScope;
            olderScope.isWorkflowProgressbarLoaded = $scope.isWorkflowProgressbarLoaded;
            olderScope.stepperComponentData = $scope.stepperComponentData;
            olderScope.fileData = angular.copy(sc.fileData);
            olderScope.showPlusSign = angular.copy($scope.showPlusSign);
            olderScope.commentFldHavingValidations = angular.copy($scope.commentFldHavingValidations);
            olderScope.errorsFromServer = $scope.errorsFromServer;
            olderScope.downloadObj = angular.copy($scope.downloadObj);
            olderScope.isWorkFlowBug = $scope.isWorkFlowBug;
            olderScope.currentRelationId = $scope.currentRelationId;
            olderScope.buttonMapper = angular.copy($scope.$formService.buttonMapper);
            $scope.isWorkFlowBug = false;
            $scope.errorsFromServer = undefined;
            $scope.falseIds = undefined;
            olderScope.versions = $scope.versions;
            $scope.versions = undefined;
            olderScope.subScope = $scope.subScope;
            $scope.subScope = undefined;
            olderScope.undoDisable = $scope.undoDisable;
            $scope.undoDisable = undefined;
            olderScope.shouldIShowFieldErrorsVar = $scope.shouldIShowFieldErrorsVar;
            $scope.shouldIShowFieldErrorsVar = undefined;
            /** New scope variables added for ux 2.0 layout **/
            olderScope.contractDocumentTabUpload= $scope.contractDocumentTabUpload;
            $scope.contractDocumentTabUpload = false;
            olderScope.pageType = $scope.pageType;
            olderScope.workFlowButtons = $scope.workFlowButtons;
            olderScope.nonWorkFlowButtons = $scope.nonWorkFlowButtons;
            olderScope.docViewerTab = angular.copy($rootScope.docViewerTab);
            olderScope.docViewerTables = angular.copy($rootScope.docViewerTables);
            olderScope.leftTabList = showPage2DataTransformationService.returnObj.leftTabList;
            olderScope.leftTabInfo = showPage2DataTransformationService.returnObj.leftTabInfo;
            olderScope.rightTabInfo = showPage2DataTransformationService.returnObj.rightTabInfo;
            olderScope.allleftTabInfo = showPage2DataTransformationService.returnObj.allleftTabInfo;
            olderScope.selectedTabInfo = showPage2DataTransformationService.returnObj.selectedTabObj;
            olderScope.contractDocuments = docTreeService.contractDocuments;
            olderScope.selectedContract = docTreeService.selectedContract;
            olderScope.selectedContractId = docTreeService.selectedContractId;
            olderScope.otherFolder = docTreeService.otherFolder;
            olderScope.expandLeftSection = $scope.expandLeftSection;
            olderScope.skipWFStepPopup = $scope.skipWFStepPopup;
            olderScope.invoiceValidationStatusBtn = $scope.invoiceValidationStatusBtn;
            olderScope.isInvoiceViewerActive = $rootScope.isInvoiceViewerActive;
            olderScope.invoiceRegenerateBanner = $scope.invoiceRegenerateBanner;
            olderScope.showContractUploadStepper = $scope.showContractUploadStepper;
            olderScope.toShowContractUpload = angular.copy(showPageService.toShowContractUpload);
            $scope.selectContractId = docTreeService.selectedContractId;
            $scope.previewTab.isActive = false;

            window.htmlEditorList = [];
            if($scope.cActions) {
                olderScope.cActions = angular.copy($scope.cActions);
                delete $scope.cActions;
            }
            $scope.invoiceValidationStatusBtn = undefined;
            $scope.invoiceRegenerateBanner = undefined;
            $scope.showBanner = false;
            $scope.showButton = false;
            $rootScope.isInvoiceViewerActive =  false;
            if (!olderScope.fromExternalUserOld) {
                if(olderScope.data && olderScope.data.contractSupplier) {
                    if (Array.isArray(olderScope.data.contractSupplier.values)) {
                        olderScope.data.contractSupplier.values = [];
                    } else {
                        olderScope.data.contractSupplier.values = null;
                    }
                }
                if(!_.get($scope.data,"autoPortContract.values") && olderScope.data.contractParentEntityType) {
                    olderScope.data.contractParentEntityType.values = null;
                }
                if(!_.get($scope.data,"autoPortContract.values") && olderScope.data.contractParent) {
                    olderScope.data.contractParent.values = null;
                }
            }
            olderScope.showContractTemplateSaveButton = $rootScope.preSignature.showContractTemplateSaveButton;
            docTreeService.resetServiceVar();
            /** New scope variables end for ux 2.0 layout **/
            ngPopupOlderScope = angular.copy($scope.header);
            setTimeout(()=>{
                if($scope.fromSupplierDropdown && $scope?.globalData?.dynamicFormId) {
                    window.sarc.channelBroadcast("reactDynamicForms", {
                        actionType: "savePartialEditState",
                        payload: {
                            type:'createPatch'
                        }
                    }, `dfSubscriptions_${$scope.globalData.dynamicFormId}`)
                }
            })
        }
        $scope.createLink = undefined;
    };
    // formService
    $scope.applyBasePageJson = function (closeCallBack) {
        $scope.angularPopUp = false;
        $scope.documentOpenWithForm = false;
        if ($scope.searchableFields) {
            return false;
        }
        delete $scope.multiSupplierApi;
        $scope.orderVal = 1;
        $rootScope.showPageFilters = false;
        $(window).resize();
        $window.jsonData = "";
        $window.jsonApi = "";
        isCreate = false;
        angular.element("li[tab] a:visible").closest("#mainContainer").addClass("fixedButtons");
        $scope.originalDataFromServer = null;
        $rootScope.fieldHierarchy = {
            "fields": []
        };
        $rootScope.fieldMapper = {};
        $rootScope.searchText = "";
        $rootScope.metadatasearchPage = false;
        $rootScope.searchableFields = false;
        $scope.supplierCreationTitle = ''
        var closingDialog = false;

        if (angular.isDefined(olderScope.layoutInfo) && angular.isDefined(olderScope.data) && ($scope.modalInstances.length == 0 && !$scope.myModelInstance)) {
            docTreeService.resetServiceVar();
            (function () {
                $scope.toggleAllGroupsVal = 0;
                closingDialog = true;
                if ($scope.globalData) {
                    $scope.setValue("data." + $scope.globalData['currentTimeDependentOn'], undefined);
                }
                entityFactory.fieldsToBeConvertValueToJson = $scope.oldFactory.fieldsToBeConvertValueToJson;
                $scope.currentRelationId = olderScope.currentRelationId;
                $scope.data = olderScope.data;
                $rootScope.data = $scope.data;
                $scope.globalData = olderScope.globalData;
                $scope.header = ngPopupOlderScope;
                $scope.layout = olderScope.layoutInfo.layoutComponent;
                $scope.errors = olderScope.errors;

                $scope.commentFldHavingValidations = olderScope.commentFldHavingValidations;
                $scope.myJson = olderScope;
                $scope.undoDisable = olderScope.undoDisable;
                $scope.falseIds = olderScope.falseIds;
                $scope.errorsFromServer = olderScope.errorsFromServer;
                $scope.shouldIShowFieldErrorsVar = olderScope.shouldIShowFieldErrorsVar;
                $scope.createLink = olderScope.createLink;
                $scope.fileData = olderScope.fileData;
                $scope.showPlusSign = olderScope.showPlusSign;
                $scope.isWorkFlowBug = olderScope.isWorkFlowBug;
                $scope.$formService.buttonMapper = olderScope.buttonMapper;
                olderScope.undoDisable = undefined;
                $scope.versions = olderScope.versions;
                $scope.subScope = olderScope.subScope;
                $scope.showPageUrl = olderScope.showPageUrl;
                $scope.downloadObj = olderScope.downloadObj;
                // Restore stepper component data  
                $scope.isWorkflowCompleted = olderScope.isWorkflowCompleted;
                $scope.isWorkflowProgressbarLoaded = olderScope.isWorkflowProgressbarLoaded;
                $scope.stepperComponentData = olderScope.stepperComponentData;
                $scope.fromExternalUserOld = olderScope.fromExternalUserOld;
                olderScope.fromExternalUserOld = false;
                $scope.fromSupplierDropdownOld = olderScope.fromSupplierDropdownOld;
                olderScope.fromSupplierDropdownOld = false;
                $scope.updatedData = olderScope.updatedData;
                $scope.showStatusInfoProgressBar = olderScope.showStatusInfoProgressBar;
                // Re-mount stepper component if data exists and component should be loaded
                if ($scope.stepperComponentData && $scope.isWorkflowProgressbarLoaded && !_.isEmpty($scope.stepperComponentData.stages)) {
                    setTimeout(() => {
                        $scope.mountWorkFlowComponent($scope.stepperComponentData);
                    }, 100);
                }
                if($scope.showStatusInfoProgressBar){
                    $scope.mountStatusInfoProgressBar($scope.updatedData?.statusInfoMessages?.values);
                }
                $scope.timeLineFeedSecActive = olderScope.timeLineFeedSecActive;
                $scope.commentDataScope = olderScope.commentDataScope;
                $scope.contractDocumentTabUpload = olderScope.contractDocumentTabUpload;
                $scope.showContractUploadStepper = olderScope.showContractUploadStepper;
                showPageService.toShowContractUpload = olderScope.toShowContractUpload;

                /** New scope variables added for ux 2.0 layout **/
                $scope.pageType = olderScope.pageType;
                $rootScope.docViewerTab = olderScope.docViewerTab;
                $rootScope.docViewerTables = olderScope.docViewerTables;
                showPage2DataTransformationService.returnObj.leftTabList = olderScope.leftTabList;
                showPage2DataTransformationService.returnObj.leftTabInfo = olderScope.leftTabInfo;
                showPage2DataTransformationService.returnObj.rightTabInfo = olderScope.rightTabInfo;
                showPage2DataTransformationService.returnObj.allleftTabInfo = olderScope.allleftTabInfo;
                showPage2DataTransformationService.returnObj.selectedTabObj = olderScope.leftTabInfo[0];
                $scope.workFlowButtons = olderScope.workFlowButtons;
                $scope.nonWorkFlowButtons = olderScope.nonWorkFlowButtons;
                docTreeService.contractDocuments = olderScope.contractDocuments;
                docTreeService.selectedContract = olderScope.selectedContract;
                docTreeService.selectedContractId = olderScope.selectedContractId;
                docTreeService.pageType = olderScope.pageType;
                docTreeService.otherFolder = olderScope.otherFolder;
                docTreeService.cdrToContractPorting = false;
                docTreeService.contractToCdrPorting = false;
                docTreeService.showPlaybook = false;
                docTreeService.contractToCdr = false;
                window.htmlEditorList = [];
                if(olderScope.cActions) {
                    $scope.cActions = angular.copy(olderScope.cActions);
                    if($scope.data.entityTypeId.values == 67){
                        $scope.renderActionbuttons();
                    }
                }
                $scope.skipWFStepPopup = olderScope.skipWFStepPopup;
                $rootScope.preSignature.showContractTemplateSaveButton = olderScope.showContractTemplateSaveButton;
                if(angular.element("[name=contractSupplier]").length && _.has($scope.data, "suppliers.values") && $scope.data.suppliers.values.length == 1) {
                    $scope.data.contractSupplier.values = $scope.data.suppliers.values[0];
                }

                if ($scope.pageType == 'show') {
                    if($scope.showInWorkspace) {
                        $scope.expandLeftSection = true;
                    }
                    else {
                        $scope.expandLeftSection = false;
                    }
                }
                $scope.expandLeftSection = olderScope.expandLeftSection;
                // showPageService.manageTimeLineCommentOldScope.call($scope,olderScope,false);

                /** New scope variables end for ux 2.0 layout **/

                $scope.subScope = undefined;
                /* Breadcrumb issue */
                if (angular.isObject(olderScope.data.history) && olderScope.data.history.states && olderScope.data.history.states.length > 0) {
                    for (var k = 0; k < olderScope.data.history.states.length; k++) {
                        olderScope.data.history.states[k]["seqId"] = k;
                    }
                    $scope.actionHistory = {
                        history: olderScope.data.history.states
                    };
                    $scope.zeroStates = false;
                    $scope.breadCrumbObj = olderScope.data.history;
                    $scope.colorStateId = $scope.actionHistory.history[$scope.actionHistory.history.length - 1].seqId;
                    $scope.breadCrumbStateBack($scope.actionHistory.history[$scope.actionHistory.history.length - 1], $scope.breadCrumbObj, 0);

                } else if (angular.isObject(olderScope.data.history) && olderScope.data.history.status) {
                    $scope.zeroStates = true;
                    $scope.actionHistory = {
                        history: olderScope.data.history.status
                    };
                } else {
                    $scope.actionHistory = undefined;
                }
                $scope.invoiceValidationStatusBtn = olderScope.invoiceValidationStatusBtn;
                $scope.invoiceRegenerateBanner = olderScope.invoiceRegenerateBanner
                var isInvoiceViewerActive = olderScope.isInvoiceViewerActive;
                olderScope = {};
                ngPopupOlderScope = {};
                if (!$scope.$$phase) {
                    $scope.$digest();
                }
                setTimeout(function(){
                    if(isInvoiceViewerActive){
                        $scope.loadInvoiceContentHandler(true )
                        isInvoiceViewerActive = null
                    }
                },20)

            })();
        }
        if ($scope.fromExternalUserOld || $scope.fromSupplierDropdownOld) {
            // Parent form may remount after this broadcast; it re-applies the patch on mount while pending.
            if (window.partialPatch) {
                window.partialPatch.restorePending = true;
                setTimeout(function () {
                    if (window.partialPatch) window.partialPatch.restorePending = false;
                }, 2000);
            }
            // Restore UI state first so mandatory toggle survives even if partial-edit patch is absent
            window.sarc.channelBroadcast("reactDynamicForms", {
                actionType: "saveFormUiState",
                payload: { type: 'applyPatch' }
            }, `dfSubscriptions_${$scope.globalData.dynamicFormId}`);
            window.sarc.channelBroadcast("reactDynamicForms", {
                actionType: "savePartialEditState",
                payload: {
                    type: 'applyPatch'
                }
            }, `dfSubscriptions_${$scope.globalData.dynamicFormId}`);
            $scope.fromExternalUserOld = false;
            $scope.fromSupplierDropdownOld = false;
        }
        checkId = {};

        if (!closingDialog && $rootScope.currentController == "contractController" && $rootScope.prevController == "listController") {
            $scope.myJson = {};
        }

        if(($scope.commentDataScope == -1 || !$scope.commentDataScope) && ($scope.timeLineFeedScope == -1 || !$scope.timeLineFeedScope) ){
            $scope.timeLineFeedSecActive = false;
            $scope.expandLeftSection = true;
        }


        if ($rootScope.integrationLayer)
            $scope.renderXMLPage($scope.myJson, $scope.header);
        setTimeout(function () {
            $scope.commentLayout($scope);
            $scope.scrollableView();
            if (closeCallBack) {
                closeCallBack();
            }
            $scope.fromSupplierDropdown = false;
        }, 0);
    };

    $scope.compilePopupHtml = function (popUp, bulkedit) {
        $scope.currentOuterPopup = popUp;
        entityFactory.factoryOuterPopUp = popUp;
        if (bulkedit == true) {
            $rootScope.searchableFields = true;
        } else {
            $rootScope.searchableFields = false;
        }
        $rootScope.fieldHierarchy = {
            "fields": []
        };
        $rootScope.fieldMapper = {};
        $compile($(popUp).contents())($scope);
        $rootScope.bulkedit = true;
        $scope.configOptionFromServer(bulkedit);
    };

    if (window.location.href.indexOf('/listRender/3') != -1) {
        $scope.supplierListingPage = true;
    } else
        $scope.supplierListingPage = false;

    $scope.configOptionFromServer = function (bulkedit) {
        $scope.datepicker = datepicker;
        if ($scope.currentOuterPopup && !bulkedit) {
            $scope.createCloneOfScope();
            $rootScope.bulkedit = false;
        }
        jsonUrl = $scope.jsonApi || $window.jsonApi;
        if (jsonUrl) {
            if (!showPageBulkActionService.isShowPageBulkAction(jsonUrl) && !($scope.showInvoiceUploadDialog && $scope.showInvoiceUploadDialog.visible)) {
                $scope.layout = undefined;
                $scope.data = undefined;
                $scope.header = undefined;
                $scope.validity = {};
                $scope.subScope = undefined;
            }
        }


        if ($window.jsonData) {
            $window.jsonData = $window.jsonData.replace(/\t/g, "  ");
            $window.jsonData = $window.jsonData.replace(/([^\\])(\n)/g, "$1\\\\n");
            if ($.isPlainObject(JSON.parse($window.jsonData))) {
                $scope.summarLayoutPromise.then(function(){
                    $scope.getJson(JSON.parse($window.jsonData), callMethod, entity, true);
                });
            }
        } else if (jsonUrl) {
            $scope.jsonApi = jsonUrl;
            if( $scope.pageType == "globalCreate"){
                var splitedUrl = jsonUrl.split('/');
                $scope.iconClassName= $rootScope.NumToSPClassNameMapping[urlToCodeMapper[splitedUrl[1]]];
                if(window.location.hash == '#/listRender/2'){
                    $scope.iconClassName= $rootScope.NumToSPClassNameMapping['61'];
                }

            }
            $scope.getJson(jsonUrl, callMethod, entity);
        }
        $window.jsonApi = "";

    };
    var dataThatNeedsSpecialHandling = ['stakeHolders'];
    // formService(data)
    var transformData = formService.transformData;

    $scope.loadMiraDocRepository = (jsonUrlOpts) => {
        $scope.setMiraDocRepoScope(true);
    }

    $scope.loadTimelineFeed = (jsonUrlOpts) => {
        let pageType = jsonUrlOpts[1];
        // let pageType = _.get(data,"body.globalData['pageType ']") || _.get(data,"body.globalData.pageType") || _.get(data,"body.globalData['pageType']");
        if($scope.excludeTimelineFeedFor.indexOf(pageType) == -1 && !$scope.angularPopUp ) {
            let entityId = jsonUrlOpts[3],
                entityTypeId = urlToCodeMapper[jsonUrlOpts[2]];
            showPageService.getFeedsData.call($scope,{entityId,entityTypeId}).then(res => {

                const currentUrlOpts = getUrlOpts();
                if(!$scope.showWorkspaceView && currentUrlOpts[3] != entityId)
                    return;

                if(res && res.status == 200 && !res.data.ERROR) {
                    $scope.feedsResponse = res.data.DATA;
                    $scope.feedsResponse.entityTypeId = entityTypeId;
                    $scope.feedsResponse.entityId = entityId;
                    window.sarc.channelBroadcast("clusterHeader",{
                        actionType:'updateNextTaskCardClickable',
                        value: $scope.feedsResponse.isNextTaskCardClickable
                    },'clusterHeaderSubscription')

                    // Below code is required once we get flag from back-end
                    if(!$scope.omitRightPanelToggle) {
                        if($scope.doNotOpenDocTreeByDefault && !$scope.highlightComment){
                            if($scope.showWorkspaceView || $scope.timeLineFeedScope){
                                !$scope.showUploadSection && $scope.setTimelineFeedDataScope(-1,true,1000);
                            }else{
                                const {isCommentBoxAllowed, comment, isNextTaskCardClickable} = $scope.feedsResponse;
                                if(!$scope.showUploadSection && (isCommentBoxAllowed || !_.isEmpty(comment) || isNextTaskCardClickable) && !sessionStorage.getItem("redireactFromEmbedded") && !window.location.href.includes("envelopeId")) {
                                    $scope.expandLeftSection = false;
                                    if(!$rootScope.enableChatBot || !conditionCheck?.isValidShowPage()) {
                                       $scope.setTimelineFeedDataScope(1,true,1000);
                                    }
                                }else if(sessionStorage.getItem("redireactFromEmbedded") && !window.location.href.includes("envelopeId")){
                                    window.sarc.channelBroadcast("reactDynamicForms", {
                                        payload:null,
                                        actionType:"openSignatureFeedCard"
                                    },"reactToAngular");
                                }
                            }
                            $scope.showUploadSection && $scope.handleUploadSectionVisibility(true);
                        } else if ($scope.highlightComment) {
                            const url = window.location.hash.split("?");
                            const subCategory = url.length>1 ? url[1].split('&'): [];
                            const commentHighlightProps = {
                                commentId: subCategory[0].split("=")[1],
                                parentCommentId: subCategory[1].split("=")[1],
                                isChildComment: subCategory[2].split("=")[1]
                            };
                            $scope.setCommDataScope(1, false, false, commentHighlightProps);
                        }
                    }
                    if(!$scope.feedsResponse.isCommentBoxAllowed && !$scope.feedsResponse.isNextTaskCardClickable)
                        $scope.hasTimeLineFeed = false;
                }else $scope.hasTimeLineFeed = false;

                if(!$scope.hasTimeLineFeed && entityTypeId == 160) {
                    showPageService.getFeedCardList.call($scope,{entityId,entityTypeId}).then(res => {
                        if(res) {
                            $scope.hasTimeLineFeed = res;
                            if( !$scope.showUploadSection && !sessionStorage.getItem("redireactFromEmbedded") && !window.location.href.includes("envelopeId")){
                                if(!conditionCheck?.isValidShowPage() || !$rootScope.enableChatBot ) {
                                    $scope.setTimelineFeedDataScope(1,true,1000);
                                }
                            }else if(sessionStorage.getItem("redireactFromEmbedded") && !window.location.href.includes("envelopeId")){
                                window.sarc.channelBroadcast("reactDynamicForms", {
                                    payload:null,
                                    actionType:"openSignatureFeedCard"
                                },"reactToAngular");
                            }
                        }
                    })
                }
            });
        }
    }

    $scope.checkCommentRightSection = (hasCommunicationSec) => {
        const hasCommunicationTab = !!hasCommunicationSec;
        const permissionChanged = $scope.hasCommunicationTab !== hasCommunicationTab;
        $scope.hasCommunicationTab = hasCommunicationTab;
        if (permissionChanged && $scope.stepperComponentData && $scope.mountWorkFlowComponent) {
            $scope.mountWorkFlowComponent($scope.stepperComponentData);
        }
        if($scope.isNewUX && $scope.isCreateRoute) {
            if(hasCommunicationSec) {
                $scope.hasCommunicationSec = true;
                $scope.showCommentPanelInRightSec = true;
                $scope.fixedCommentPanel = $scope.showCommentPanelInRightSec;
                $rootScope.hideCommentToggle = true;
                if($scope.commentDataScope != 1){
                    $scope.setCommDataScope(1, null, true);
                }
            }else $scope.fixedCommentPanel = true;
        }

    }

    $scope.getTagMetadata = function (tag, data) {
        const {signatureTabToIconMap,validSignatureTabs} = getIconAndValidTabsMapper();
        let roleId, recipientRoleType ;
        // logic to get role name, tag icon class and information about signature tag
        let currentTagClass = null, currentTagInfo = null, tagRoleName = null;
        data?.signatureData?.values?.recipients?.map(item => { // looping through all type of roles
            for (const tabName in item?.tabs) { // looping through tabs to get desired tab name
                if (validSignatureTabs.includes(tabName)) { // checking if tab name is valid
                    const tab = item?.tabs[tabName];
                    if (Array.isArray(tab)) {
                        tab.forEach(d => { // looping through tabs to get various info about the tag
                            if (d?.customTabId == tag.id) {
                                currentTagClass = tabName;
                                currentTagInfo = d;
                                tagRoleName = item?.role;
                                roleId = item.roleGroupId;
                                recipientRoleType = item.recipientRoleType
                                return d;
                            }
                        });
                    }
                }
            }
        });
              
        
        return {icon : signatureTabToIconMap?.[currentTagClass]?.icon || "icon-Initiate-Signature", role : tagRoleName, tabName : currentTagClass, locked : currentTagInfo?.locked,  required : currentTagInfo?.required,  optional : currentTagInfo?.optional, roleId: roleId, recipientRoleType:recipientRoleType };
    }

    $scope.getIconClass = function (tagName) {
        return $scope.iconClassNameMap?.[tagName] || "icon-Initiate-Signature";
    }

    $scope.updateSignatureTagForPlugin = (tempElm, data) => {
        const signatureTags = [];
        //getting all tags which are of signature type
        data?.body?.data?.clauseTags?.values?.forEach(tag => {
            if(tag.tagType === "SignatureTag") {
                signatureTags.push(tag);
            }
        })
        signatureTags.forEach(tag => {
            const el = tempElm.querySelector(`.tag_${tag.id}`),
                name = tag?.name?.split(/ (.*)/),
                initial = name[0].replace("[","").replace("]",""),
                id = el?.getAttribute('id')
                const {icon, role, tabName, locked, required, optional} = $scope.getTagMetadata(tag, data?.body?.data);
                if(el?.getAttribute("roleName")){
                    return;
                }
                const iconName = icon;
           if(el){
             //adding attributes to the signature tag
             el.setAttribute('rolename',role);
             el.setAttribute('iconClass',iconName);
             el.setAttribute('logoinitial',initial);
             el.setAttribute('id',id);
             el.setAttribute('tabname',tabName);
             el.setAttribute('d-optional',optional || null);
             el.setAttribute('d-required',required || null);
             el.setAttribute('d-locked',locked || null);
             el.classList.add("role_tag");
             
             let htmlbefore = "";
             el.querySelectorAll("span").forEach(span => {
                 if(span.innerText.includes(tag.name)){
                     htmlbefore = span.innerText.slice(0,-1).split(/(?<=\])(.*)/).filter(Boolean);;
                 }
             })
 
             /*
             * below code is for changing the HTML text to from clause tag to signature tag 
             * so that logic can be applied in the similar way as it was working before
             * 
             * Making structural changes similar to the HTML structure below
             *     <span style="display:none">${34398: </span>
             *     <span></span>
             *     [CS]
             *     <span class="tag-text"> Signature</span>
             *     <span style="display: none;">}</span>
             */ 
             const emptySpanParent = document.createElement("span");
             emptySpanParent.classList.add("parent");
 
             //create span supporting signature tag
             const childElement1 = document.createElement("span");
             childElement1.style.display = "none";
             const tempStr = "${";
             childElement1.innerHTML = `${tempStr}${id}:`;
             const roleText = htmlbefore[0];
             const textNode = document.createTextNode(roleText)
             el.appendChild(textNode);
 
             //create childElement2 for signature tag
             const childElement2 = document.createElement("span");
             childElement2.classList.add("tag-text");
             childElement2.innerHTML = htmlbefore[1];
             el.insertBefore(childElement2, textNode.nextSibling);

             //create childElement3 for signature tag
             const childElement3 = document.createElement("span");
             childElement3.style.display = "none";
             childElement3.innerHTML = "}";
             el.insertBefore(childElement3, childElement2.nextSibling);
             
             //create reqElementSpan for signature tag in case of required is true
             const reqElementSpan = document.createElement("span");
             if(optional == "false"){
                reqElementSpan.classList.add("required");
                reqElementSpan.innerHTML = "*";
                el.insertBefore(reqElementSpan, childElement2.nextSibling);
             }
             //handling for replace html with something else
             el.querySelectorAll("span").forEach(span => {
                 if(span.innerText.includes(tag.name)){
                     span.innerHTML = emptySpanParent.innerHTML;
                 }
             })
 
             //remove inline css if it exists
             el.querySelectorAll("span")[1].removeAttribute('style');
           }
        })
        return tempElm;
    }

    const alterBackEndResponse = (data) => {
        /*
        * @todo showpage_2.5 | Temporary fix. Need to be done by back end team
        * */
        const source = _.get(data,"header.source");
        const response = data?.header?.response;
        if(response?.errorMessage && $scope.isNewUX && $scope.isCreateRoute && _.isUndefined(response.redirect) && _.isUndefined(response.redirectTo)) {
            response.redirect = true;
        }

        if(source && !!$scope.exceptionalInNewUx.popupToBasic.find(str=> source.indexOf(str) > -1)) {
            data.header.response.type = 'basic';
        }
        if($scope.isCreateRoute && !$scope.exceptionalInNewUx.crudPage && !$scope.fromSupplierDropdown) {
            const actions = _.get(data,"body.layoutInfo.actions");
            if(actions) {
                let cancelBtn = _.find(actions,action => action.cancelType);
                const hasCancelBtn = !!cancelBtn;
                if(!hasCancelBtn)
                    cancelBtn = SirionUtils.getCancelBtnLayout();
                cancelBtn.properties.onClick.success = "directNonAjax";
                cancelBtn.api = sessionStorage.getItem('previousURL') || cancelBtn.api;

                !hasCancelBtn && actions.push(cancelBtn);
            }
        }
        if(_.get(data.body,"data.clauseText.values.htmlText")){
            const htmlText = _.get(data.body,"data.clauseText.values.htmlText");
            let domParse = new DOMParser();
            let doc = domParse.parseFromString(htmlText, 'text/html');
            doc = $scope.updateSignatureTagForPlugin(doc, data);
            data.body.data.clauseText.values.htmlText = doc.body.innerHTML;
        }
        $scope.isClonePage = !!(window.location.href.indexOf('/clone/') > -1);
        if($scope.isCommonRouteCrudPage && $scope.isClonePage)
            $scope.pageType = "clone";

        $scope.showAmendment = JSON.parse(sessionStorage.getItem('showAmendment') || null);
        $scope.multiSupplierApi = sessionStorage.multiSupplierApi;
        $scope.contractNewApi = sessionStorage.contractNewApi;
        if($scope.contractNewApi || $scope.multiSupplierApi) {
            sessionStorage.removeItem('contractNewApi');
            sessionStorage.removeItem('multiSupplierApi');
            sessionStorage.removeItem('api');
        }
        docTreeService.contractToCdrPorting = $scope.showAmendment;
        docTreeService.cdrToContractPorting = JSON.parse(sessionStorage.getItem('cdrToContractPorting'));
        docTreeService.cdrToContractField = JSON.parse(sessionStorage.getItem('cdrToContractField'));
        $scope.selectContractId = sessionStorage.selectedContractId;
        if(!['applicationError', 'validationError'].includes(_.get(data,"header.response.status")) && _.get( data, 'body.layoutInfo.layoutComponent.fields.length')) {
            $scope.exceptionalInNewUx.pageWithoutGeneralTab = $scope.showRawDataPopup?.visible ? false : !_.find( _.get( data, 'body.layoutInfo.layoutComponent.fields' ), ['type', 'basic'] );
        }

        if(response?.properties?.notification?.includes('/show/tblcdr')) {
            $rootScope.showRefresh = {
                entityId: response.entityId
            }
        }
        if(window.location.href.includes('/show/tblcontractdocuments/')) {
            const entityPath = listIdToEntityDataMapper[entityTypeIdToListIdMapper[_.get(data, 'body.data.parentEntityTypeId.values')]].url;
            const parentEntityId = _.get(data,'body.data.parentEntityId.values');
            const idsList = [_.get(data, 'body.data.id.values'),_.get(data, 'body.data.aeDocumentId')]
            $scope.showPageEntityUrl = addtStamp(`#/show/${entityPath}/${parentEntityId}`);
            $scope.summaryViewEntityUrl = SirionUtils.addParameterToUrl(`#/show/${entityPath}/${parentEntityId}`,['docId','aeDocId'],idsList);
            $scope.isAutoExtractionDocId = SirionUtils.getParameterValueFromURL($scope.summaryViewEntityUrl,"aeDocId");
            const callFn = () => window.sarc.channelBroadcast("askMira",{actionType:'resetAskMira'},'askMiraSubscription');
            SirionUtils.sarcChannelExecutionar("askMira",callFn);
        }
        if(conditionCheck.isValidShowPage()) {
            const callFn = () => window.sarc.channelBroadcast("askMira",{actionType:'initShowPage'},'askMiraSubscription');
            SirionUtils.sarcChannelExecutionar("askMira",callFn);
        }
    }

    $scope.checkConditionToOpenMiraFromConvoSearch = function () {
        const ifUrlContainsAEdocId = $scope.summaryViewEntityUrl.includes('aeDocId');
        const isRoutedFromConvoSearch = JSON.parse(localStorage.getItem("corpusDocViewerContinuation"));
        isRoutedFromConvoSearch && localStorage.removeItem("corpusDocViewerContinuation");
        return ifUrlContainsAEdocId && isRoutedFromConvoSearch;
    }

    function shouldOpenMiraFromDocTree() {
        const fromDocTree = SirionUtils.getParameterValueFromURL(window.location.href, 'fromDocTree');
        if(fromDocTree) {
            window.history.replaceState(null, "", SirionUtils.removeURLParameter(window.location.href, 'fromDocTree'));
            return SirionUtils.getParameterValueFromURL($scope.summaryViewEntityUrl, 'aeDocId');
        } else return false; 
    }

    $scope.checkSendForDigitalSignature = function(shouldTriggerEsignFlow = false) {
        var jsonUrlOpts = getUrlOpts();
        if ([63,80,160].includes(urlToCodeMapper[jsonUrlOpts[2]]) && jsonUrlOpts[3]) {
            const params = {
                entityId: jsonUrlOpts[3],
                entityTypeId: urlToCodeMapper[jsonUrlOpts[2]]
            };
            const url = `/esign/sendForDigitalSignature/v2?${new URLSearchParams(params).toString()}`;
            const checkSendForDigitalSignatureCall = entityFactory.getJson(url, "GET");
            checkSendForDigitalSignatureCall.success(function (res) {   
                $scope.esignUserAuthFlowPermitted = res.data.esignUserAuthFlowPermitted;
                $scope.sendForDigitalSignature = res.data.sendForDigitalSignature;
                $scope.launchViewEnabled = res.data.launchViewEnabled;
                if (shouldTriggerEsignFlow) {
                    if ($scope.esignUserAuthFlowPermitted) {
                        $scope.esignUserAuthFlow();
                    } else {
                        delete $scope.integrationId;
                        delete $scope.docuSignErrorMessage;
                        delete $scope.docuSignRedirectUri;
                    }
                }
            });
        }
    }

    $scope.esignUserAuthFlow = function() {
        const shortCodeId =  $scope.data?.shortCodeId?.values;
        if(!shortCodeId) {
            return;
        }
        var jsonUrlOpts = getUrlOpts();
        if ([63,80,160].includes(urlToCodeMapper[jsonUrlOpts[2]]) && jsonUrlOpts[3]) {
            const params = {
                entityId: jsonUrlOpts[3],
                entityTypeId: urlToCodeMapper[jsonUrlOpts[2]],
                ...(shortCodeId && {clientSeqId: shortCodeId}),
                ...(($rootScope.parentFldIds[0]?.parentFieldId != null) && { parentFieldId: $rootScope.parentFldIds[0].parentFieldId }),
                ...(($rootScope.parentFldIds[0]?.parentFieldOptionId != null) && { parentFieldOptionId: $rootScope.parentFldIds[0].parentFieldOptionId })
            };

            const url = `/esign/login-details?${new URLSearchParams(params).toString()}`;
            const esignUserAuthFlowPermission = entityFactory.getJson(url, "GET");
            esignUserAuthFlowPermission.success(function (res) {
                $scope.integrationId = res.data.integrationId;
                $scope.docuSignErrorMessage = res.data.message;
                $scope.docuSignRedirectUri = res.data.userLoginRedirectUrl;
            });
        }
    }

    $scope.getJson = function (jsonUrl, callMethod, entity, noServerCall, dataBody, wrapInsideBody) {
        if(sessionStorage.getItem('refreshePageWithWfId')) {
            window.location.replace(window.location.href.split("?")[0]);
            sessionStorage.removeItem('refreshePageWithWfId');
        }
        if($scope.showWorkspaceView && $scope.listId == 279) { // for cdr Detailed view 
            const cdrId = $scope.workSpaceCurrentListUrl.split('/').pop()
            $scope.getHeadContractDoc(cdrId);
        }
        if(window.location.href.indexOf("tblcdr") > -1 && jsonUrl.indexOf("cdr/edit") == -1 && !$rootScope.externalContract) {
            $scope.getHeadContractDoc();
        }
        if (noServerCall || jsonUrl == "/contracttemplate/show/first") {
             startLoader();
            $scope.processData(jsonUrl);
        } else {
            $scope.jsonApi = jsonUrl;
            var jsonUrlOpts = getUrlOpts();
            if($scope.showInWorkspace){
                jsonUrlOpts = $scope.showInWorkSpaceData.jsonOptUrlLink;
                if(jsonUrlOpts[0]=="#")
                    jsonUrlOpts[0]="";
            }
            //in case of other folder, posting two values actual parent and parent ids
            if ($rootScope.stagingTreeVal && $rootScope.integrationLayer) {
                jsonUrl = jsonUrl + "?parentEntityTypeId=" + $rootScope.stagingTreeVal.parentEntityTypeId;
                if ($rootScope.stagingTreeVal.parentContractEntityId != "undefined" && $rootScope.stagingTreeVal.parentContractEntityId != "null" && $rootScope.stagingTreeVal.parentContractEntityId != null) {
                    jsonUrl = jsonUrl + "&parentEntityId=" + $rootScope.stagingTreeVal.parentContractEntityId;
                } else {
                    jsonUrl = jsonUrl + "&parentEntityId=" + $rootScope.stagingTreeVal.parentEntityId;
                }
                jsonUrl = jsonUrl + "&actualParentEntityId=" + $rootScope.stagingTreeVal.parentEntityId;
            }
            if ($scope.bulkedit) {
                let dataToPost;
                if (typeof BU !== "undefined" && BU.buildPayload) {
                    dataToPost = BU.buildPayload();
                    dataToPost.listId = Number($scope.listId || window.listId);
                } else {
                    dataToPost = { entityIds: (Array.isArray(window.checkedVal) ? window.checkedVal : []), selectAll: false, filterMap: (typeof window.filterDataJson !== "undefined" ? window.filterDataJson : {}), listId: Number($scope.listId || window.listId) };
                }
                var listCtxForBulkCreate = SirionUtils.getListingBulkContextParamsFromHash();
                if (listCtxForBulkCreate && jsonUrl.indexOf("/bulkedit/create") > -1) {
                    dataToPost.contractId = listCtxForBulkCreate.contractId;
                    dataToPost.relationId = listCtxForBulkCreate.relationId;
                    dataToPost.vendorId = listCtxForBulkCreate.vendorId;
                }
                if (jsonUrl.indexOf("/bulkedit/create") > -1) {
                    var parentForBulkSubmit = SirionUtils.getBulkEditParentEntityContextFromListing(jsonUrl, { skipStash: true });
                    if (parentForBulkSubmit) {
                        $rootScope.bulkEditSubmitParentEntity = {
                            parentEntityTypeId: parentForBulkSubmit.parentEntityTypeId,
                            parentEntityId: parentForBulkSubmit.parentEntityId
                        };
                    } else {
                        delete $rootScope.bulkEditSubmitParentEntity;
                    }
                }
                if (SirionUtils.mergeListingBulkContextIntoPayload) {
                    SirionUtils.mergeListingBulkContextIntoPayload(dataToPost);
                }
                startLoader();
                $scope.bulkEntityId = dataToPost;
                getData = entityFactory.getJson(jsonUrl, "POST", entity, dataToPost, false);
            } else {
                const isShowApi = ['contracts/show','relations/show'].some(item => jsonUrl.includes(item));
                window.entityURLdata = jsonUrl;
                startLoader();

                /** sirion ui2.0 changes : addition of new query param to get the expected layout as per new design */
                var entityNameArray = [ "tblcontracts","tblrelations","tbldnoes","tblchilddnoes","tblslas","tblchildslas","tblgovernancebody",  "tblgovernancebodychild","tblactionitemmgmts","tblissuemgmts","tblservicedataconsumptions","tblbaseinvoice","tblinvoicelineitem","tblcontractservicedatas", "tblcontractintpns","tblworkorderrequest" ,"tblpos","tblvendors","tblcdr","tblclause","tblcontracttemplate","contracttemplate","tblcontracttemplatestructure","tbldisputemgmts","changerequests","clause","tblcontractratecards"];
                var version = false;
                if (!isCreate && ( entityNameArray.indexOf($routeParams.entityName) > -1 ) ||
                    ( $scope.showInWorkspace && entityNameArray.indexOf($scope.showInWorkSpaceData.jsonOptUrlLink[2]) > -1 ) ||
                    jsonUrl.indexOf("governancebodyFreeCreate") > -1 ) {
                    version = true;
                }else if (isCreate || $scope.pageType=='globalCreate' || ($scope.isNewUX && $scope.isCreateRoute && !$scope.exceptionalInNewUx.crudPage)) {
                    entityFactory.entityNameMapper.forEach(function (d) {
                        if (d.version2 == true && jsonUrl.indexOf(d.apiName + "/") > -1) {
                            version = true;
                        }
                    });
                }

                version && (jsonUrl = jsonUrl.indexOf('?')<0? jsonUrl + "?version=2.0":jsonUrl + "&version=2.0");

                //checking if workflowId is present or already appended, not appending wf_id for '*/show' api.
                // Don't append workflowId if isSupplierCreationAllowed is set to true
                if($rootScope.createForWorkflowId && jsonUrl.indexOf($rootScope.createForWorkflowId) == -1 && !isShowApi && !_.get($scope, 'globalData.isSupplierCreationAllowed')){
                    jsonUrl = SirionUtils.updateQueryStringParameter(jsonUrl, 'workflowId', $rootScope.createForWorkflowId);
                    delete $rootScope.createForWorkflowId;
                }

                if (_.has(window, "summaryLayout.body.summaryViewLayout") && jsonUrl.indexOf("/show/") > -1 && urlToCodeMapper[jsonUrlOpts[2]] && !$rootScope.templateSuggestionPage) {

                    // Request for getting the data object of summary section of current show page

                    var summaryLayout = window.summaryLayout.body.summaryViewLayout[urlToCodeMapper[jsonUrlOpts[2]]];
                    if (summaryLayout && typeof parseInt(jsonUrlOpts[3]) == "number") {
                        $scope.showPagePreloader = true;
                        var apiUrl = apiVersioning.getApiDynamicVersion("summarydata") + urlToCodeMapper[jsonUrlOpts[2]] + "/" + jsonUrlOpts[3] + "/show";
                        var getSummaryData = entityFactory.getJson(apiUrl, "GET");
                        !$scope.showWorkspaceView && showPageService.logAjaxCall(getSummaryData);
                        getSummaryData.success(function (response) {
                            if(_.has(response, "header.response.status") && response.header.response.status == "applicationError"){
                                return;
                            }
                            if($scope.showPagePreloader && response && response.body && response.body.data && (response.body.data != null || response.body.data != undefined)){
                                response.body.data.summaryData = true;
                                var summaryObj = $scope.populateSummaryPreloadLayout(response);
                                $scope.processData(summaryObj, true);
                                try{
                                    $scope.summaryObj = summaryObj.body.layoutInfo.layoutComponent.fields[0].fields[0];
                                } catch (e){

                                }
                                showPageService.preventLabelClick();
                            }else{
                                $scope.noSummaryGroup = true;
                                $scope.showExpandAllInHeader=true;
                            }
                        });
                    }
                }
                if( jsonUrl.indexOf("/clause/new?version=2.0" ) > -1 ){
                    var urlParams = SirionUtils.getQueryParam(window.location.hash);
                    var clauseIdParam = urlParams && urlParams['clauseId'];
                    if(!SirionUtils.isEmpty(clauseIdParam)){
                        jsonUrl = jsonUrl.replace("/new","/newClause/"+clauseIdParam);
                        jsonUrl = SirionUtils.updateQueryStringParameter(jsonUrl,"clauseId",clauseIdParam);
                        jsonUrl = SirionUtils.updateQueryStringParameter(jsonUrl,"mobileView",true);
                    }
                }
                try {
                    $scope.showPageUrl = jsonUrl;
                    SirionUtils.startInfiniteLoader();
                    getData = entityFactory.getJson(jsonUrl, callMethod, entity, dataBody, wrapInsideBody);
                    !$scope.showWorkspaceView && showPageService.logAjaxCall(getData);
                    if(window.conditionCheck.isValidSignShowPage()) {
                        $scope.checkSendForDigitalSignature();
                    }
                }catch (e) {
                    SirionUtils.stopInfiniteLoader();
                }
                if(!(window.location.hash.indexOf('EntityId')>-1)){
                    filterService.updateThroughJourney(false);
                }

                if($scope.exceptionalInNewUx.crudPage) {
                    const entityName = SirionUtils.getEntityTypeFromUrl();
                    $scope.boxTitle = _.get(urlToEntityDataMapper, `[${entityName}].headerLabel`);
                    if (entityName === 'clause' || entityName === 'tblclause') {
                        $scope.boxTitle = intl_msg[23350] || 'Create Clause';
                    } else if (entityName === 'tblcontracttemplate') {
                        $scope.boxTitle = intl_msg[8248] || 'Create Template';
                    }
                }

                if (jsonUrl == "/clause/new" || jsonUrl.indexOf('contracttemplate/new') >= 0) {
                    clauseReq = getData;
                    clauseDefer.resolve();
                }
            }
            getData.success(function (data) {
                const suppName = data?.body?.data?.vendor?.values?.name;
                const globalDataPageType = data?.body?.globalData["pageType "];
                if(suppName){
                    $scope.supplierCreationTitle = intl_msg[35458]?.replace( "%s", suppName) || `Create Supplier From ${suppName}`;
                }else{
                    $scope.supplierCreationTitle = $scope.titlebartext || intl_msg[35457] || 'Create Supplier';
                } 
                if(olderScope.fromExternalUserOld && globalDataPageType == 3){
                    $scope.isStakeHolderInlineEdit = true;
                    $scope.hideCrossModalButton = true;
                    $scope.dynamicPageTitle = "Edit External Contact";
                }
                else{
                    $scope.hideCrossModalButton = false;
                }
                // data.body.data.statusInfoMessages = ["Progressing", "This is a message 2", "This is a message 3", "This is a message 4"];

                $scope.showStatusInfoProgressBar = data?.body?.data?.statusInfoMessages?.values?.length >= 2;   
                
                if($scope.showStatusInfoProgressBar) {
                    window._lastToastStatus = data?.body?.data?.status?.values?.name || null;
                    $scope.mountStatusInfoProgressBar(data.body.data?.statusInfoMessages?.values);
                }
                if(data?.body?.data?.clauses?.values?.length && jsonUrl.includes('/contracttemplate/')) {
                    let selectedMandatoryCategoryIds = [];
                    data.body.data.clauses.values.forEach((obj) => {
                        if (!obj.definition && ( obj.mandatory === "true" || obj.mandatory === true) ) {
                            selectedMandatoryCategoryIds.push(obj.categoryId);
                        }
                    });
                    $rootScope.preSignature.selectedMandatoryCategories = _.uniq(selectedMandatoryCategoryIds).length;
                }
                if($rootScope.bulkedit && _.has(data, 'body.layoutInfo.layoutComponent.fields')){
                    const isBulkEditConfigured = data.body.layoutInfo.layoutComponent.fields.filter(field => field.type === 'basic');
                    if(_.isEmpty(isBulkEditConfigured)){
                        Toaster.create(intl_msg[35401] || "No field(s) configured for Bulk Edit.",{iconClass:"icon-Information_filled"});
                        $rootScope.myModelInstance.close();
                        delete $rootScope.bulkedit;
                        BU.hideBulkDropDown('bulkPlaceHolderListParent','bulkPlaceHolderLi');
                        return;
                    }
                }
                $scope.hideWorkspaceShowpage = false;
                window.sessionStorage.removeItem('postDataForWL');
                if(sessionStorage.getItem('wfFreeFormAPI'))
                    window.sessionStorage.setItem('api',sessionStorage.getItem('wfFreeFormAPI'));
                SirionUtils.stopInfiniteLoader();
                if(jsonUrl.includes('show') && $scope.showInWorkspace && $scope.adjustPaginationEllipsis) {
                    $scope.adjustPaginationEllipsis();
                }
                $('#ajaxcalloading').removeClass('always_visible');
                const response = data.header.response;
                alterBackEndResponse(data);
                if(response.errorMessage){
                    SirionUtils.handleExceptionErrors(response, $scope.isCreateRoute);
                    if($scope.showBulkEditDialog) $scope.showBulkEditDialog.visible = false;
                    $("body").removeClass("overRideLoading");
                    return;
                }
                if($scope.isNewUX && $scope.isCreateRoute) {
                    $("body").removeClass("overRideLoading");
                    if (!$scope.exceptionalInNewUx.crudPage)
                        $scope.pageType = "globalCreate";
                }

                if(_.has(data,'body.data.category')){
                    $scope.clauseCategory = _.get(data,'body.data.category.values');
                }
                if(_.has(data,'body.data.clauseText')){
                    window.clauseTextChange = false;
                    data.body.data._clauseText = _.get(data,'body.data.clauseText');
                }
                if(_.has(data,'body.data.id')){
                    $scope.clauseId = _.get(data,'body.data.id.values');
                }
                if(_.has(data,'body.globalData.workflowId')){
                    sessionStorage.setItem("wf_id", _.get(data,'body.globalData.workflowId'))
                }
                if (_.has(data, 'body.layoutInfo.layoutComponent.fields')){
                    checkUploadDocAllowed(data);
                    // If Comm Panel Exists
                    const commTab = _.find( _.get( data, 'body.layoutInfo.layoutComponent.fields' ), ['type', 'communicationTab'] );
                    $scope.checkCommentRightSection(!!commTab);

                    // If edit Template call

                    //  add check of values later data.body.data.contractTemplateLockInfo.values
                    if(_.get(data.body.data.contractTemplateLockInfo,'values')){
                        let contractTemplateLockedInfo = data.body.data.contractTemplateLockInfo.values;
                        //here update the lockedClauseIds and lockedTagIds array when recieved in response;
                        $scope.lockedClauseIds = contractTemplateLockedInfo.lockedClauseIds || [];
                        $scope.lockedTagIds =  contractTemplateLockedInfo.lockedTagIds || [];
                        $scope.lockedPricingTableNames = contractTemplateLockedInfo.lockedPricingTableNames || [];
                        _.forEach(data.body.data.clauses.values,clause =>{
                            contractTemplateLockedInfo.lockedClauseIds.indexOf(clause.clause.id) !== -1 ?  clause.isLocked = true : false;
                        })
                    }


                    $scope.initializeCommentValidations(data);
                    if(commTab && commTab.fields.length > 0 && !isCreate){
                        showPageService.showCommPanelNotification.call($scope, jsonUrlOpts);
                    }else $scope.rightPanelAvailable = false;

                    $scope.hasTimeLineFeed && ($scope.rightPanelAvailable = $scope.hasTimeLineFeed);

                    if(!$scope.rightPanelAvailable) {
                        let selector = ".active-index-" + showPage2DataTransformationService.returnObj.selectedTabIndex;
                        $(selector).css("width","100%");
                    }

                    // For AE showpage only
                    if($scope.aeDocShowPage){
                        window.sarc.channelBroadcast('aeShowPage', data.body.layoutInfo.layoutComponent.fields, "layoutTabs");
                        $scope.autoExtractionFields = data.body.layoutInfo.layoutComponent.fields;
                        $scope.autoExtractionActions = data.body.layoutInfo.actions;
                    }
                }
                // @Todo This is a temporary fix for UI-14145
                if($scope.isClauseShowPage && _.has(data,"body.data")) {
                    $scope.clauseShowPage = true;
                    $scope.actualClauseTags = angular.copy(data?.body?.data?.clauseTags);
                }
                $scope.initialClauseTags = angular.copy(data?.body?.data?.clauseTags);

                $scope.showPagePreloader = false;
                if(_.has(data, "header.source") && data.header.source.indexOf("uploadinvoicecopy") > -1 && $scope.showInvoiceUploadDialog && !$scope.showInvoiceUploadDialog.visible) {
                    return;
                }
                if($rootScope.metadatasearchPage){
                    startLoader();
                }

                if(data?.body?.data?.id) {
                    let fetchLoclListOptUrl= showPageService.getLocalListingURL(urlToCodeMapper[jsonUrlOpts[2]],jsonUrlOpts[3]);
                    let previousCopyOfRelationsID = null;
                    $scope.getLocalListingLinks = (nameProp, valProp)=>{
                        if(nameProp === "localListingSwitch" && valProp && previousCopyOfRelationsID !== jsonUrlOpts[3] ){
                            previousCopyOfRelationsID = jsonUrlOpts[3];
                            $rootScope.lazyLoadForLocalListing = true;
                            showPageService.localListingList = null;
                            showPageService.showNoData = false;
                            entityFactory.getJson(fetchLoclListOptUrl, "GET").then(function(res){
                                if(_.isEmpty(res)) throw res;
                                if(res && urlToCodeMapper && urlToCodeMapper[jsonUrlOpts[2]]
                                    && showPageService.isLocalListingPermissible( urlToCodeMapper[jsonUrlOpts[2]]) ){
                                    $scope[nameProp] = valProp;
                                    showPageService.setLocalListingSwitchData(res);
                                    if (!$scope.$$phase) {
                                        $scope.$digest();
                                    }
                                }
                            }).catch(function(err){
                                $rootScope.lazyLoadForLocalListing = false;
                                showPageService.showNoData = true;
                                $scope[nameProp] = valProp;
                                if (!$scope.$$phase) {
                                    $scope.$digest();
                                }
                            });
                        }else{
                            $scope[nameProp] = valProp;
                        }
                    }
                }
                if($rootScope.isAEProjectShowPage && _.has(data, "body.layoutInfo")){
                    $scope.pageType = 'show';
                    showPageService.renderActionButtons.call($scope,data.body.layoutInfo.actions,showPage2DataTransformationService);
                    setTimeout(() => {
                        $scope.cActions=data.body.layoutInfo.actions;
                        window.sarc.channelBroadcast("reactDynamicForms", {
                            actionType: "updateAdditionalData",
                            payload: window.createRDFSecObj($scope)
                        },`dfSubscriptions_${$scope.globalData.dynamicFormId}`);
                    },0)
                }
                if (jsonUrlOpts && _.has(data, "header.source")
                    && data.header.source.indexOf("/show/") > -1
                    && !$rootScope.templateSuggestionPage
                    && !$rootScope.isAEProjectShowPage
                    && urlToCodeMapper[jsonUrlOpts[2]] || ($scope.aeDocShowPage && $rootScope.isWorkFlowTriggered)) {
                    //Requesting and rendering of action
                    if(_.has(data,"body.data.hideContractTree.values")){
                        $scope.showDocTree = false;
                        $scope.isdocTreeVisible();
                    }
                    if(!jsonUrlOpts[3]){
                        window.systemWarning(jsonUrlOpts, "all options not found");
                        return ;
                    }
                    if($scope.aeDocShowPage || $scope.isAEContractPage) jsonUrlOpts[2] = "autoExtraction";
                    $scope.isAEContractPage && (jsonUrlOpts[3] = $scope.docId);
                    const actnGETUrl = apiVersioning.getApiDynamicVersion("actions") + urlToCodeMapper[jsonUrlOpts[2]] + "/" + jsonUrlOpts[3];
                    const createLnkGETUrl = apiVersioning.getApiDynamicVersion("createlinks") + urlToCodeMapper[jsonUrlOpts[2]] + "/" + jsonUrlOpts[3];
                    const nwfInfoUrl =  addtStamp('/workflow/v1/action/owner/'+urlToCodeMapper[jsonUrlOpts[2]]+'/'+jsonUrlOpts[3],true);

                    $scope.actionDataLoader = true;
                    var getActions = entityFactory.getJson(actnGETUrl, "GET");
                    var getCreateLinks = entityFactory.getJson(createLnkGETUrl, "GET");

                    $scope.getWFActionsUrl = workflowVersioning.createWorkflowVersioningUrl(apiVersioning.createApiVersioningUrl(actnGETUrl));
                    $scope.getWFLinksUrl = workflowVersioning.createWorkflowVersioningUrl(apiVersioning.createApiVersioningUrl(createLnkGETUrl));

                    var requestArr = [getActions, getCreateLinks];
                    /*if( urlToCodeMapper && urlToCodeMapper[jsonUrlOpts[2]]
                        && showPageService.isLocalListingPermissible( urlToCodeMapper[jsonUrlOpts[2]]) ){
                        requestArr.push( getLocalListingLinks);
                    }*/
                    if(!$scope.aeDocShowPage){
                        var wfStepIndex = requestArr.length;
                        var getNWFStepInfo = entityFactory.getJson(nwfInfoUrl, "GET");
                        // requestArr.push( getNWFStepInfo);
                        getNWFStepInfo.success((response)=>{
                            if(response && response.length){
                                $scope.showNextWFStepBtn = true;
                                window.sarc.channelBroadcast("clusterHeader", {
                                    actionType: "nextStepData",
                                    nextStepInfo: response
                                },`clusterHeaderSubscription`);
                            }
                            updateNextWFStepBtnStatusInRightSection();
                            window.sarc.channelBroadcast("reactDynamicForms", {
                                actionType: "updateAdditionalData",
                                payload: window.createRDFSecObj($scope)
                            },`dfSubscriptions_${$scope.globalData.dynamicFormId}`);
                        })
                    }

                    const hasWfIdAndRequestIdInURL = $location.search()['wfId'] && $location.search()['requestId'];

                    /*
                    * ================= Infinite loader until workflow action completes =======================
                    * */
                    if(hasWfIdAndRequestIdInURL) {
                        $scope.workflowActionStart = true;
                        let interval = setInterval(()=>{
                            if($scope.workflowActionStart)
                                startLoader();
                            else {
                                clearInterval(interval);
                                stopLoader();
                            }
                        },500);
                    }
                    /* ======================================================================================== */

                    // After all requests are resolved for showpage
                    Promise.all(requestArr).then(function(values) {
                        const jsonUrlOpts = getUrlOpts();

                        if( !values[0] || values[1].fields == null){
                            return;
                        }
                        if(values[0].errorMessages && values[0].errorMessages.length){
                            Toaster.create(values[0].errorMessages[0].errorMessage,{iconClass:"icon-Information_filled"});
                            return;
                        }else{
                            values[0] = values[0].layoutActions;
                            $scope.downloadTemplateUrl = values[0].filter(el => el.name && el.name.includes('Download'));
                        }
                        if(hasWfIdAndRequestIdInURL){
                            let field = values[0].find(v => v.api && v.api.includes($location.search()['wfId']));
                            if(_.isEmpty(field)){
                                delete  $scope.workflowActionStart;
                                $location.search('wfId', null);
                                $location.search('requestId', null);
                            }
                            try {
                                !_.isEmpty(field) && $http.get('/workflow-action/get-payload/'+$location.search()['requestId']).then(res =>{
                                    let wfData = _.get(res,'data.dataMap.body.data');
                                    $scope.data = wfData;
                                    $scope.selectedButton = field.label;
                                    window.sarc.channelBroadcast("reactDynamicForms",{
                                        actionType:'toggleExpandeCollapse',
                                        expandeAll: false,
                                    },`dfSubscriptions_${$scope.globalData.dynamicFormId}`)
                                    $scope.submitData(field.api, wfData, field.requestType, true, false, field)
                                })
                            }catch (e) {
                                delete $scope.workflowActionStart;
                            }
                        }
                        $scope.pageType = 'show';
                        $scope._renderActionButtons($scope,values[0],showPage2DataTransformationService);
                        if($rootScope.aeDocShowPage){
                            if(values[1]?.fields[0]?.secondaryEntities && !_.isEmpty(values[1]?.fields[0]?.fields)){
                                values[1]['fields'] = values[1]?.fields[0]?.fields;
                            }
                            $scope.saveCommentButton = values[0]?.find(item => item.name === "SaveComment/Attachment");
                            !_.isEmpty($scope.saveCommentButton) && $scope.updateSaveCommentButtonAccess();
                        }
                        showPageService.renderCreateLinkOptions.call($scope, values[1]);
                        if(values[2]){
                            showPageService.setLocalListingSwitchData(values[2]);
                        }
                        $scope.actionDataLoader = false;
                        $scope.showTimelineLink=true;

                        if(data.body && _.has(data.body, "layoutInfo.layoutComponent.fields")){
                            let fields = data.body.layoutInfo.layoutComponent.fields;
                            let tabIDFromParams = $scope.$route.current.params && $scope.$route.current.params.activeTabId;
                            $scope.layoutComponentFields = fields;
                            // If TabID is present in the URL
                            if(tabIDFromParams) {
                                $scope.timeLineFeedScope = $scope.commentDataScope = undefined;
                                $scope.timeLineFeedSecActive = false;
                                $scope.expandLeftSection =  true;
                                showPageService.activateTabOnLoad($scope);
                            }
                            // For CDR showpage only
                            if(jsonUrlOpts[2] == "tblcdr"){
                                const tabType = 'contractClauseTab';
                                const isReviewAllowed = _.has(data.body, "data.reviewAllowed") && data.body.data.reviewAllowed.values;
                                let clauseTab = fields.filter((tab, i)=>{
                                    if(tab.type == tabType){
                                        return tab;
                                    }
                                });
                                clauseTab = clauseTab[0];
                                $scope.clauseTab = clauseTab;
                                let contractDocumentTab = fields.filter((tab, i)=>{
                                    if(tab.id == 3909){
                                        return true;
                                    }
                                })[0];
                                $scope.previewTab.iscontractDocumentTabAllowed = contractDocumentTab && true;
                                $scope.getHeadContractDoc();
                                $scope.getWopiEnabled();

                                var getRedirectURL = () =>{
                                    const hash = window.location.hash;
                                    let redirectURL = (hash.indexOf('activeTabId='+ clauseTab.id) == -1) ? ((hash.indexOf('?')>-1) ?  (hash + '&activeTabId=' + clauseTab.id) : (hash + '?activeTabId=' + clauseTab.id)): hash;
                                    return redirectURL;
                                }

                                // Create toast
                                var createClauseReviewToast = function () {
                                    let reviewCountUrl = '/cdr/reviewPending/' + urlToCodeMapper[jsonUrlOpts[2]] + "/" + jsonUrlOpts[3];
                                    reviewCountUrl = SirionUtils.addQueryString(reviewCountUrl, "_t=" + tStamp);
                                    $http.get(reviewCountUrl).then(function (response) {
                                        // response.data.reviewPending = 3;
                                        const totalClauseReviewCount = _.get(response, 'data.reviewPending');
                                        if(totalClauseReviewCount == 0)
                                            return;

                                        let msgPart1 = intl_msg[30139] || "Contract review is in-progress.";
                                        let msgPart2 = " " + totalClauseReviewCount + " " + intl_msg[30140] || "clauses pending for your review.";
                                        let msgPart3 = " <a style='text-decoration: underline' href='" + getRedirectURL() + "' onclick='reloadRoute()'>"+ (intl_msg[30141] || 'View Details') + "</a>";
                                        let message = (totalClauseReviewCount) ? msgPart1 + msgPart2 + msgPart3 : msgPart1 + msgPart3;
                                        // Toaster.create(message);
                                    }, function errorCallback(error) {
                                        console.error('Data cannot be loaded due to: ' + error);
                                    });
                                }

                                if(!!clauseTab && isReviewAllowed && !tabIDFromParams){
                                    createClauseReviewToast();
                                }
                            }
                        }

                        $scope.cActions = values[0];
                        window.sarc.channelBroadcast("reactDynamicForms", {
                            actionType: "updateAdditionalData",
                            payload: window.createRDFSecObj($scope)
                        },`dfSubscriptions_${$scope.globalData.dynamicFormId}`);
                        window.sarc.channelBroadcast("communicationChannel", {
                            actionType: 'actionBtnLoaded',
                            value: {actions: $scope.cActions}
                        }, 'communicationChannel')

                        $scope.$applyAsync();

                    });
                }
                if (data.body && data.body.data) {
                    var tempData = data.body.data;
                    $rootScope.tagsCount = 0;
                    $scope.definitionCount = 0;
                    if (tempData.clauseTags && tempData.clauseTags.values && tempData.clauseTags.values.length)
                        $rootScope.tagsCount = tempData.clauseTags.values.length;
                    if (tempData.definitionCategories && tempData.definitionCategories.values && tempData.definitionCategories.values.length)
                        $scope.definitionCount = tempData.definitionCategories.values.length;
                    if ($scope.DocusignEnabled)
                        $scope.DocusignEnabled = false;
                }

                let showErrorModal = sessionStorage.getItem('showErrorModal');

                if (data && showErrorModal && data.body && data.body.errors && data.body.errors.error) {
                    $scope.showErrorModal = false;
                    sessionStorage.removeItem('showErrorModal');
                    if (  $('#showdialog').dialog.isOpen === true) {
                        $('#showdialog').dialog("close");
                    }
                    $timeout(function(){
                        if($("#ajaxcalloading").is(":visible")){
                            stopLoader();
                        }
                    },1500);
                    Toaster.create(data.body.errors.error,{iconClass:"icon-Information_filled"});
                    $timeout(function() {
                        if (window.history.length > 1) {
                            $window.history.back();
                        } else {
                            $scope.applyBasePageJson();  // No history, restore state instead
                        }
                    }, 100);
                } else {
                    if (!showPageBulkActionService.formShowPageBulkActionObject.call(this, jsonUrl, data, $scope)) {
                        if (!$scope.originalDataFromServer && data.body && data.body.data) {
                            $scope.originalDataFromServer = angular.copy(data.body.data);
                        }
                        $(".searchDropdownEntity select").prop("disabled", true);
                        formService.updateTreeJson(data);
                        data = $scope.modifyDataForRequestBy(data);
                        if($scope.showInvoiceUploadDialog && $scope.showInvoiceUploadDialog.visible){
                            $scope.newTabData=data.body.layoutInfo.layoutComponent.fields;
                            $scope.actionButtons=data.body.layoutInfo.actions;
                            $rootScope.showPageBulkActionData.data  = data.body.data;
                            if (data.body.layoutInfo.layoutComponent.fields[0]["id"] == 40 || data.body.layoutInfo.layoutComponent.fields[0]["id"] == 4007) {
                                $scope.cloneText = data.body.layoutInfo.layoutComponent.fields[0].label;
                                var actionArray = data.body.layoutInfo.actions;
                                for (var h = 0; h < actionArray.length; h++) {
                                    if (actionArray[h]["properties"]["replaceLinkUrl"]) {
                                        actionArray[h]["api"] = $rootScope.showPageBulkActionData["rawData"]["api"];
                                    }
                                }
                            }
                        }
                       else if($scope.rawDataCommentBox){
                            $scope.newTabData=data.body.layoutInfo.layoutComponent.fields;
                            $scope.actionButtons=data.body.layoutInfo.actions;
                            $rootScope.showPageBulkActionData.data  = data.body.data;
                            if (data.body.layoutInfo.layoutComponent.fields[0]["id"] == 40 || data.body.layoutInfo.layoutComponent.fields[0]["id"] == 4007) {
                                $scope.cloneText = $rootScope.showPageBulkActionData["rawData"]["commentLabel"];
                                var actionArray = data.body.layoutInfo.actions;
                                for (var h = 0; h < actionArray.length; h++) {
                                    if (actionArray[h]["properties"]["replaceLinkUrl"]) {
                                        actionArray[h]["api"] = $rootScope.showPageBulkActionData["rawData"]["api"];
                                    }
                                }
                            }
                        }
                        else if($scope.showlineItemCommentBox){
                            $scope.newTabData=data.body.layoutInfo.layoutComponent.fields;
                            $scope.actionButtons=data.body.layoutInfo.actions;
                            $rootScope.showPagePermissionObj.showPageBulkAction = true;
                            $rootScope.showPageBulkActionData.copyCommentObject = angular.copy($scope.data.comment);
                            $rootScope.showPageBulkActionData.layout = data.body.layoutInfo.layoutComponent;
                            $rootScope.showPageBulkActionData.layout.fields[0]["actions"] = data.body.layoutInfo.actions;
                            $scope.cloneText = $rootScope.showPageBulkActionData.layout.fields[0].label;
                            $rootScope.showPageBulkActionData.data  = data.body.data;

                            var actionArray = data.body.layoutInfo.actions;
                            for (var h = 0; h < actionArray.length; h++) {
                                if (actionArray[h]["properties"]["replaceLinkUrl"]) {
                                    actionArray[h]["api"] = $rootScope.showPageBulkActionData.api;
                                }
                            }
                        }
                        else {
                            $scope.processData(data,false,true);
                        }
                        $("#contentWrap").show();
                        $("#mainContainer").css("overflow", "auto");
                    }
                    showPageService.preventLabelClick();

                }

                if ($scope.isNewUX && $scope.isNewCrudPage && _.get($scope.showPage2DataTransformationService,"returnObj.uploadTabInfo.length")) {
                    const docUploadTabList = $scope.showPage2DataTransformationService.returnObj.uploadTabInfo;

                    if (_.get(data,"data.uploadAllowedOnCreate.values") || docUploadTabList) {
                        $scope.showUploadSection = true;
                    }
                }
                if(!window.isExceptionalPage && !$scope.isCreateRoute) {
                    !$rootScope.isAEProjectShowPage && $scope.loadTimelineFeed(jsonUrlOpts);
                    SirionUtils.getParameterValueFromURL(window.location.href,'docId') && SirionUtils.getParameterValueFromURL(window.location.href,'aeDocId') && $rootScope.enableChatBot && $scope.loadMiraDocRepository(jsonUrlOpts);
                }
                if(window.location.href.includes('/show/tblcontractdocuments/') && ($scope.checkConditionToOpenMiraFromConvoSearch() || shouldOpenMiraFromDocTree())) {
                    window.open($scope.summaryViewEntityUrl, "_self");
                }
                if($scope.aeDocShowPage || $scope.isAEContractPage){
                  if(!$rootScope.isWorkFlowTriggered){
                    // Hardcoded comment object for AE non workflow trigerred docs
                    $scope.saveCommentButton = {
                        buttonPosition: 30,
                        buttonType: 5,
                        api: '/autoextraction/v2/entity-comment'
                    };
                  }
                  $scope.loadPdf();
                }
                if(window.wf2Enabled && $scope.pageType == 'show' && $scope.hasProgressBarPermission){
                    $scope.getWorkflowProgressBarData()
                }
            });
        }
    };
    $scope.updateSaveCommentButtonAccess = async function () {
        window.sarc.channelBroadcast("renderAEShowPage", {
            actionType: 'updateSaveCommentAccess',
        }, 'renderAEShowPageSubscription');
    };
    $scope.openAECommentTab = function () {
        window.sarc.channelBroadcast("renderAutoExtractionPage", {
            actionType: 'toggleCommentTab',
        }, 'renderAutoExtractionPageSubscription');
    }
    $scope.modifyDataForRequestBy = function (data) {
        if (data && data.body &&  data["body"]["data"] && data["body"]["data"]["comment"]) {
            var commentData = data["body"]["data"]["comment"];
            if (commentData["requestedBy"]) {
                var requestBy = commentData["requestedBy"];
                if (requestBy.options) {
                    if (!requestBy.options.autoComplete) {
                        //Filter the array.
                        requestBy.options.data = requestBy.options.data.filter($scope.requestedByFilterFunction);
                    }
                }
            }

        }
        return data;
    }


    $scope.launchlocalListing  = function(_args,_entityId,_entityTypeId,pageType,_entityName){
        var _entity= {name:_entityName,id:_entityId};
        showPageService.setLocalListingHistory(_args,_entity,_entityTypeId,pageType);
    }

    $scope.getLocalListLink = function(obj){
        var hashURL = '';
        if(obj) {
            hashURL = '#/listRender/'+obj.listId+"?";
        var _entityTypeId = $scope.data.entityTypeId.values;
        var _entityId = $scope.data.id.values ;
        if(_entityTypeId == 1){
            hashURL+="relationId="+_entityId;
        }
        else if(_entityTypeId == 61 ){
            hashURL+="contractId="+_entityId+(localListingRelationId ?"&relationId="+localListingRelationId: '' );

        }else if(_entityTypeId == 3){
            hashURL+="vendorId="+_entityId;
        }
        return hashURL ;}
        return hashURL;
    }

    $scope.requestedByFilterFunction = function (data) {
        var toReturn = true;
        if (data.idTypes) {
            toReturn = false;
        }

        return toReturn;
    }

    $scope._renderActionButtons  = function(scope,value,service) {
        showPageService.renderActionButtons.call(scope, value, service);

        showPageService.assignValuesBasedOnActions(value);
    }
    $scope.renderXMLPage = function (data, header) {
        if (window.localStorage.getItem("integrationLayer") != "true") {
            return;
        }
        var xmldata = "<master-agreement>\n <batch-id>1234</batch-id>\n  <id>str1234</id>\n  <name>str1234</name>\n  <description>str1234</description>\n  <scope>str1234</scope>\n  <ccm-segment>\n    <id>str1234</id>\n    <name>str1234</name>\n  </ccm-segment>\n  <master-agreement-type>\n    <name>str1234</name>\n  </master-agreement-type>\n  <contract-language>\n    <id>str1234</id>\n    <name>str1234</name>\n  </contract-language>\n  <translation-needed>\n    <value>str1234</value>\n  </translation-needed>\n  <vpc-document-class>\n    <id>str1234</id>\n    <name>str1234</name>\n  </vpc-document-class>\n  <local-markets-document-class>\n    <id>str1234</id>\n    <name>str1234</name>\n  </local-markets-document-class>\n  <terminal-document-class>\n    <id>str1234</id>\n    <name>str1234</name>\n  </terminal-document-class>\n  <vpc-business-area>\n    <id>str1234</id>\n    <name>str1234</name>\n  </vpc-business-area>\n  <contract-spend-type>\n    <id>str1234</id>\n    <name>str1234</name>\n  </contract-spend-type>\n  <document-effective-date>2012-12-13T12:12:12</document-effective-date>\n  <docment-expiry-date>2012-12-13T12:12:12</docment-expiry-date>\n  <payment-term-expiration-date>2012-12-13T12:12:12</payment-term-expiration-date>\n  <payment-term-reminder-date>2012-12-13T12:12:12</payment-term-reminder-date>\n  <last-signature-date>2012-12-13T12:12:12</last-signature-date>\n  <auto-renewal-period>1234</auto-renewal-period>\n  <renewal-reminder-date>2012-12-13T12:12:12</renewal-reminder-date>\n  <term-communicated-date>2012-12-13T12:12:12</term-communicated-date>\n  <internal-party-invoicing-terms>str1234</internal-party-invoicing-terms>\n  <internal-party-payment-terms>\n    <code>str123</code>\n    <name>str1234</name>\n    <definition>str1234</definition>\n    <definition-long-text>str1234</definition-long-text>\n  </internal-party-payment-terms>\n  <internal-party-late-terms>\n    <code>str123</code>\n    <name>str1234</name>\n    <definition>str1234</definition>\n    <definition-long-text>str1234</definition-long-text>\n  </internal-party-late-terms>\n  <internal-party-early-terms>\n    <code>str123</code>\n    <name>str1234</name>\n    <definition>str1234</definition>\n    <definition-long-text>str1234</definition-long-text>\n  </internal-party-early-terms>\n  <internal-contracting-parties>\n    <company>\n      <id>str1234</id>\n      <name>str1234</name>\n      <legal-name>str1234</legal-name>\n    </company>\n  </internal-contracting-parties>\n  <external-party-payment-terms>\n    <code>str123</code>\n    <name>str1234</name>\n    <definition>str1234</definition>\n    <definition-long-text>str1234</definition-long-text>\n  </external-party-payment-terms>\n  <external-party-invoicing-terms>str1234</external-party-invoicing-terms>\n  <external-contracting-party>\n    <batch-id>1234</batch-id>\n    <id>str1234</id>\n    <ecc-id>str1234</ecc-id>\n    <companies>\n      <company>\n        <id>str1234</id>\n        <name>str1234</name>\n        <block-delete>true</block-delete>\n        <supplier-type>st</supplier-type>\n      </company>\n    </companies>\n    <name>str1234</name>\n    <duns>str1234</duns>\n    <vat-country>\n      <iso-code>str</iso-code>\n      <name>str1234</name>\n    </vat-country>\n    <vat-registration-number>str1234</vat-registration-number>\n    <vendor-registration-number>str1234</vendor-registration-number>\n    <replicated>true</replicated>\n    <purchasing-hold>true</purchasing-hold>\n    <qualification-id>str1234</qualification-id>\n    <qualification-status>\n      <id>1234</id>\n      <name>str1234</name>\n      <description>str1234</description>\n    </qualification-status>\n    <supplier-currency>\n      <id>1234</id>\n      <name>str1234</name>\n      <description>str1234</description>\n    </supplier-currency>\n    <payment-block>true</payment-block>\n    <payment-block-function>st</payment-block-function>\n    <tax-id>str1234</tax-id>\n    <tax-number>str1234</tax-number>\n    <purchasing-organizations>\n      <purchasing-organization-collection>\n        <purchasing-organization>\n          <id>str1234</id>\n          <name>str1234</name>\n        </purchasing-organization>\n        <purchasing-organization-currency>\n          <id>1234</id>\n          <name>str1234</name>\n          <description>str1234</description>\n        </purchasing-organization-currency>\n        <payment-term>\n          <code>str123</code>\n          <name>str1234</name>\n          <definition>str1234</definition>\n          <definition-long-text>str1234</definition-long-text>\n        </payment-term>\n      </purchasing-organization-collection>\n    </purchasing-organizations>\n    <addresses>\n      <address>\n        <address-1>str1234</address-1>\n        <address-2>str1234</address-2>\n        <address-3>str1234</address-3>\n        <city>str1234</city>\n        <state-province>str1234</state-province>\n        <postal-code>str1234</postal-code>\n        <district>str1234</district>\n        <county>str1234</county>\n        <region>str1234</region>\n        <country>\n          <iso-code>str</iso-code>\n          <name>str1234</name>\n        </country>\n        <po-box>str1234</po-box>\n        <po-box-postal-code>str1234</po-box-postal-code>\n      </address>\n    </addresses>\n    <contacts>\n      <contact>\n        <country>\n          <iso-code>str</iso-code>\n          <name>str1234</name>\n        </country>\n        <main-phone>str1234</main-phone>\n        <extension>str1234</extension>\n        <mobile-phone>str1234</mobile-phone>\n      </contact>\n    </contacts>\n    <fax>\n      <country>\n        <iso-code>str</iso-code>\n        <name>str1234</name>\n      </country>\n      <main-fax>str1234</main-fax>\n      <fax-extension>str1234</fax-extension>\n    </fax>\n    <telex>\n      <country>\n        <iso-code>str</iso-code>\n        <name>str1234</name>\n      </country>\n      <telex-number>str1234</telex-number>\n      <extension>str1234</extension>\n    </telex>\n    <url>str1234</url>\n    <business-system>\n      <id>str1234</id>\n      <name>str1234</name>\n    </business-system>\n    <vendor-account-group>\n      <id>str1234</id>\n      <name>str1234</name>\n    </vendor-account-group>\n    <publish-status>\n      <id>1234</id>\n      <name>str1234</name>\n      <description>str1234</description>\n    </publish-status>\n    <publish-date>2012-12-13T12:12:12</publish-date>\n    <category-manager>\n      <id>str1234</id>\n      <name>str1234</name>\n    </category-manager>\n    <commercial-contract-manager>\n      <id>str1234</id>\n      <name>str1234</name>\n    </commercial-contract-manager>\n    <business-contract-manager>\n      <id>str1234</id>\n      <name>str1234</name>\n    </business-contract-manager>\n    <vssc>\n      <id>str1234</id>\n      <name>str1234</name>\n    </vssc>\n    <business-partner>\n      <id>str1234</id>\n      <name>str1234</name>\n    </business-partner>\n    <business-executive>\n      <id>str1234</id>\n      <name>str1234</name>\n    </business-executive>\n    <scm-executive>\n      <id>str1234</id>\n      <name>str1234</name>\n    </scm-executive>\n    <finance-team>\n      <id>str1234</id>\n      <name>str1234</name>\n    </finance-team>\n    <legal-team>\n      <id>str1234</id>\n      <name>str1234</name>\n    </legal-team>\n    <administrator>\n      <id>str1234</id>\n      <name>str1234</name>\n    </administrator>\n    <supplier-account-manager>\n      <id>str1234</id>\n      <name>str1234</name>\n    </supplier-account-manager>\n    <supplier-commercial-contract-manager>\n      <id>str1234</id>\n      <name>str1234</name>\n    </supplier-commercial-contract-manager>\n    <supplier-business-contract-manager>\n      <id>str1234</id>\n      <name>str1234</name>\n    </supplier-business-contract-manager>\n    <inactive>true</inactive>\n    <abbreviated-name>str1234</abbreviated-name>\n    <alternative-name>str1234</alternative-name>\n    <erp-region>\n      <id>str1234</id>\n      <name>str1234</name>\n    </erp-region>\n    <extended-as>str123</extended-as>\n  </external-contracting-party>\n  <external-contracting-parties-collection>\n    <vendor>\n      <batch-id>1234</batch-id>\n      <id>str1234</id>\n      <ecc-id>str1234</ecc-id>\n      <companies>\n        <company>\n          <id>str1234</id>\n          <name>str1234</name>\n          <block-delete>true</block-delete>\n          <supplier-type>st</supplier-type>\n        </company>\n      </companies>\n      <name>str1234</name>\n      <duns>str1234</duns>\n      <vat-country>\n        <iso-code>str</iso-code>\n        <name>str1234</name>\n      </vat-country>\n      <vat-registration-number>str1234</vat-registration-number>\n      <vendor-registration-number>str1234</vendor-registration-number>\n      <replicated>true</replicated>\n      <purchasing-hold>true</purchasing-hold>\n      <qualification-id>str1234</qualification-id>\n      <qualification-status>\n        <id>1234</id>\n        <name>str1234</name>\n        <description>str1234</description>\n      </qualification-status>\n      <supplier-currency>\n        <id>1234</id>\n        <name>str1234</name>\n        <description>str1234</description>\n      </supplier-currency>\n      <payment-block>true</payment-block>\n      <payment-block-function>st</payment-block-function>\n      <tax-id>str1234</tax-id>\n      <tax-number>str1234</tax-number>\n      <purchasing-organizations>\n        <purchasing-organization-collection>\n          <purchasing-organization>\n            <id>str1234</id>\n            <name>str1234</name>\n          </purchasing-organization>\n          <purchasing-organization-currency>\n            <id>1234</id>\n            <name>str1234</name>\n            <description>str1234</description>\n          </purchasing-organization-currency>\n          <payment-term>\n            <code>str123</code>\n            <name>str1234</name>\n            <definition>str1234</definition>\n            <definition-long-text>str1234</definition-long-text>\n          </payment-term>\n        </purchasing-organization-collection>\n      </purchasing-organizations>\n      <addresses>\n        <address>\n          <address-1>str1234</address-1>\n          <address-2>str1234</address-2>\n          <address-3>str1234</address-3>\n          <city>str1234</city>\n          <state-province>str1234</state-province>\n          <postal-code>str1234</postal-code>\n          <district>str1234</district>\n          <county>str1234</county>\n          <region>str1234</region>\n          <country>\n            <iso-code>str</iso-code>\n            <name>str1234</name>\n          </country>\n          <po-box>str1234</po-box>\n          <po-box-postal-code>str1234</po-box-postal-code>\n        </address>\n      </addresses>\n      <contacts>\n        <contact>\n          <country>\n            <iso-code>str</iso-code>\n            <name>str1234</name>\n          </country>\n          <main-phone>str1234</main-phone>\n          <extension>str1234</extension>\n          <mobile-phone>str1234</mobile-phone>\n        </contact>\n      </contacts>\n      <fax>\n        <country>\n          <iso-code>str</iso-code>\n          <name>str1234</name>\n        </country>\n        <main-fax>str1234</main-fax>\n        <fax-extension>str1234</fax-extension>\n      </fax>\n      <telex>\n        <country>\n          <iso-code>str</iso-code>\n          <name>str1234</name>\n        </country>\n        <telex-number>str1234</telex-number>\n        <extension>str1234</extension>\n      </telex>\n      <url>str1234</url>\n      <business-system>\n        <id>str1234</id>\n        <name>str1234</name>\n      </business-system>\n      <vendor-account-group>\n        <id>str1234</id>\n        <name>str1234</name>\n      </vendor-account-group>\n      <publish-status>\n        <id>1234</id>\n        <name>str1234</name>\n        <description>str1234</description>\n      </publish-status>\n      <publish-date>2012-12-13T12:12:12</publish-date>\n      <category-manager>\n        <id>str1234</id>\n        <name>str1234</name>\n      </category-manager>\n      <commercial-contract-manager>\n        <id>str1234</id>\n        <name>str1234</name>\n      </commercial-contract-manager>\n      <business-contract-manager>\n        <id>str1234</id>\n        <name>str1234</name>\n      </business-contract-manager>\n      <vssc>\n        <id>str1234</id>\n        <name>str1234</name>\n      </vssc>\n      <business-partner>\n        <id>str1234</id>\n        <name>str1234</name>\n      </business-partner>\n      <business-executive>\n        <id>str1234</id>\n        <name>str1234</name>\n      </business-executive>\n      <scm-executive>\n        <id>str1234</id>\n        <name>str1234</name>\n      </scm-executive>\n      <finance-team>\n        <id>str1234</id>\n        <name>str1234</name>\n      </finance-team>\n      <legal-team>\n        <id>str1234</id>\n        <name>str1234</name>\n      </legal-team>\n      <administrator>\n        <id>str1234</id>\n        <name>str1234</name>\n      </administrator>\n      <supplier-account-manager>\n        <id>str1234</id>\n        <name>str1234</name>\n      </supplier-account-manager>\n      <supplier-commercial-contract-manager>\n        <id>str1234</id>\n        <name>str1234</name>\n      </supplier-commercial-contract-manager>\n      <supplier-business-contract-manager>\n        <id>str1234</id>\n        <name>str1234</name>\n      </supplier-business-contract-manager>\n      <inactive>true</inactive>\n      <abbreviated-name>str1234</abbreviated-name>\n      <alternative-name>str1234</alternative-name>\n      <erp-region>\n        <id>str1234</id>\n        <name>str1234</name>\n      </erp-region>\n      <extended-as>str123</extended-as>\n    </vendor>\n  </external-contracting-parties-collection>\n  <inco-term>\n    <id>str1234</id>\n    <name>str1234</name>\n  </inco-term>\n  <applicable-law>\n    <id>str1234</id>\n    <name>str1234</name>\n  </applicable-law>\n  <jurisdiction>\n    <id>str1234</id>\n    <name>str1234</name>\n  </jurisdiction>\n  <currency>\n    <id>1234</id>\n    <name>str1234</name>\n    <description>str1234</description>\n  </currency>\n  <internal-party-currency-clause>str1234</internal-party-currency-clause>\n  <external-party-currency-clause>str1234</external-party-currency-clause>\n  <external-party-currency-clause-long>str1234</external-party-currency-clause-long>\n  <auto-renewal>true</auto-renewal>\n  <perpetual-term>true</perpetual-term>\n  <termination-notice-lead>1234</termination-notice-lead>\n  <contract-termination-details-1>str1234</contract-termination-details-1>\n  <contract-termination-details-2>str1234</contract-termination-details-2>\n  <forecasting-obligation-description-1>str1234</forecasting-obligation-description-1>\n  <forecasting-obligation-description-2>str1234</forecasting-obligation-description-2>\n  <forecasting-obligation-with-supplier>\n    <value>str1234</value>\n  </forecasting-obligation-with-supplier>\n  <product-warranty-length>1234</product-warranty-length>\n  <product-warranty-information-1>str1234</product-warranty-information-1>\n  <product-warranty-information-2>str1234</product-warranty-information-2>\n  <performance-bond>str1234</performance-bond>\n  <delivery-term>str1234</delivery-term>\n  <status>\n    <id>str1234</id>\n    <name>str1234</name>\n  </status>\n  <created-by>\n    <id>str1234</id>\n    <name>str1234</name>\n    <legal-name>str1234</legal-name>\n  </created-by>\n  <created-for>\n    <id>str1234</id>\n    <name>str1234</name>\n    <legal-name>str1234</legal-name>\n  </created-for>\n  <fx-rate-clause>\n    <value>str1234</value>\n  </fx-rate-clause>\n  <fx-rate-clause-description>str1234</fx-rate-clause-description>\n  <supply-chain-finance-model>\n    <value>str1234</value>\n  </supply-chain-finance-model>\n  <free-samples>\n    <value>str1234</value>\n  </free-samples>\n  <sample-details-1>str1234</sample-details-1>\n  <sample-details-2>str1234</sample-details-2>\n  <free-dummies>\n    <value>str1234</value>\n  </free-dummies>\n  <dummies-details-1>str1234</dummies-details-1>\n  <dummies-details-2>str1234</dummies-details-2>\n  <doa-period-length>1234</doa-period-length>\n  <doa-information-1>str1234</doa-information-1>\n  <doa-information-2>str1234</doa-information-2>\n  <handling-fee>\n    <value>str1234</value>\n  </handling-fee>\n  <handling-fee-description-1>str1234</handling-fee-description-1>\n  <handling-fee-description-2>str1234</handling-fee-description-2>\n  <stock-protection>\n    <value>str1234</value>\n  </stock-protection>\n  <stock-protection-description-1>str1234</stock-protection-description-1>\n  <stock-protection-description-2>str1234</stock-protection-description-2>\n  <marketing-fund>str1234</marketing-fund>\n  <vendor-management-replenishment>\n    <value>str1234</value>\n  </vendor-management-replenishment>\n  <vendor-management-inventory>\n    <value>str1234</value>\n  </vendor-management-inventory>\n  <vmi-type>str1234</vmi-type>\n  <frozen-period>\n    <value>str1234</value>\n  </frozen-period>\n  <frozen-period-description-1>str1234</frozen-period-description-1>\n  <frozen-period-description-2>str1234</frozen-period-description-2>\n  <stock-aging-description-1>str1234</stock-aging-description-1>\n  <enablement-fee-description-1>str1234</enablement-fee-description-1>\n  <enablement-fee-description-2>str1234</enablement-fee-description-2>\n  <lump-sum-description>str1234</lump-sum-description>\n  <parent-agreement>\n    <value>str1234</value>\n  </parent-agreement>\n  <linked-master-agreements>\n    <linked-master-agreement>\n      <ma-name>str1234</ma-name>\n      <ma-id>str1234</ma-id>\n      <relationship>\n        <id>str1234</id>\n        <name>str1234</name>\n      </relationship>\n      <marked-for-deletion>true</marked-for-deletion>\n      <updated>true</updated>\n    </linked-master-agreement>\n  </linked-master-agreements>\n  <master-agreement-attachment>str1234</master-agreement-attachment>\n  <contract-document-attachment>str1234</contract-document-attachment>\n</master-agreement>";
        var parentEntityId;
        var parentEntityTypeId;
        var prntAgmnt;
        var treeItemId;
        var integ = false;
        //window.localStorage.setItem("allowDiffNodeSelection" , true);
        if (data && data.data) {
            xmlData = data.data.otherInfo;
            $scope.btnlist = data.layoutInfo.actions;
            parentEntityId = data.data.parentEntityId;
            parentEntityTypeId = data.data.parentEntityTypeId;
            prntAgmnt = data.data.parentAgreement;
        }
        if (data && data.body && data.body.data) {
            xmldata = data.body.data.otherInfo;
            $scope.btnlist = data.body.layoutInfo.actions;
            parentEntityId = data.body.data.parentEntityId;
            parentEntityTypeId = data.body.data.parentEntityTypeId;
            prntAgmnt = data.body.data.parentAgreement;
            $scope.errMsgFlag = false;
            if (data.body.layoutInfo.globalValues) {
                $scope.errMsgFlag = true;
                $scope.errMsg = data.body.layoutInfo.globalValues.message;
            }
        }
        if (prntAgmnt == false) {
            window.localStorage.setItem("allowDiffNodeSelection", true);
            window.localStorage.setItem("allowDiffNodeOn", parentEntityId);
        } else {
            window.localStorage.setItem("allowDiffNodeSelection", false);
            window.localStorage.setItem("allowDiffNodeOn", null);
        }

        function removeSelfClosingTags(xml) {
            var split = xml.split("/>");
            var newXml = "";
            for (var i = 0; i < split.length - 1; i++) {
                var edsplit = split[i].split("<");
                newXml += split[i] + "></" + edsplit[edsplit.length - 1].split(" ")[0] + ">";
            }
            return newXml + split[split.length - 1];
        }

        if (data && data.body && data.body.data) {
            stopLoader();
            $(".dummyShow").remove();
            $scope.xmlTemp = true;
            $(".xmlContent").html("");
            var elem = $("<div></div>");
            xmldata = removeSelfClosingTags(xmldata);
            $(xmldata).each(function (i, val) {
                if (val.tagName != null) {
                    val = val.children;
                    $(val).each(function (j, val1) {
                        contentDiv = $('<div style="margin-bottom:1em;font-size:10pt;border-radius:0 0 4px 4px;"></div>');
                        if (val1.children.length > 0) {
                            var headerDiv = $('<div style="background-color:#DEDACB;text-transform: uppercase;color:#84786A;padding:4px;border-radius:4px 4px 0 0;"/>');
                            headerDiv.html(val1.localName);
                        } else {
                            var childDiv = $('<div class="child" />');
                            var div1 = $("<label class='childNode' />");
                            var cn = "";
                            if (val1.localName == "id")
                                cn = "capitalCaseId";
                            div1.html('<span class="fieldLabel ' + cn + '">' + val1.localName.replace(/-/g, " ") + ' :</span><span class="content-left"> ' + val1.innerText + '</span>');
                            childDiv.append(div1);
                            contentDiv.append(childDiv);
                        }
                        if (val1.children.length != 0) {
                            contentDiv.addClass("showBorder");
                            var childDiv = $('<div class="child"/>');
                            $(val1.children).each(function (j, childVal) {
                                /*if(childVal.localName.replace(/-/g," ") == "value" && val1.localName.replace(/-/g," ") == "parent agreement"){
                                	if(childVal.innerText.toLowerCase() == "no")
                                	window.localStorage.setItem("allowDiffNodeSelection" , true);
                                	//console.log("sdhfskjhfkjshfk--sdjhsfjh");
                                }*/
                                var div1 = $("<label class='childNode' />");
                                var cn = "";
                                if (childVal.localName == "id")
                                    cn = "capitalCaseId";
                                div1.html('<span class="fieldLabel ' + cn + '">' + childVal.localName.replace(/-/g, " ") + ' :</span><span class="content-left"> ' + childVal.innerText + '</span>');
                                childDiv.append(div1);
                            });
                            contentDiv.append(childDiv);
                        }
                        elem.append(headerDiv).append(contentDiv);
                    });
                }
            });
            stopLoader();
            $(".xmlContent").append(elem);
            $(".tabs").tabs();
            setTimeout(function () {
                $(window).resize();
            }, 1000)
            $scope.myJson = data.body;
            $scope.header = data.header;
            $scope.layout = data.body.layoutInfo.layoutComponent;
            $scope.global = data.body.layoutInfo.globalValues;
            $scope.data = data.body.data;
            $scope.actions = data.body.layoutInfo.actions;
        }
        if (parentEntityId && parentEntityTypeId) {
            $scope.xmlTempTree = true;
            $rootScope.currentRelationId = parentEntityId;
            $rootScope.relationId = parentEntityId;
            $rootScope.entityTypeIdJS = parentEntityTypeId;
            treeItemId = parentEntityTypeId + "_" + parentEntityId;
            $rootScope.treeItemIdCreate = treeItemId;
            treeeJson = {};
            $scope.currentRelationId = parentEntityId;

            loadTree(parentEntityId, parentEntityTypeId, true);
        }
        // if (!$scope.$$phase) {
            $scope.$applyAsync();
        // }
    }

    $scope.callUpdateTab = (data) => {
        let urlData = window.location.href,
            isItshowPage = urlData.indexOf("searchTypeParam") === -1 && urlData.indexOf("create") === -1 && urlData.indexOf("templateWizard/cdr")=== -1,
            isItClonePage = urlData.indexOf("clone") > -1,
            isItCreatePage = urlData.indexOf("create") > -1,
            isItBulkActionEdit = data?.header?.source.indexOf("bulkaction") > -1 || data?.header?.source.indexOf("bulkedit") > -1,
            isItCreateExternal = data?.header?.source.indexOf("externalcontact/new") > -1 || data?.header?.source.indexOf("externalContactFreeCreate")> -1 || data?.header?.source.indexOf("relations/new") > -1,
            isAutoExtract = data?.header?.source.indexOf("autoextraction") > -1,
            isItEditExternal = data?.header?.source.indexOf("externalcontact/edit") > -1;

            return (isItClonePage && "clone")
                || (isItCreatePage && "create")
                || (isItshowPage && !isItBulkActionEdit && !isItCreateExternal && !isAutoExtract && !isItEditExternal && "showPage") || null;

    }

    let updateTabView = function() {
        // Get the query string parameters from current URL
        if (!window.location.href.includes("mobileView"))
            return

        let findGroupInterval = setInterval(() => {
            const tabElement = $('[data-mtab-id="4358"]');
            console.log("Tab element not found, cannot update view.1");
            if (tabElement?.length) {
                clearInterval(findGroupInterval);
                tabElement.trigger("click");
            }else{
                console.log("Tab element not found, cannot update view.");
            }
        }, 100);

        setTimeout(() => {
            clearInterval(findGroupInterval);
        }, 5000);
    }
    $scope.processData = function (data, summaryOnly, isShowPageDataCall) {
        
        if(data && !summaryOnly){
            let tabName = $scope.callUpdateTab(data);
            !!tabName && setTabTitleUtils.updateTabTitle(null, data?.body?.data, tabName);
            updateTabView();
        }
        $scope.disableUpdateCall = true;
        $timeout(()=>{
            $scope.disableUpdateCall = false;
        },3000);
        $scope.xmlTemp = false;
        $scope.xmlTempTree = false;
        $scope.createPageTree = false;
        $scope.documentOpenWithForm = false;
        $scope.initLoadComments = true;
        if($scope.pageType == "globalCreate" && _.has(data,"body.globalData.entityTypeId")){
            $scope.documentTypeId =  data.body.globalData.entityTypeId;
        }
        if(data.body && data.body.data){
            $scope.applySelectedSupplierToExternalContactData(data);
            $rootScope.data = data.body.data;
            if((_.has($rootScope.data, "name.values") || $scope.showWorkspaceView) && !olderScope.fromExternalUserOld){
                var nameValue = $rootScope.data.name.values;
                $scope.pageTitle = nameValue != null ? unescapeHtml(commonUtil.ampToAmpersand(nameValue)) : nameValue;
            }
            if(_.has(data.body, "data.entityTypeId.values")){
                const entityTypeId = data.body.data["entityTypeId"].values;
                if(entityTypeId == 140 && _.get(data.body, 'globalData["pageType "]') != 1){
                    $scope.showTagsIcon = true;
                    if(_.has(data.body.data, "templateVersion.values")) $scope.showVersionHistoryIcon = true;
                }
            }
            $scope.versionOptions = [];

            if(_.has(data.body.data, "templateVersion.values")){
                $scope.currentTemplateVersionNumber = data.body.data["templateVersion"].values;
                $scope.currentTemplateVersionSpn = ' ('+intl_msg[31932] + ' ' + $scope.currentTemplateVersionNumber + ')';
                $scope.showVersionLabel = true;
                $scope.currentVersionNum = data.body.data["templateVersion"].values;

            }
            if(_.has(data.body.data, "templateVersion.values") && _.has(data.body.data, "intermediateTemplate.values") && data.body.data["intermediateTemplate"].values == true){
                $scope.showVersionDropdown = true;
                $scope.isIntermediateAvailable = true;
                $scope.showVersionLabel = false;
            }

            if($scope.showVersionDropdown){
                let versionObj = {
                    name : '',
                    value : ''
                }
                versionObj['name'] = data.body.data["templateVersion"].values;
                versionObj['value'] = `V ${data.body.data["templateVersion"].values}`;
                $scope.versionOptions.push(versionObj);
                $scope.firstVersionOption = {name : 'intermediate',
                    value : `V ${data.body.data["templateVersion"].values} - ${intl_msg["31935"]}`
                }
                $scope.versionOptions.unshift($scope.firstVersionOption);
                $scope.selectedTemplateVersion = $scope.firstVersionOption;
                $scope.showIntermediateIcon = true;
            }
            if(data.body.data["name"].values){
                $scope.templateName = data.body.data["name"].values;
            }

            if(_.has(data.body.data, "clauseCategories.options.data")){
                $scope.playbook["options"] = data.body.data.clauseCategories.options.data;
            }
            if(_.has(data.body.data, "playbookClauseCategories.values")){
                $scope.playbook["playbookClauseCategories"] = data.body.data.playbookClauseCategories.values;
            }
            if(_.has(data.body.data, "projectFields")){
                $scope.project["projectFields"] =_.cloneDeep(data.body.data.projectFields);
                data.body.data.projectFields.values = _.cloneDeep(showPageService.removeUnusedGroupInfo(data.body.data.projectFields.values,$rootScope.isAEProjectShowPage));
            }
            if(_.has(data.body.data, "baseClauseTexts")){
                $scope.project["baseClauseTexts"] = data.body.data.baseClauseTexts;
            }
            if(_.has(data.body.data, "clauses")){
                $scope.project['clauses'] = {
                    ...data.body.data?.clauses,
                    'options': {
                        ...data.body.data?.clauses?.options,
                        'enableListView': false
                    }
                }
            }
        }
        $scope.loadHeaderData && $scope.loadHeaderData(data.body.data);
        var treeItemId;
        if (SirionUtils.getParameterByName("dialogMessage") && !summaryOnly) {
            const args = {
                popupType: 'alert',
                str: unescape(SirionUtils.getParameterByName("dialogMessage")),
                heading: "ALERT",
                yesCbFn: 'cancel',
                yesName: 'OK'
            }
            SirionUtils.openSirionDialogs(args);
        }
        // this statement is to replace escaped nextLine characters with
        // unescaped ones.

        /*
         * if(data.header && data.header.response && data.header.response.status ==
         * "applicationError") { alertDialog(data.header.response.errorMessage); }
         * else
         */
        if (_.has(data, 'body.globalData') && $scope.pageType != "delegationCreate") {
            if($scope.pageType != "globalCreate") {
                $scope.pageType = pageTypeArr[data.body.globalData["pageType "]];
                $rootScope.pageType = $scope.pageType; // Sync to rootScope for drawer access
            }
            docTreeService.hasAutoExtractEntitiesPermission = data.body.globalData.hasAutoExtractEntitiesPermission;
            docTreeService.hasMetadataAutoExtractPermission = data.body.globalData.hasMetadataAutoExtractPermission;
        }
        docTreeService.pageType = $scope.pageType;
        if (isCreate) {
            data.header.response.type = "popUp";
        }
        if (_.has(data, 'body.data.contractDocuments') && ["clone","globalCreate","show","edit","create"].indexOf($scope.pageType) > -1) {
            docTreeService.contractDocuments = data.body.data.contractDocuments.values;
            if(docTreeService.contractDocuments != undefined ){
                docTreeService.contractDocumentsCopy = JSON.parse(JSON.stringify(docTreeService.contractDocuments));
            }
            docTreeService.selectedContract = data.body.data.name;
            docTreeService.selectedContractId = data.body.data.id.values;
            docTreeService.supplierId = (data.body.data.supplier.values && data.body.data.supplier.values.id)? data.body.data.supplier.values.id : data.body.data.relations.values[0].id;
            docTreeService.otherContract = (data.body.data.documentType && data.body.data.documentType.values.id == 76 ? true : false);
            if ($scope.pageType == 'edit') {
                $scope.documentEditPermission = true;
            }
            if(_.has(data, "body.data.relations.values") && data.body.data.relations.values.length > 0){
                docTreeService.multiSupplierIds = data.body.data.relations.values.map((obj)=>{
                    return obj.id
                });
            }
        }
        var mainFormScope = angular.element(document.getElementById('mainForm')).scope();
        var isCreateDef = (typeof isCreate != "undefined" && isCreate) ? true : false;
        // if(!isCreateDef && $scope.pageType == "show" && $rootScope.enableShowPagePrint) { //To enable show page print
        //
        //     var printBtn = {
        //         api: "/listRenderer/list/3",
        //         "clientValidation": false,
        //         "confirmationForBlockedEntities": false,
        //         "hideWorkflowButton": false,
        //         "name": "Print",
        //         "label": "Print",
        //         "properties": {
        //             onClick: {
        //                 name: "submitData"
        //             }
        //         },
        //         "buttonPosition":20,
        //         "buttonType":2,
        //         "requestType": "Print",
        //         "secondaryEntity": false,
        //         "type": "button",
        //         "id": "print_showPage"
        //     };
        //     if (_.has(data,'body.layoutInfo.actions')) {
        //         data.body.layoutInfo.actions.push(printBtn);
        //     }
        // }

        function isDefintionLibraryPage() {
            if (window.listId && window.listId == "361")
                return true;
            else if (data && data.body && data.body.data && data.body.data.group && data.body.data.group.id && data.body.data.group.id == 11837 && data.body.data.group.values && data.body.data.group.values.id == 2)
                return true;
            else
                return false;
        }
        if(window.entityURLdata && window.entityURLdata.indexOf("/contractFreeCreate/") == -1 && !$("#showdialog:visible").length) {
            $rootScope.preSignature.showContractTemplateSaveButton = false;
        }

        if (window.entityURLdata && _.has(data, 'body.layoutInfo')) {
            $rootScope.backUrlPresent = false;
            if (isDefintionLibraryPage()) {
                $rootScope.backUrl = '#/listRender/361';
                $rootScope.backUrlPresent = true;
                $rootScope.backUrlTitle= intl_msg[25506];
            } else {
                if (window.entityURLdata.indexOf("/cdr") > -1 || window.entityURLdata.indexOf("/clause") > -1 || window.entityURLdata.indexOf("/contracttemplate") > -1 || window.entityURLdata.indexOf("/contracts/")>-1) {
                    showPageService.assignValuesBasedOnActions(data.body.layoutInfo.actions);
                    if(summaryOnly && window.entityURLdata.indexOf("/cdr")>-1){
                        $rootScope.backUrlPresent = true;
                        $rootScope.backUrlTitle = "";
                    }
                } else {
                    $rootScope.backUrlPresent = false;
                    $rootScope.backUrlTitle = "";
                }
            }
        } else {
            $rootScope.backUrlPresent = false;
        }
        if (window.localStorage.getItem("integrationLayer") != "true") {
            window.localStorage.setItem("allowDiffNodeSelection", false);
        }
        if (_.has(data, 'body.layoutInfo.layoutComponent.fields') && !summaryOnly) {
            // formService, JSON editor function
            formService.modifyJSON(data.body.layoutInfo.layoutComponent.fields, data.body.data,$scope.summaryObj);
        }
        entityFactory.fieldsToBeConvertValueToJson = [];
        $scope.undoDisable = 0;
        if (_.has(data, 'body.data')) {
            $scope.defaultDataForForm = angular.copy(data.body.data);
            data.body.data = JSON.parse(JSON.stringify(data.body.data).replace(/(\\\\n)/g, "\\n"));
            data.body.data.dummyModels = [];
            if (data.body.data.supplier && data.body.data.supplier.values) {
                $rootScope.currentRelationId = data.body.data.supplier.values.id;
                $scope.selectedSupplier = data.body.data.supplier.values;
            } else if(_.has(data, "body.data.suppliers.values") && data.body.data.suppliers.values.length > 0 ) {
                var supplierIdFromUrlSuppliers = SirionUtils.getParameterValueFromURL(window.location.href, 'supplierId');
                var matchingSupplier = supplierIdFromUrlSuppliers && _.find(data.body.data.suppliers.values, function(sup) { return String(sup.id) === String(supplierIdFromUrlSuppliers); });
                if (matchingSupplier) {
                    $rootScope.currentRelationId = matchingSupplier.id;
                    $scope.selectedSupplier = matchingSupplier;
                } else {
                    $rootScope.currentRelationId = data.body.data.suppliers.values[0].id;
                    $scope.selectedSupplier = data.body.data.suppliers.values[0];
                }
            } else if(_.has(data, "body.data.relations.values") && data.body.data.relations.values.length > 0 ) {
                var supplierIdFromUrl = SirionUtils.getParameterValueFromURL(window.location.href, 'supplierId');
                var matchingRelation = supplierIdFromUrl && _.find(data.body.data.relations.values, function(rel) { return String(rel.id) === String(supplierIdFromUrl); });
                if (matchingRelation) {
                    $rootScope.currentRelationId = matchingRelation.id;
                    $scope.selectedSupplier = matchingRelation;
                } else {
                    $rootScope.currentRelationId = data.body.data.relations.values[0].id;
                    $scope.selectedSupplier = data.body.data.relations.values[0];
                }
            } else if (data.body.data.entityTypeId && data.body.data.entityTypeId.values == 1) {
                $rootScope.currentRelationId = data.body.data.id.values;
                $scope.selectedSupplier = {
                    name : data.body.data.name.values || data.body.data?.shortCodeId?.values,
                    id: data.body.data.id.values
                };
            } else if (data.body.data.documentViewer) {
                $rootScope.currentRelationId = data.body.data.documentViewer.values.relationId;
                $rootScope.fromDocViewer = true;
            }
            if (data.body.data.entityTypeId && (data.body.data.entityTypeId.values == 1 || data.body.data.entityTypeId.values == 61)) {
                $scope.relationId = $rootScope.currentRelationId;
            }
            if (data.body.data.name) {
                $rootScope.listName = data.body.data.name.values;
            }

            if (angular.isObject(data.body.data.history)) {

                $(function () {

                    var userAgent = navigator.userAgent.toLowerCase();
                    if (userAgent.indexOf("chrome") != -1) {
                        $('html').addClass('chrome');
                    }

                });
                if (data.body.data.history.states && data.body.data.history.states.length > 0) {
                    for (var k = 0; k < data.body.data.history.states.length; k++) {
                        data.body.data.history.states[k]["seqId"] = k;
                        data.body.data.history.states[k]['showStates'] = false;
                    }
                    data.body.data.history.states[data.body.data.history.states.length-1]['showStates'] = true;
                    $scope.zeroStates = false;
                    $scope.actionHistory = {
                        history: data.body.data.history.states
                    };
                    $scope.breadCrumbObj = data.body.data.history;
                    $scope.colorStateId = $scope.actionHistory.history[$scope.actionHistory.history.length - 1].seqId;
                    $scope.breadCrumbStateBack($scope.actionHistory.history[$scope.actionHistory.history.length - 1], $scope.breadCrumbObj, 0);
                } else {
                    $scope.zeroStates = true;
                    $scope.actionHistory = {
                        history: data.body.data.history.status
                    };
                }
            } else {
                $scope.actionHistory = undefined;
            }
            if (data.body.data.entityTypeId && data.body.data.id) {
                if (data.body.data.id.values)
                    treeItemId = data.body.data.entityTypeId.values + "_" + data.body.data.id.values;
                else if ((data.body.data.actualParentEntityId || data.body.data.parentEntityId) && data.body.data.parentEntityTypeId && data.header.source.indexOf("staging") > -1) {
                    $scope.createPageTree = true;
                    $rootScope.entityTypeIdJS = data.body.data.parentEntityTypeId.values;
                    treeItemId = data.body.data.parentEntityTypeId.values + "_" + (data.body.data.actualParentEntityId.values ? data.body.data.actualParentEntityId.values : data.body.data.parentEntityId.values);
                    $rootScope.treeItemIdCreate = treeItemId;
                    $scope.currentRelationId = (data.body.data.actualParentEntityId.values ? data.body.data.actualParentEntityId.values : data.body.data.parentEntityId.values);
                    treeeJson = {};
                }
            }
        }
        if($.isEmptyObject($rootScope.preSignature.clientSpecificFieldOptions) && typeof data == "object" && data.header?.source) {
            dataManipulationService.getClientSpecificFieldIds(data.header?.source);
        } else if(typeof data == "object" && data.header?.source) {
            dataManipulationService.getClientSpecificDynamicFieldName(data.header?.source);
        }
        $scope.hideContractTree = undefined;
        if (!summaryOnly && data.body != undefined && data.body.data['hideContractTree']) {
            $scope.hideContractTree = data.body.data['hideContractTree'].values;
        }
        if (angular.isDefined(data.header) && angular.isDefined(data.header?.response) && data.header?.response.status === "applicationError") {
            var boxType = "ERROR";
            if (angular.isDefined(data.header?.response.errorMessage) && ((data.header?.response.errorMessage).toString().trim().length > 0)) {
                $rootScope.currentRelationId = null;
                $rootScope.relationId = null;
                if (data.header?.response.type == "NOTIFICATION") {
                    boxType = intl_msg[24153];
                }
                $($scope.currentOuterPopup).dialog("close");
                if ($scope.popupOpen) {
                    data.header.response.redirect = false;
                    $scope.popupOpen = false;
                }
                const args = {
                    popupType: 'alert',
                    str: data.header?.response.errorMessage,
                    heading: boxType,
                    yesCbFn: "goToPreviousPage",
                    yesName: intl_msg[24184]
                }
                if (data.header.response.redirect && ($rootScope.templateSuggestionPage || $scope.apiName == "tblchildslas")) {
                    args.rmvCloseBtn = true;
                    SirionUtils.openSirionDialogs(args);
                } else if (data.header.response.redirect) {
                    SirionUtils.openSirionDialogs(args);
                } else {
                    Toaster.create(data.header.response.errorMessage,{iconClass:"icon-Information_filled"});
                    $("body").removeClass("overRideLoading");
                    if(olderScope.createLink) {
                        $scope.createLink = olderScope.createLink;
                    }
                }
                if($scope.isCreateRoute) {
                    const oldRoute = sessionStorage.previousURL || urlFactory.convertUrlfromAPI(window.location.hash, false)
                    $location.path(oldRoute);
                    return;
                }
                data.header.response.redirect && ($scope.permissionDenied = true);
            } else {
                toggleServerErrorNotification(true);
                $($scope.currentOuterPopup).dialog("close");
            }
        } else if (data.header && data.header.source && (data.header.source).indexOf("integration") > -1) {
            $scope.renderXMLPage(data);
            return;
        } else if (data.body == undefined && data == "/contracttemplate/show/first") {
            stopLoader();
            return;
        } else if (data.body == "" || data.body == undefined) {
            const args = {
                popupType: 'alert',
                str: intl_msg[6495],
                heading: "ERROR",
                yesCbFn: cancelString,
                yesName: intl_msg[24184]
            }
            SirionUtils.openSirionDialogs(args);
            $($scope.currentOuterPopup).dialog("close");
            $scope.goToPreviousRoute();
        } else {
            $scope.gridData = {};
            $scope.myJson = data.body;
            $scope.header = data.header;
            $scope.layout = data.body.layoutInfo.layoutComponent;
            $scope.formatDate = convertToJquiDateFormat(data.body.globalData.dateFormatToShow) || "mm-dd-yy";
            dateFormatToShow = data.body.globalData.dateFormatToShow || "MM-dd-yy";
            $scope.timeFormatForPicker = getTimeDateFormat(data.body.globalData.datetimeFormatToShow);
            $scope.globalData = data.body.globalData;
            $scope.subScope = {};
            for (var i = 0; i < dataThatNeedsSpecialHandling.length; i++) {
                if (!summaryOnly && angular.isDefined(data.body.data[dataThatNeedsSpecialHandling[i]])) {
                    formService.transformData(data.body.data[dataThatNeedsSpecialHandling[i]], dataThatNeedsSpecialHandling[i]);
                }
            }
            $scope.global = data.body.layoutInfo.globalValues;
            $scope.data = data.body.data;
            $scope.data.dummyModels = [];
            $scope.downloadObj = data.body.layoutInfo.downloadObjectList;

            if($scope.layout) {
                $scope.showBaseClauseTab = _.get($scope, 'layout.fields.length') ? $scope.layout.fields.filter(field => field.label == intl_msg['35463']).length > 0 : false;
                $scope.breadcrumbTemplateToLoad = !!$scope.showBaseClauseTab ? 'createProjectStructure-0' : 'createProjectStructure';
            }

            setTimeout(()=>{
                if ((($scope.currentRelationId && !$scope.hideContractTree && $scope.data.parentEntityId && $scope.data.parentEntityTypeId) || $scope.showInWorkspace )&& $scope["showDocTree"]){
                    $scope.treeDefInstance = $q.defer();
                    $scope.treeDefInstance.promise.then(function () {
                        loadTree($scope.currentRelationId, undefined, true,$scope.data.id.values);
                    });
                }
            })
            if ($scope.pageType != "show") {
                formService.detailActions = [];
                var indexes = []
                if (data.body.layoutInfo && data.body.layoutInfo.actions && data.body.layoutInfo.actions.length) {
                    var prevActiveMap = {};
                    if (formService.buttonMapper) {
                        Object.keys(formService.buttonMapper).forEach(function (fId) {
                            formService.buttonMapper[fId].forEach(function (btn) {
                                if (btn.active && btn.properties && btn.properties.buttonType === 'upload') {
                                    if (!prevActiveMap[fId]) prevActiveMap[fId] = {};
                                    prevActiveMap[fId][btn.name] = true;
                                }
                            });
                        });
                    }
                    formService.buttonMapper = {};
                    data.body.layoutInfo.actions.forEach(function (field, i) {
                        if (field.properties && field.properties.detailsTab) {
                            formService.detailActions.push(angular.copy(field));
                            indexes.push(i);
                        }
                        if (field.properties && field.properties.targetLocation) {
                            indexes.push(i);
                            if (!formService.buttonMapper[field.properties.targetLocation]) {
                                formService.buttonMapper[field.properties.targetLocation] = [];
                            }
                            formService.buttonMapper[field.properties.targetLocation].push(field);
                        }
                    })
                    Object.keys(prevActiveMap).forEach(function (fId) {
                        if (formService.buttonMapper[fId]) {
                            formService.buttonMapper[fId].forEach(function (btn) {
                                if (prevActiveMap[fId][btn.name]) {
                                    btn.active = true;
                                }
                            });
                        }
                    });
                    for (var j = indexes.length - 1; j >= 0; j--)
                        data.body.layoutInfo.actions.splice(indexes[j], 1);
                }

                var printBtn = {
                    api: "/listRenderer/list/3",
                    "clientValidation": false,
                    "confirmationForBlockedEntities": false,
                    "hideWorkflowButton": false,
                    "name":intl_msg[26888],
                    "label":intl_msg[26888],
                    "properties": {
                        onClick: {
                            name: "directNonAjax"
                        }
                    },
                    "buttonPosition": 20,
                    "buttonType": 2,
                    "requestType": "Print",
                    "secondaryEntity": false,
                    "type": "list"
                }
                // data.body.layoutInfo.actions.push(printBtn);
                $scope.actions = data.body.layoutInfo.actions;
            }
            if (data.createLinks) {
                $scope.createLink = data.createLinks.fields;
                if ($scope.data && $scope.data.contract && $scope.data.contract.values && $scope.data.contract.values.id) {
                    $scope.contractPrevId = $scope.data.contract.values && $scope.data.contract.values.id;
                } else {
                    $scope.showBackNavigation = false;
                }
                $scope.showPlusSign = true;
                if (data.createLinks.fields.length == 0) {
                    $scope.showPlusSign = false;
                }
            } else {
                $scope.createLink = undefined;
                $scope.showPlusSign = false;
            }
            $scope.errors = data.body.errors;
            $scope.shouldIShowFieldErrorsVar = undefined;
            if ($scope.pageType != "show") {
                var undoButton = {
                    name: "Undo",
                    label: intl_msg[27452],
                    clientValidation: false,
                    type: "button",
                    cancelType:true,
                    properties: {
                        onClick: {
                            name: "undo"
                        },
                        showCondition: "undoDisable",
                        dontTouchThisButton: true
                    },
                    "buttonPosition": 10,
                    "buttonType": 3
                };
                if (angular.isDefined($scope.actions) && angular.isArray($scope.actions)) {
                    $scope.actions.push(undoButton);
                }
            }
            // push the actions in 2nd tab for show clause
            if ( angular.isDefined($scope.actions) && $scope.actions &&
                (window.entityURLdata && (window.entityURLdata.indexOf("/clause/show") > -1  || window.entityURLdata.indexOf("/contracttemplate/show") > -1))
                && data.body.layoutInfo.layoutComponent.fields.length>1 ) {
                data.body.layoutInfo.layoutComponent.fields[1]["actions"] = $scope.actions;
            }
            // push the actions in first tab..
            else if($scope.actions){
                if(data.body.layoutInfo.layoutComponent.fields[0]) {
                    data.body.layoutInfo.layoutComponent.fields[0]["actions"] = $scope.actions;
                }
            }
            if(window.entityURLdata && window.entityURLdata.indexOf("/clause/show") > -1){
                $scope.basePageIndex = 1;
            }
            $scope.errors = data.body.errors;
            $timeout(function () {
                $scope.initErrors();
            }, 0);

            if(($scope.showBulkActionDialog && $scope.showBulkActionDialog.visible) || ($scope.showInvoiceUploadDialog && $scope.showInvoiceUploadDialog.visible)){
                $scope.cloneText = data.body.layoutInfo.layoutComponent.fields[0].label;
            }

        }
        /*** ui2.0 specific changes **/
        if (_.has(data, 'body.layoutInfo')) {

            $scope.showFirstTabOnly = ($scope.showInWorkspace || $rootScope.mobileView) ? true : false;

            if ((data.body.data.entityTypeId.values == 3) && $scope.pageType == "globalCreate") {
                showPage2DataTransformationService.separateLeftRightTabs.call($scope, data.body.layoutInfo.layoutComponent.fields, data.body.data.entityTypeId.values, true,$scope.showInWorkspace);
            } else {
                showPage2DataTransformationService.separateLeftRightTabs.call($scope, data.body.layoutInfo.layoutComponent.fields, data.body.data.entityTypeId.values,undefined,$scope.showInWorkspace);
            }
            $scope.commSkeltonAttachment = true;
            //showPage2DataTransformationService.separateCommentData.call($scope);
            if ($scope.pageType != "show")
                showPage2DataTransformationService.separateButtons.call($scope, $scope.actions);
            // $scope.showDocTree = showPage2DataTransformationService.setVisiblityOfDocTree.call($scope);

            $scope.selectedLeftTabObj = $scope.leftTabInfo[0];
            if ($scope.metadatasearchPage) {
                showPage2DataTransformationService.separateSearchTableFieldInfo.call($scope);
            }
            if(['create', 'clone', 'globalCreate'].includes($scope.pageType)){
                docTreeService.metadataUrl = data.header.source;

                // docTreeService.uploadDocProp = data.body.layoutInfo.layoutComponent.fields[1].fields[0].fields;
            }
            if($scope.showWorkspaceView){
                $scope.showDocTree = false;
            }
        }
        $scope.showpageDataLoaded = true;
        $scope.$broadcast("updateTabsData");
        /*** ui2.0 specific changes **/
        $timeout(function () {
            if ($scope.pageType != 'show') {
                $scope.toggleAllGroupsVal = true;
                $scope.showDocTree = false;
            }else{
                (!$(".summaryCluster").length) ? $scope.showExpandAllInHeader=true : angular.noop();
            }
            if($scope.docViewerPage){
                $scope.expandLeftSection = false;
            }
            angular.element(".original#contentWrap").show();
            angular.element(".dummyShow").remove();
            angular.element(".searchDropdownEntity select").prop("disabled", false);
            stopLoader();

            $scope.commentLayout($scope);

            // Open Comm Panel based on user preference
            if(!summaryOnly)
                //$scope.setCommDataScope(1);
                showPageService.loadCommPanelPreference.call($scope);

            if (!summaryOnly && $scope.entityTypeIdJS == 61 && $scope.data.id && $scope.data.id.values) {
                angular.element("#j61_" + $scope.data.id.values + "_anchor").addClass("jstree-clicked");
            }
            $scope.scrollableView();
            $scope.populateReferencePage();
            $scope.treeDefInstance && $scope.treeDefInstance.resolve("loadTree");
            $(window).resize();
            addTitleToMultiSelect();
            if(window.emailTokenValidation) {
                var invalidLinks = $("a:not(.communication_expandIcon a):not(.toggleBtn):not(.rightSec a):not(.button-groups a):not(.mesh-list a)");
                invalidLinks.attr("href","javascript:void(0)");
                invalidLinks.addClass("notValidInMail");
                $("#wrapper").attr("style","height: 100% !important");
            }
        }, 100);
        if(isShowPageDataCall) {
            showPageService.suggestRefresh($scope);
        }
    };

    /***** NEW Functions written for show page ui2.0 ******/
    $scope.init();

    $scope.setselectedLeftTabIdx = function (idx) {
        $scope.selectedLeftTabIndex = idx;
        //$scope.selectedLeftTabObj=selObj;
        if($scope.previewTab.isActive){
            let generalTab = showPage2DataTransformationService.returnObj.allleftTabInfo.filter(tab => tab.id == 3502)[0];
            showPage2DataTransformationService.returnObj.selectedTabObj=generalTab;
            showPage2DataTransformationService.returnObj.selectedTabIndex=idx;
            formService.alertMe(idx, generalTab, null, $scope);
        }else if($scope.creditCalculation?.creditCalculateTable){
            const generalTab = showPage2DataTransformationService.returnObj.allleftTabInfo.filter(tab => tab.id == 1102)[0];
            showPage2DataTransformationService.returnObj.selectedTabObj=generalTab;
            showPage2DataTransformationService.returnObj.selectedTabIndex=idx;
            formService.alertMe(idx, generalTab, null, $scope);
            $scope.creditCalculation=null;
        }
        else {
            formService.alertMe(idx, null, null, $scope);
        }

    };
    $scope.findLastObjIndex = function(obj,prop,propValue){
        return _.findLastIndex(obj,function(o){return o[prop]== propValue});
    };

    $scope.fixedCommentData = false;
    $scope.removeLabelForCommentSec = {
        'id': 86,
        'newLabel': intl_msg[28056]
    };
    $scope.setselectedRightTabIdx = function (idx) {
        $scope.selectedRightTabIndex = idx;
        formService.alertMe(idx, null, null, $scope);
    };
    $scope.highLightCommentBox = function(e){
        $scope.showCommentBox=true;
        if(angular.element(e.target).closest('.jx-showPageTabContentRight.active').find('#jx-commentForm').find('.scrollable').length){
            angular.element(e.target).closest('.jx-showPageTabContentRight.active').find('#jx-commentForm').find('.scrollable').addClass('highlightedBox');
        }else{
            angular.element(e.target).closest('.jx-showPageTabContentRight.active').find('#jx-commentForm').find('textarea[name="comments"]').focus();
        }
    };
    //Call resizeDocTree function on Docviewer initially
    $scope.resizeDocTreeOnLoad = function(){
        setTimeout(function() {
            resizeForResizer();
        });
    }
    $scope.openRightSection = function openRightSection() {
        let selectedTab = showPage2DataTransformationService.returnObj.selectedTabObj;
        showPageService.openRightSection(selectedTab,$scope);
    }
    $scope.togglePropValue = function (propName, propVal,e) {
        let element;
        if(propName == 'showPagePreviewViewSubDoc'){
            element = document.querySelector(".local-listing-switch-sub-doc");
        } else if(propName == 'showPagePreviewViewHeadDoc'){
            element = document.querySelector(".select-head-document");
        } else if(propName == 'showPagePreviewView'){
            element = document.querySelector(".preview-ddl");
        }
        else {
            element = document.querySelector(".local-listing-switch");
        }
        if(typeof e != "undefined" && propName == "showCreateLinkDD")
            e.stopPropagation();
        if(element && angular.element(element).is('.highlightLocalListDD')){
            propVal = false;
        }
        if(e && (angular.element(e.toElement).is('.active') == true || $(e.target).closest('div').hasClass('tabdropright') || angular.element(e.currentTarget).is('.whiteBg'))){
             $scope.closeThis(propName);
        } else{
       if(propName == "showDocTree" && $scope.showWorkspaceView){
            showPage2DataTransformationService.toggleDocTreeVisibilitySession(true);
            window.open($scope.workSpaceCurrentListUrl, '_blank');
            return;
       }
       if(propName == "showDocTree" && $scope[propName] && propVal){
           return;
       }
        if (propVal != undefined) {
            $scope[propName] = propVal;
        } else {
            $scope[propName] = !$scope[propName];
        }
        if(propName == 'expandDocTree' || propName == 'showDocTree') {
            if($scope[propName] && !$scope.isNewCrudPage) {
                $scope.timeLineFeedScope = $scope.commentDataScope = undefined;
                $scope.timeLineFeedSecActive = false;
            }
            $timeout(()=>resizeForResizer());
        }
        if (propName == 'showDocTree') {
            if ($scope[propName]) {
                loadTree($scope.currentRelationId, undefined, true);
                showPage2DataTransformationService.toggleDocTreeVisibilitySession(true);
                if($scope.showInWorkspace){
                    if(!$scope.expandLeftSection){
                        $scope.expandLeftSection=true;
                    }
                    angular.element(".workSpaceShowDiv").find("#left_menu").addClass("inWorkSpaceView");
                } else if(!$scope.docViewerPage) {
                    $scope.expandLeftSection = true;
                    $scope.forceHideRightSec = true;
                }
                if($scope.isNewCrudPage)
                    $scope.expandLeftSection = false;
            }
            else {
                $("#left_menu.showPageLeftMenu").css("width",'45%');
                showPage2DataTransformationService.toggleDocTreeVisibilitySession(false);
                    // re-open right section if it was in opened state before.
                    $scope.openRightSection();
                }
            $timeout(function(){checkStepperOverflow();},300)
        } else if (propName == 'hideErrorListDiv') {
            if(document.getElementById("left_menu")) {
                if ($scope[propName]) {
                    document.getElementById("left_menu").style.top = '230px';
                } else {
                    document.getElementById("left_menu").style.top = '288px';
                }
            }
        } else if (propName == 'expandLeftSection') {
            $scope.closeDocViewer();
            //$scope.$broadcast('updateTabLength');
            if($rootScope.isInvoiceViewerActive && typeof propVal === "undefined") {
                $rootScope.isInvoiceViewerActive = false;
            }
            if ($scope.expandLeftSection == false) {
                if($scope.documentOpenWithForm) {
                    $scope.expandLeftSectionDocFormView = false;
                    $scope.showDetailSection = false;
                }
                $scope.showDocTree=false;

                // Commented due to timeline implementation
                /*if($scope.pageType == 'show')
                    showPage2DataTransformationService.toggleBrowserStorageObjVal(true, 'commPanel');*/

                $scope.$$postDigest(function() {
                    $scope.$broadcast('loadComment');
                });
                $scope.initLoadComments = false;
            }else{
                // Commented due to timeline implementation
                /*if($scope.pageType == 'show')
                    showPage2DataTransformationService.toggleBrowserStorageObjVal(false, 'commPanel');*/
            }
            $scope.showCommNotification = false;
            $scope.showTagTabOnClause = false;
            $scope.showTagTabOnTemplate = false;
            $timeout(function(){checkStepperOverflow();},300)
        } else if (propName == "showDetailSection" && $scope.documentOpenWithForm) {
            if ($scope.expandLeftSectionDocFormView == false && $scope.showDetailSection == true) {
                $scope.expandLeftSection = true;
            } else if ($scope.expandLeftSectionDocFormView == true) {
                $scope.expandLeftSectionDocFormView = false;
            }
        }
        if(propName=="showAdditionalTabsList"){
            if($scope.showAdditionalTabsList) {
                angular.element(".addTabs").addClass("whiteBg");
                angular.element(".tabs-wrapper").addClass("overflowVisible");
            }
            else{
                angular.element(".addTabs").removeClass("whiteBg");
                angular.element(".tabs-wrapper").removeClass("overflowVisible");
            }
        } else if (propName != "showUploadLinkDD") {
            $timeout(function () {
                $scope.$broadcast('updateTabLength');
            }, 100);
        }
        if(propName == "meshColValue" ){
            var elm = $(".clientSideValidation");
            if(propVal == 1){
                elm.removeClass("two-col-mesh-active").addClass("one-col-mesh-active");
                elm.css("top", (elm.parent().height() + 22) + "px");
            }
            else{
                elm.removeClass("one-col-mesh-active").addClass("two-col-mesh-active");
                elm.css("top", (elm.parent().height() + 2) + "px");
            }
        }
        if(propName == "expandRightSectionDoc" && propVal) {
            $scope.showDocTree = false;
        }
        if(propName == 'leftSecTransition' ){
            if($scope['leftSecTransition']){
                $('[class*="active-index"]').css({'transition': '.4s all'});
            } else {
                $('[class*="active-index"]').css({'transition': 'none'});
            }
        }
        if(propName == "showPageInvoiceView") {
                $scope.showPageInvoiceView ? $('#invoiceDrpDwnLi').show() : $('#invoiceDrpDwnLi').hide();
        }
        if(propName == "showPagePreviewView") {
            $scope.showPagePreviewView ? $('#previewDrpDwnLi').show() : $('#previewDrpDwnLi').hide();
        }
        if(propName == "showPagePreviewViewHeadDoc") {
            $scope.showPagePreviewViewHeadDoc ? $('#previewHeadDrpDwnLi').show() : $('#previewHeadDrpDwnLi').hide();
        }
        if(propName == "showPagePreviewViewSubDoc") {
            $scope.showPagePreviewViewSubDoc ? $('#previewSubDrpDwnLi').show() : $('#previewSubDrpDwnLi').hide();
        }
        if(propName == 'hideDocTree') {
            if(!propVal) {
                $scope.closeDocViewer();
            }
        }
        if(propName == 'showFileFilter') {
            if(!$scope['showFileFilter']) {
                $scope.classificationOpen = false;
                $scope.docTagsOpen = false;
            }
        }
        if(_.get($scope,'feedsResponse.entityTypeId') == 160 && !$scope.isdocTreeVisible()) {
            $scope.tabFullWidth = true;
        }

    }};

    $scope.createButtonTogglePropValue = function(event){
        $scope.togglePropValue('showCreateLinkDD',true,event);
        $scope.togglePropValue('showMoreBtnDD',false,event);
        $scope.togglePropValue('showPagePreviewViewHeadDoc',false,event);
        $scope.togglePropValue('showPagePreviewViewSubDoc',false,event);
        $scope.togglePropValue('showPagePreviewView',false,event);
    }

    $scope.toggleAllGroups = function(){
        /*To check CTRL-F Hit Case Always Expand All & show Collapse-All Option at the top
        * http://jira.sirionlabs.office/browse/SIR-194871
        * */
        if((event && ! (event.keyCode === $scope.f3Key ||
                ( ( event.ctrlKey || event.metaKey) && event.keyCode === $scope.fKey) )) || $scope.toggleAllGroupsVal == 0){
            $scope.toggleAllGroupsVal = !$scope.toggleAllGroupsVal;
        }
        if($scope.toggleAllGroupsVal || (event && event.keyCode === $scope.f3Key ||
                ( ( event.ctrlKey || event.metaKey) && event.keyCode === $scope.fKey) ) ){
            angular.element('.jx-headerCaret:visible').closest('fieldset').addClass('open');
            adjustDatatableColumnsizing(angular.element('.jx-toggleAllGroups').closest('.jx-parentForm'));
            resizeiframeinshowpage(angular.element('.jx-toggleAllGroups').closest('.jx-parentForm'));
        }else{
            angular.element('.jx-headerCaret:visible').closest('fieldset').removeClass('open');
        }

    };
    function resizeiframeinshowpage(elm){
        var ifrms = elm.find('.iframe_textEditor_showpage');
        for(var i =0;i<ifrms.length;i++){
            if(!angular.element(ifrms[i]).data('frameheight')){
                resizeIframe(ifrms[i], null,null);
                angular.element(ifrms[i]).data('frameheight',true);
            }

        }
    }
    $scope.shareWithCounterParty = function(wfId, requestId,field, fromAddNewExternalSupplierPopup){
        if(!fromAddNewExternalSupplierPopup){
            $scope.wfFields = field;
        }
        let url = window.location.href;
        if(wfId){
            url += url.includes("?") ? '&' : '?';
            url += 'wfId='+wfId
        }
        window.location.href = url;
        let propsToPass={
            dataOfShareCountyPartyModal: _.get($scope,"dataOfShareCountyPartyModal"),
            openFromShareWithConuterParty: _.get($scope,"openFromShareWithConuterParty"),
            dataOfnewExtarnalContract: _.get($scope,"dataOfnewExtarnalContract"),
            wfId,
            requestId,
        }
        let mountAt = '#shareWithCounterPartyModal';
        let interval = setInterval(() => {
            if ($(mountAt).length) {
                clearInterval(interval);
                if(!propsToPass.entityId || !propsToPass.entityTypeId){
                    propsToPass.entityId = _.get($scope.data,'id.values');
                    propsToPass.entityTypeId = _.get($scope.data,'entityTypeId.values');
                }
                if (!$(mountAt).children().length)
                    window.reactComponents.mountDynamicComponent(mountAt, "ShareWithCounterPartyModal",propsToPass);
                else {
                    window.sarc.channelBroadcast("shareWithCounterPartyModal", {
                        actionType:'openModal',
                        payload:propsToPass
                    }, 'shareWithCounterPartySubscription')
                }
            }
            if(_.get($scope,"openFromShareWithConuterParty")){
                $scope.openFromShareWithConuterParty = false;
                $scope.dataOfnewExtarnalContract = null;
                $scope.dataOfShareCountyPartyModal = null;
            }
        }, 10)
    }

    $scope.shareWithContractDoc = function(){
        let propsToPass = {
            entityId: _.get($scope.data,'id.values'),
            entityTypeId:_.get($scope.data,'entityTypeId.values'),
            tagsMetadata:$scope.tagsMetadata,
            tagsToUpdate: $scope.tagsToUpdate
        }
        let mountAt = '#shareWithContractDocModal';
        let interval = setInterval(() => {
            if ($(mountAt).length) {
                clearInterval(interval);
                if (!$(mountAt).children().length)
                    window.reactComponents.mountDynamicComponent(mountAt, "ModalForDoc",propsToPass);
                else {
                    window.sarc.channelBroadcast("shareWithContractDocModal", {
                        actionType:'openModal',
                        payload:propsToPass
                    }, 'shareWithContractDocSubscription')
                }
            }
        }, 10)
    }
    $scope.sendForSignature = function(wfId, wfReqId, field){
        $rootScope.$emit("clickAccountList",{wfId,wfReqId, field})
    }

    $scope.templateWizard = function(wfId, requestId){
        let url = '#/templateWizard/cdr/'+_.get($scope.data,'id.values')+'?wfId='+wfId+'&requestId='+requestId;
        if($scope.showOnlyTemplateSuggestion) {
            url = window.SirionUtils.addQueryString(url, "showOnlyTemplateSuggestion=" + $scope.showOnlyTemplateSuggestion)
        }
        window.location.href = url;
    }

    $scope.loadClauseAssembly = function(wfId, requestId){
        let agreementType = _.get($scope.data,'agreementType.values.id');
        if(agreementType)
            window.location.href = '#/clauseAssembly/cdr/'+_.get($scope.data,'id.values')+'/'+agreementType+'?wfId='+wfId+'&requestId='+requestId;

    }

    function triggerReference(api) {
        startLoader();
        $http.get(addtStamp(api))
            .then(function(response){
                stopLoader();
                if(response.status == 200){
                    let message = _.get(response,"data.response");
                    Toaster.create(message || "Request submitted successfully" ,{iconClass:"icon-Information_filled"});
                }
            })
    }

    $scope.getWorkflowId = function(wfId){
        return wfId?.split("work-")[1] || "";
    }

    $scope.btnClick = async function (e, btn) {
        // EC Cancel uses directNonAjax → listing; restore CDR create instead.
        if (btn && btn.cancelType && $scope.isCdrCreateExternalContactFlow && $scope.isCdrCreateExternalContactFlow()) {
            $scope.handleCdrCreateExternalContactCancel();
            return;
        }
        if(window.listFieldsLinkedCLI?.length && btn.api.includes("/cdr/edit")){
            const ulHtml = `<ul class="disc-type">${window.listFieldsLinkedCLI.map(item =>`<li>${item.label}</li>`).join("")}</ul>`
            const popUpText = intl_msg[36130] || "New Following fields are used in associated line-item records. Do you want to automatically remove the unselected options from all line-item records? testing";
            const args = {
                popupType: 'confirm',
                str:`<div><p>${popUpText}</p>${ulHtml}<div>`,
                yesCbFn: function () {
                    delete window.listFieldsLinkedCLI;
                    $scope.data.removeInvalidOptionsFromCli.values = true
                    $scope.btnClick(e, btn);
                },
                heading: intl_msg[25772],
                noCbFn: 'successOnBothFalse',
                yesName: intl_msg[25815],
                noName: intl_msg[25816]
            }
            SirionUtils.openSirionDialogs(args);
            return;
        }
        if(btn?.api?.includes("{parentEntityId}") && _.get( $scope.data, "supplier.values")){
            const url = btn.api.replace("{parentEntityId}", $scope.data.supplier.values.id ? $scope.data.supplier.values.id: $scope.data.supplier.values[0].id);
            btn.api = url
        }
        localStorage.removeItem('docTreeCache');
        let responseData = {};
        let shouldBeGenerated = false;
        let stopTemplateWizard = false, showOnlyTemplateSuggestion = false;
        $scope.showOnlyTemplateSuggestion = false;
        const entityTypeId = $scope.data?.entityTypeId;
        const entityId = $scope.data?.id?.values;
        if((btn?.nonWorkFlowAction?.id == 2 || btn?.nonWorkFlowAction?.name == "Template Wizard")){
            responseData = await showPageService.shouldGenerateDraft(entityTypeId, entityId);
            shouldBeGenerated = responseData?.data?.responseCode == '200' ? true : false;
            stopTemplateWizard = responseData?.data?.stopTemplateWizard;
            $scope.showOnlyTemplateSuggestion = responseData?.data?.showOnlyTemplateSuggestion;
            stopLoader();
        }

        if(shouldBeGenerated){
            let wfData = {}
            wfData = _.get($scope, 'data');
            $scope.selectedButton = btn.label;
            $scope.submitData(btn.api, wfData, "post", true, false, btn);
        } else {
            if (stopTemplateWizard) {
                Toaster.create(responseData?.data?.response);
                return;
            }
        if ($scope.commentFromReact && $scope.data?.comment?.comments?.values) {
            let domParse = new DOMParser();
            let doc = domParse.parseFromString($scope.data.comment.comments.values, 'text/html');
            let allEms = doc.body.querySelectorAll('.mention usr-email');
            Array.prototype.map.call(allEms, em => {
                em.remove();
            })
            $scope.data.comment.comments.values = doc.body.innerHTML;
        }
        if(btn.api && btn.api.includes("trigger-parent-reference")){
            triggerReference(btn.api);
            return;
        }

        if($scope.exceptionalInNewUx.isSpecialDataAPI(btn.api)) {
            $scope.plusIconReq(btn.api,btn.label,btn);
            return;
        }

        // todo need to remove this fix as wee need to find the root cause for this. It is just a hack to solve UI-10033
        $rootScope.newlyCreatedSuppArray = [];

        //this condition to store a data, when user create new external contact
        if(($scope.openFromShareWithConuterParty || $scope.openFromUserRoleGroup ||
                $scope.openFromSendForSignatue )&& btn.properties["onClick"]["name"] === 'submitData'
            && !_.get($scope.data,"supplier.options.data.length")){
            $scope.dataOfnewExtarnalContract = {emailId:$scope?.data?.emailId?.values,name:$scope?.data?.name?.values}
        }

        //this condition use to change btn api at time of submit, if the contract will have multiple supplier and user will choose one suplier
        if(($scope.openFromShareWithConuterParty || $scope.openFromUserRoleGroup || $scope.openFromSendForSignatue)
            && _.get($scope.data,"supplier.options.data.length")
            && _.get($scope.data,"supplier.values.id")
        ) {
            if(!isNaN(Number($scope.data.supplier.values.id))) {
                btn.api = `/externalcontact/new/${Number($scope.data.supplier.values.id)}${$scope.openFromSendForSignatue ? '?withInternalContact=true':'/'}`
            } else {
                Toaster.create(intl_msg[32118] || "Something went wrong",{iconClass:"icon-Information_filled"})
                return;
            }
        }
        if($scope.advSearchForm) {
            _.forEach($scope.data.dynamicMetadata,(val,key) => {
                if(Array.isArray(val.values) && typeof val.values[0] == "object") {
                    let remove =  Object.keys(val.values[0]).find(x => x.indexOf("dyn") > -1);
                    remove && (val.values = []);
                }
            })
        }
        if(e?.currentTarget?.classList?.contains("disabled")){return;}
        if(angular.element(".fieldError-ribbon.active").length){
            angular.element(".fieldError-ribbon").removeClass("active");
        }
        if(docTreeService.showDoctreeTemplate){
            docTreeService.toggleDocEditTemplate(false);
            $rootScope.$emit("Active index of breadcrumb", "create",$scope.pageType=="globalCreate"?1:0);
            $timeout(function(){
                if(!angular.element(e.target).hasClass('disabled')){
                    showPage2DataTransformationService.btnClick.call($scope, angular.element(e.currentTarget), btn);
                }
            },0);
        }else{
            if(!angular.element(e.target).hasClass('disabled')){
                if(btn.cancelType == false){
                    $rootScope.$emit("Active index of breadcrumb", "createInvoiceContractShowPage", 0);
                    $rootScope.$emit("Active index of breadcrumb", "createInvoiceShowPage", 1);
                    $rootScope.$emit("Active index of breadcrumb", "createEditClause", 0);
                    if (!$rootScope.preSignature.templateCEpage) {
                        $rootScope.$emit("Active index of breadcrumb", "create", 0);
                    }
                }
                let target = e.target;
                angular.element(target).addClass('disabled');
                setTimeout(function() {
                    angular.element(target).removeClass('disabled');
                }, 3000);
                if(window.emailTokenValidation){
                    window.workflowActionDone = true;
                    if(e.currentTarget.id === "jx-addCommentButton")
                        btn = $scope.saveCommentButton;
                    if($scope.firstLoadByEmail){
                        angular.element(e.target).removeClass('disabled');
                        $scope.firstLoadByEmail = false;
                    }
                }
                //using timeout so that the function has enough time to delete the key isDynData
                $timeout(function () {
                    showPage2DataTransformationService.btnClick.call($scope, angular.element(e.currentTarget), btn);
                }, 0);
            }
        }
        if(btn.api){
            // For HEAP Analytics
            if(btn.api.indexOf("/bulk") > -1){
                var postValForHeap = "", bulkType;
                if(btn.api.indexOf("/bulkedit/edit") > -1){
                    bulkType = 1;
                } else if(btn.api.indexOf("/bulkaction/save") > -1){
                    bulkType = 2;
                } else if(btn.api.indexOf("/commentAttachments/bulkSave") > -1){
                    bulkType = 3;
                }
                if(typeof listJson != "undefined" && listJson.entityTypeId){
                    postValForHeap = SirionUtils.transformEntityName(NumToURLPartMapping[listJson.entityTypeId]);
                }
                bulkType ? SirionUtils.triggerHeap(bulkType,"bulk", postValForHeap) : '';
            }

            // For clone page on invoice
            if(btn.api.indexOf("/baseInvoice/clone") > -1){
                $scope.isInvoiceViewerActive = false;
            }
            if(btn?.api?.indexOf("/tblcontracts/create") > -1){
                $scope.skipStopLoader = true;
            }
        }
        $scope.enableAddComment = false;
        $scope.resetCommentScope = ( angular.isDefined($scope.insightView) && angular.isDefined($scope.showWorkspaceView) &&
                                    !$scope.showWorkspaceView && !$scope.insightView && (!btn.cancelType) );
        }
    };

    $scope.openCloningConfirmation = (e, btn, entityName, entityId, entityTypeId) =>{
        const entityTypeName = listIdToEntityDataMapper[entityTypeIdToListIdMapper[entityTypeId]].url;
        const link = `#/show/${entityTypeName}/${entityId}`
        if(btn.name != 'Cancel') {
            const args = {
                popupType: 'confirm',
                str: `<a href="javascript:void(0)" onclick="redirectToShowPageAfterCloning('${link}')">${entityName}</a> ${intl_msg[35737] || 'contains additional data. Please select the items you want to clone.'} <ul>
                                                    <li> 
                                                        <label class="label-disabled"> 
                                                            <input checked disabled type="checkbox"/>
                                                            <span>${intl_msg[35755] || 'Field Values'}</span>
                                                            <i data-mod-title=${intl_msg[35755] || 'Field Values'} new-style-tooltip="tooltip-newStyle2 bottom" 
                                                            class="icon-Information icon-info-blue"></i>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input onchange="selectTabToClone()" type="checkbox"/>
                                                            <span>${intl_msg[31612] || 'Contract Line Items'}</span>
                                                            <i data-mod-title=${intl_msg[31612] || 'Contract Line Items'} new-style-tooltip="tooltip-newStyle2 bottom" 
                                                            class="icon-Information icon-info-blue"></i>
                                                        </label>
                                                    </li>
                                                </ul>`,
                yesCbFn: function () {
                    $scope.btnClick(e, btn);
                },
                heading: intl_msg[25772],
                noCbFn: 'resetCloneCLIState',
                yesName: intl_msg[35768] || 'Proceed',
                noName: intl_msg[23731]
            }
            SirionUtils.openSirionDialogs(args);
        }else{
            $scope.btnClick(e, btn);
        }
    }

    window.redirectToShowPageAfterCloning = (link) => {
        let args = {
            str: ''
        }
        SirionUtils.openSirionDialogs(args);
        window.location.href = link;
    }

    window.selectTabToClone = (e) => {
        $scope.isCloneCLIFrom = !$scope.isCloneCLIFrom;
        if($scope.isCloneCLIFrom) {
            $scope.data['cloneCLISource'] = $scope.data.cloneCLIFrom;
        }else{
            delete $scope.data['cloneCLISource'];
        }
    }

    $scope.toggleDisplay = function (e) {

        var x = angular.element('.jx-parentForm').find('fieldset');
        var j = _.filter(x, function (o) {
            return (!angular.element(o).hasClass('non-box') && !angular.element(o).parent().is('fieldset') && !angular.element(o).parent().hasClass('summaryCluster'));
        });

        angular.element(e.target).closest('fieldset').toggleClass('open');
        if (_.filter(j, function (o) {
                return angular.element(o).hasClass('open');
            }).length == j.length) {
            $scope.toggleAllGroupsVal = true;
        }
        if (_.filter(j, function (o) {
                return !angular.element(o).hasClass('open');
            }).length == j.length) {
            $scope.toggleAllGroupsVal = false;
        }
        adjustDatatableColumnsizing(angular.element(e.target).closest('fieldset'));
        resizeiframeinshowpage(angular.element(e.target).closest('fieldset'));
    };

    $scope.openCreateSubDD = function (e) {
        e.stopPropagation();
        showPageService.fetchTemplateCreateSubDD(e, $scope);
    };

    /* function to adjust datatable column width */
    function adjustDatatableColumnsizing(elem){
        var oTable = elem.find('.dataTables_scrollBody>table');
        if (oTable.length > 0) {
            oTable.each(function () {
                if ($(this).scope() && $(this).scope().dataTable) {
                    $(this).scope().dataTable.fnAdjustColumnSizing(false);
                }

            });
        }
        var unCompiledTables = elem.find("[my-table]:not(.dataTable)");
        if(unCompiledTables.length > 0){
            unCompiledTables.each(function(){
                var tableScope = $(this).scope();
                tableScope.deferredInstance.resolve("Initiated");
                tableScope.deferredInstance.promise.then(function () {
                    tableScope.deferred.promise.then(function () {
                        tableScope.$broadcast("initializeTable");
                    });
                });
            })
        }
    };
    $scope.toggleShowCommentBox = function(){
        $scope.showCommentBox=true;
        $scope.setFieldFocus("comments", 500);
    }
    $scope.setFieldFocus = function (value, delay) {
        $timeout(function (){
            angular.element("[name="+value+"]").focus();
        },delay);
    }
    $scope.cancelCommentSaveOperation = function (e) {
        $scope.data.comment = angular.copy($scope.tempCommentData);
        angular.element(e.target).closest('#jx-commentForm').find('.jx-fileListDiv').html('');
        $scope.enableAddComment = false;
        if(angular.element(e.target).closest('#jx-commentForm').find('iframe').length){
            angular.element(e.target).closest('#jx-commentForm').find('iframe').contents().find('.note-editable').html('').addClass('hasPlaceholder');
            angular.element(e.target).closest('#jx-commentForm').find('#jx-addCommentButton').addClass('disabled');
            $timeout(function(){
                $compile(angular.element(e.target).closest('#jx-commentForm').find('div[append-content]'))($scope);
            },10);
        }
        showPageService.setValueOfenableAddComment.call($scope);
        $scope.showCommentBox = false;
        if($scope.oldTimeLineFeedScope) {
            $scope.setTimelineFeedDataScope($scope.oldTimeLineFeedScope);
        }
    };
    $scope.switchView = function(e){
        if(angular.element('#jx-switchView').prop('checked')){
            $location.path('/'+$routeParams.action+'/'+$routeParams.entityName+'/'+$routeParams.entityId);
        }
    };
    $scope.openNovation = function(data){
       $scope.novateData = data
        $scope.novationDialogInstance = $modal.open({
            templateUrl: $rootScope.createHtmlUrl("novationPopup.html"),
            modal: true,
            size: "lg",
            keyboard: false,
            animation: true,
            height: "auto",
            windowClass: "novationPopupDialog clonepopup",
            resizable:false,
            backdrop: "static",
            id: "novationDialog",
            scope: $scope
        })
        $scope.novationDialogInstance.result.then(function(){
            if($rootScope.bulkNovation){
                $scope.showEditButton.enabled = true;
                window.sarc.channelBroadcast("docTreeChannel", {
                    actionType: "clearSelectedNodes"
                }, 'docTreeChannelSubscription')
            }
            $rootScope.bulkNovation=false;
            delete $scope.novationDialogInstance;
            delete  $scope.novateData;
            $("#overlay").remove();
        })
    };

    /***** NEW Functions written for show page ui2.0 ******/

    $scope.checkLoadFreeForm = function (field, data) {
        formService.createContractCDRData($scope, field);
        const extractedWfId = SirionUtils.getParameterValueFromURL(field.api,'workflowId');
        extractedWfId && sessionStorage.setItem('wf_id', extractedWfId);
        if($scope.data.autoPortContract && $scope.data.autoPortContract.values) {
            var parentEntityTypeId, parentEntityIds, relationIds;
            if($scope.data.suppliers && $scope.data.suppliers.values){
                parentEntityTypeId = 1;
                if($scope.data.suppliers.values.id){
                    parentEntityIds = [$scope.data.suppliers.values.id];
                }else if($scope.data.suppliers.values.length){
                    parentEntityIds = $scope.data.suppliers.values.map((obj)=>{return obj.id})
                }
            }
            if($scope.data.contractSupplier && $scope.data.contractSupplier.values){
                parentEntityTypeId = 1;
                if($scope.data.contractSupplier.values.id){
                    parentEntityIds = [$scope.data.contractSupplier.values.id];
                }else if($scope.data.contractSupplier.values.length){
                    parentEntityIds = $scope.data.contractSupplier.values.map((obj)=>{return obj.id})
                }
            }
            if($scope.data.contractParent && $scope.data.contractParent.values){
                parentEntityTypeId = 61;
                relationIds = angular.copy(parentEntityIds);
                if($scope.data.contractParent.values.id){
                    parentEntityIds = [$scope.data.contractParent.values.id]
                }else if($scope.data.contractSupplier.values.length){
                    parentEntityIds = $scope.data.contractParent.values.map((obj)=>{return obj.id})
                }
            }

            if(!parentEntityIds) {
                Toaster.create("Please select a supplier for Contract Draft Request.",{iconClass:"icon-Information_filled"})
                return;
            }

            var postBody = {
                documentTypeId: $scope.contractFromCDRData.documentTypeId,
                parentEntity:{
                    entityIds:parentEntityIds,
                    entityTypeId:parentEntityTypeId
                },
                sourceEntity:{
                    entityIds:[$scope.data.id.values],
                    entityTypeId: $scope.data.entityTypeId.values
                },
                actualParentEntity:{
                    entityIds:parentEntityIds,
                    entityTypeId:parentEntityTypeId
                }
            };

            if(relationIds){
                postBody.relationIds = relationIds;
            }
            var autoCreateUrl = "/contracts/autoCreate";
            startLoader();
            entityFactory.getJson(autoCreateUrl, "POST", entity, postBody, false).then(function(res){
                stopLoader();
                if(_.get(res,"header.response.status") == "success") {
                    $(".tab-detail .dataTables_scrollBody table").each(function () {
                        var scopeTemp = $(this).scope();
                        scopeTemp.$broadcast("refreshData");
                    });
                    $scope.responsePopUp(res);
                }
                else {
                    $scope.loadFreeFormDialogBox(field, data);
                }
            }).catch(function(err){
                stopLoader();
                var res = JSON.parse(err.responseText);
                if(_.get(res,"header.response.errorMessage")){
                    if(_.get(res,"header.response.type") == "globalCreate") {
                        field.jspApi = "/admin/contractFreeCreate/" + $scope.contractFromCDRData.sourceEntityId + "/" + $scope.contractFromCDRData.sourceEntityTypeId + "/"+ $scope.contractFromCDRData.documentTypeId;
                        $scope.loadFreeFormDialogBox(field, data, true);
                    } else if(_.get(res,"header.response.type") == "notification") {
                        Toaster.create(res.header.response.errorMessage,{iconClass:"icon-Information_filled"});
                    }
                    else
                        $scope.loadFreeFormDialogBox(field, data);
                }
            });
        }else {
            $scope.loadFreeFormDialogBox(field, data)
        }
    };

    $rootScope.createSurvey = async (isSupplierSurvey, isBulkSurvey) => {
        if(isSupplierSurvey) {
            if(window.checkedVal.length > 0 && !isBulkSurvey) {
                window.checkedVal = [];
            }

            if(!window.supplierDataDB) {
                window.supplierDataDB = await window.getIndexedDB() || null;
            }

            const supplierEntityIds = window.supplierDataDB.transaction('supplierEntityIds', 'readwrite').objectStore('supplierEntityIds');
            supplierEntityIds.clear();

            const addEntityIds = supplierEntityIds.add({
                entityKey: 'entityIds',
                entityData: window.checkedVal.length > 0
                    ? [...window.checkedVal]
                    : [parseInt($rootScope.relationId, 10)]
            });
            addEntityIds.onerror = (e) => {
                Toaster.create("Saved supplier data failed.", {iconClass: "icon-Information_filled"});
                return;
            }
            addEntityIds.onsuccess = () => {
                const supplierData = window.supplierDataDB.transaction('supplierData', 'readwrite').objectStore('supplierData');
                let supplierDataArray = [];
                if (isBulkSurvey) {
                    var promise = $.ajax({
                        type: 'post',
                        contentType: "application/json;charset=UTF-8",
                        async: false,
                        data: JSON.stringify({
                                clientId: window.clientId,
                                surveyId: "",
                                entityIds: window.checkedVal,
                                limit: 15,
                                offset: 0,
                                entityTypeId: window.listJson?.entityTypeId,
                                searchParam: "",
                                isFirstCall: true
                            }),
                        url: "/survey/list/entities",
                        success: function (response, status) {
                            stopLoader();
                            supplierDataArray = response?.body?.entities;
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            stopLoader();
                            handleErrorResponse(jqXHR);
                            Toaster.create("Saved supplier data failed.", {iconClass: "icon-Information_filled"});
                            return false;
                        }
                    })
                } else if (!isBulkSurvey && _.get($rootScope, 'relationId')) {
                    supplierDataArray = [{
                        entityShortId: _.get($rootScope, 'data.shortCodeId.values'),
                        entityName: _.get($rootScope, 'listName')
                    }];
                }
                if(_.size(supplierDataArray) > 0) {
                    const addSupplierData = _.forEach(supplierDataArray, (supplier) => supplierData.add(supplier));
                    if (_.size(addSupplierData) > 0) {
                        window.location.href = appName + "#/createSurvey?" + showPageService.getSurveyQueryParams(isSupplierSurvey, isBulkSurvey);
                    } else {
                        Toaster.create("Saved supplier data failed.", {iconClass: "icon-Information_filled"});
                    }
                }
            }
        } else {
            window.deleteIndexedDB();
            window.location.href = appName + "#/createSurvey?" + showPageService.getSurveyQueryParams(isSupplierSurvey, isBulkSurvey);
        }
    }
    $rootScope.createTemplate = function(isSupplierTemplate) {
        if (!isSupplierTemplate) {
            window.deleteIndexedDB();
        }
        $window.location.href = appName + "#/createTemplate?" + showPageService.getSurveyQueryParams(isSupplierTemplate, false);
    }

    $scope.loadFreeFormDialogBox = function (field, data, openGlobalForm) {

        $scope.showFreeFormContract = false;
        startLoader();
        field.api = field.api || "/admin/contractFreeCreate";
        $scope.newFreeFormInfoHelper = null;
        var documentTypeId = $scope.contractFromCDRData && $scope.contractFromCDRData.documentTypeId;
        if (!documentTypeId) {
            documentTypeId = 4
        }
        $window.jsonApi = field.api + "/" + data.id.values + "/" + data.entityTypeId.values + "/" + documentTypeId;
        $scope.showErrorModal = true;

        if (!$scope.globalData.dynamicFormId){
            if ($.isEmptyObject($scope.contractFromCDRData) == false && _.get($scope.data.contractSupplier, "options.data")) {
                //Global create form fields editable on CDR show page
                $rootScope.IShouldSeeFieldErrors(true);
                // Open create page directly (Skipping Global create form)
                createFreeFormUrl(field, data);
            } else {
                field.jspApi = "/admin/contractFreeCreate/" + $scope.contractFromCDRData.sourceEntityId + "/" + $scope.contractFromCDRData.sourceEntityTypeId + "/" + documentTypeId;
                $scope.plusIconReq(field.jspApi, field.label, field);
            }
        }else{
            //
            let shouldOpenGlobalForm = $.isEmptyObject($scope.contractFromCDRData) ||  !_.get($scope.data.contractSupplier, "options.data") || openGlobalForm;

            if(!shouldOpenGlobalForm) {
                //MSA && PSA
                if (field.createEntityTypeId == 5 || field.createEntityTypeId == 4) {
                    let contractSupplier = _.get($scope.data,"contractSupplier.values")
                    shouldOpenGlobalForm = _.isEmpty(contractSupplier);
                }
                if (field.createEntityTypeId == 9 || field.createEntityTypeId == 10) {
                    let contractSupplier = _.get($scope.data,"contractSupplier.values");
                    let contractParentEntityType= _.get($scope.data,"contractParentEntityType.values");
                    let contractParent = _.get($scope.data,"contractParent.values");
                    shouldOpenGlobalForm = _.isEmpty(contractSupplier) || _.isEmpty(contractParentEntityType) || _.isEmpty(contractParent);
                }
                if(!shouldOpenGlobalForm){
                    createFreeFormUrl(field, data);
                } else{
                    //this variable to be used for transmitting data to RDF
                    //to prepopulate values
                    $scope.newFreeFormInfoHelper = {
                        btnInfo: field,
                        contractSupplier:_.get($scope.data,"contractSupplier"),
                        contractParentEntityType:_.get($scope.data,"contractParentEntityType"),
                        contractParent:_.get($scope.data,"contractParent"),
                        customer:_.get($scope.data,"customer")
                    }
                }
            }

            if(shouldOpenGlobalForm){
                window.sessionStorage.setItem('raiserequestBaseUrl', window.location.href?.split(`/${envAlias}`)[1]);
                field.jspApi = "/admin/contractFreeCreate/" + $scope.contractFromCDRData.sourceEntityId + "/" + $scope.contractFromCDRData.sourceEntityTypeId + "/" + documentTypeId;
                $scope.plusIconReq(field.jspApi, field.label, field);
            }
        }
    }
    $scope.createFreeFormUrl = function(field){
        return createFreeFormUrl(field);
    }

    function createFreeFormUrl(field,data){
        var sendMethod = "post";
        var url = appName + "/contracts/v1/new:;post";
        var parentEntityTypeId, parentEntityIds, relationIds;

        var basicValidation =  showPageService.getFormValidity.call($scope, true);
        if( basicValidation && !$scope.globalData.dynamicFormId ) {
            basicValidation = formService.validateRequiredFields($scope, field);
        }

        if(!basicValidation) {
            var generalTab = $("show-page-tabs ul").first().find("li").first();
            if (!generalTab.hasClass("active")) {
                $scope.$$postDigest(function () {
                    generalTab.trigger('click');
                    showPageService.scrollToElem("postError");
                    stopLoader();
                });
            } else {
                showPageService.scrollToElem("postError");
                stopLoader();
            }
            return false;
        }

        if($scope.data.contractSupplier && $scope.data.contractSupplier.values){
            parentEntityTypeId = 1;
            if($scope.data.contractSupplier.values.id){
                parentEntityIds = [$scope.data.contractSupplier.values.id];
            }else if($scope.data.contractSupplier.values.length){
                parentEntityIds = $scope.data.contractSupplier.values.map((obj)=>{return obj.id})
            }
        }
        if($scope.data.contractParent && $scope.data.contractParent.values){
            parentEntityTypeId = 61;
            relationIds = angular.copy(parentEntityIds);
            if($scope.data.contractParent.values.id){
                parentEntityIds = [$scope.data.contractParent.values.id]
            }else if($scope.data.contractSupplier.values.length){
                parentEntityIds = $scope.data.contractParent.values.map((obj)=>{return obj.id})
            }
        }
        var postBody = {
            documentTypeId: $scope.contractFromCDRData.documentTypeId,
            parentEntity:{
                entityIds:parentEntityIds,
                entityTypeId:parentEntityTypeId
            },
            sourceEntity:{
                entityIds:[$scope.data.id.values],
                entityTypeId: $scope.data.entityTypeId.values
            },
            actualParentEntity:{
                entityIds:parentEntityIds,
                entityTypeId:parentEntityTypeId
            }
        };

        if(relationIds){
            postBody.relationIds = relationIds;
        }
        $scope.savedBodyReq = postBody;
        docTreeService.docUploadPostBody = postBody;
        field.jspApi = url;
        $scope.plusIconReq(field.jspApi,field.label,field);
        return field.jspApi;

    }
    function renderFormInModal(urlp, isContractParentPopup,dialogTitle) {
        var promise = $.ajax({
            type: 'GET',
            cache: true,
            dataType: "html",
            url: urlp,
            success: function (response, status) {
                stopLoader();
                if (isContractParentPopup) {
                    $('#showdialog_list').dialog("close");
                    $scope.showSourceNameTitle = false;
                    $scope.showFreeFormContract = false;
                }
                $('#showdialog').html(response);
                $("#showdialog").dialog("open");
                if(dialogTitle){
                    $("#showdialog").dialog("option","title", intl_msg[25535]+" "+dialogTitle);
                }
                if ($("#showdialog").find("input[type='text']").length > 0)
                    $("#showdialog").find("input[type='text']")[0].focus();
                //start code to compile popup in angularjs -- added by pushpendra
                if (typeof angular != "undefined") {
                    var scope = angular.element($("#data-ng-app")).scope();
                    document.createElement('dynamicForm');
                    document.createElement('dynamic-form-new');
                    $('#showdialog').off("dialogclose");
                    $('#showdialog').on("dialogclose", function () {
                        $(".showPage").eq(1).fadeOut("slow");
                        scope.closePopupFlag();
                        if ($(".showPage").size() > 1) {
                            $(".showPage:last").remove();
                        }
                        setTimeout(function () {
                            scope.applyBasePageJson();
                            $("#mainContainer .dataTables_wrapper > .dataTables_filter, #mainContainer  .dataTables_wrapper > .dataTables_length, #mainContainer  .dataTables_wrapper > .dataTables_info, #mainContainer  .dataTables_wrapper > .dataTables_paginate").remove();
                            $(".showPage").fadeIn("slow");
                        }, 10);
                    });
                    $scope.compilePopupHtml("#showdialog");
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                stopLoader();
                if (jqXHR.status == 704) {
                    Toaster.create(dm_popup["dm_upload_contract"]);
                } else if (jqXHR.status == 801) {
                    Toaster.create(intl_msg[6423],{iconClass:"icon-Information_filled"});
                } else
                    handleErrorResponse(jqXHR);
            }
        })
    }
    $scope.changeBulkDownloadFileType = function(type) {
        $scope.bulkDownloadFileType = type;
    }
    $scope.plusIconReq = function (api, title, field, integration, meetingNoteId, bulkProps, isListPage, fromSupplierDropdown = false, template) {
        $scope.showAmendment = false;
        $scope.fromSupplierDropdown = fromSupplierDropdown;
        const fieldParams = api && SirionUtils.getQueryParam(api);
        const wf_id = fieldParams && fieldParams['workflowId'] || sessionStorage.getItem('wf_id');
        wf_id ? ($rootScope.createForWorkflowId = wf_id) : delete $rootScope.createForWorkflowId;
        if(!$rootScope.externalContract && title && title!=" " && title.split(" ")[0]=="Create"){
            title = intl_msg[25535]+" "+title.split(" ")[1];
        }
        $("#drop").hide();
        if(_.get(field, "properties.showDocumentTreeFiles")) {
            $scope.showAmendment = true;
            $scope.shouldEnableGlobalHeader('show', $scope);
        }
        var enabledImportFromCdr  = showPageService.checkCDRimportEnability(field,docTreeService,$scope);
        if(typeof(listJson) != "undefined" && listJson.id == 434 && $scope.docTreeFilterPage && $scope.showDocTree){
            filterDataJson = getNewFilters(false);
            $.each( filterDefaultDataJson, function(a, b) {
                if( !(a in filterDataJson) ) {
                    filterDataJson[a] = b;  }
            });
            preserveFltrMap = {
                "listJson" : listJson,
                "filterDataJson" : filterDataJson,
                "filterDefaultDataJson" : filterDefaultDataJson,
                "filterMetaDataJson" : filterMetaDataJson,
                "userListMetaData" : userListMetaData,
                "rptId": parseInt(window.localStorage.getItem("rpt"))
            };
            preserveFltrMap = angular.copy(preserveFltrMap);
        }
        if (integration) {
            if ((["On Hold", "Rejected", "Activate", "Reprocess", "Reprocess Xml"]).indexOf(field.name) > -1) {
                getData = entityFactory.getJson(api, field.requestType, integration);
                getData.success(function (data) {
                    stopLoader();
                    const args = {
                        popupType: 'alert',
                        str: data.message,
                        yesCbFn: "cancelModal",
                        yesName: intl_msg[24184]
                    }
                    if(data.status == 200){
                        args.heading = intl_msg[24153];
                    }else{
                        args.heading = "ALERT";
                    }
                    SirionUtils.openSirionDialogs(args);
                });
            } else if ((["Back"]).indexOf(field.name) > -1) {
                location.href = urlFactory.getEntityListUrl(field.api);
            } else {
                $scope.createFromXml = true;
                loadDialogBox($rootScope.createHtmlUrl("formView.html"), null, "PORT", api);
            }
        } else if (field && field.bulkSystemLabel == "Bulk") {
            var text1=intl_msg[25536];
            var text2=intl_msg[25537];
            var text3=intl_msg[25538];
            var text4 = intl_msg[25539];
            var text5 = intl_msg[25540];
            const text6 = "Download Master Data";
            var uploadUrl = appName + field.properties.uploadAPI;
            $scope.downloadUrl = appName + field.properties.downloadAPI;
            if(template?.ProvisioningId) {
                $scope.downloadUrl = $scope.downloadUrl + '?provisioningId=' + template.ProvisioningId;
                provisioningId = template.ProvisioningId;
            }
            $scope.serviceDataRequest = false;
            if(field.isServiceDataUpload){
                $scope.serviceDataRequest = true;
                $scope.downloadUrl.slice(-1) === '/' ? $scope.downloadUrl += $scope.routeParams.entityId : $scope.downloadUrl += "/" + $scope.routeParams.entityId;
            }
            if($rootScope.createForWorkflowId){
                $scope.downloadUrl += '/' + $rootScope.createForWorkflowId;
                uploadUrl += '/' + $rootScope.createForWorkflowId;
            }
            $scope.bulkOptionField = field;
            $scope.bulkUploadFileName = {
                name: intl_msg[25719]
            };
            var prefix  = field.dialogTitle ? field.dialogTitle : field.label;
            var title  = prefix + " " +field.properties.label;
            if(template?.TemplateName) {
                title = title + " - " + template.TemplateName;
            }
            var bulkDialog = $("#bulkCreateServiceDialog");
            var bulkDialogSS = $("#bulkCreateServiceDialogSuccess");
            bulkDialog.dialog("option", "title", title);
            $scope.bulkMasterDataDownloadLink = $scope.downloadUrl.replace("download", "downloadMasterData"	)
            if ($scope.listId && ($scope.listId == "271" || $scope.listId == "273"))
                bulkDialog.addClass('bulkUploadDialog');
            bulkDialog.html(
                '<div class="bulk-download-btn-wrapper">' +
                '<div ng-if="initialBulkDownloadFileType == \'both\'" class="download-type">' +
                '<span>File Type:</span>' +
                '<label class="download-type-text" for="excel">'+
                '<input onchange="angular.element(this).scope().changeBulkDownloadFileType(\'excel\')" type="radio" id="excel" name="fileType" value="excel" checked />' +
                'Excel</label>' +
                '<label class="download-type-text" for="csv">'+
                '<input onchange="angular.element(this).scope().changeBulkDownloadFileType(\'csv\')" type="radio" id="csv" name="fileType" value="csv" />' +
                'CSV</label>' +
                '</div>' +
                '<a href="javascript:void(0)" ng-click = "downloadLineBulkData(downloadUrl)" class="download-link-btn"><span class="download"></span>' + text2 + '</a>' +
                '<a ng-if="bulkDownloadFileType == \'csv\'" href="javascript:void(0)" ng-click = "downloadLineBulkData(bulkMasterDataDownloadLink, true)" class="download-link-btn"><span class="download"></span>' + text6 + '</a>' +
                '</div>' +
                '<label>' + text1 + '</label>' +
                '<div class="fileUploadBulk">' +
                '<button class="UploadBulkButton">'+intl_msg[25541]+'</button>' +
                '<input title="'+intl_msg[25719]+'"  class="upload" type="file" id="fileDataBulkUpload" name="multipartFile" ' +
                'onchange="angular.element(this).scope().fileNameChanged()">' +
                '<label ng-bind="bulkUploadFileName.name"></label>' +
                '</div>' +
                '<div style="display:none" class="error">' + text3 + '</div>' +
                '<div class="modal-footer">' +
                '<input type="submit" ng-click = "uploadLineBulkData(bulkOptionField)" value="'+intl_msg[23809]+'" name="upload">' +
                '</div>');
            $compile(bulkDialog)($scope);
            bulkDialog.dialog("open");
            bulkDialogSS.dialog("option", "title", title);
            $("[aria-describedby='bulkCreateServiceDialog']").find(".ui-dialog-titlebar-close").attr("title",intl_msg[24237]);
            $scope.togglePropValue('showCreateLinkDD',false);
            bulkDialogSS.html('<div class="fileSuccess">' +
                '<label>' + text4 + '</label>' +
                '<div class="fileSuccessNotify"><div>' +
                '<label>' + text5 + '</label>' +
                '</div>' +
                '<div class="modal-footer">' +
                '<input type="submit" ng-click = "bulkDialogClose()" value="'+intl_msg[24184]+'" name="upload">' +
                '</div>');
            $compile(bulkDialogSS)($scope);
        } else if (bulkProps && _.get(bulkProps,'properties.bulk') && (bulkProps.bulkSystemLabel == "Bulk Create SL" || bulkProps.bulkSystemLabel == "Bulk Create Obligation"|| bulkProps.bulkSystemLabel == "Bulk Create Service Data")) {
            var text1=intl_msg[25536];
            var text2=intl_msg[25537];
            var text3=intl_msg[25538];
            var text4 = intl_msg[25539];
            var text5 = intl_msg[25540];
            var uploadUrl = appName + bulkProps.properties.uploadAPI;
            $scope.downloadUrl = appName + bulkProps.properties.downloadAPI;
            $scope.bulkOptionField = bulkProps;
            $scope.bulkUploadFileName = {
                name: intl_msg[25719]
            };

            var title = bulkProps.label;
            var bulkDialog = $("#bulkCreateServiceDialog");
            var bulkDialogSS = $("#bulkCreateServiceDialogSuccess");
            bulkDialog.dialog("option", "title", title);
            bulkDialog.html('<label>' + text1 + '</label>' +
                '<div class="fileUploadBulk">' +
                '<button  class="UploadBulkButton">'+intl_msg[25541]+'</button>' +
                '<input  title="'+intl_msg[25719]+'"  class="upload" type="file" id="fileDataBulkUpload" name="multipartFile" ' +
                'onchange="angular.element(this).scope().fileNameChanged()">' +
                '<label ng-bind="bulkUploadFileName.name"></label>' +
                '</div>' +
                '<a href="javascript:void(0)" ng-click = "downloadLineBulkData(downloadUrl)"><span class="download"></span>' + text2 + '</a>' +
                '<div style="display:none" class="error">' + text3 + '</div>' +
                '<div class="modal-footer">' +
                '<input type="submit" ng-click = "uploadLineBulkData(bulkOptionField)" value="'+intl_msg[23809]+'" name="upload">' +
                '</div>');
            $compile(bulkDialog)($scope);
            bulkDialog.dialog("open");
            $("[aria-describedby='bulkCreateServiceDialog']").find(".ui-dialog-titlebar-close").attr("title",intl_msg[24237]);
            $scope.togglePropValue('showCreateLinkDD',false);
            bulkDialogSS.dialog("option", "title", title);
            bulkDialogSS.html('<div class="fileSuccess">' +
                '<label>' + text4 + '</label>' +
                '<div class="fileSuccessNotify"><div>' +
                '<label>' + text5 + '</label>' +
                '</div>' +
                '<div class="modal-footer">' +
                '<input type="submit" ng-click = "bulkDialogClose()" value="'+intl_msg[24184]+'" name="upload">' +
                '</div>');
            $compile(bulkDialogSS)($scope);

        } else if (isListPage == true) {
            $scope.documentTypeId = 4;
            if(field.properties && field.properties.documentTypeId){
                $scope.documentTypeId = field.properties.documentTypeId;
            }
            var boxTitle = (field && field.properties && field.properties.label) ? field.properties.label : title;
            loadDialogBox(appName + api, "true", boxTitle, null, null, null, function () {
                angular.noop();
            });
        } else {
            const createLinkFields = _.get($scope,'createLink[0].fields');
            title == "Single" && (title = _.get(field,"properties.label"));
            const isSingleWF =  createLinkFields && !createLinkFields.length;
            var boxTitle = ($rootScope.popupTitle && isSingleWF && !$scope.currentEntityId ? $rootScope.popupTitle : (field && field.label && field.label != 'Single') ? (field.label) : title),
                loadDialog = (api && api.indexOf("masterdeliverycountrys") != -1) || (field && field.api && field.api.indexOf('/tblcompositerating') > -1),
                endpoint = field ? field.api : api;
            if(boxTitle  && boxTitle.indexOf(intl_msg[25535])==-1){
                boxTitle  = intl_msg[25535] + boxTitle ;
            }
            if (loadDialog) {
                loadDialogBox2(appName + endpoint + (meetingNoteId ? ("&meetingNoteId=" + meetingNoteId) : ""), null, boxTitle, null,function () {
                    if (meetingNoteId)
                        $scope.$broadcast("openMeetingTab");
                });
            }else{
                //Changes made as REST CREATE URLs are changed to *new/:entityid* APIs in 2.0 :::::: SIR-208574
                if(meetingNoteId){
                    var paramId = typeof meetingNoteId == "object" ? meetingNoteId.createEntityTypeId : meetingNoteId;
                    api = SirionUtils.addQueryString(api,"meetingNoteId="+paramId);
                }
                $scope.baseNameEntity = $scope.data.name.values || '';
                $scope.boxTitle = boxTitle;
                $scope.jsonUrl = (field && field.multiSupplierApi) ? field.multiSupplierApi : api;
                if(field && field.multiSupplierApi) {
                    $scope.multiSupplierApi = field.jspApi;
                    if (field.properties.isContractNew) {
                        $scope.contractNewApi = true;
                    }
                } else {
                    $scope.multiSupplierApi = false;
                }
                !field && (field = {});
                const dataApi = field.multiSupplierApi || field.jspApi || $scope.exceptionalInNewUx.isSpecialDataAPI(field.api) || $scope.jsonUrl;
                if($scope.isNewUX && dataApi && !$rootScope.externalContract && !fromSupplierDropdown) {
                    $scope.savedBodyReq && sessionStorage.setItem('savedBodyReq',JSON.stringify($scope.savedBodyReq))
                    SirionUtils.storePreviousPageURL();
                    sessionStorage.setItem('showAmendment',$scope.showAmendment);
                    $scope.contractNewApi && sessionStorage.setItem('contractNewApi',$scope.contractNewApi);
                    $scope.multiSupplierApi && sessionStorage.setItem('multiSupplierApi',$scope.multiSupplierApi);
                    sessionStorage.setItem('selectedContractId',docTreeService.selectedContractId);
                    sessionStorage.setItem('api',encodeURIComponent(dataApi));
                    sessionStorage.setItem('createFromShowPage',true);
                    sessionStorage.setItem('showErrorModal',$scope.showErrorModal);
                    sessionStorage.setItem('entityTypeId', $scope.data.entityTypeId.values);
                    docTreeService.contractDocuments = [];

                    let createEntityTypeId = field.createEntityTypeId;
                    if(!createEntityTypeId && (field.api || dataApi)) {
                        let aURLParams = (field.api || dataApi).split('/');
                        let workflowIndex = aURLParams.indexOf('wf2');

                        if(workflowIndex > -1) {
                            aURLParams.splice(workflowIndex, 1);
                        }

                        let entity = aURLParams[1].replace('tbl','');
                        entity = 'tbl' + entity;
                        createEntityTypeId = urlToCodeMapper[entity];
                    }
                    const pageLabel = `${$scope.boxTitle} ${intl_msg[23707]} ${$scope.baseNameEntity}`;
                    const entityName = (NumToURLPartMapping[createEntityTypeId] || `entity_${createEntityTypeId}`).replace('tbl','');
                    sessionStorage.setItem('pageLabel',pageLabel);
                    window.location.href = window.location.origin + `/${envAlias}/#/create/${entityName}`;
                    return;
                }
                isCreate = true;
                $scope.createCloneOfScope();
                const ecApi = (field && field.multiSupplierApi) ? field.multiSupplierApi : api;
                $scope.jsonUrl = null;
                $timeout(function () {
                    $scope.jsonUrl = ecApi;
                    $scope.applyScope($scope);
                }, 0);

            }
        }

    }
    //React meetingMinutes
    window.sarc.channelInstall('dataFromReactMeetingNoteSubscription');
        window.sarc.channelSubscription('dataFromReactMeetingNote', (args) => {
            if(args.actionType === 'moreButtonClick'){
                const item=args.payload;
                $scope.plusIconReq(item.jspApi, intl_msg[25535] + ' ' + item.label,item,null,item.meetingNoteId)
            }
        }, `dataFromReactMeetingNoteSubscription`);
    // function to keep the comment box in sync on all pages
    // formService
    $scope.commentLayout = formService.commentLayout;

    $scope.bulkDialogClose = function () {
        $("#bulkCreateServiceDialogSuccess").dialog("close");
    }
    $scope.downloadLineBulkData = function (downloadUrl, isMasterDataDownload = false) {
        const tempLink = isMasterDataDownload ? downloadUrl : `${downloadUrl}&fileFormat=${$scope.bulkDownloadFileType}`;
        const link = addtStamp(tempLink,true);
        const rootScope = $("#data-ng-app").scope();
        rootScope.fromMainListDownload = true;
        if ((!$rootScope.bulkOldUrl && !rootScope.fromMainTemplateDownload) || $rootScope.bulkOldUrl == downloadUrl) {
            if (SirionUtils.isDuplicateRequest(() => {
                rootScope.downloadAlreadyRequested = false;
                $scope.downloadLineBulkData(downloadUrl, isMasterDataDownload)
            }))
            return;
        }
        $rootScope.bulkOldUrl = downloadUrl;
        $.ajax({
            dataType: "json",
            async: true,
            transformRequest: angular.identity,
            processData: false,
            contentType: false,
            type: 'GET',
            url: link,
            success: function (response, status) {
                if(response.message) {
                    Toaster.create(response.message);
                }
                rootScope.fromMainTemplateDownload = false;
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if(jqXHR.responseText)
                    Toaster.create(jqXHR.responseText);
            },
        })
    }
    $scope.uploadLineBulkData = function (data) {
        var fileProp = $('#fileDataBulkUpload').prop('files');
        $scope.fileProperties = null;
        if (!fileProp[0]) {
            $("#bulkCreateServiceDialog  .error").text(intl_msg[25542]);
            $("#bulkCreateServiceDialog  .error").show();
            return;
        }
        if (fileProp[0]) {
            $scope.bulkUploadFileName.name = fileProp[0].name;
        }
        var elem = $('#fileDataBulkUpload');
        var obj = {};

        if (data && data.properties && data.properties.uploadAPIFormData && data.properties.uploadAPIFormData.parentEntityTypeId && data.properties.uploadAPIFormData.parentEntityId) {
            obj.params = '{"parentEntityTypeId":' + data.properties.uploadAPIFormData.parentEntityTypeId + ',"parentEntityId":' + data.properties.uploadAPIFormData.parentEntityId + '}';
        } else
            obj.params = '{"parentEntityTypeId": "entityTypeId","parentEntityId": "id"}';

        obj.api = data.properties.uploadAPI;
        if($rootScope.createForWorkflowId){
            obj.api += '/' + $rootScope.createForWorkflowId;
        }

        if(!!provisioningId) {
            obj.api += '?provisioningId=' + provisioningId;
        }

        if($scope.serviceDataRequest){
            $scope.fileProperties = fileProp;
            formService.listFileUpload(obj, elem, function(){
                $scope.documentContractUpload(elem, $scope.serviceDataRequest);
            }, null, formService.responseCallBack, $scope.serviceDataRequest);
        } else {
            formService.listFileUpload(obj, elem, null, null, formService.responseCallBack);
        }

    }
    $scope.fileNameChanged = function () {
        $("#bulkCreateServiceDialog  .error").hide();
        if ($('#fileDataBulkUpload').prop('files')[0]) {
            $scope.bulkUploadFileName.name = $('#fileDataBulkUpload').prop('files')[0].name;
        }else {
            $scope.bulkUploadFileName.name = intl_msg[25719];
        }
        $scope.$applyAsync();
    };
    $scope.hideGenericErrBox = function () {
        $scope.errors.genericErrors = [];
        resizeInnerForm();
    };
    // formService
    $scope.scrollableView = formService.scrollableView;
    $scope.populateReferencePage = formService.populateReferencePage;
    $scope.tt = function (msg) {
        confirm(msg);
    };
    // dataService
    $scope.converToTrusted = formService.converToTrusted;
    // formService
    $scope.saveEditedContent = function () {
        formService.saveEditedContent($scope);
    }
    $rootScope.shouldIShowFieldErrors = function () {
        if (angular.isUndefined($scope.shouldIShowFieldErrorsVar)) {
            return false;
        }
        return $scope.shouldIShowFieldErrorsVar;
    };
    $rootScope.IShouldSeeFieldErrors = function (val) {
        $scope.shouldIShowFieldErrorsVar = val;
    };
    // formService
    $scope.createContractFileUploadJson = function () {
        var fileJson = dataManipulationService.createContractFileUploadJson();
        if (angular.isDefined($scope.data.contractDocuments)) {
            $scope.data.contractDocuments.values = fileJson.jsonDataArray;
            if( docTreeService.cdrToContractPorting || (docTreeService.contractDocuments && docTreeService.contractDocuments.length)){
                $scope.data.contractDocuments.values = docTreeService.postObjOfContractDocuments(true);
            }
        }
        return fileJson;
    };


    // formService

    $scope.uploadContractDoc = async function (elem,droppedFilesList, editFromContractTreeVal) {

        if(_.has($scope.uploadingDocumentData, 'entityId'))
            await $scope.handleDocumentUpload($scope.uploadingDocumentData);
        
        
        var editFromContractTree = angular.element(elem).data('editcontracttree') || editFromContractTreeVal;
        var isReplaceFile = angular.element(elem).data('replacefile');
        //$scope.files = elem.files;
        $scope.files = droppedFilesList != undefined ? droppedFilesList : elem.files;
        var filesList;
        filesList = $.extend(true, $scope.files, filesList);

        var invalidExtensions = [];
        var totalFiles = filesList.length;
        var fIndex = 0;
        var hasValid = 0;
        angular.forEach(filesList, function (file) {
            var sFileName = file.name;
            var extension = sFileName.split('.')[sFileName.split('.').length - 1].toLowerCase();
            if (VALIDEXTENSIONS.indexOf(extension) < 0 && invalidExtensions.indexOf(extension) < 0) {
                invalidExtensions.push(extension);
            } else if (VALIDEXTENSIONS.indexOf(extension) != -1) {
                hasValid++;
            }
            fIndex++;
        });
        var fileSize = $scope.calculateFilesSize(elem);
        if (fileSize >= 262144000) {
            Toaster.create(intl_msg[6554] + " 250 MB",{iconClass:"icon-Information_filled"});
            angular.element(elem).val('');
            return;
        }
        var extensionMessage = intl_msg[24187]+" " + invalidExtensions.join(',') + ".";
        if ($rootScope.alertBoxes.length == 0 && filesList.length > 0) {
            if (invalidExtensions.length > 0 && hasValid > 0) {
                Toaster.create(UPLOADINPROGRESSMESSAGE + " " + extensionMessage,{iconClass:"icon-Information_filled"});
            } else if (invalidExtensions.length > 0 && hasValid == 0) {
                Toaster.create(extensionMessage,{iconClass:"icon-Information_filled"});
                $(elem).val("");
            } else {
                Toaster.create(UPLOADINPROGRESSMESSAGE,{iconClass:"icon-Information_filled"});
            }
        }
        var modalToClose;
        if ($rootScope.alertBoxes.length > 0) {
            modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
        }
        var indexFU = 0;
        var count = 0;

        angular.forEach($scope.files, function (file) {
            var fd = new FormData();
            // file actions-------------------
            // 1-create, 2-update, 3-delete, 4-replace
            var fileKey = formService.getFileKey(file.name); // to be sent from
            // client every time
            // you upload new
            // file, replace
            // file...
            var parentFileID = null; // to push as parentId in a file object to
            // make the parent-child r/ship..
            var fileID = null; // to be sent as id in case of replace and to be
            // used in edit page...
            var sFileName = $scope.files[indexFU].name;
            var arrayOfNamesSplitted = sFileName.split('.');
            arrayOfNamesSplitted.splice((arrayOfNamesSplitted.length - 1), 1);
            var sFileNameWithoutExt = escapeHtml(arrayOfNamesSplitted.join("."));
            const reverseCharMap = {"&amp;": "&","&quot;": '"',"&#39;": "'"};
            sFileNameWithoutExt = window.unescapeHtml(sFileNameWithoutExt,reverseCharMap); // Safe for database storage
            var sFileExtension = sFileName.split('.')[sFileName.split('.').length - 1].toLowerCase();

            $scope.fileElem = angular.element(elem);
            var templateDiv = $($scope.fileElem).closest("div." + $scope.fileElem.attr("template") + "_appended");
            $scope.myTemplate = $('.' + $scope.fileElem.attr("template")).html();
            if (VALIDEXTENSIONS.indexOf(sFileExtension) != -1) {
                var divToAppend = angular.element('<div></div>');
                if (templateDiv && templateDiv.length > 0) {
                    if (templateDiv.attr("id") && (templateDiv.attr("id") !== null) && (templateDiv.attr("id") !== "null")) {
                        if (templateDiv.attr("id").toString().trim().length > 0) {
                            divToAppend.attr("parentId", templateDiv.attr("id"));
                            parentFileID = templateDiv.attr("id");
                        }
                    } else if (templateDiv.attr("key") && (templateDiv.attr("key") !== null) && (templateDiv.attr("key") !== "null")) {
                        if (templateDiv.attr("key").toString().trim().length > 0) {
                            divToAppend.attr("parentId", templateDiv.attr("key"));
                            parentFileID = templateDiv.attr("key");
                        }
                    }

                }
                var actionTable = angular.element("<table></table>");
                var iFileSize = $scope.files[indexFU].size;
                divToAppend.attr("id", fileID).attr("key", fileKey).attr("fileName", sFileNameWithoutExt).attr("fileExtension", sFileExtension).attr("fileAction", "1").attr("class", $scope.fileElem.attr("template") + "_appended").attr("ng-model", $scope.fileElem.attr("ng-model"));
                divToAppend.append($scope.myTemplate);
                $(divToAppend).prepend('<span id="fileNameSpan">' + sFileNameWithoutExt + "." + sFileExtension + '</span>');
                var ss = angular.element('<input id="cancel_' + fileKey.replace(/(?:^|\s)\S/g, "").replace(/\(/g, "").replace(/\)/g, "") + '" type="button" class="upload-delete"></input>');
                $(ss).on("click", function () {
                    // console.log("file :",$scope.fileElem.attr("template"));
                    $scope.deleteItem(this, $scope.fileElem.attr("template"));
                });
                var action = angular.element(elem).attr("action");
                var template = $scope.fileElem.attr("template");
                var replaceElement = angular.element("<input></input>").attr({
                    "type": "file",
                    "onchange": "angular.element(this).scope().replaceContractDoc(this, '" + fileKey + "', '" + fileID + "', '" + sFileNameWithoutExt + "', '" + sFileExtension + "', '" + action + "', '" + $scope.fileElem.attr("template") + "','" + parentFileID + "')"
                });
                // var myelem = angular.element("<div class='replaceDoc'><span><button
                // class='replace-icon' title='Replace file'></button></span></div>");
                // myelem.append(replaceElement.attr("style","position:absolute;opacity:0;"));
                var actionTableRow = angular.element("<tr></tr>");
                var fileNameElem = angular.element('<span class="fileNameSpan" id="fileNameSpan">' + sFileNameWithoutExt + "." + sFileExtension + '</span>');
                actionTableRow.append(angular.element("<td></td>").append(ss));
                actionTableRow.append(angular.element("<td></td>").append(ss));
                $(actionTable).append(actionTableRow);
                var myTd = actionTableRow.append(angular.element("<td></td>").append(ss));
                $(divToAppend).prepend(actionTable);
                if (searchableExtensions.indexOf(sFileExtension) == -1) {
                    $(divToAppend).find("input[name='search']").attr("disabled", "disabled");
                }
                if (viewerExtensions.indexOf(sFileExtension) == -1) {
                    $(divToAppend).find("input[name='viewerAvailable']").attr("disabled", "disabled");
                }
                $scope.$applyAsync();
                fd.append("documentFileData", file);
                fd.append("key", fileKey);
                fd.append("name", sFileNameWithoutExt);
                fd.append("extension", sFileExtension);
                var tempFileObj = {
                    'filekey': fileKey,
                    "name": sFileNameWithoutExt,
                    "extension": sFileExtension,
                    "fileAction": '1'
                };
                if(editFromContractTree && $scope.ttdEnabled) {
                    tempFileObj['metadataAutoExtract']  = true;
                }
                if (editFromContractTree && $scope.parentId) {
                    tempFileObj['parentId'] = $scope.parentId;
                }
                if (editFromContractTree && angular.element(elem).data('parentcid') != undefined) {
                    tempFileObj['parentId'] = angular.element(elem).data('parentcid');
                }
                if ($scope.currentRelationId) {
                    fd.append("relationId", $scope.currentRelationId);
                }
                if($scope.currentRelationId == null && $scope.relationId ){
                    fd.append("relationId", $scope.relationId);
                }
                if ((!$scope.globalData.hasAutoExtractEntitiesPermission) || (sFileExtension && ["doc", "dot", "docx", "docm", "dotx", "dotm", "docb"].indexOf(sFileExtension)== -1)) {
                    divToAppend.find("#elem_12146").parent().hide();
                }
                $rootScope.createForWorkflowId && (action += `?workflowId=${$rootScope.createForWorkflowId}`)

                $scope.noOfFilesUploaded = $scope.noOfFilesUploaded + 1;

                $http.post(appName + action, fd, {
                    transformRequest: angular.identity,
                    async: false,
                    headers: {
                        "Content-Type": undefined
                    }
                }).then(function (d) {
                    angular.element(elem).val('');
                    $scope.noOfFilesUploaded = $scope.noOfFilesUploaded-1;
                    if(d.status != 200){
                        Toaster.create(intl_msg[6552],{iconClass:"icon-Information_filled"});
                        return;
                    }
                    d = d.data;
                    if (d == "error") {
                        if (modalToClose) {
                            modalToClose.result.then(function () {
                                $rootScope.alertBoxes.pop();
                                Toaster.create(intl_msg[6499],{iconClass:"icon-Information_filled"});
                            });
                            modalToClose.close();
                        }
                    } else if (d == "extensionError") {
                        modalToClose.result.then(function () {
                            $rootScope.alertBoxes.pop();
                            Toaster.create(intl_msg[6500],{iconClass:"icon-Information_filled"});
                        });
                        modalToClose.close();
                    } else if (d == "virus") {
                        modalToClose.result.then(function () {
                            $rootScope.alertBoxes.pop();
                            Toaster.create(intl_msg[6551],{iconClass:"icon-Information_filled"});
                        });
                        modalToClose.close();
                    } else if (d == "virusCheckFailed") {
                        modalToClose.result.then(function () {
                            $rootScope.alertBoxes.pop();
                            Toaster.create(intl_msg[27946],{iconClass:"icon-Information_filled"});
                        });
                        modalToClose.close();
                    } else if (d.indexOf("totalNumberOfPages") > -1) {
                        var strObj = d.split("=");
                        if (strObj && strObj[1]) {
                            $(divToAppend).find("input[name=totalPages]").val(strObj[1]);
                            $(divToAppend).find("label.customPageNumbering").hide();
                            tempFileObj['totalPages'] = strObj[1];
                        }
                        if (editFromContractTree) {
                            if (isReplaceFile) {
                                docTreeService.replaceExistingFile(tempFileObj);
                            } else {
                                docTreeService.appendNewFile(tempFileObj, $scope);
                            }

                        } else {
                            ($scope.fileElem.parent()).append(divToAppend);
                        }

                        $($scope.fileElem).val("");
                        count++;
                        if (count == hasValid){
                            if (modalToClose) {
                                $rootScope.alertBoxes.pop();
                                modalToClose.opened.then(function () {
                                    modalToClose.close();
                                    modalToClose = null;
                                })
                            }
                            if (!isReplaceFile){
                                docTreeService.openFilePropertiesModal(true);
                            }
                        }

                    } else if(d == 'invalidFileFormat'){
                        if (modalToClose) {
                            modalToClose.result.then(function () {
                                $rootScope.alertBoxes.pop();
                                const args = {
                                    popupType: 'alert',
                                    heading: intl_msg[24153],
                                    str: intl_msg[30832],
                                    yesCbFn: cancelString,
                                    yesName: intl_msg[24184]
                                }
                                SirionUtils.openSirionDialogs(args);
                            });
                            modalToClose.close();
                        }else{
                            Toaster.create(intl_msg[30832],{iconClass:"icon-Information"});
                        }
                    }
                    else {
                        if (editFromContractTree) {
                            if (isReplaceFile) {
                                docTreeService.replaceExistingFile(tempFileObj);
                            } else {
                                //docTreeService.newlyAppendFileList.push(tempFileObj);
                                docTreeService.appendNewFile(tempFileObj,$scope);
                            }
                        } else {
                            ($scope.fileElem.parent()).append(divToAppend);
                        }
                        $($scope.fileElem).val("");
                        count++;
                        if (count == hasValid){


                            if (modalToClose) {
                                $rootScope.alertBoxes.pop();
                                modalToClose.opened.then(function () {
                                    modalToClose.close();
                                    modalToClose = null;
                                })
                            }
                            if (!isReplaceFile){
                                docTreeService.openFilePropertiesModal(true);
                            }
                        }
                    }
                    var preselectionExists = dataManipulationService.validateClientSpecificOptionSelection();
                    if(preselectionExists){
                        $(divToAppend).find("input[name=businessCase]").prop("checked", true);
                    }

                }, function (d) {
                    Toaster.create(intl_msg[6552],{iconClass:"icon-Information_filled"});
                });
            }
            indexFU++;
        });
    };
    $scope.calculateFilesSize = function (inputFilesElem, filesList) {
        var fileSize = 0;
        var filesArr = filesList ? filesList : (inputFilesElem.files && inputFilesElem.files.length) ? inputFilesElem.files : [];
        try {
            for (var i = 0; i < filesArr.length; i++) {
                var file = filesArr[i];
                fileSize += file.size;
            }
        } catch (err) {
            // If unable to calculate fileSize then just proceed
        }
        return fileSize;
    };
    $scope.truncateFileName = function (fName) {
        var t = fName.split(".");
        if (t[0].length < 55) {
            return fName;
        }
        return t[0].substr(0, 47) + "..." + t[0].substr(t[0].length - 5, t[0].length) + "." + t[1];
    }
    $scope.getAccessToken = function(){
        let url = addtStamp("/v1/authHelper/getAccessToken");
        return $http.get(url);
    }
    $scope.uploadFile = function (elem, returnFileElem, droppedFilesList) {

        let isCommentForm = angular.element(elem).closest('.commentForm').length ||
                            angular.element(elem).closest('.commentAttachmentForm').length;
        if(isCommentForm) {
            $scope.getAccessToken().then((res) => {
                sessionStorage.setItem("accessToken", res.data.token);
                communicationService.uploadFile.call($scope, elem, null, returnFileElem, droppedFilesList)
            }).catch(() => {
                var msg = intl_msg[29007] || 'Something went wrong.'
                Toaster.create(msg, {iconClass: "icon-Information_filled"});
            })
            return;
        }

        angular.element(elem).closest('#dialogForm').find('.error').html('').hide();
        var INVOICE_VALIDEXTENSIONS = ["doc", "docx", "pdf"];
        formService.bulkEditFiles = null;
        if ($scope.buPricingData && $scope.buPricingData.errormsg) {
            $scope.buPricingData.errormsg = '';
        }
        if (!droppedFilesList && elem.files && elem.files.length == 0) {
            return;
        }
        var isDuplicate = false;
        var extraFields = [];
        var extraFields = [];
        if (angular.element(elem).attr("extraFields")) {
            extraFields = JSON.parse($(elem).attr("extraFields"));
        }
        $scope.files = droppedFilesList != undefined ? droppedFilesList : elem.files;
        if (returnFileElem) {
            formService.bulkEditFiles = $scope.files;
            formService.bulkEditFilesElem = elem;
            $scope.uploadFileName = $scope.files[0].name;
            $(elem).closest("#dialogForm").find('.tab-content').find('div.formPost').show();
            if ($(elem).closest('div').find('#id_filename').length) {
                $(elem).closest('div').find('#id_filename').html($scope.uploadFileName).addClass("fileUploadBulkEdit").attr("title", $scope.uploadFileName);
            } else {
                $(elem).parent().append($('<div/>', {
                    'html': $scope.uploadFileName,
                    'id': 'id_filename'
                }).addClass("fileUploadBulkEdit").attr("title", $scope.uploadFileName));
            }
            angular.element(elem).val('');
            return;
        }
        var indexFU = 0;
        var modalToClose, fileSize;
        if ($rootScope.alertBoxes.length > 0) {
            modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
            modalToClose.close();
        }
        if ($(elem).hasClass("singleFile") && $(elem).closest("fieldset").find(".file").size() > 0) {
            //  alertDialog("Only one file allowed for upload.");
            var msg = intl_msg[23560];
            Toaster.create(msg,{iconClass:"icon-Information_filled"});
            return;
        }
        if ($(elem).hasClass("singleFile") && $(elem).closest("div").attr("allowedExtensions") != undefined && $scope.files[0] && $scope.files[0].name) {
            var allowedExtenisons = $(elem).closest("div").attr("allowedExtensions");
            var currextsn = $scope.files[0].name.split('.')[$scope.files[0].name.split('.').length - 1].toLowerCase();
            if (allowedExtenisons.indexOf(currextsn) == -1) {
                var msg = intl_msg[6431] + " Allowed extensions are : " + allowedExtenisons;
                Toaster.create(msg,{iconClass:"icon-Information_filled"});
                //  alertDialog(intl_msg[6431] + " Allowed extensions are : " + allowedExtenisons);
                return;
            }
        }
        if (($(elem).closest(".formPost").hasClass("singleFile") || ($(elem).hasClass("singleFile"))) && (fileSize = $scope.calculateFilesSize(elem)) > 10485760) {

            /* alertDialog(intl_msg[6439].replace(/"/g, "")

                 +
                 parseInt(MAX_MASSEMAIL_UPLOAD_SIZE / 1000000) +
                 " MB. Currently it is more than " +
                 parseInt(fileSize / 1048576) + " MB");
                 */
            var msg = intl_msg[6439].replace(/"/g, "")  +  parseInt(MAX_MASSEMAIL_UPLOAD_SIZE / 1000000) + " MB. "+intl_msg[27628]+" "
                +    parseInt(fileSize / 1048576) + " MB";
            Toaster.create(msg,{iconClass:"icon-Information_filled"});
            return;
        } else if (!$(elem).hasClass("singleFile") && (fileSize = $scope.calculateFilesSize(elem)) >= 104857600) { // 100
            // MB

            /*  alertDialog(intl_msg[6439].replace(/"/g, "")

                  +
                  parseInt(MAX_UPLOAD_SIZE / 1000000) +
                  " MB. Currently it is more than " +
                  parseInt(fileSize / 1048576) + " MB");
  */

            var msg = intl_msg[6439].replace(/"/g, "") + parseInt(MAX_UPLOAD_SIZE / 1000000) + " MB. "+intl_msg[27628]+" "
                + parseInt(fileSize / 1048576) + " MB";
            Toaster.create(msg,{iconClass:"icon-Information_filled"});
            return;
        }
        /**  previous code being commented to show popup in case of duplicate file **/
        /*$(elem).parent().find("span").each(function () {
            if ($(this).text().trim() == $scope.files[indexFU].name) {
                isDuplicate = true;
            }

        });*/
        /**  new code to show popup in case of duplicate file as per the new dom structure  **/
        if (angular.element(elem).closest('form').find('.jx-fileListDiv').length) {
            var fileNamesElm = angular.element(elem).closest('form').find('.jx-fileListDiv').find('.jx-uplodedFN');
            if (_.indexOf(Array.prototype.map.call(fileNamesElm, function (x) {
                    return x.innerText.trim();
                }), $scope.files[indexFU].name) > -1) {
                Toaster.create(intl_msg[6553],{iconClass:"icon-Information_filled"});
                isDuplicate = true;
            }
        }
        if (angular.element(elem).closest('.adv-textbox').length) {
            angular.element(elem).parent().find("span").each(function () {
                if ($(this).text().trim() == $scope.files[indexFU].name) {
                    Toaster.create(intl_msg[6553],{iconClass:"icon-Information_filled"});
                    isDuplicate = true;
                }
            });
        }
        if(elem && !elem.multiple && !isDuplicate) {
            angular.element(elem).closest('form').find('.jx-fileListDiv').html("");
        }
        var filesList;
        filesList = $.extend(true, $scope.files, filesList);
        var invalidExtensions = [];
        var totalFiles = filesList.length;
        var fIndex = 0;
        var hasValid = 0;
        angular.forEach(filesList, function (file) {
            var sFileName = file.name;
            var extension = sFileName.split('.')[sFileName.split('.').length - 1].toLowerCase();
            $rootScope.invoiceName = sFileName;
            if($scope.showInvoiceUploadDialog && $scope.showInvoiceUploadDialog.visible && INVOICE_VALIDEXTENSIONS.indexOf(extension) < 0 && invalidExtensions.indexOf(extension) < 0) {
                invalidExtensions.push(extension);
            }
            else if (VALIDEXTENSIONS.indexOf(extension) < 0 && invalidExtensions.indexOf(extension) < 0) {
                invalidExtensions.push(extension);
            } else if (VALIDEXTENSIONS.indexOf(extension) != -1) {
                hasValid++;
            }
            fIndex++;
        });
        var extensionMessage = intl_msg[24187]+" " + invalidExtensions.join(',') + ".";
        if ($rootScope.alertBoxes.length == 0 && $scope.files.length > 0) {
            if (invalidExtensions.length > 0 && hasValid > 0) {
                Toaster.create(UPLOADINPROGRESSMESSAGE + " " + extensionMessage,{iconClass:"icon-Information_filled"});
            } else if (invalidExtensions.length > 0 && hasValid == 0) {
                Toaster.create(extensionMessage,{iconClass:"icon-Information_filled"});
                return;
            } else {
                Toaster.create(UPLOADINPROGRESSMESSAGE,{iconClass:"icon-Information_filled"});
            }
        }
        if (isDuplicate) {
            elem && angular.element(elem).val('');
            return;
        }
        //$scope.jqueryElem = $(elem).parent();
        /** changed code for positioning of uploadedfiles in new ui 2.0 **/
        if (!angular.element(elem).closest('form').find('.jx-fileListDiv').length) {
            if (angular.element(elem).closest('.myPopUpFileUpload,.myFileUpload').next('label.noMousePointer').length > 0) {
                angular.element(elem).closest('.myPopUpFileUpload,.myFileUpload').next('label.noMousePointer').after($('<div/>', {
                    'class': 'jx-fileListDiv'
                }));
            }else {
                angular.element(elem).closest('.myPopUpFileUpload,.myFileUpload').after($('<div/>', {
                    'class': 'jx-fileListDiv'
                }));
            }
        }

        if (angular.element(elem).closest('.adv-textbox').length) {
            $scope.jqueryElem = $(elem).closest('.adv-textbox');
        } else {
            $scope.jqueryElem = $(elem).closest('form').find('.jx-fileListDiv');
        }

        /** changed code for positioning of uploadedfiles in new ui 2.0 **/
        var totalFiles = $scope.files.length;
        var count = 0;
        angular.forEach($scope.files, function (file, i) {
            var sFileName = $scope.files[indexFU].name;
            var arrayOfNamesSplitted = sFileName.split('.');
            arrayOfNamesSplitted.splice((arrayOfNamesSplitted.length - 1), 1);
            var sFileNameWithoutExt = arrayOfNamesSplitted.join(".");
            var fileExtension = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
            var removeLBL = intl_msg[28358];
            if (hasValid == 0) {
                stopLoader();
            }
            if (VALIDEXTENSIONS.indexOf(fileExtension) > -1) {
                var action = 'onclick="angular.element(this).scope().clickThis($(this).parent().attr\(\'id\'),$(this).parent().prev())"';
                var fileKey = formService.getFileKey(file.name);
                var isClassificationShown = false;
                if (angular.element(elem).closest('.adv-textbox').length) {
                    var newelem = "<span class='file' id='" + fileKey + "' title='" + escapeHtml(file.name) + "' style='overflow: hidden;text-overflow: ellipsis; white-space: nowrap !important;' file=\"" +     fileKey + "\">" + "<input class='upload-delete' type='button' " + action + "></input>" + escapeHtml($scope.truncateFileName(file.name)) +                     "&nbsp;&nbsp;&nbsp;";
                }
                else {
                    var newelem = "<span class='file jx-fileListSpan' data-elemname='" + $(elem).attr('name') + "' id='" + fileKey + "' style='text-overflow: ellipsis;white-space:nowrap !important;' file=\"" + fileKey + "\"><small class='jx-uplodedFN' title='" + escapeHtml(file.name) + "'>" + escapeHtml($scope.truncateFileName(file.name)) + "</small><span title='" + escapeHtml(removeLBL) + "' class='upload-delete icon-close' " +
                        "onclick=\"angular.element(this).scope().clickThis($(this).parent().attr('id'))\"></span><span class='icon-" + escapeHtml($scope.truncateFileName(file.name)).split(/[. ]+/).pop().toLowerCase() + "' style='font-size: 20px; position: absolute; left: 0px; top:2px;'></span>";
                }
                extraFields.forEach(function (d, i) {
                    var value = false;
                    if (d.properties["default"] == true) {
                        value = true;
                    }
                    if (d.name && d.type == "checkbox") {
                        newelem = newelem + "<span class='searchableBox'></span>";
                    }
                    if ( [61, 160].indexOf($scope.data.entityTypeId.values) > -1
                        && d.type == "basic" && d.properties
                        && d.properties.multiselect == "true" && d.fields && d.fields.length > 0
                    ) {
                        var optn = "";
                        isClassificationShown = true;
                        var filePropertiesTempplate = '<div  class="uploadFileProps" >' +
                            '<i class="icon-Gear-Settings-line"  ng-class="{ \'active\' : isVisible($event,\'' + fileKey + '' + '\') }"  id="icon-Gear-Settings-line" title={{intl_msg[29024]}}  ' +
                            'outside-if-not="propertiesSpan_'+fileKey+'" ' +
                            'click-outside="closeProperties($event,\'' + fileKey + '' + '\')" ' +
                            'data-ng-click  = "openProperties($event,\'' + fileKey + '' + '\')"  ></i>' +
                            '<span  class="propertiesSpan" id="propertiesSpan_'+fileKey+'" ng-show="isVisible($event,\'' + fileKey + '' + '\')">'
                            + SirionUtils.appendDocProperties(d,$scope.data,true,$scope.layout); + '</span></div>';
                        newelem = newelem + filePropertiesTempplate;
                    }
                });
                if(_.get($scope.data,"comment.documentTags['options']['data']")
                    && _.get($scope.data,"comment.documentTags['options']['data']").length
                    &&  SirionUtils.checkForDocTagPermission($scope.layout)
                    &&  [12,13,61,160].indexOf($scope.data.entityTypeId.values) > -1 ){
                    if(!isClassificationShown){
                        var filePropertiesTempplate = '<div  class="uploadFileProps" >' +
                            '<i class="icon-Gear-Settings-line"  ng-class="{ \'active\' : isVisible($event,\'' + fileKey + '' + '\') }" id="icon-Gear-Settings-line" title="Settings"  ' +
                            'outside-if-not="propertiesSpan_'+fileKey+'" ' +
                            'click-outside="closeProperties($event,\'' + fileKey + '' + '\')" ' +
                            'data-ng-click  = "openProperties($event,\'' + fileKey + '' + '\')"  ></i>' +
                            '<span  class="propertiesSpan" id="propertiesSpan_'+fileKey+'" ng-show="isVisible($event,\'' + fileKey + '' +'\')"  >' +
                            SirionUtils.appendDocTagsOnly(newelem,$scope.data.comment.documentTags); + '</span></div>';
                        newelem = newelem + filePropertiesTempplate;
                    }
                }
                newelem = newelem + "</span>";
                var fd = new FormData();
                fd.append("documentFileData", file);
                fd.append("name", sFileNameWithoutExt.replace(/\./g, "_"));
                fd.append("extension", fileExtension);
                fd.append("key", fileKey);
                if (!$(elem).closest(".formPost") || ($(elem).closest(".formPost") && $(elem).closest(".formPost").length == 0)) {
                    var promise = $http.post(appName + angular.element(elem).attr("action"), fd, {
                        transformRequest: angular.identity,
                        headers: {
                            "Content-Type": undefined
                        }
                    }).then(function (d) {
                        angular.element(elem).val('');
                        if(d.status != 200){
                            if($rootScope.alertBoxes.length){
                                modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                                modalToClose.result.then(function () {
                                    $rootScope.alertBoxes.pop();
                                    Toaster.create(intl_msg[6552],{iconClass:"icon-Information_filled"});
                                });
                                modalToClose.close();
                            }
                            Toaster.create(intl_msg[6552],{iconClass:"icon-Information_filled"});
                            return;
                        }
                        if (d.data == "virusvirusvirusvirus") {
                            modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                            modalToClose.result.then(function () {
                                $rootScope.alertBoxes.pop();
                                Toaster.create(intl_msg[6551],{iconClass:"icon-Information_filled"});
                            });
                            modalToClose.close();
                        } else if (d.data == "virusCheckFailed") {
                            modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                            modalToClose.result.then(function () {
                                $rootScope.alertBoxes.pop();
                                Toaster.create(intl_msg[27946],{iconClass:"icon-Information_filled"});
                            });
                            modalToClose.close();
                        } else if (d.data == "extensionError") {
                            modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                            modalToClose.result.then(function () {
                                $rootScope.alertBoxes.pop();
                                Toaster.create(intl_msg[6500],{iconClass:"icon-Information_filled"});
                            });
                            modalToClose.close();
                        } else {
                            $("[name='documentFileData']").parent().find("button").removeClass("errorClass");
                            if ($(elem).hasClass("singleFile")) {
                                $scope.SingleFileDelMsg = true;
                                $(elem).closest(".adv-textbox").find(".singleFileUpload").hide();
                            } else {
                                $scope.SingleFileDelMsg = false;
                            }

                            /*//Todo :  HARADCODED - check if 'Contract Managing Unit' is 'RIHQ' then RUSSIAN GENERAL should be by-default selected - NEED TO MAKE IT GENERIC
                            if(_.has($rootScope.data, "dynamicMetadata.dyn103684.values.id") && $rootScope.data.dynamicMetadata.dyn103684.values.id == 2073){
                                $("span.file select").find("[value=12059]").prop("selected", true);
                            }*/

                            var preselectionExists = dataManipulationService.validateClientSpecificOptionSelection();
                            if(preselectionExists) {
                                $("span.file select").find("[value=" + $rootScope.preSignature.clientSpecificFieldOptions.rbiBusinessCaseId + "]").prop("selected", true);
                            }
                            $scope.jqueryElem.append(newelem);
                            //  Compile and update DOM
                            $compile($scope.jqueryElem)($scope);
                            $("span.file select").multiselect({
                                selectedList: 4,
                                position: {my: 'right top', at: 'right top'},
                                open: function (event, ui) {
                                    // event handler here
                                    angular.element(event.target).closest('.jx-fileListSpan').addClass('activeSpan');
                                },
                                close: function (event, ui) {
                                    // event handler here
                                    angular.element(event.target).closest('.jx-fileListSpan').removeClass('activeSpan');
                                }
                            });
                            $(elem).closest("span.label-height").find("span.sem").html("");
                            count++;
                            if (count == hasValid) {
                                stopLoader();
                                if ($rootScope.alertBoxes.length > 0) {
                                    modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                                    modalToClose.close();
                                    $rootScope.alertBoxes.pop();
                                }
                                Toaster.create(intl_msg[23502]);
                            }

                            $scope.enableAddComment = true;
                        }
                    }, function(d) {
                        Toaster.create(intl_msg[6552],{iconClass:"icon-Information_filled"});
                    });
                }
                indexFU++;
            }
        });
        angular.element(elem).val('');
    };

    $scope.uploadFileIE = function (elem) {

        var modalToClose;
        /*
         * if($rootScope.alertBoxes.length >0){ modalToClose =
         * $rootScope.alertBoxes[$rootScope.alertBoxes.length-1];
         * modalToClose.close(); }
         */

        var extraFields = JSON.parse($(elem).attr("extraFields"));
        var isDulicate = false;
        var fileName = elem.value.split('\\').pop();
        var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1)
            .toLowerCase();
        $(elem).parent().find("span").each(function () {
            var fn = $(this).text();
            fn = fn.trim();
            if (fn == fileName) {
                Toaster.create(intl_msg[6553],{iconClass:"icon-Information_filled"});
                isDulicate = true;
            }
        });
        if (isDulicate) {
            return;
        } else {
            if (VALIDEXTENSIONS.indexOf(fileExt) == -1) {
                Toaster.create(intl_msg[24178]+ " " + fileName + " "+intl_msg[24179],{iconClass:"icon-Information_filled"});
                return false;
            } else if ($rootScope.alertBoxes.length == 0) {
                Toaster.create(UPLOADINPROGRESSMESSAGE,{iconClass:"icon-Information_filled"});
            }
        }
        $scope.jqueryElem = $(elem).parent();
        try {
            $scope.files = elem.files; // not for IE
            if ((fileSize = entityFactory.calculateFilesSize($scope.files)) >= $rootScope.gMaxFileUploadSize) {
                Toaster.create(intl_msg[6554] +
                    parseInt($rootScope.gMaxFileUploadSize / 1000000) +
                    " MB. Currently it is " +
                    parseInt(fileSize / 1000000) + " MB",{iconClass:"icon-Information_filled"});
            }
        } catch (e) {
            return false;
        }
        const args = {
            popupType: 'alert',
            heading: intl_msg[24153],
            yesCbFn: cancelString,
            yesName: intl_msg[24184]
        }
        if (VALIDEXTENSIONS.indexOf(fileExt) == -1) {
            args.str = intl_msg[24177] + " " + fileName + " " + intl_msg[24178];
            SirionUtils.openSirionDialogs(args);
            return false;
        } else {
            if (fileName && fileName.length >= $rootScope.gMaxFileLength) {
                args.str = fileName + intl_msg[25543] + $rootScope.gMaxFileLength + ".";
                SirionUtils.openSirionDialogs(args);
                // continue;// Skip this file and continue adding other files
            } else {
                var action = 'onclick="angular.element(this).scope().clickThis($(this).parent().attr\(\'id\'),$(this).parent().prev())"';
                var fileKey = formService.getFileKey(fileName);
                var newelem = "<span class='file' id='" + fileKey + "' file=\"" + fileKey + "\">" + $scope.truncateFileName(fileName) + "&nbsp;&nbsp;&nbsp;";
                extraFields.forEach(function (d, i) {
                    var value = false;
                    if (d.properties["default"] == true) {
                        value = true;
                    }
                    if (d.name && d.type == "checkbox") {
                        newelem = newelem + "<input checked = " + value + " class= 'fileCheckbox " + d.name + "' type = 'checkbox'></input>" +
                            "<strong>" + d.label + "</strong> &nbsp;&nbsp;&nbsp;"
                    }
                });
                newelem = newelem + "<input class='upload-delete' type='button' " + action + "></input></span>";
                var formWrapperString = '<form action="' +
                    appName + angular.element(elem).attr("action") +
                    '" enctype="multipart/form-data" encoding="multipart/form-data"  method="POST" style="display:none"></form>';
                var formWrapper = $(formWrapperString);
                formWrapper.attr('target', 'ajaxIframe_' + fileKey);
                $('body').append(
                    '<iframe name="ajaxIframe_' + fileKey +
                    '" style="display:none"/>');
                $(elem).after($(elem).clone());
                formWrapper.append('<input type="hidden" name="key" value="' + fileKey + '"/>');
                formWrapper.append('<input type="hidden" name="name" value="' +
                    fileName.substring(0, fileName.lastIndexOf('.')) + '"/>');
                formWrapper.append('<input type="hidden" name="extension" value="' +
                    fileName.substring(fileName.lastIndexOf('.') + 1) + '"/>');
                if ($("#relationId").val() != undefined && $("#relationId").val() != null) {
                    formWrapper.append('<input type="hidden" name="relationId" value="' +
                        $("#relationId").val() + '"/>');
                }
                formWrapper.append(elem);
                globalFunctions.appendCSRFField(formWrapper);
                $('body').append(formWrapper);
                if (!$(elem).closest(".formPost").length) {
                    formWrapper.submit();
                    $("iframe[name='ajaxIframe_" + fileKey + "']").load(function () {
                        if ($("iframe[name='ajaxIframe_" + fileKey + "']").contents().text() == "error") {
                            args.str = intl_msg[6499];
                            SirionUtils.openSirionDialogs(args);
                        }
                        if ($("iframe[name='ajaxIframe_" + fileKey + "']").contents().text() == "extensionError") {
                            modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                            modalToClose.result.then(function () {
                                $rootScope.alertBoxes.pop();
                                args.str = intl_msg[6500];
                                SirionUtils.openSirionDialogs(args);
                            });
                        } else if ($("iframe[name='ajaxIframe_" + fileKey + "']").contents().text() == "virus") {
                            modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                            modalToClose.result.then(function () {
                                $rootScope.alertBoxes.pop();
                                args.str = intl_msg[24179];
                                SirionUtils.openSirionDialogs(args);
                            });
                        } else if ($("iframe[name='ajaxIframe_" + fileKey + "']").contents().text() == "virusCheckFailed") {
                            modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                            modalToClose.result.then(function () {
                                $rootScope.alertBoxes.pop();
                                args.str = intl_msg[27946];
                                SirionUtils.openSirionDialogs(args);
                            });
                        } else if ($("iframe[name='ajaxIframe_" + fileKey + "']").contents().text() != "" && $("iframe[name='ajaxIframe_" + fileKey + "']").contents().text().indexOf(fileName) < 0) {
                            modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                            modalToClose.result.then(function () {
                                $rootScope.alertBoxes.pop();
                                args.str = intl_msg[6552];
                                SirionUtils.openSirionDialogs(args);
                            });
                            $("[name='documentFileData']").parent().find("button").removeClass("errorClass");
                        } else {
                            if ($(elem).hasClass("singleFile")) {
                                $(".adv-textbox").find(".singleFileUpload").hide();
                            }
                            $scope.jqueryElem.append(newelem);
                            $compile($scope.jqueryElem)($scope);
                        }
                        // setTimeout(function(){
                        if ($rootScope.alertBoxes.length > 0) {
                            modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                            modalToClose.opened.then(function () {
                                modalToClose.close();
                                modalToClose = null;
                            })
                            $rootScope.alertBoxes.pop();
                        }
                        // },1000);
                    });
                }
            } // end else ..
        } // end else
    };
    $scope.deleteElem = function (id) {
        var jqueryElem = $(id);
        jqueryElem.remove();
    }

    $scope.fetchCommentFiles = function (url = '') {
        const fromComment = _.get($scope.data,"comment.fromComment.values");
        if(!fromComment) {
            if(url.includes('create') || url.includes('clone')){
                angular.element('.jx-fileListDiv').find('.jx-fileListSpan').innerHTML = [];
            }
            let filesList = angular.element('.jx-fileListDiv').find('.jx-fileListSpan');
            if(!_.get($scope.data,'comment.commentDocuments.values')){
                $scope.data.comment.commentDocuments = {};
                $scope.data.comment.commentDocuments.values = [];
            }

            var searchable, computation, key, name, financial, legal, businessCase, permissionArr;

            for (let i = 0; i < filesList.length; i++) {
                financial = false;
                legal = false;
                businessCase = false;
                searchable = $(filesList[i]).find("input.searchable").is(":checked");
                computation = $(filesList[i]).find("input.performanceData").is(":checked");
                financial = $(filesList[i]).find("input.financial").is(":checked");
                legal = $(filesList[i]).find("input.legal").is(":checked")
                businessCase = $(filesList[i]).find("input.businessCase").is(":checked");
                key = $(filesList[i]).attr('file');
                name = $(filesList[i]).data("elemname");
                if(!_.isEmpty(key)) {
                    if (name != "documentFileData") {
                        $scope.data[name] = {};
                        $scope.data[name].name = name;
                        $scope.data[name].values = [];
                        $scope.data[name].values = {
                            "key": key
                        };
                    }
                    var docTagArray = SirionUtils.fetchDocTagIDs(filesList[i]);
                    $scope.data.comment.commentDocuments.values.push({
                        "key": key,
                        "performanceData": computation,
                        "searchable": searchable,
                        "legal": legal,
                        "financial": financial,
                        "businessCase": businessCase,
                        "documentTags": SirionUtils.isEmpty(docTagArray) ? [] : docTagArray
                    });
                    $scope.data.comment.commentDocuments.values[i] = SirionUtils.rmCollectionBlankArrayEntries($scope.data.comment.commentDocuments.values[i], "documentTags");
                }
            }
        }else {
            let documents = $scope.data.comment.commentDocuments
            if (documents.values && !Array.isArray(documents.values)) {
                let key = $scope.data.comment.commentDocuments.values.key;
                if (key) {
                    documents.values = [];
                    documents.values.push({
                        "key": key,
                        "performanceData": false,
                        "searchable": false,
                        "legal": false,
                        "financial": false,
                        "documentTags": [],
                        "businessCase": false,
                    });
                }
            }
        }
    }

    $scope.nextTab = function () {
        $('.nav-tabs li:nth-child(2) a').click();
    }
    // lockedClauseInfo arrays
    $scope.lockedClauseIds = [];
    $scope.lockedTagIds = [];
    $scope.lockedPricingTableNames = [];

    const updateLockInfoObj = (sc,lockedArrayType)=>{
        const lockedIdsArray = ['clauseType'].indexOf(lockedArrayType) > -1 ? $scope.lockedClauseIds : $scope.lockedTagIds;
        const objectPassedId = ['clauseType'].indexOf(lockedArrayType) > -1 ? sc.objPassed.id.value : sc.objPassed.id;
        if (sc.isLocked != "true" && lockedIdsArray.indexOf(objectPassedId) !== -1){
            ['clauseType'].indexOf(lockedArrayType) > -1 && ($scope.lockedClauseIds =  lockedIdsArray.filter(cId => cId != objectPassedId));
            ['tags'].indexOf(lockedArrayType) > -1 && ($scope.lockedTagIds =  lockedIdsArray.filter(cId => cId != objectPassedId));
        }
        else if (sc.isLocked == "true" && lockedIdsArray.indexOf(objectPassedId) == -1){
            if(['clauseType'].indexOf(lockedArrayType) > -1) $scope.lockedClauseIds.push(sc.objPassed.id.value)
            else $scope.lockedTagIds.push(sc.objPassed.id)
        }
        else return
    }


    var cleanUpLockedClauseData = $rootScope.$on("update lockedInfo obj",function (e,dataScope) {
        if(dataScope.objPassed.isClause || dataScope.objPassed.clauseType == 2 || dataScope.objPassed.clauseType == 1) updateLockInfoObj(dataScope,'clauseType');
        else updateLockInfoObj(dataScope,'tags')
    });

    $scope.$on('$destroy', function () {
        cleanUpLockedClauseData();
    });
    $scope.preProcessTemplateData = function () {
        let response = window.sarc.channelBroadcast("sendLineItemDetailChannel", {actionType: "sendBackData"}, 'sendLineItemDetailChannelSubscription')
        let processedData = [];
        if (!_.isEmpty(response)) {
            _.forEach(response[0].res, template => {
                template.tables.map((table, i) => {
                    let obj = {
                        columnSequence: {},
                        heading: true,
                        numbering: table.tableNumbering,
                        header: template.templateName,
                        templateType: template.templateId,
                        tableName: table.tableName,
                        tableId: table.tableId,
                        filterQuery: table.filterQuery,
                        filterQueryToShow:table.filterQueryToShow,
                        locked: table.locked
                    }
                    table.tableColumns.map((itm, ind) => obj.columnSequence[ind + 1] = itm.columnName);
                    table.tableNumbering && table.tableNumbering == 'yes' && (obj.numbering = true);
                    processedData.push(obj);
                })
            })
        }
        return processedData;
    }
    $scope.validateLineItemObject = function (lineItems) {
        let hasError = false;
        _.forEach(lineItems, item => {
            if (!Object.keys(item.columnSequence).length){
                Toaster.create('Please select table columns for ' + item.header + ' template', {iconClass: "icon-Information_filled"});
                hasError = true;
            }
        })
        _.forEach(lineItems, item => {
            if (!item.tableName.length) {
                Toaster.create('Please enter table name in ' + item.header + ' template', {iconClass: "icon-Information_filled"});
                hasError = true;
            }
        })
        if(_.isEmpty(lineItems)){
            hasError = true;
        }
        return hasError;
    }

    $scope.isCommentDraft = function(from, sc){
        let documentData = SirionUtils.prepareFinalCreatePostData(sc, sc.fileData),
        draftVal = false;
        if (documentData) draftVal = true;
        let draftObj = {
            name: "draft",
            values: draftVal
        }
        if(from === 'ammendment') {
            $scope.modiFiedData.comment.commentDocuments.values = documentData;
            $scope.modiFiedData.comment["draft"] = draftObj;
        } else{
            $scope.data.comment.commentDocuments.values = documentData;
            $scope.data.comment["draft"] =  draftObj
        }
    };

    $scope.submitData = function (url, submittedData, sendMethod, handleResponse, animateIcon,btnInfo, newShowPage,isFromContractDocUpload) {
        startLoader();

        if (submittedData?.comment?.parentCommentId?.values && _.isEmpty(submittedData?.comment?.comments?.values) && _.isEmpty(submittedData?.comment?.commentDocuments?.values)) {
            submittedData.comment.parentCommentId.values = null;
        }
        /*
        * @todo showpage_2.5
        * */
        if($scope.isCreateRoute && url.indexOf('create') > -1 && !$scope.exceptionalInNewUx.crudPage) {
            $scope.isNewEntityCreate = true;
        }

        if($scope.isNewUX){
            $scope.contractFromCDRData = JSON.parse(sessionStorage.getItem('contractFromCDRData'));
        }

        if(btnInfo?.properties?.isPartialEdit && $scope.undoDisable) {
            $scope._deferredUndoReset = true;
        }

        $scope.aeDocObject = JSON.parse(sessionStorage.getItem('aeDocObject'));
        if(!_.isEmpty($scope.aeDocObject)){
            $scope.aeDocObject.createUrl=url;
        }

        SirionUtils.disableSubmitButton('globalHeaderEnabled', 2000);

        //To check if any cahnge is made in clauseText.
        if(!window.clauseTextChange && _.get(submittedData, '_clauseText')){
            submittedData.clauseText = _.get(submittedData, '_clauseText');
        }

        if(submittedData.clauseText?.values?.htmlText) {
            submittedData.clauseText.values.htmlText = SirionUtils.remToBasePixel(submittedData.clauseText.values.htmlText)
        }

        //To handle empty values array in case of empty contractreference in pageRefernce values
        if(_.get(submittedData,"pageReference.values")) submittedData.pageReference.values = _.filter(submittedData.pageReference.values, (val)=>val.contractReference)

        if(url.includes('contracttemplate') && _.get(submittedData, 'uploadDocument.values.key')){
            submittedData.uploadDocument.values.name = window.uploadFileMapper[submittedData.uploadDocument.values.key].file.name;
        }

        //To handle empty values array in case of agreementType

        if(_.get(submittedData,"agreementType.values") && Array.isArray(_.get(submittedData,"agreementType.values")) && !_.get(submittedData,"agreementType.values").length){
            submittedData.agreementType.values = null;
        }
        // @Todo This is a temporary fix for UI-14145
        if($scope.clauseShowPage && !$scope.data.clauseTags.values) {
            $scope.data.clauseTags = $scope.actualClauseTags;
        }
        if(url && url.indexOf("novation") == -1 && (url.indexOf("archive") > -1 || url.indexOf("restore") > -1 || url.indexOf("edit") > -1)){
            treeeJson = {};
        }
        if (url && url.indexOf("comment") > -1 && submittedData.comment.comments.hasOwnProperty("taggedIds")) {
            submittedData.comment.comments = dataManipulationService.formatComment(submittedData.comment.comments)
        }
        var skipCommentFldValidationFor = ['novation','archive','restore','edit','clone','delete','onhold','activate','submitdraft'];
        var dontRemoveComment = ['edit','clone'];

        window.sessionStorage.removeItem("tJson");
        dataManipulationService.handleDummyModels(submittedData, $scope.data.dummyModels, $scope);

        if ($scope.data.dummyModels) {
            delete $scope.data.dummyModels;
        }
        if($scope.downloadObj == null || !$scope.downloadObj){
            delete $scope.downloadObj;
        }
        /* start code to make object of string incas eof slmet -- pushpendra */


        dataManipulationService.handleSLMetValues($scope);

        /* end code to make object of string incas eof slmet -- pushpendra */

        // upload file validation check function

        if(docTreeService.contractDocuments && docTreeService.customNumberingCheckValidation($scope) == true){
            const args = {
                popupType: 'alert',
                str: "Input for document start page number / initial pages to exclude is incorrect",
                heading: "ERROR",
                yesCbFn: cancelString,
                yesName: intl_msg[24184],
            }
            SirionUtils.openSirionDialogs(args);
            $rootScope.$emit("Active index of breadcrumb", "create",$scope.pageType == "clone" ? 1 : 2);
            return ;
        }


        var filesStatus = $scope.createContractFileUploadJson();
        const args = {
            popupType: 'alert',
            heading: "ERROR",
            yesCbFn: cancelString,
            yesName: intl_msg[24184],
        }
        if(filesStatus.customNumValidate == false){
            if(filesStatus.customNumValidationMsg && filesStatus.customNumValidationMsg==-1){
                args.str = intl_msg[24181];
                SirionUtils.openSirionDialogs(args);
            }
            else if(filesStatus.customNumValidationMsg && filesStatus.customNumValidationMsg==1){
                args.str = intl_msg[24182];
                SirionUtils.openSirionDialogs(args);
            }
            return false;
        }
        if (filesStatus.valid == false) {
            args.str = filesStatus.message;
            SirionUtils.openSirionDialogs(args);
            return false;
        }
        if (angular.isDefined(submittedData) && angular.isDefined($scope.data.comment)) {
            $scope.fetchCommentFiles(url);
        }
        // console.log("submitted data2",JSON.stringify(submittedData));
        // invoice condition check

        if ($scope.data.dynamicData) {
            var invoice =  $("[data-ng-controller = 'invoiceController']").scope();
            if(invoice){
                invoice.$broadcast("fetchInvoice");
                $scope.data.dynamicData.values = JSON.stringify($rootScope.invoiceData);
            }
        }
        if($scope.data.states){
            var statesEle = $("[fieldname='states']");
            if(statesEle.length){
                $scope.data.states.values = statesEle.data("fieldData").selectedVals;
            }
        }

        //here we are adding uploaded files in commentData if files are uploaded while creating cdr on final submit.
        const sc = $('[contract-doc-upload]').scope();
        if(sc && $scope.showContractUploadStepper ){
            $scope.isCommentDraft('', sc);
        }
        // console.log("submitted data -- ",$scope.data);
        // create clone of data object to remove options and then send it to
        // server......
        if($scope.showInvoiceUploadDialog && $scope.showInvoiceUploadDialog.visible) {
            angular.copy($rootScope.showPageBulkActionData.data["comment"]["comments"],$scope.data.comment.comments)
            if(!_.get($scope,'data.comment.commentDocuments.values') ||  !_.get($scope,'data.comment.commentDocuments.values.length')){
                stopLoader();
                Toaster.create(intl_msg[23593]);
                return;
            }

            if($scope.data && $scope.data.comment && $scope.data.comment["invoiceCopy"]) {
                $scope.data.comment['invoiceCopy']["values"] = true;
            }
        }
        else {
            if($scope.data && $scope.data.comment && $scope.data.comment["invoiceCopy"]) {
                $scope.data.comment['invoiceCopy']["values"] = false;
            }
        }
        $scope.modiFiedData = angular.copy($scope.data);
        if (btnInfo?.properties?.isPartialEdit && $scope.modiFiedData.comment) {
            if ($scope.modiFiedData.comment.comments) $scope.modiFiedData.comment.comments.values = null;
            if ($scope.modiFiedData.comment.commentDocuments) $scope.modiFiedData.comment.commentDocuments.values = null;
            if ($scope.modiFiedData.comment.privateCommunication) $scope.modiFiedData.comment.privateCommunication.values = null;
        }

        if($scope.resetCommentScope) {
            $scope.oldCommentDataScope = $scope.commentDataScope;
            $scope.commentDataScope = -1;
            $scope.resetCommentScope = undefined;
        }

        if($scope.bulkEdit) {
            window.SirionUtils.dynamicMetadataCleanup($scope.modiFiedData);
        }

        if($scope.globalData.dynamicFormId){
            let cleanedObj = window.sarc.channelBroadcast("reactDynamicForms",{
                actionType:'cleanUp',
                payload: $scope.modiFiedData
            },`dfSubscriptions_${$scope.globalData.dynamicFormId}`)
            if(cleanedObj && cleanedObj.length){
                $scope.modiFiedData = cleanedObj[0].res;
            }
        } else if(window.location.href.includes('/autoExtraction/') && $scope.modiFiedData.dynamicMetadata) {
            //Reinsert dynamicMetadata in dynamicMetadata
            SirionUtils.dynamicMetadataCleanup($scope.modiFiedData);
        }

        var modiFiedClauseTagsvalues = [];
        var clauseTagTypeKey = {
            'Text Field': 1,
            'Numeric': 18,
            'Date': 8,
            'Currency': 19
        };
        var htmlTypeMapper = {
            '1': 'Text Field',
            '18': 'Numeric',
            '8': 'Date',
            '19': 'Currency'
        }
        if(_.has($scope.modiFiedData, 'dynamicMetadata')){
            showPageService.removeDynamicTableErrObj($scope)
        }
        if ($scope.modiFiedData && $scope.modiFiedData.clauseTags && $scope.modiFiedData.clauseTags.values) {
            modiFiedClauseTagsvalues = $scope.modiFiedData.clauseTags.values;
        }

        if ($scope.modiFiedData.formulas) {
            formService.operandCorrectionForFormula($scope.modiFiedData.formulas.values);
            var a = {
                "AND": [formService.combineFormulasWithJoinAndOperator($scope.modiFiedData.formulas.values, true)]
            };
            $scope.modiFiedData.formula.values = JSON.stringify(a);
            delete $scope.modiFiedData.formulas;
        }
        let skipCommSecValidation = skipCommentFldValidationFor.find(v => url.indexOf(v) > -1 );
        let removeComment = !(dontRemoveComment.find(v => url.indexOf(v) > -1 ));
        if(!skipCommSecValidation) {
            var validityObj = dataManipulationService.fetchTextAreaValues($scope.modiFiedData, window.htmlEditorList,$scope.workflowStepsvalidation,null,null,true);
            if(!validityObj.isValid){
                stopLoader();
                if(validityObj.isCommentInvalid && $scope){
                    $scope.togglePropValue('expandLeftSection',false);
                    $scope.toggleShowCommentBox();
                }
                return;
            }
        } else if(removeComment){
            if(_.get($scope.modiFiedData,"comment.comments.values")) {
                $scope.modiFiedData.comment.comments.values = '';
            }
        }
        var clausesDom = $(".s-handle:not(.ng-hide)");
        var lineItemScope = $("[line-item-details]").scope();
        var clauseLibraryDom = $("[clause-library]");
        var linkedFields = $("[linked-tab]");
        var clauseTagDom = $("[clause-text-editor] .iframe_textEditor");
        var allClauses = [],
            clauseArr = [],
            counter = 0;

        for (i = 0; i < linkedFields.length; i++) {
            var key = $(linkedFields[i]).attr("field");
            var tmpScope = $(linkedFields[i]).scope();
            if ($scope.modiFiedData[key]) {
                $scope.modiFiedData[key].values = tmpScope.selectedTemplates;
            }
        }
        if (clauseTagDom.length > 0) {
            const iframeWindowObj = clauseTagDom[0].contentWindow;
            let tagElements = clauseTagDom.contents().find(".tag"),
                roleTagElements = clauseTagDom.contents().find(".role_tag");

            tagElements = Array.from(tagElements);
            roleTagElements = Array.from(roleTagElements);
            tagElements = _.concat(tagElements,roleTagElements);

            if (tagElements.length) {
                $scope.modiFiedData['clauseTags'].values = [];

                _.forEach(tagElements,tgElm => {
                    var tagClasses = $(tgElm).attr("class");
                    var tagArray = tagClasses.split(" ");
                    var tagId = tagArray[0].split("_");
                    var tagname = $(tgElm).text();
                    var tExists = false;
                    var tHtmlType = $(tgElm).attr('htmlTagType');
                    var tHtmlTypeVal = $(tgElm).attr('htmlTagTypeVal');

                    var obj = $scope.modiFiedData['clauseTags'].values;
                    if(tagname.indexOf(":") > -1 && tagname.indexOf("${") > -1){
                        tagname = tagname.split(":")[1].replace("}", "");
                    }
                    $.each(obj, function (i, o) {
                        if (o.id == parseInt(tagId[1])) {
                            tExists = true;
                        }
                    });
                    const isSigner = Array.from(tgElm.classList).indexOf('role_tag') > -1;
                    if (tExists == false && tHtmlTypeVal) {
                        $scope.modiFiedData['clauseTags'].values.push({
                            "id": parseInt(tagId[1]),
                            "name": tagname,
                            tagHTMLType: {'id': tHtmlType, 'name': tHtmlTypeVal}
                        });
                    } else if (tExists == false) {
                        $scope.modiFiedData['clauseTags'].values.push({
                            "id": parseInt(tagId[1]),
                            "name": tagname,
                            tagHTMLType: {
                                'id': tHtmlType,
                                'name': htmlTypeMapper[tHtmlType]
                            }
                        });
                    }
                })
            } else {
                if(window.clauseTextChange){
                    delete $scope.modiFiedData['clauseTags'].values;
                }
            }
            if(roleTagElements.length > 0) {
                let recipients = [],
                    clauseDirScope = $("[show-clause-definition]").scope(),
                    rgGroup={};

                _.forEach(roleTagElements, elem =>{
                    const {roleId, recipientRoleType} = $scope.getTagMetadata({id:elem.id}, $scope.modiFiedData);
                    rgGroup[elem.id] = { roleId: roleId,recipientRoleType:recipientRoleType }
                })

                let roleTagGroupBy = _.groupBy(roleTagElements,elm => elm.getAttribute('roleid') || rgGroup[elm.id]?.roleId)
                _.forEach(roleTagGroupBy,rtElm => {
                    let dataObj = {
                        tabs:{},
                        recipientRole: "Signer",
                        role: rtElm[0].getAttribute('roleName'),
                        recipientRoleType: rtElm[0].getAttribute('recipientroletype') || rgGroup[rtElm[0]?.id]?.recipientRoleType,
                        roleGroupId:rtElm[0].getAttribute('roleId') || rgGroup[rtElm[0]?.id]?.roleId
                    };
                    _.forEach(rtElm,elm => {
                        const customTabId = elm.id,
                              tabName = elm.getAttribute('tabName'),
                              objToPush = {customTabId};
                        if(["signHereTabs","initialHereTabs"].indexOf(tabName) > -1) {
                            objToPush.optional = elm.getAttribute('d-optional') === "true";
                        }
                        if(["textTabs"].indexOf(tabName) > -1) {
                            const tagData = clauseDirScope.placeholderList.find(x => x.id == customTabId);
                            objToPush.required = elm.getAttribute('d-required') === "true";
                            objToPush.locked = elm.getAttribute('d-locked') === "true";
                            if(tagData) {
                                objToPush.value = tagData.textValue || "";
                            }
                        }

                        if(dataObj.tabs[tabName])
                            dataObj.tabs[tabName].push(objToPush)
                        else
                            dataObj.tabs[tabName] = [objToPush];
                    });
                    recipients.push(dataObj);
                })
                if(!_.isEmpty($scope.modiFiedData['signatureData'].values)) {
                    $scope.modiFiedData['signatureData'].values.recipients = recipients
                }else {
                    $scope.modiFiedData['signatureData'].values = {
                        recipients
                    }
                }
            }else delete $scope.modiFiedData['signatureData'].values;
        }
        if ($scope.modiFiedData['definitionCategories']) {
            $scope.modiFiedData['definitionCategories'].values = {};
        }
        if (modiFiedClauseTagsvalues && modiFiedClauseTagsvalues.length) {
            if (modiFiedClauseTagsvalues[0].customData && modiFiedClauseTagsvalues[0].customData.tagHTMLType && $scope.modiFiedData.clauseTags && $scope.modiFiedData.clauseTags.values) {
                $.each($scope.modiFiedData.clauseTags.values, function (index, val) {
                    $.each(modiFiedClauseTagsvalues, function (count, item) {
                        if (item.id == val.id)
                            val.tagHTMLType = {
                                'id': clauseTagTypeKey[item.customData.tagHTMLType],
                                'name': item.customData.tagHTMLType
                            };
                    })

                })
            }
        }
        if ($scope.modiFiedData['definitionCategories'] && $scope.modiFiedData['definitionCategories'].values) {
            var clauseDirScope = $("[show-clause-definition]").scope();
            if (clauseDirScope && clauseDirScope.selectedCategories.length > 0) {
                $scope.modiFiedData['definitionCategories'].values = clauseDirScope.selectedCategories;
            } else if (clauseDirScope && clauseDirScope.selectedCategories.length == 0) {
                delete $scope.modiFiedData['definitionCategories'].values;
            }
        }
        if ($scope.modiFiedData && $scope.modiFiedData.group && $scope.modiFiedData.group.values && $scope.modiFiedData.group.values.id) {
            if ($scope.modiFiedData.group.values.id == 1)
                delete $scope.modiFiedData["definitionCategory"];
            else if ($scope.modiFiedData.group.values.id == 2) {
                delete $scope.modiFiedData["category"];
                if ($scope.modiFiedData['definitionCategories'] && $scope.modiFiedData['definitionCategories'].values) {
                    delete $scope.modiFiedData['definitionCategories'].values;
                }
            }
        }
        else if ($scope.modiFiedData.group) {
            delete $scope.modiFiedData["definitionCategory"];
            delete $scope.modiFiedData["category"];
            if ($scope.modiFiedData['definitionCategories'] && $scope.modiFiedData['definitionCategories'].values) {
                delete $scope.modiFiedData['definitionCategories'].values;
            }
        }

        if($scope.modiFiedData['definitionCategories']?.values && !Array.isArray($scope.modiFiedData['definitionCategories'].values))  {
            delete $scope.modiFiedData['definitionCategories'].values;
        }

        //update  lockedInfo before final update call
        if($scope.modiFiedData.contractTemplateLockInfo && !$scope.fromTagsOutlineComp) {
            $scope.modiFiedData.contractTemplateLockInfo.values = {
                "lockedClauseIds": $scope.lockedClauseIds,
                "lockedTagIds": $scope.lockedTagIds,
                "lockedPricingTableNames": $scope.lockedPricingTableNames,
                "entityTypeId": _.get($scope.data,'entityTypeId.values'),
                "entityId": _.get($scope.data,'id.values'),
                "clientId": !!clientId ? clientId : null
            }
        }
        $scope.fromTagsOutlineComp = false;
        if (($scope.modiFiedData && $scope.modiFiedData.addSubclauses && $scope.modiFiedData.addSubclauses.values == true && clauseLibraryDom.size() > 0) || ($scope.modiFiedData && $scope.modiFiedData.clauses && clauseLibraryDom.size() > 0)) {
            if (($scope.modiFiedData.subClauses && clausesDom.length == 0 && typeof $scope.modiFiedData.subClauses.values == "undefined") || ($scope.modiFiedData.subClauses && $scope.modiFiedData.subClauses.values && $scope.modiFiedData.subClauses.values.length == 0 && clausesDom.length == 0)) {
                Toaster.create(intl_msg[9312],{iconClass:"icon-Information_filled"});
                stopLoader();
                return;
            } else if (clausesDom.length > 0) {
                let foundLineItem = false;
                if ($scope.modiFiedData.addSubclauses && $scope.modiFiedData.addSubclauses.values == false) {
                    $scope.modiFiedData.subClauses.values = null;
                } else {
                    let definationSelectedCount = 0;
                    for (var i = 0; i < clausesDom.length; i++) {
                        var thisClause = $.parseJSON($(clausesDom[i]).attr("selectedDataClauses"));
                        Object.keys(thisClause).forEach(function (item, index) {
                            if (thisClause[item] && (typeof thisClause[item].value != "undefined"))
                                thisClause[item] = thisClause[item].value;
                        })
                        var clauseId;
                        if (typeof (thisClause.id) == "number") {
                            thisClause.id = thisClause.id.toString();
                        }
                        if (thisClause.id && (thisClause.id.indexOf(":;") > -1)) {
                            clauseId = thisClause.id.split(":;")[1];
                        } else {
                            clauseId = thisClause.id;
                        }
                        if(clausesDom[i].className.indexOf('definitionBlock') > -1) {
                            const defCountText = clausesDom[i].querySelector('.selectionCount ').innerText;
                            definationSelectedCount = defCountText ? parseInt(defCountText) : 0;
                            definationSelectedCount = definationSelectedCount || _.get($scope.data,"definitions.values.length") || 0;
                        }
                        if(thisClause.lineItem && $scope.modiFiedData.lineItemInfo) {
                            if(foundLineItem)
                                continue;
                            foundLineItem = true;
                            let columnSequence = lineItemScope.tableColumns.filter(col => col.selected).reduce((acc,col,index) => {
                                acc[index + 1] = col.name
                                return acc;
                            },{});

                            let valid = true,
                                isHeading = lineItemScope.tableDetails.isHeading == 'true',
                                isNumbering = lineItemScope.tableDetails.isNumbering == 'true';

                            const lineItemOrder = i + 1 + (definationSelectedCount ? definationSelectedCount-1 : 0);
                            let lineItemObj = $scope.preProcessTemplateData();
                            if($scope.validateLineItemObject(lineItemObj)){
                                stopLoader();
                                return;
                            }
                            let hasColumnSequence = true;
                            _.forEach(lineItemObj,(template,index)=>{
                                if(!template.columnSequence){
                                    hasColumnSequence = false;
                                }
                                template.order = lineItemOrder + index;
                            })
                            if(!_.keys(columnSequence).length && !hasColumnSequence) {
                                let values = _.get($scope.modiFiedData,"lineItemInfo.values");
                                if(!_.keys(values).length)
                                    valid = false;
                                else {
                                    lineItemObj = values;
                                    lineItemObj.order = lineItemOrder;
                                }
                            }
                            if($scope.modiFiedData.pricingTemplate.values && valid) {
                                $scope.modiFiedData.lineItemInfo.values = lineItemObj;
                            }else  delete $scope.modiFiedData.lineItemInfo.values;

                        }else if ($scope.modiFiedData.subClauses) {
                            var clause = {
                                "clauseReference": {
                                    "id": parseInt(clauseId),
                                    "name": thisClause.name
                                },
                                "order": i + 1
                            }
                            allClauses.push(clause);
                        } else if ($scope.modiFiedData.clauses) {
                            if (thisClause.definition == true) {
                                for (var j = 0; j < clausesDom.length; j++) {
                                    var thisClause = $.parseJSON($(clausesDom[j]).attr("selectedDataClauses"));
                                    if(thisClause.lineItem)
                                        continue;
                                    Object.keys(thisClause).forEach(function (item, index) {
                                        if (thisClause[item] && (typeof thisClause[item].value != "undefined"))
                                            thisClause[item] = thisClause[item].value;
                                    })
                                    if (thisClause.clauseType == 2) {
                                        counter++;
                                        var clauseId;
                                        if (typeof (thisClause.id) == "number") {
                                            thisClause.id = thisClause.id.toString();
                                        }
                                        if (thisClause.id.indexOf(":;") > -1) {
                                            clauseId = thisClause.id.split(":;")[1];
                                        } else {
                                            clauseId = thisClause.id;
                                        }
                                        clauseArr.push({
                                            "clauseCategory": {
                                                "name": thisClause.category,
                                                "id": thisClause.categoryId
                                            },
                                            "clause": {
                                                "name": thisClause.name,
                                                "id": parseInt(clauseId)
                                            },
                                            "clauseGroup": {
                                                "name": "Clause",
                                                "id": thisClause.clauseType
                                            },
                                            "order": i + counter,
                                            "mandatory": null
                                        });
                                    }
                                }
                                counter--;
                            } else {
                                if (thisClause.clauseType == 1) {
                                    clauseArr.push({
                                        "clauseCategory": {
                                            "name": thisClause.category,
                                            "id": thisClause.categoryId
                                        },
                                        "clause": {
                                            "name": thisClause.name,
                                            "id": parseInt(clauseId)
                                        },
                                        "clauseGroup": {
                                            "name": "Clause",
                                            "id": thisClause.clauseType
                                        },
                                        "order": i + counter + 1,
                                        "mandatory": null
                                    });
                                }
                            }
                        }
                    }
                    if ($scope.modiFiedData.subClauses) {
                        $scope.modiFiedData.subClauses["values"] = allClauses;
                    } else if ($scope.modiFiedData.clauses) {
                        $scope.modiFiedData.clauses["values"] = clauseArr;
                    }
                }
            } else if ($scope.modiFiedData.subClauses && $scope.modiFiedData.addSubclauses && $scope.modiFiedData.addSubclauses.values == true && $rootScope.preSignature.initClauseLibrary && clausesDom.length == 0) {
                $scope.modiFiedData.subClauses.values = [];
                Toaster.create(intl_msg[9313],{iconClass:"icon-Information_filled"});
                stopLoader();
                return;
            }
        } else if ($scope.modiFiedData && $scope.modiFiedData.subClauses && $scope.data.entityTypeId && ($scope.data.entityTypeId.values == 138 || $scope.data.entityTypeId.values == 140)) {
            $scope.modiFiedData.subClauses.values = [];
        } else if ($scope.modiFiedData && $scope.modiFiedData.clauses && $scope.data.entityTypeId && ($scope.data.entityTypeId.values == 138 || $scope.data.entityTypeId.values == 140)) {
            if($scope.pageType != "show") {
                $scope.modiFiedData.clauses.values = [];
            }
        } else if ($scope.modiFiedData.subClauses && $scope.modiFiedData.addSubclauses && $scope.modiFiedData.addSubclauses.values == false) {
            $scope.modiFiedData.subClauses.values = [];
        }
        // $scope.modiFiedData = dataManipulationService.addDefinitionToClause($scope.modiFiedData); //SIR-145364
        if (dataManipulationService.validateMandatoryCategories() == false) {
            $rootScope.$emit("Show Error on mandatory validation fail");
            stopLoader();
            return;
        }
        $scope.extraTableStyle = "<style>.table-bordered, .table-bordered>tbody>tr>td, .table-bordered>tbody>tr>th, .table-bordered>tfoot>tr>td, .table-bordered>tfoot>tr>th, .table-bordered>thead>tr>td, .table-bordered>thead>tr>th{	 border: 1px solid #ddd;      border-collapse: collapse;}.table {   width: 100%;    max-width: 100%;    margin-bottom: 20px;}</style>";
        if ($scope.modiFiedData && $scope.modiFiedData.clauseText && $scope.modiFiedData.clauseText.values && $scope.modiFiedData.clauseText.values.htmlText) {
            if ($scope.modiFiedData.clauseText.values.htmlText.indexOf("<style>") == -1) {
                if ($scope.modiFiedData.clauseText.values.htmlText.slice(-4) == "<br>") {
                    $scope.modiFiedData.clauseText.values.htmlText = $scope.extraTableStyle + $scope.modiFiedData.clauseText.values.htmlText.slice(0, -4);
                } else {
                    $scope.modiFiedData.clauseText.values.htmlText = $scope.extraTableStyle + $scope.modiFiedData.clauseText.values.htmlText;
                }
            }
        }
        /*if(_.get($scope.modiFiedData,"multilingualTemplate.values")) {
            _.has($scope.modiFiedData,"clauses.values") && ($scope.modiFiedData.clauses.values = []);
            _.has($scope.modiFiedData,"attachments.values") && ($scope.modiFiedData.attachments.values = []);
            _.has($scope.modiFiedData,"lineItemInfo.values") && (delete $scope.modiFiedData.lineItemInfo.values);
        }*/
        dataManipulationService.removeFalseIds($scope.modiFiedData, $scope);
        dataManipulationService.removeExtraKeyValFromDD($scope.modiFiedData);
        $scope.modiFiedData = dataManipulationService.getSelectedLineItem.call($scope, $scope.modiFiedData);

        $scope.removeOptions($scope.modiFiedData, "$scope.modiFiedData");
        $scope.modiFiedData = dataManipulationService.checkForEmptyRefOption.call($scope, $scope.modiFiedData)
        if ($.isArray($scope.errorsFromServer)) {
            $scope.errorsFromServer.forEach(function (d) {
                if (d) {
                    var str = d.replace("data.", "modiFiedData.");
                    var deleteCandidate = showPageService.getModelfromString.call($scope, str);
                    if (deleteCandidate != null && deleteCandidate["error"]) {
                        delete deleteCandidate["error"];
                    }
                }
            })
        }
        var callMethod = "get";
        var entity = "contractCreate";
        var responseData = {};
        // var url1 = "D:/my%20Projects/SPA-Angular/common/json/responseJson.json"
        // var url1 = "/web/SPA-Angular/common/json/entityJson2.json"
        var getDataSuccessParam = true;
        if (url) {
            var additionalFieldIds = [];
            $(".fieldForm.redesign label.coveringParent").find("span[id*=elem_]").each(function () {
                var id = $(this).attr("id");
                if (id) {
                    id = id.split("_")[1];
                }
                if (id && additionalFieldIds.indexOf(id) == -1) {
                    additionalFieldIds.push(Number(id));
                }
            });
            if (additionalFieldIds && additionalFieldIds.length) {
                $scope.modiFiedData["additionalFieldIdsDummy"] = additionalFieldIds;
            }
            if(!btnInfo?.properties?.isPartialEdit && !_.get($scope,"modiFiedData.comment.comments.values") && _.get(submittedData,"comment.comments.values")){
                $scope.modiFiedData["comment"]['comments']["values"] = submittedData["comment"]['comments']["values"];
            }
            if (!btnInfo?.properties?.isPartialEdit && submittedData["comment"] && submittedData["comment"]["draft"] && submittedData["comment"]["draft"]["values"]) {
                for (var commentItem in submittedData["comment"]) {
                    if(commentItem && $scope.modiFiedData["comment"] && $scope.modiFiedData["comment"][commentItem] && !['comments'].includes(commentItem))
                        $scope.modiFiedData["comment"][commentItem]["values"] = submittedData["comment"][commentItem]["values"];
                }
            }
            var isListingPage = false;
            if(window.location.href.indexOf("tblcdr") == -1&& !$scope.cdrDetailedView && !JSON.parse(sessionStorage.getItem('createFromShowPage'))){
                $scope.contractFromCDRData = {};
            }
            if(_.has($scope.data,"additionalOptions") && (!$scope.data.additionalOptions.values ||  $scope.data.additionalOptions.values.id!=12218)){
                $scope.modiFiedData.companyPositions.values = [];
            }
            if(sessionStorage.getItem('fromAEShowPage') && (window.location.href.indexOf("autoExtraction") == -1) && sessionStorage.getItem('aeDocObject') && !$scope.fromSupplierDropdown){
                sendMethod = "GET"
            }
            const validPath = (window.location.href.indexOf("/listRender/") > -1 || $scope.isNewUX) && !JSON.parse(sessionStorage.getItem('createFromShowPage'))
            if (entity=="contractCreate" && validPath && ($scope.data.entityTypeId == 61 || ($scope.data.entityTypeId && $scope.data.entityTypeId.values == 212) || $scope.data.entityTypeId == 160)) {
                $scope.contractFromCDRData = {};
                isListingPage = true;
                if ($scope.data.supplier && $scope.data.supplier.values && $scope.data.supplier.values.id)
                    $scope.contractFromCDRData.sourceEntityId = $scope.data.supplier.values.id;
                if ($scope.data.supplier && $scope.data.supplier.values && !$scope.data.supplier.values.id) {
                    $scope.contractFromCDRData.sourceEntityId = $scope.data.supplier.values[0].id;
                    $scope.multiSupplierFromListing = true;
                }
                if ($scope.data.entityTypeId && $scope.data.entityTypeId.values)
                    $scope.contractFromCDRData.sourceEntityTypeId = $scope.data.entityTypeId.values;
                if ($scope.documentTypeId)
                    $scope.contractFromCDRData.documentTypeId = $scope.documentTypeId;
            } else if ($scope.contractFromCDRData && Object.entries($scope.contractFromCDRData).length > 0 && !$scope.contractFromCDRData.documentTypeId) {
                $scope.contractFromCDRData.documentTypeId = $scope.documentTypeId ? $scope.documentTypeId : 4;
            }
            if (sendMethod == "GET" && entity == "contractCreate" && $scope.contractFromCDRData && $scope.contractFromCDRData.sourceEntityId && $scope.contractFromCDRData.sourceEntityTypeId && $scope.contractFromCDRData.documentTypeId) {
                var contractId = "";
                var supplierId = null;
                var actualParentEntityTypeId = 1;
                $scope.multiSupplierFromListing = true;
                if ($scope.data.contracts.values)
                    contractId = $scope.data.contracts.values.id;
                if($scope.data.contracts.values && !$scope.data.contracts.values.id)
                    contractId = $scope.data.contracts.values[0].id;
                if ($scope.data.supplier.values)
                    supplierId = $scope.data.supplier.values.id;
                if ($scope.data.supplier.values && !$scope.data.supplier.values.id) {
                    supplierId = $scope.data.supplier.values[0].id;
                }
                var actualParentEntityId = supplierId;

                if (contractId) {
                    actualParentEntityTypeId = 61;
                    // contractId = contractId;
                }

                if ($scope.data.parentEntityType && $scope.data.parentEntityType.values && $scope.data.parentEntityType.values.id != 1)
                    actualParentEntityTypeId = 61;

                if ($scope.data.contracts && $scope.data.contracts.values && $scope.data.contracts.values.id) {
                    actualParentEntityId = $scope.data.contracts.values.id;
                    contractId = $scope.data.contracts.values.id;
                }


                getDataSuccessParam = true;
                var persistCDRtoContractData;
                if (isListingPage || JSON.parse(sessionStorage.getItem('createFromShowPage')) || (window.location.href.indexOf("/tblcdr/") > -1 && ($scope.data.entityTypeId && $scope.data.entityTypeId.values == 212))) {
                    var entityStringUrl = "";
                    var multiSupEntityId;
                    if (contractId) {
                        entityStringUrl = "/61/" + contractId;
                        multiSupEntityId = 61;
                    } else if (supplierId) {
                        entityStringUrl = "/1/" + supplierId;
                        multiSupEntityId = 1;
                    }

                    url = appName + "/contracts/new/" + $scope.contractFromCDRData.documentTypeId + entityStringUrl + "/" + actualParentEntityTypeId + "/" + actualParentEntityId + "?version=2.0";
                    if(!isListingPage && $scope.contractFromCDRData && $scope.contractFromCDRData.sourceEntityId && $scope.contractFromCDRData.sourceEntityTypeId){
                        url = url+'&sourceEntityTypeId='+$scope.contractFromCDRData.sourceEntityTypeId+'&sourceEntityId='+$scope.contractFromCDRData.sourceEntityId;
                        persistCDRtoContractData =  angular.copy($scope.contractFromCDRData);
                    }

                    if($scope.data.supplier && $scope.data.supplier.values && $scope.data.supplier.values.id){
                        url = url + "&relationIds[]="+ $scope.data.supplier.values.id;
                    }
                    else if ($scope.data.supplier && $scope.data.supplier.values instanceof Array) {
                        var ids='';
                        for (var i = 0; i < $scope.data.supplier.values.length; i++) {
                            ids = ids+ $scope.data.supplier.values[i].id +',';
                        }
                        ids = ids.substr(0,ids.length-1);
                        url = url + "&relationIds[]="+ ids;
                    }
                    $scope.documentTypeId = $scope.contractFromCDRData.documentTypeId;
                }
                else {
                    url = appName + url + "?sourceEntityId=" + $scope.contractFromCDRData.sourceEntityId + "&sourceEntityTypeId=" + $scope.contractFromCDRData.sourceEntityTypeId + "&documentTypeId=" + $scope.contractFromCDRData.documentTypeId + "&relationId=" + supplierId + "&entityId=" + contractId + "&actualParentEntityTypeId=" + actualParentEntityTypeId + "&actualParentEntityId=" + actualParentEntityId;
                    // renderFormInModal(url);
                }
                if(url.indexOf('null') > -1){
                    return;
                } else {
                    startLoader();
                    if($scope.multiSupplierFromListing) {
                        var parentEntityIds,parentEntityTypeId,sourceEntityIds,sourceEntityTypeId;
                        sendMethod = "post";
                        url = !_.isEmpty($scope.aeDocObject) ? appName + $scope.aeDocObject.createUrl : appName + "/contracts/v1/new?version=2.0";
                        const workflow_id = sessionStorage.getItem("wf_id");
                        if(_.has($scope, "globalData.workflowId") || workflow_id ){
                            url += "&workflowId=" + ($scope.globalData.workflowId || workflow_id) ;
                        }
                        if(!$scope.data.supplier.values.id) {
                            parentEntityIds = $scope.data.supplier.values.map(function (obj) {
                                return obj.id;
                            });
                            sourceEntityIds = [$scope.data.supplier.values[0].id];

                        } else if($scope.data.supplier.values.id) {
                            parentEntityIds = [$scope.data.supplier.values.id];
                            sourceEntityIds = [$scope.data.supplier.values.id];
                        }
                        parentEntityTypeId = multiSupEntityId;
                        sourceEntityTypeId = multiSupEntityId;
                        if(!_.isEmpty($scope.aeDocObject)){
                            sourceEntityIds = [];
                            sourceEntityIds.push($scope.aeDocObject.aeDocId);
                            sourceEntityTypeId = $scope.aeDocObject.aeEntityTypeId;
                        }

                        var postBody = {
                            documentTypeId: $scope.documentTypeId,
                            parentEntity:{
                                entityIds:parentEntityIds,
                                entityTypeId:parentEntityTypeId
                            },
                            actualParentEntity:{
                                entityIds:sourceEntityIds,
                                entityTypeId:parentEntityTypeId
                            },
                            sourceEntity:{
                                entityIds:sourceEntityIds,
                                entityTypeId: sourceEntityTypeId
                            }
                        };
                        if($scope.data.contracts && $scope.data.contracts.values && $scope.data.contracts.values.id){
                            postBody.relationIds = postBody.parentEntity.entityIds;
                            postBody.parentEntity.entityIds = [ $scope.data.contracts.values.id ];
                            postBody["actualParentEntity"]["entityIds"] = [$scope.data.contracts.values.id];
                        }
                        if(persistCDRtoContractData){
                            postBody.sourceEntity.entityIds = [persistCDRtoContractData.sourceEntityId];
                            postBody.sourceEntity.entityTypeId = persistCDRtoContractData.sourceEntityTypeId;
                            postBody.actualParentEntity = postBody.parentEntity;
                            persistCDRtoContractData = null;
                        }
                        docTreeService.docUploadPostBody = postBody;
                        getData = entityFactory.getJson(url, sendMethod, entity, postBody, false);
                        if (!_.has($scope, "globalData.workflowId") && _.isEmpty($scope.aeDocObject)) {
                            showPageService.getWfSelectionList(url, postBody, $scope.data.entityTypeId.values)
                        }
                        delete $scope.multiSupplierFromListing;
                    }
                    else {
                        getData = entityFactory.getJson(url, sendMethod, entity, $scope.modiFiedData);
                    }
                }
            } else {
                if (sendMethod == "post" && entity == "contractCreate" && $scope.contractFromCDRData && $scope.contractFromCDRData.sourceEntityId && $scope.contractFromCDRData.sourceEntityTypeId) {
                    if ($scope.modiFiedData) {
                        if ($scope.modiFiedData.sourceEntityId)
                            $scope.modiFiedData.sourceEntityId.values = $scope.contractFromCDRData.sourceEntityId;
                        if ($scope.modiFiedData.sourceEntityTypeId)
                            $scope.modiFiedData.sourceEntityTypeId.values = $scope.contractFromCDRData.sourceEntityTypeId;
                        $scope.modiFiedData.documentTypeId = {
                            'name': 'documentTypeId',
                            'values': $scope.contractFromCDRData.documentTypeId

                        };
                    }
                }
                if($scope.radioButtonValue == 'invoice' && $scope.modiFiedData && $scope.modiFiedData.comment && $scope.modiFiedData.comment.invoiceCopy) {
                    $scope.modiFiedData.comment.invoiceCopy.values = true;
                }
                if(globalUploadButtonActive!="" && $scope.modiFiedData && $scope.modiFiedData.comment && $scope.modiFiedData.comment.commentDocuments.values && $scope.modiFiedData.comment.commentDocuments.values.length)
                    $scope.modiFiedData.comment.commentDocuments.values[0].documentId = globalUploadButtonActive;
                $scope.modiFiedData = updateUndefinedValues($scope.modiFiedData);
                url = SirionUtils.addQueryString(url,"version=2.0");
                getDataSuccessParam = checkLinkedFields($scope.modiFiedData);

                let lineItemInfo = _.get($scope.modiFiedData,"lineItemInfo.values");
                let updatedLineItemInfo = $scope.preProcessTemplateData();
                if (_.get($scope.data, "pricingTemplate.values") && _.isEmpty(updatedLineItemInfo) && !$scope.isShowPage) {
                    let sc = $('.templateCEpageBreadcrumb').scope();
                    if (typeof sc != 'undefined' && sc.fuel?.levels[4]) {
                        sc.fuel.levels[4].status = "invalid";
                        stopLoader();
                        return;
                    }
                }
                if (!_.isEmpty(updatedLineItemInfo) && !_.isEqual($scope.modiFiedData.lineItemInfo?.values, updatedLineItemInfo)) {
                    if (clausesDom.length > 0) {
                        let definationSelectedCount = 0;
                        for (var i = 0; i < clausesDom.length; i++) {
                            if (clausesDom[i].className.indexOf('definitionBlock') > -1) {
                                const defCountText = clausesDom[i].querySelector('.selectionCount ').innerText;
                                definationSelectedCount = defCountText ? parseInt(defCountText) : 0;
                                definationSelectedCount = definationSelectedCount || _.get($scope.data, "definitions.values.length") || 0;
                            }
                            const lineItemOrder = i + 1 + (definationSelectedCount ? definationSelectedCount - 1 : 0);
                            _.forEach(updatedLineItemInfo, (template, index) => {
                                let templateId = $.parseJSON($(clausesDom[i]).attr("selectedDataClauses")).templateType;
                                let tableId = $.parseJSON($(clausesDom[i]).attr("selectedDataClauses")).tableId;
                                if(template.templateType === templateId && template.tableId == tableId) {
                                    template.order = lineItemOrder;
                                    template.header = template.tableName;
                                }
                            })
                        }
                        updatedLineItemInfo.sort((a,b)=>a.order - b.order);
                        _.set($scope,"modiFiedData['lineItemInfo'].values", updatedLineItemInfo);
                    }
                    lineItemInfo = updatedLineItemInfo;
                }
                if(_.get($scope.modiFiedData,"pricingTemplate.values") &&
                    (!_.keys(lineItemInfo).length || (lineItemInfo.heading && !lineItemInfo.header)) && !$scope.isShowPage) {
                    stopLoader();
                    return ;
                }else if(!_.get($scope.modiFiedData,"pricingTemplate.values") && _.keys(lineItemInfo).length)
                    delete $scope.modiFiedData.lineItemInfo.values

                if(getDataSuccessParam){
                    startLoader();
                    if(_.get($scope.modiFiedData, "dynamicMetadata.error")){
                        delete $scope.modiFiedData.dynamicMetadata.error;
                        delete $scope.modiFiedData.error;
                    }
                    if($scope.contractNewApi) {
                        sendMethod = "POST";
                        var postBody = {};
                        if($scope.modiFiedData.multiParentSuppliers.values.constructor === Array) {
                            postBody["entityIds"] = $scope.modiFiedData.multiParentSuppliers.values.map(function (obj) {
                                return obj.id;
                            });
                        } else {
                            postBody["entityIds"] = [$scope.modiFiedData.multiParentSuppliers.values.id];
                        }
                        url = SirionUtils.addQueryString($scope.multiSupplierApi,"version=2.0");
                        getData = entityFactory.getJson(url, sendMethod, entity, postBody, false);
                        delete $scope.contractNewApi;
                        $scope.multiSupplierApi = false;
                    }
                    else {
                        if ($scope.multiSupplierApi) {
                            const selectedSuppliers = $scope.modiFiedData?.multiParentSuppliers?.values?.[0] || $scope.modiFiedData?.multiParentSuppliers?.values;
                            // Using 0th index as API does not support mutiple suppliers in GET payload, can remove later

                            let selectedSupplierIds = selectedSuppliers?.id;
                            if(selectedSuppliers && _.isArray(selectedSuppliers)){
                                selectedSupplierIds = selectedSuppliers.map(obj => obj.id).join(',');
                            }
                            url = SirionUtils.addQueryString($scope.multiSupplierApi, "multiParentSupplierId=" + selectedSupplierIds + "&version=2.0")
                            delete $scope.modiFiedData.multiParentSuppliers;
                            $scope.multiSupplierApi = false;
                            sendMethod = "GET";
                        }
                        if($scope.bulkedit) {
                            url = url + "&listId="+$scope.listId;
                        }
                        if($scope.showAmendment){
                          let contractTreeDocuments = {
                                "name": "contractTreeDocuments",
                                    "values": {
                                    "documents": $rootScope.documents
                                },
                                "multiEntitySupport": false
                          }
                          if($scope.modiFiedData){
                              $scope.modiFiedData["contractTreeDocuments"] = contractTreeDocuments;
                          }
                        }
                        const sc = $('[contract-doc-upload]').scope();
                        // if(sc) $scope.modiFiedData.comment.commentDocuments.values = sc.fileData;
                        if(sc && $scope.showContractUploadStepperAmmendmentCase){
                            $scope.isCommentDraft('ammendment',sc);
                        }
                        $scope.nonDeletedFiles && _.update($scope,'modiFiedData.comment.commentDocuments.values',() => $scope.nonDeletedFiles);
                        delete $scope.nonDeletedFiles;
                        delete $scope.isCloneCLIFrom;
                        const postData = url.indexOf('contractDocument/upload') > -1  ? submittedData : $scope.modiFiedData;
                        getData = entityFactory.getJson(url, sendMethod, entity, postData);
                    }
                }
            }

        }
        if ($scope.modalInstance && getData) {
            getData.success(function (newAppendData) {
                stopLoader();
                $scope.modalInstance.close(newAppendData);
                $scope.applyBasePageJson();
            });
        }
        if (getDataSuccessParam) {
            if (angular.isDefined(handleResponse) && handleResponse) {
                return (getData.success(function (newAppendData) {
                    if(!$scope.skipStopLoader) {
                        stopLoader();
                        $scope.skipStopLoader = false;
                    }
                    if(window.location.href.indexOf("/show/tblcdr/") > -1){
                        $scope.pageTitle = _.get($scope.data,"title.values")
                    }
                    alterBackEndResponse(newAppendData);

                    if (_.isEmpty(newAppendData?.body?.errors)) {
                        if(_.get($scope.data,"comment.commentDocuments.values") && !btnInfo?.properties?.isPartialEdit){
                            $scope.data.comment.commentDocuments.values = [];
                        }
                    }

                    stopLoader();
                    $scope.initializeCommentValidations(newAppendData);
                    const layoutFields = _.get(newAppendData, 'body.layoutInfo.layoutComponent.fields');
                    if (layoutFields) {
                        const commTab = _.find(layoutFields, ['type', 'communicationTab']);
                        $scope.checkCommentRightSection(!!commTab);
                    }
                    if($scope.isNewUX && $scope.isNewCrudPage && window.location.href.indexOf("/update/") == -1) {
                        $scope.showCommentPanelInRightSec = true;
                        $rootScope.hideCommentToggle = true;
                    }
                    checkUploadDocAllowed(newAppendData);
                    if($scope.commentFromReact) {
                        $scope.commentFromReact = false;
                        $scope.newCommentAdded(submittedData?.comment?.parentCommentId?.values);
                    }
                    $timeout(function () {
                        $scope.populateReferencePage();
                    }, 1000);
                    if($rootScope.bulkedit && $rootScope.isMiraPageActive){
                        window.SirionUtils.resetDataGridTableSelectedCheckbox();
                    }
                    if (typeof isSupplier != "undefined") {
                        if (angular.isDefined(isSupplier)) {
                            var loc = window.location.href;
                            var url = (loc.indexOf("?") == -1) ? loc + "?ajax=true" : loc + "&ajax=true";
                            $.ajax({
                                type: 'GET',
                                cache: false,
                                dataType: "html",
                                url: url,
                                success: function (response, status) {
                                    $("#mainContainer").html(response);
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    handleErrorResponse(jqXHR);
                                }
                            });
                        }
                    }
                    if($scope.showInvoiceUploadDialog && $scope.showInvoiceUploadDialog.visible) {
                        // var _ = '{"header":{"response":{"type":"notification","properties":{"notification":"Invoice Copy Uploaded Successfully.","title":"NOTIFICATION"},"status":"success"}},"session":null,"body":{},"actions":null,"createLinks":null}'
                        // newAppendData = JSON.parse(_);
                        $scope.renderActionbuttons();
                        if($scope.data && $scope.data.invoiceCopyName && $scope.data.invoiceCopyName)
                            $scope.data.invoiceCopyName.values = $rootScope.invoiceName;
                        // $scope.setInvoiceDocIcons($rootScope.invoiceName);
                        showPageService.updateCommentAndFeeds.call($scope, submittedData?.comment?.parentCommentId?.values);
                        $scope.showInvoiceUploadDialog.visible = false;
                        $scope.loadInvoiceContentHandler();
                        if(newAppendData.header.response && newAppendData.header.response.properties && newAppendData.header.response.properties.notification) {
                            Toaster.create(newAppendData.header.response.properties.notification);
                        }
                        showPageService.showInvoiceCopyToolTip();
                    } else $scope.responsePopUp(newAppendData, animateIcon, btnInfo, newShowPage, submittedData?.comment?.parentCommentId?.values);
                    // $scope.responsePopUp(newAppendData, animateIcon, btnInfo, newShowPage);
                }));
            } else {
                return (getData.success(function (newAppendData) {
                    stopLoader();
                    return newAppendData;
                }));
            }
        } else{
            stopLoader();
        }
    }
    // formService

    $scope.initializeCommentValidations = (data) => {

        function getFieldsWithValidation(fields,validationFields) {
            _.forEach(fields,field => {
                if(field.hasOwnProperty('validations')) {
                    validationFields.push(field);
                }else if(field.fields && field.fields.length) {
                    getFieldsWithValidation(field.fields,validationFields);
                }
                if(field.name==="shareWithSupplier"){
                    $scope.communicationShareWithSupplier=true;
                }
            })
        }

        $scope.errors = null;
        if(_.has(data, 'body.layoutInfo.layoutComponent.fields')) {
            const commTab = _.find( _.get( data, 'body.layoutInfo.layoutComponent.fields' ), ['type', 'communicationTab'] );

            let commFlds = _.get(_.find(_.get( commTab,'fields'),['type',"borderedBox"]),"fields");
            $scope.commentFldHavingValidations = [];
            if(!commTab && _.get(data,"body.errors.fieldErrors")) {
                commFlds = _.filter(_.get( data, 'body.layoutInfo.layoutComponent.fields'),fld => fld.model == "comment");
            }
            getFieldsWithValidation(commFlds,$scope.commentFldHavingValidations);
        }
    }

    // formService
    $scope.removeOptions = function (obj, parentModel) {
        angular.forEach(obj, function (v, k) {
            var myModel = parentModel + "." + k;
            if ((k === "options") && (angular.isObject(v) || (angular.isArray(v)))) {
                var model = showPageService.getModelfromString.call($scope, myModel);
                var myModelArray = myModel.split(".");
                var tempModel = $scope;
                for (var i = 1; i < myModelArray.length - 1; i++) {
                    tempModel = tempModel[myModelArray[i]];
                    continue;
                }
                tempModel.options = undefined;
            } else {
                if (angular.isArray(v) || angular.isObject(v)) {
                    $scope.removeOptions(v, myModel);
                }
            }
        });
    };
    // navigate to home
    // superController
    $rootScope.navigateTo = function () {
        $scope.cancel();
        window.location.href = $rootScope.appBaseApiUrl + "/";
    }
    // close the popup
    // THink
    $rootScope.cancel = function (skipApplyBasePage,animateOnClose) {
        $rootScope.dateAlert = false;
        if (window.location.href.toLowerCase().search("listrender") == -1) {
            stopLoader();
        }
        $timeout(function () {
            $scope.populateReferencePage();
        }, 1000);
        stopLoader();
        var modalToClose;
        var modalPresent = false;
        if ($rootScope.alertBoxes.length > 0) {
            modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
            modalToClose.close();
            modalPresent = true;
        }
        if (modalToClose) {
            modalToClose.closed.then(function () {
                $rootScope.alertBoxes.pop();
                if(!skipApplyBasePage && modalPresent){
                    $scope.applyBasePageJson();
                }
            });
        }

        if ($(".modal-body span.success-icon").text() == "Attendance Updated") {
            if ($("select.colattended option:selected, select.colpresencetype  option:selected, select.colduration  option:selected").text().indexOf("Select") == -1) {
                $("select.colattended, select.colpresencetype, select.colduration").attr("disabled", true);
            }
        }
        if (((window.location.href).indexOf("integration") > -1) && ($scope.createFromXml == true)) {
            $scope.createFromXml = false;
            window.location.reload();
        }
        if(animateOnClose){
            commonUtil.animateUserTaskIcon();
        }

    };
    // Think
    $rootScope.cancelModal = function () {
        var modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
        modalToClose.close();
        location.reload();
    }
    $rootScope.cancelPp = function () {
// if($rootScope.myModelInstance){
        var modalPresent = false;
        $scope.modalInstances.forEach(function (d) {
            var modalToClose = angular.copy(d);
            modalToClose.close();
            modalPresent = true
        });
        $scope.modalInstances = [];
        if(modalPresent) {
            $scope.applyBasePageJson();
        } else {
            $rootScope.fieldHierarchy = {"fields": []};
            $rootScope.fieldMapper = {};
            $rootScope.bulkedit && ($rootScope.fieldMapper2 = {});
        }
        $timeout(function () {
            $scope.populateReferencePage();
        }, 1000);
// }
    }
    // THink
    $scope.closePopupFlag = function () {
        $scope.currentOuterPopup = null;
        entityFactory.factoryOuterPopUp = null;
    }
    // formService
    $scope.openCommentDialog = function (templateId, model) {

        // $scope.createContractFileUploadJson();//create json of fileupload
        $templateCache.put(templateId, $("#" + templateId).html());
        if (typeof model === "string") {
            temp = model.split(".");
            tempModel = $scope;
            for (i = 0; i < temp.length; i++) {
                tempModel = tempModel[temp[i]];
            }
        } else { // else if we got the actual model then we put it in the
            // variable.
            tempModel = model;
        }
        // console.log(templateId, tempModel);
        $rootScope.data = $scope.data;
        // $rootScope.data.comment = tempModel;
        $scope.modalInstance = $modal.open({
            templateUrl: templateId
            // controller: 'dialogController'
        });
        $scope.alertBoxes.push($scope.modalInstance);
        var index = $scope.alertBoxes.length - 1;
        $scope.modalInstance = null;
        $scope.alertBoxes[index].result.then(function (selectedItem) {

            var selectedItem = selectedItem.data;
            if (selectedItem) {
                // console.log('Modal -- ' , selectedItem);
                $scope.selectedItem = selectedItem;
                $scope.responsePopUp($scope.selectedItem);
            }
        });
    };
    $scope.responsePopUp = function (data, animateIcon, btnInfo, newShowPage, parentCommentId) {
        $scope.workflowActionStart && (delete $scope.workflowActionStart);
        // $scope.header = resData.header;
        if(window.isExceptionalPage){
            data.header.response.skipNotification = true;
            delete  window.isExceptionalPage
        }
        if(data.header.response && data.header.response.properties && data.header.response.properties.novation){
            $scope.openNovation(data.body);
            stopLoader();
            return;
        }
        resizeInnerForm();
        $scope.responseDataFromPopup = data;
        var tempCheckFlagForCreateFree = undefined;
        if ($scope.responseDataFromPopup.header.hasOwnProperty("renderInCurrentPopUp")) {
            tempCheckFlagForCreateFree = $scope.responseDataFromPopup.header["renderInCurrentPopUp"];
        }
        angular.element(".errorClassDT").removeClass("errorClassDT");
        // console.log("tempArray :",tempCheckFlagForCreateFree);
        if ($scope.responseDataFromPopup.header?.response?.status === "success") {
            $scope.createHeaderStageTwo = true;
            window.sessionStorage.removeItem("tJson");
            if(window.location.href.indexOf('sendSignature') === -1 && !$scope.openFromShareWithConuterParty) {
                $location.search('wfId', null);
                $location.search('requestId', null);
            }
            $scope.contractFromCDRData = {};
            if (angular.isDefined($scope.currentOuterPopup) && (($scope.currentOuterPopup) !== null) && !angular.isDefined(tempCheckFlagForCreateFree)) {
                $($scope.currentOuterPopup).dialog("close");
                $scope.applyBasePageJson();
            }
            if($scope.responseDataFromPopup.header.response.properties?.nameChanged) {

                const cacheKey = $scope.data?.entityTypeId?.values + "_" + $scope.data?.id?.values;
                let cacheData = JSON.parse(localStorage.getItem('docTreeCache') || '[]');

                cacheData = cacheData.filter(item => Object.keys(item)[0] !== cacheKey);

                try {
                    localStorage.setItem('docTreeCache', JSON.stringify(cacheData));
                } catch (e) {
                    localStorage.removeItem('docTreeCache');
                    window.systemWarning("Error saving in localStorage:", e)
                }

                if(window.location.href.includes('/show')) { // Refresh doc tree in case of show page
                    const docTreeObj = document.getElementById('doc_tree_react');
                    if(docTreeObj && docTreeObj.offsetWidth > 0 && docTreeObj.offsetHeight > 0) { // Doc tree is opened
                        window.mountReactDocTree({externalRefresh:true});
                    }
                }
            }

            if ($scope.responseDataFromPopup.header.response.type === "redirect" && btnInfo?.properties?.isPartialEdit == true) {
                if($scope.esignUserAuthFlowPermitted){
                    $scope.esignUserAuthFlow();
                }
                const node = document.getElementsByClassName('comment-partial-edit');
                if(node.length){
                    node[0]?.click()
                    $scope.newCommentAdded();
                }
                    let jsonUrlOpts = window.location.hash.split("/");
                    let temp = jsonUrlOpts[3] && jsonUrlOpts[3].indexOf("?");
                    let jsonUrlOptsValAtIndex3 = jsonUrlOpts[3];
                    let jsonUrlOptsValAtIndex2 = jsonUrlOpts[2];
                    let urlCodeMapper = urlToCodeMapper[jsonUrlOptsValAtIndex2];
                    if(!jsonUrlOptsValAtIndex3 || !urlCodeMapper) {
                        urlCodeMapper = _.get($scope.data.entityTypeId, "values" );
                        jsonUrlOptsValAtIndex3 = _.get($scope.data.id, "values" );
                    }
                    let id = (temp > -1) ? jsonUrlOptsValAtIndex3.substring(0,temp) : jsonUrlOptsValAtIndex3;
                    let actionGetUrl = apiVersioning.getApiDynamicVersion("actions") + urlCodeMapper + "/" + id;
                    const nwfInfoUrl =  addtStamp(actionGetUrl,true);
                    var getNWFStepInfo = entityFactory.getJson(nwfInfoUrl, "GET");
                    getNWFStepInfo.success((response)=>{
                        if($scope.selectedButton && response && response.layoutActions) {
                            const isSelectedButtonStillValid = response.layoutActions.some(function(action) {
                                return action.label === $scope.selectedButton;
                            });
                            if(!isSelectedButtonStillValid) {
                                $scope.selectedButton = '';
                                $scope.undoDisable = 0;
                                delete $scope.versions;
                            }
                        }
                        if($scope._deferredUndoReset) {
                            $scope.undoDisable = 0;
                            delete $scope.versions;
                            delete $scope._deferredUndoReset;
                        }
                        window.sarc.channelBroadcast("partialEditActions", {
                            actionType: 'updateWorflowActions',
                            value : response
                        }, 'partialEditActionsSubscription')
                      window.sarc.channelBroadcast("partialEditActions", {
                            actionType: 'isValidFormToSubmit',
                            value: true
                        }, 'partialEditActionsSubscription')
                        stopLoader();
                        Toaster.create(intl_msg[36892] || "Changes have been saved successfully.",{iconClass:"icon-Success_Executed_Done"});
                    }).error(function() {
                        delete $scope._deferredUndoReset;
                        stopLoader();
                    });
                return;
            }
            if ($scope.responseDataFromPopup.header.response.type === "redirect" && !btnInfo?.properties?.isPartialEdit) {
                if ($scope.isCdrCreateExternalContactFlow && $scope.isCdrCreateExternalContactFlow()) {
                    $scope.handleCdrCreateExternalContactSuccess();
                    return;
                }
                var redirectUrl;
                //$scope.rightTabInfo = [];
                if($scope.wfsModalOpen && typeof $scope.closeWorkFlowStepDialog == 'function'){
                    $scope.closeWorkFlowStepDialog();
                }
                if (newShowPage && ($scope.responseDataFromPopup.header.response.properties.redirectUrl.indexOf('show')>-1 || $scope.responseDataFromPopup.header.response.properties.redirectUrl.indexOf('update')>-1)) {
                    redirectUrl = urlFactory.convertUrlToRest($scope.responseDataFromPopup.header.response.properties.redirectUrl + '');
                } else {
                    redirectUrl = urlFactory.convertUrlToRest($scope.responseDataFromPopup.header.response.properties.redirectUrl);
                }

                if (btnInfo && btnInfo.buttonPosition == 30 && btnInfo.buttonType == 5) {
                    stopLoader();
                    // $scope.$broadcast('updateComment', true);
                    $scope.newCommentAdded(parentCommentId);
                    angular.element('#jx-cancelCommentSave').trigger('click');
                } else {
                    if(window.emailTokenValidation) {
                        var workflowActionResponse = {
                            "type": "success",
                            "notification": "",
                            "heading": intl_msg[23519] || "Updated Successfully"
                        };
                        localStorage.setItem("workFlowNotification", JSON.stringify(workflowActionResponse));
                        window.location.href = "/ux/notification.html";
                    }
                    else {
                        if($scope.showInWorkspace){
                            if($scope.showMoreBtnDD){
                                $scope.showMoreBtnDD=false;
                            }
                            $scope.workFlowButtons=null;
                            if(btnInfo && btnInfo.api &&  btnInfo.api.indexOf('/delete')>-1){
                                window.location.reload();
                            }else{
                                angular.element($scope.workSpaceViewListData.currentElement).click();
                            }
                        }else if($scope.isStakeHolderInlineEdit) {
                            $scope.isStakeHolderInlineEdit = false;
                            $scope.hideCrossModalButton = false;    
                            $scope.closeExternalContactModal();
                        }else{
                            $location.path(redirectUrl);
                            if(btnInfo?.api?.includes('delete')) {
                                if (!$scope.$$phase) {
                                    $scope.$applyAsync();
                                }
                            }else $scope.refreshUpdateParam();
                        }
                    }
                }
            }
            else if ($scope.responseDataFromPopup.header.response.type === "notification") {
                var notificationMessage = intl_msg[23500];
                var notificationTitle = "NOTIFICATION";
                if (angular.isDefined($scope.responseDataFromPopup.header.response.properties.notification)) {
                    notificationMessage = $scope.responseDataFromPopup.header.response.properties.notification;
                    notificationTitle = $scope.responseDataFromPopup.header.response.properties.notification;
                    if(_.get($scope,"dataOfnewExtarnalContract")){
                        $scope.dataOfnewExtarnalContract['id'] = $scope.responseDataFromPopup.header.response.entityId
                    }
                    //$rootScope.$emit("updateTasks");
                    try {
                        $("#showdialog_list").dialog && $("#showdialog_list").data('ui-dialog') && $("#showdialog_list").dialog("close");
                    } catch (e) {
                        console.warn("Dialog is not initialized");
                    }
                }
                // close clone after successfully creation
                if($scope.header && $scope.header.response.type == "popUp"){
                    $scope.header.response.type = "";
                }
                if ($rootScope.myModelInstance) {
                    $rootScope.myModelInstance.close();
                    $rootScope.myModelInstance = null;
                    $scope.supplierCreationTitle = '';
                    $scope.modalInstances.forEach(function (d) {
                        var modalToClose = angular.copy(d);
                        modalToClose.close();
                        $rootScope.myModelInstance = null;
                    });
                    $scope.modalInstances = [];
                }

                $(".errorMessageHolder:visible").hide();
                $(".errorClass").removeClass("errorClass");
                if(data.header.response.properties.redirectUrl){
                    if ($scope.isCdrCreateExternalContactFlow && $scope.isCdrCreateExternalContactFlow()) {
                        $scope.handleCdrCreateExternalContactSuccess();
                    } else if(data.header.response.properties.hardReload){
                        var hardReloadCallback = function(){//for staging
                            window.location.reload();
                        }
                        const args = {
                            popupType: 'alert',
                            str: notificationMessage,
                            heading: intl_msg[24153],
                            yesCbFn: "redirectToListing",
                            yesName: intl_msg[24184],
                            rmvCloseBtn: rmvCloseBtn,
                            url: data.header.response.properties.redirectUrl,
                            closeCallBack: hardReloadCallback
                        }
                        SirionUtils.openSirionDialogs(args);
                    }
                    else
                    {
                        Toaster.create(notificationMessage, {}, function () {
                            if(animateIcon)
                                commonUtil.animateUserTaskIcon();
                            $window.history.back();
                        });
                    }
                } else if(!$scope.responseDataFromPopup.header.response.skipNotification){
                    if(data.header.response.properties.refreshUrl){
                            Toaster.create(notificationMessage, {}, function () {
                                if(animateIcon)
                                    commonUtil.animateUserTaskIcon();
                                $route.reload();
                            });
                    }else{
                        const args = {
                            popupType: 'alert',
                            str: notificationMessage,
                            heading: intl_msg[24153],
                            yesCbFn: 'cancel',
                            yesName: intl_msg[24184],
                            rmvCloseBtn: animateIcon,
                            isfirstTabSpecificEntity: data.header.response.properties.isfirstTabSpecificEntity
                        }
                        if(data.header.response.properties.isfirstTabSpecificEntity) {
                            SirionUtils.openSirionDialogs(args);
                        } else {
                            if(animateIcon) {
                                Toaster.create(notificationMessage, {}, function () {
                                    commonUtil.animateUserTaskIcon();
                                });
                            } else {
                                if($scope.openFromShareWithConuterParty) {
                                    startLoader();
                                    $rootScope.externalContract = false;
                                    const wfId = $scope.dataOfShareCountyPartyModal.wfId;
                                    const requestId = $scope.dataOfShareCountyPartyModal.requestId;
                                    $scope.callShareWithCounterParty(null,wfId,requestId,$scope.openFromShareWithConuterParty);
                                    Toaster.create(intl_msg[34983] || "Contact added successfully");
                                    $location.search('wfId', null);
                                    $location.search('requestId', null);
                                }else if($scope.openFromUserRoleGroup){
                                    if ($scope.isCdrCreateExternalContactFlow && $scope.isCdrCreateExternalContactFlow()) {
                                        $scope.handleCdrCreateExternalContactSuccess();
                                    } else {
                                        startLoader();
                                        var externalContactProcessingDelay = 100;
                                        
                                        if($scope.globalData && $scope.globalData.dynamicFormId && $scope.dataOfnewExtarnalContract && $scope.dataOfnewExtarnalContract.id){
                                            try {
                                                window.sarc.channelBroadcast("reactDynamicForms", {
                                                    actionType: "updateAdditionalData",
                                                    payload: window.createRDFSecObj($scope)
                                                }, `dfSubscriptions_${$scope.globalData.dynamicFormId}`);
                                            } catch (error) {
                                                console.error("Error broadcasting external contact update:", error);
                                            }
                                        }
                                        Toaster.create(intl_msg[34983] || "Contact added successfully");
                                        stopLoader();
                                        
                                        var timeoutId = setTimeout(() => {
                                            $scope.openFromUserRoleGroup = false;
                                            if (!$scope.$$phase) {
                                                $scope.$applyAsync();
                                            }
                                        }, externalContactProcessingDelay);

                                        if ($scope.$on) {
                                            $scope.$on('$destroy', function() {
                                                if (timeoutId) {
                                                    clearTimeout(timeoutId);
                                                }
                                            });
                                        }
                                    }
                                } else if($scope.openFromSendForSignatue){
                                    Toaster.create(intl_msg[34983] || "Contact added successfully");
                                    $scope.callNewExtInStakeholderList();
                                }else{
                                    SirionUtils.openSirionDialogs(args);
                                }

                            }
                        }
                    }

                } else if($scope.responseDataFromPopup.header.response.skipNotification && !$scope.fromSupplierDropdown) {
                    if ($scope.isCdrCreateExternalContactFlow && $scope.isCdrCreateExternalContactFlow()) {
                        $scope.handleCdrCreateExternalContactSuccess();
                    } else {
                    isCreate = false;
                    window.doNotApplyOldScope = true;
                    window.doNotRedirectToPreviousRoute = true;
                    var url = $(notificationMessage).attr("href").split("#")[1];
                    if(url) {
                        if($scope.isNewEntityCreate) {
                            $scope.isNewEntityCreate && window.location.replace($(notificationMessage).attr("href"));
                            $scope.isSkipNotification = true;
                        }
                        !$scope.isNewEntityCreate && (window.location.href = `${basePath}/#${url}`);
                    }
                    }
                  }

                    if ($scope.fromSupplierDropdown) {
                        window.__supplierOwnedModalClose = true;
                        Toaster.create(intl_msg[34724] || "Supplier added successfully");
                        let newlyCreatedSupplier = {
                            'name': $scope.modiFiedData.name.values,
                            'id': data.header.response.entityId
                        };
                        $rootScope.newlyCreatedSuppArray.push(newlyCreatedSupplier);
                        window.sarc.channelBroadcast("reactDynamicForms", {
                            actionType: "newlyCreatedSupplierDetails",
                            payload: $rootScope.newlyCreatedSuppArray
                        }, `dfSubscriptions_${$scope.globalData.dynamicFormId}`);
                        setTimeout(()=>{
                            $scope.applyBasePageJson();
                            $timeout(function () {
                                delete window.__supplierOwnedModalClose;
                            }, 1000);
                        },100)
                    }

                if ($scope.responseDataFromPopup.header.response.redirectUrl) {
                    document.location.hash = $scope.responseDataFromPopup.header.response.redirectUrl;
                } else if ($scope.responseDataFromPopup.header.response.properties.refreshElement) {
                    if ($scope.responseDataFromPopup.header.response.properties.refreshElement.name === "contractTree") {
                        if ($("#relationId").val()) {
                            loadTree($("#relationId").val(), undefined, true);
                        } else {
                            treeeJson = {};
                            loadTree($scope.currentRelationId, undefined, true);
                        }
                    } else if ($scope.responseDataFromPopup.header.response.properties.refreshElement.name === "dataTables") {
                        if ($('#cr').length > 0) {
                            $('#cr').dataTable().fnDraw();
                        }
                    }
                }
                sessionStorage.removeItem('wfListData');
                docTreeService.renderWfSelectionPage = false;
                if(!$scope.fromSupplierDropdown) {
                    if ($scope.isNewEntityCreate) {
                        $timeout(function () {
                            !window.doNotRedirectToPreviousRoute && !$scope.isSkipNotification && $scope.goToPreviousRoute();
                            delete $scope.isNewEntityCreate;
                            delete $scope.isSkipNotification;
                            delete window.doNotRedirectToPreviousRoute;
                        }, 0)
                    }
                }
            } else if ($scope.responseDataFromPopup.header.response.type === "asyncNotification") {
                const redirectURL = $scope.responseDataFromPopup.header.response.properties.redirectUrl;
                const notificationMessage = $scope.responseDataFromPopup.header.response.properties.notification;

                Toaster.create(notificationMessage,{iconClass:"icon-Information_filled"});
                if(redirectURL) {
                    const hash = redirectURL.indexOf('#') > -1? '' : '#';
                    window.location.replace(hash + redirectURL);
                }
            } else {
                $scope.processData(data);
                showPageService.preventLabelClick();

            }
        }
        else if ($scope.responseDataFromPopup.header.response.status === "validationError") {
            !$scope.isNewCrudPage && ($scope.commentDataScope = $scope.oldCommentDataScope);
            delete $scope.oldCommentDataScope;
            $scope.hasCommentErrors = false;
            if ($scope.responseDataFromPopup.body.errors.genericErrors.length > 0) {
                $scope.errors = $scope.responseDataFromPopup.body.errors;
                if($scope.aeDocShowPage && $scope.errors) {
                    _.forEach($scope.errors.genericErrors,error => {
                        error.message && Toaster.create(error.message);
                    })
                }
                if (!$scope.$$phase) {
                    $scope.$applyAsync();
                }
                stopLoader();
            } else {
                if(_.has($scope.responseDataFromPopup,"body.errors.fieldErrors") && _.size($scope.responseDataFromPopup.body.errors.fieldErrors) > 0){
                    window.sarc.channelBroadcast("reactDynamicForms",{actionType:"updateInitialLoad"},`dfSubscriptions_${$scope.globalData.dynamicFormId}`)
                    angular.forEach($scope.responseDataFromPopup.body.errors.fieldErrors, function(obj, key){
                        if(key.includes('comment.')){ // Handled the case specific to comments field
                            $scope.noCmntAdValTriggered = true;
                            $timeout(()=>{
                                $scope.showCommentBox=true;
                            },2000);
                            Toaster.create(obj.message,{iconClass:"icon-Information_filled"});
                        }
                        if(key == "eSignStatus"){
                            Toaster.create(obj.message,{iconClass:"icon-Information_filled"});
                        }
                    });
                }
                $scope.data.dummyModels = [];
                var versionObject = {};
                if (angular.isUndefined($scope.versions) || ($scope.versions && $scope.versions.versionArray && $scope.versions.versionArray.length == 0)) {
                    $scope.versions = {};
                    $scope.versions.latestVersion = 1;
                    $scope.versions.versionArray = [];
                } else {
                    $scope.versions.latestVersion += 1;
                }
                stopLoader();
                versionObject.version = $scope.versions.latestVersion;
                versionObject.data = angular.copy($scope.data);
                versionObject.timeLineFeedScope = $scope.timeLineFeedScope;
                versionObject.commentDataScope = $scope.commentDataScope;
                if (angular.isDefined($scope.validity)) {
                    versionObject.validity = angular.copy($scope.validity);
                }
                versionObject.errors = angular.copy($scope.errors);
                versionObject.htmlComponents = {};
                versionObject.globalData = angular.copy($scope.globalData);
                dataManipulationService.mergeData($scope.data, $scope.responseDataFromPopup.body.data);
                for (var i = 0; i < dataThatNeedsSpecialHandling.length; i++) {
                    if (angular.isDefined($scope.data[dataThatNeedsSpecialHandling[i]])) {
                        transformData($scope.data[dataThatNeedsSpecialHandling[i]], dataThatNeedsSpecialHandling[i]);
                    }
                }
                var errorObject = $scope.responseDataFromPopup.body.errors.fieldErrors;
                for (var j in errorObject) {
                    var mod = j.split(".");
                    var lastAttr = mod.pop();
                    if (mod.length > 0) {
                        var a = showPageService.getModelfromString.call($scope, "data." + mod.join("."));
                        if ($.isArray($scope.errorsFromServer) && $scope.errorsFromServer.indexOf(j) == -1) {
                            $scope.errorsFromServer.push("data." + mod.join("."));
                        }
                        if (a) {
                            a.error = a.error || {};
                            a.error[lastAttr] = errorObject[j];
                        }
                    }

                }
                // code to convert dot notation to nested objects
                for (var i in errorObject) {
                    if (!errorObject.hasOwnProperty(i))
                        continue;
                    if (i.indexOf(".") > -1) {
                        var modelArray = i.split(".");
                        if (angular.isUndefined(errorObject[modelArray[0]])) {
                            errorObject[modelArray[0]] = {};
                        }
                        var t = errorObject[modelArray[0]];
                        for (var j = 1; j < modelArray.length; j++) {
                            if (angular.isUndefined(t[modelArray[j]])) {
                                t[modelArray[j]] = {};
                            }
                            t = t[modelArray[j]];
                        }
                        t.message = errorObject[i].message;
                    }
                }
                var myErrorId;
                $scope.errors = $scope.responseDataFromPopup.body.errors;
                // if (!$scope.$$phase) {
                $scope.$applyAsync();
                // }
                var elemToAppend = "";
                if ($("#angularPopUpHtml").length > 0) {
                    elemToAppend = "#angularPopUpHtml ";
                } else if ($scope.currentOuterPopup === "showdialog") {
                    elemToAppend = "#showdialog ";
                } else if ($scope.currentOuterPopup === "#showdialog") {
                    elemToAppend = "#showdialog ";
                } else if ($scope.currentOuterPopup === "#showdialog_list") {
                    elemToAppend = "#showdialog_list ";
                }
                elemToAppend += "#mainForm:first";
                $scope.redesignElem = [];
                $scope.toRemove = [];
                var additionalFieldsArr = angular.copy($scope.responseDataFromPopup.body.layoutInfo.layoutComponent.fields);

                $scope.arrayToCheck = $scope.responseDataFromPopup.body.layoutInfo.layoutComponent.fields;

                if(!$scope.subScope){
                    $scope.subScope = {};
                }
                if ($scope.subScope && !$scope.subScope.newFieldIds) {
                    $scope.subScope.newFieldIds = [];
                }

                var fields = [], index = null;
                $scope.layout.fields.forEach(function (d, i) {
                    if(index == null && d.type == "basic"){
                        index = i;
                    }
                });
                var commentFieldsArr= $scope.layout.fields[_.findIndex($scope.layout.fields,function(o){return o.type=="communicationTab"})];
                var commentFields = [];
                if(commentFieldsArr && commentFieldsArr.fields){
                    //var commentFieldsArrFd = commentFieldsArr.fields;
                    commentFields = commentFieldsArr.fields[_.findIndex(commentFieldsArr.fields,function(o){return o.type=='borderedBox'})];
                }
                var fieldsToBeSearched = _.concat($scope.layout?.fields[index]?.fields || [] ,commentFields);
                formService.getFinalFields(fields, fieldsToBeSearched);
                if(_.findIndex($scope.arrayToCheck,function(o){return o.model == 'comment'})>-1 && $scope){
                    $scope.hasCommentErrors = true;
                    $scope.toggleShowCommentBox();
                }
                myErrorId = $scope.arrayToCheck[0]?.id;
                for (var i = 0; i < $scope.arrayToCheck.length; i++) {
                    $("[name='" + $scope.arrayToCheck[i].name + "']").removeAttr("disabled");
                    $("[name='" + $scope.arrayToCheck[i].name + "']").closest(".fieldForm").show();
                    for (var j = 0; j < fields.length; j++) {
                        if (formService.compareFieldTypeForValidationError($scope.arrayToCheck[i], fields[j])) {
                            if ($scope.arrayToCheck[i].displayMode == fields[j].displayMode) {
                                $scope.toRemove.push(i);
                            } else {
                                $scope.toRemove.push(i);
                                $scope.redesignElem.push($scope.arrayToCheck[i]);
                            }
                        }
                    }
                }
                /*if($scope.toRemove.length > 0){
                	for (var a = $scope.toRemove.length - 1; a >= 0; a--) {
                		$scope.arrayToCheck.splice($scope.toRemove[a], 1);
                	}
                }else{
                	$scope.arrayToCheck.splice($scope.toRemove.length, 1);
                }*/

                for (var a = $scope.toRemove.length - 1; a >= 0; a--) {
                    $scope.arrayToCheck.splice($scope.toRemove[a], 1);
                }


                var newElemMerged = {};
                $scope.redesignElem.forEach(function (d, i) {
                    if (d.id == 707 && d.type == "borderedBox") {
                        if ($scope.fieldMapper["fieldset" + d.id]) {
                            newElemMerged = angular.copy($scope.fieldMapper["fieldset" + d.id]);
                            formService.mergeFieldsQA(newElemMerged, d);
                            $scope.redesignElem[i] = newElemMerged;
                        }
                    }
                })
                if ($scope.redesignElem.length > 0) {
                    var n;
                    for (var m = 0; m < $scope.redesignElem.length; m++) {
                        $scope.templl = [];
                        n = $scope.redesignElem[m].id + ((angular.isDefined($scope.redesignElem[m].fields) && $scope.redesignElem[m].fields.length > 0) ? "_" : "");
                        $scope.templl.push($scope.redesignElem[m]);
                        if ($(elemToAppend).find('span#elem_' + n)) {
                            var temp = angular.element("<form style='overflow: visible;' id='f_" + n + "'><div class = 'fieldForm redesign' dynamic-form-new='' template='templl' ng-model='data'></div></form>");
                            versionObject.htmlComponents['#elem_' + n] = $('#elem_' + n).html();
                            var el = $('span#elem_' + n);
                            for (var i1 = 0; i1 < el.length; i1++) {
                                $(el[i1]).siblings().remove();
                                $(el[i1]).parent().replaceWith(temp);
                            }
                            $compile('#f_' + n)($scope);
                        }
                        if ($(elemToAppend).find(".fieldset_" + $scope.redesignElem[m].id).length) {
                            var temp = angular.element("<form id='f_" + $scope.redesignElem[m].id + "'><div class = 'fieldForm redesign' dynamic-form-new='' template='templl' ng-model='data'></div></form>");
                            versionObject.htmlComponents[".fieldset_" + $scope.redesignElem[m].id] = $(".fieldset_" + $scope.redesignElem[m].id).html();
                            var el = $(".fieldset_" + $scope.redesignElem[m].id);
                            $(elemToAppend).find(".fieldset_" + $scope.redesignElem[m].id).replaceWith(temp);
                            $compile('#f_' + $scope.redesignElem[m].id)($scope);

                        }
                    }
                }
                // Removing comment section fields and errors in case of RDF
                var fieldErrors = angular.copy($scope.errors.fieldErrors);
                fieldErrors = _.pickBy(fieldErrors,(el,key) => key.indexOf('comment') == -1 );
                additionalFieldsArr = _.filter(additionalFieldsArr, el => {
                    if(el.model)
                        return el.model.indexOf('comment') == -1;
                    return true;
                } );
                //Handling duplication on UI level
                additionalFieldsArr = _.uniqBy(additionalFieldsArr, "id");

                window.sarc.channelBroadcast("timelineFeeds",{
                    actionType:'checkCardValidation',
                    value: fieldErrors
                },'timelineFeedsSubscription')

                if(_.get($scope.commentFldHavingValidations,"length")) {
                    if($scope.globalData.isAutoExtractionPage){
                        $scope.openAECommentTab();
                    } else {
                        dataManipulationService.validateAndToggleCommentSec({scope:$scope,isValid:true})
                    }

                    if(!window.htmlEditorList || !window.htmlEditorList.length) {
                        var textAreaInterval = setInterval(() => {
                            if(window.htmlEditorList && window.htmlEditorList.length) {
                                clearInterval(textAreaInterval);
                                dataManipulationService.fetchTextAreaValues($scope.data, window.htmlEditorList,null,$scope,true);
                            }
                        },500)
                        // This is a timer in case we didn't find text area within 2 seconds. This is a fallback to clear interval
                        setTimeout(() => {
                            textAreaInterval && clearInterval(textAreaInterval);
                        },2000)
                    }
                }

                if($scope.globalData.dynamicFormId && additionalFieldsArr && additionalFieldsArr.length) {
                    if($scope.errors.fieldErrors.category && $scope.errors.fieldErrors.definitionCategory){
                        let groupId = _.get($scope.data,"group.values.id")
                        if(groupId == 1){
                            //clause selected, remove definition category
                            delete $scope.errors.fieldErrors.definitionCategory
                        }
                        if(groupId == 2){
                            //definition selected, remove category
                            delete $scope.errors.fieldErrors.category
                        }
                        additionalFieldsArr = _.filter(additionalFieldsArr,function(field) {
                            if(groupId == 1) {
                                return field.name != "definitionCategory"
                            }
                            if(groupId == 2) {
                                return field.name != "category"
                            }
                        });
                    }
                    window.rdfversion = (window.rdfversion||0)+1;
                    let container = {
                        fields: additionalFieldsArr,
                        id: '9999999_'+window.rdfversion,
                        name : "freeFormContainer",
                        type: "borderedBox",
                        label: intl_msg[25544],
                        properties : {}
                    }
                    let newFormData = {
                        layout: [container],
                        data: $scope.data,
                        globalData: $scope.responseDataFromPopup.body.globalData,
                        fieldErrors: fieldErrors,
                        actionType:"newValidationError"
                    }
                    window.sarc.channelBroadcast("partialEditActions", {
                        actionType: 'newValidationError',
                        value: true
                    }, 'partialEditActionsSubscription')
                    window.sarc.channelBroadcast("reactDynamicForms",newFormData,`dfSubscriptions_${$scope.globalData.dynamicFormId}`);
                }

                if ($scope.subScope?.newFieldIds?.length > 0) {
                    var newArrayToCheck = [];
                    for (var i = 0; i < $scope.arrayToCheck.length; i++) {
                        if ($scope.subScope.newFieldIds.indexOf($scope.arrayToCheck[i].id) === -1) {
                            newArrayToCheck.push($scope.arrayToCheck[i]);
                        }
                    }
                    $scope.arrayToCheck = newArrayToCheck;
                }

                if ($scope.arrayToCheck.length > 0) {
                    for (var i = 0; i < $scope.arrayToCheck.length; i++) {
                        $scope.subScope.newFieldIds.push($scope.arrayToCheck[i].id);
                    }
                    var tempElement = angular.element("<div dynamic-form-new='' id='newlyAppendedForm_" + versionObject.version + "'></div>").attr({
                        "class": "fieldForm col-md-12",
                        "template": "responseDataFromPopup.body.layoutInfo.layoutComponent.fields",
                        "ng-model": "data"
                    });
                    var tempElement1 = angular.element("<fieldset class='open newFields'></fieldset>");
                    tempElement1.append(angular.element("<p id='additionallyRequiredFields'>"+intl_msg[25544]+"</p>"));
                    if(!$scope.globalData.dynamicFormId) {
                        tempElement1.append($(tempElement));
                        $(elemToAppend).find(".dynamic-form").eq(0).append($(tempElement1));
                        $compile(tempElement)($scope);
                    }
                }
                const hasWfIdOrReqIdInUrl = !!( SirionUtils.getParameterValueFromURL(window.location.href,"wfId") || SirionUtils.getParameterValueFromURL(window.location.href,"requestId") )
                if(angular.isUndefined($scope.versions.versionArray) == false){
                    $scope.versions.versionArray.push(versionObject);
                }
                $scope.correctTheOptionValues();
                $scope.versions.versionArray.push(versionObject);
                if (angular.isUndefined($scope.undoDisable)) {
                    $scope.undoDisable = 0;
                }
                if(!btnInfo?.properties?.isPartialEdit) {
                    $scope.undoDisable++;
                }

                hasWfIdOrReqIdInUrl && showPage2DataTransformationService.validateDynamicForm($scope);

                stopLoader();
                // if (!$scope.$$phase) {
                    $scope.$applyAsync();
                // }
                var generalTab = $("show-page-tabs ul").first().find("li").first();
                if (!generalTab.hasClass("active")) {
                    generalTab.click();
                }
                if($scope.errors && $scope.errors.fieldErrors){
                    if(!$("#reqFieldsToggle").prop('checked')) {
                        $("#reqFieldsToggle").prop("checked", true);
                    }
                    if(!$scope.toggleAllGroupsVal) {
                        $scope.toggleAllGroups();
                    }
                        $scope.toggleAllReqFields();
                        // $('.hidden-nrf').removeClass('hidden');

                }
                if(_.has($scope.responseDataFromPopup,"body.errors.fieldErrors") && $scope.hasDynamicTableError($scope.responseDataFromPopup.body.errors.fieldErrors)){
                    $scope.updateErrorFieldsForDynamicTable($scope.responseDataFromPopup.body.errors.fieldErrors);
                    $scope.dynamicTableError = true;
                } else {
                    $scope.dynamicTableError = false;
                }
              //  showPageService.scrollToElem(myErrorId, $scope.errors, $scope.dynamicTableError);
                // end code to scroll the page to first errornous
                // field............
            }
            if(!$("#reqFieldsToggle").prop('checked')) {
                $("#reqFieldsToggle").prop("checked", true);
            }
            $scope.toggleAllReqFields();
        } else if ($scope.responseDataFromPopup.header.response.status === "applicationError") {
            if (angular.isDefined($scope.currentOuterPopup) && !$scope.responseDataFromPopup.header.response["stayInCreatePopup"]) {
                $($scope.currentOuterPopup).dialog("close");
                $scope.myJson = {};
                // $scope.applyBasePageJson();
            }
            if (angular.isDefined($scope.responseDataFromPopup.header.response.errorMessage) && (($scope.responseDataFromPopup.header.response.errorMessage).toString().trim().length > 0)) {
                var msg = $scope.responseDataFromPopup.header.response.errorMessage;
                if(typeof msg === 'object' && !angular.isArray(msg)) {
                    msg = [].concat(msg);
                }
                if (angular.isArray(msg)) {
                    var tmp = "";
                    msg.forEach(function (d) {
                        tmp = tmp + (tmp ? (", " + d.errorMessage) : d.errorMessage);
                    })
                    msg = tmp;
                }
                const args = {
                    popupType: 'alert',
                    str: msg,
                    heading: "ERROR",
                    yesCbFn: 'cancel',
                    yesName: intl_msg[24184]
                }
                stopLoader();
                Toaster.create(msg,{iconClass:"icon-Information_filled"});
            } else {
                toggleServerErrorNotification(true);
            }

        }

        // This condition is specifically written for the DocuSign new e-signature process in workflow cases.
        if($scope?.fromNewEsignature && $scope?.newEsignatureSignType && $scope?.newEsignRedirectionUrl){
            if($scope?.responseDataFromPopup?.header?.response?.status === "success"){
                    window.open($scope.newEsignRedirectionUrl, '_blank', 'noopener,noreferrer');
                    Toaster.create(intl_msg[36134] || "Enable popups in your browser window to view the request", {iconClass:"icon-Information_filled"});
            }else {
                window.location =  `#/show/tblcdr/${$scope?.data?.id?.values}`
            }
            delete $scope?.fromNewEsignature
            delete $scope?.newEsignatureSignType
            delete $scope?.newEsignRedirectionUrl
        }
    }

    $scope.hasDynamicTableError = function (fieldErrors) {
        var returnValue = false;
        angular.forEach(fieldErrors, function (obj) {

            angular.forEach(obj, function(innerObj){
                if(innerObj.parentId) {
                    innerObj.parentId = "dyn" + innerObj.parentId;
                    if (innerObj.isDynamicTable) {
                        angular.element("[dynamicTableParent=" + innerObj.parentId + "]").addClass("errorClassDT");
                        returnValue = true;
                    }
                }
            });
        });
        return returnValue;
    }

    $scope.updateErrorFieldsForDynamicTable = function (fieldErrors) {
        angular.forEach(fieldErrors, function (obj, key) {
            var modelStr = key.split(".")[1];
            angular.forEach(obj, function(innerObj){
                if(innerObj.isDynamicTable && modelStr){
                    var elementId = modelStr.substring(3),
                        tableScope = angular.element(".linkedTable").find("#elem_"+elementId).scope(),
                        tableModel = tableScope && tableScope.data.dynamicMetadata[innerObj.parentId].values[innerObj.rowId];

                    if(tableModel){
                        if(typeof tableModel[modelStr].error == "undefined"){
                            tableModel[modelStr].error = {};
                        }
                        if(typeof tableModel[modelStr].error.values == "undefined"){
                            tableModel[modelStr].error.values = {};
                        }
                        if(typeof tableModel[modelStr].error.values.message == "undefined"){
                            tableModel[modelStr].error.values.message = innerObj.message;
                        } else {
                            tableModel[modelStr].error.values.message = tableModel[modelStr].error.values.message + ", " +innerObj.message;
                        }
                    }
                }
            });
        });
        // if (!$scope.$$phase) {
            $scope.$digest();
        // }
    }

    // this function will scan the source array and then take out all the final
    // fields from it and push in destArray
    // formService

    $scope.openAutocompleteListView = function (event) {
        if ($(event.srcElement).closest('.autcompletePopGlobal').find('input').attr('disabled')) {
            return;
        }
        var s = $scope;
        var autCompleteScope = $(event.currentTarget.parentElement).find("[ajax-autocomplete-new]").scope();
        var autCompleteElement = $(event.currentTarget.parentElement).find("[ajax-autocomplete-new]");
        if(!autCompleteElement.data("fieldData")){
            autCompleteElement.data("fieldData", JSON.parse(autCompleteElement.attr("field-json")));
        }
        var dataModel = $(event.currentTarget.parentElement).attr("ng-model");
        var urlAppend = autCompleteScope.tempUrl;
        var filterId = $(this).parent().parent().attr("filterid");
        var url = urlAppend + "&query=" + "&expandAutoComplete=true&offset=0";
        var fixedUrl = urlAppend + "&expandAutoComplete=true";
        s.restdataModel = {
            dataModelObject: dataModel,
            appendFn: autCompleteScope.appendSelectedElements,
            fieldData: autCompleteElement.data("fieldData"),
            element: autCompleteElement
        };//$(this).parent().data("dt");
        s.parentDiv = $(this).parent().parent();
        if(s.restdataModel.fieldData.properties && s.restdataModel.fieldData.properties.dependentParentFieldsName){
            if(commonUtil.checkDependentFieldValues(s.restdataModel.fieldData,s.data)) {
                url = commonUtil.appendQueryParamsToGlobalCreateFieldUrl(s.restdataModel.fieldData, s.data, url);
                fixedUrl = commonUtil.appendQueryParamsToGlobalCreateFieldUrl(s.restdataModel.fieldData, s.data, fixedUrl);
            }else{
                return false;
            }
        }
        s.infinitesScrollUrl = fixedUrl;
        s.parentUrl = urlAppend;
        s.infiniteOptionData = {};
        var postData = {};
        var type = "GET";
        var fieldData = s.restdataModel && s.restdataModel.fieldData;
        if($scope.newEntityCall && fieldData &&  fieldData.name == "contractParent" ) {
            if(fieldData.dependentField || fieldData.dependentFields) {
                postData["relationIds"] = showPageService.getOnlyFieldIds.call($scope,fieldData.dependentField || fieldData.dependentFields);
            }
            type="POST";
        } else if($("[name='globalCountries']").length>0 && s.data.globalCountries && url.indexOf("/42")>-1){
            if(window.location.href.indexOf("/metadatasearch")>-1){
                postData.globalCountries = null;
            } else {
                postData.globalCountries = (!s.data.globalCountries.values && s.data.globalCountries.values.length==0)?[]:s.data.globalCountries.values.map(function(a) {return a.id;});
            }
            type="POST";
        }
        else if($("[name='countries']").length>0 && s.data.countries && url.indexOf("/42")>-1){
            if(window.location.href.indexOf("/metadatasearch")>-1){
                postData.globalCountries = null;
            } else {
                postData.globalCountries = (!s.data.countries.values || s.data.countries.values.length==0)?[]:s.data.countries.values.map(function(a) {return a.id;});
            }
            type="POST";
        } else  if(s.restdataModel.fieldData.name == "recipientCompanyCodes" || s.restdataModel.fieldData.name == "recipientClientEntities" || s.restdataModel.fieldData.name == "contractingCompanyCodes" || s.restdataModel.fieldData.name == "contractingClientEntities" || s.restdataModel.fieldData.name == "createdFor" || s.restdataModel.fieldData.name == "services" || s.restdataModel.fieldData.name == "functions") {
            if($scope.data.id.id || $scope.data.id.values){
                url += "&pageEntityId="+ ($scope.data.id.id || $scope.data.id.values);
            }
            if(s.restdataModel.fieldData.properties && typeof s.restdataModel.fieldData.properties.recipient == "boolean") {
                url += "&recipient="+s.restdataModel.fieldData.properties.recipient;
            }
        } else if($scope.newEntityCall && fieldData && fieldData.name == "contracts") {
            if(fieldData.dependentField || fieldData.dependentFields) {
                postData["relationIds"] = showPageService.getOnlyFieldIds.call($scope,fieldData.dependentField || fieldData.dependentFields);
            }
            type="POST";
        }
           autCompleteScope.getParentFieldID(s.restdataModel.fieldData.groupBy);
        if(autCompleteScope.parentFieldId){
            var returnObj = showPageService.getDataForDependentField.call(autCompleteScope);
            type="POST";
            postData=  {parentOptionIds:returnObj};
            var parentName = autCompleteScope.parentFieldName
            var parFieldId = autCompleteScope.data[parentName] ? autCompleteScope.data[parentName].id : autCompleteScope.data.dynamicMetadata[parentName].id;
            s.parentUrl = url + "&parentFieldId="+parFieldId;
            url = url + "&parentFieldId="+parFieldId;
            s.infinitesScrollUrl = url;
            s.parentFieldValues = returnObj;
        }
        // cache: false,acceptType ? acceptType :
        url = showPageService.getsourceId(s.restdataModel.fieldData,s.data.dynamicMetadata,url);
        if(fieldData.properties && (fieldData.properties.parentMap ||  fieldData.properties.childMap)){
            let retObj = $scope.getPostDataForParentOrChildReferences(fieldData);
            type = retObj.type;
            postData = retObj.postData;
        }
        if(type=="GET")
            var promise = requestData("GET",url,"",false);
        else if(type=="POST"){
            var promise = $.ajax({
                type:"POST",
                dataType: "json",
                cache: false,
                contentType: "application/json;charset=UTF-8",
                data: JSON.stringify(postData),
                url:  url
            });
        }
        promise.success(function (response) {
            //console.log(response);
            s.infiniteScrollData = response;
            s.totalRecords = response.size;
            if (response && response.sizeLimit) {
                s.filterSizeLimit = response.sizeLimit;
            } else {
                s.filterSizeLimit = 50;
            }
            $("#autocompleteFilterDialog").empty();
            $("#autocompleteFilterDialog").dialog("open");
            var acFilterName = '' ;
            if (s.restdataModel.fieldData){
                $("#autocompleteFilterDialog").dialog("option", "title", s.restdataModel.fieldData.label);
                acFilterName = s.restdataModel.fieldData.label;
            }

            else if (s.restdataModel.element.attr("field-json")) {
                $("#autocompleteFilterDialog").dialog("option", "title", JSON.parse(s.restdataModel.element.attr("field-json")).label);
                s.acFilterName = JSON.parse(s.restdataModel.element.attr("field-json")).label;
            }
            else {
                $("#autocompleteFilterDialog").dialog("option", "title", "AUTOCOMPLETE");
            }
            if(response.sizeLimit >= response.size){
                s.moreRecords = false;
            }else{
                s.moreRecords = true;
            }
            var pageType = "rest_show";
            var templateHtml = "<div infinite-scroll-directive = '' acFilterName='"+acFilterName+"'filterElement='" + filterId + "' pageType = '" + pageType + "' style='height:100%;'></div>";
            $("#autocompleteFilterDialog").html(templateHtml);
            $(".autcompletePopGlobal").find("input").blur();
            s.$root.compile($("#autocompleteFilterDialog"), s);
        }).fail(function (jqXHR, textStatus, errorThrown) {
            window.systemWarning(textStatus + ': ' + errorThrown);
        });
    }
    // remove
    $rootScope.isDefinedAndNotNull = function (abc) {
        return angular.isDefined(abc) && abc !== null;
    }
    $scope.getPostDataForParentOrChildReferences = (fieldData) => {
        let postData = {};
        let model = _.get($rootScope.data,fieldData.name);
        var  getOnlyIds = function(arrayReference){
            var tempIds = [] ;
            arrayReference && arrayReference.forEach(function (obj) {
                tempIds.push(obj.id);
            });
            return tempIds;
        }
        var dependentFieldIdsForDocuments  = function(parent,postData,fieldDataRef){
            var tempIdsForDependentField = [];
            if(fieldDataRef.dependentField || fieldDataRef.dependentFields) {
                tempIdsForDependentField = showPageService.getOnlyFieldIds.call($scope,fieldDataRef.dependentField || fieldDataRef.dependentFields);
            }
            if(parent){
                postData["autoExtractionChildIds"] = tempIdsForDependentField;
            }else{
                postData["autoExtractionParentIds"] = tempIdsForDependentField;
            }
            if(postData["autoExtractionParentIds"].includes(undefined)){
                postData["autoExtractionParentIds"]=[]
            }
            return postData;
        };
        postData["autoExtractionCurrentId"] = $scope.data.id.values;
        postData["autoExtractionChildIds"]   =[]
        if(fieldData.properties.parentMap){
            postData["autoExtractionParentIds"] = model.values;
            if(model.values && model.values.length){
                postData["autoExtractionParentIds"] = getOnlyIds(model.values)
            }
            postData = dependentFieldIdsForDocuments(false,postData,fieldData)

        }
        if(fieldData.properties.childMap){
            postData["autoExtractionChildIds"] =model.values;
            if(model.values && model.values.length){
                postData["autoExtractionChildIds"] = getOnlyIds(model.values);
            }
            postData = dependentFieldIdsForDocuments(false, postData , fieldData);
        }

        return {
            type: "POST",
            postData: postData
        }
    }
    $scope.getCurrentDate = function () {
        if (angular.isDefined($scope.globalData) && angular.isDefined($scope.globalData.currentTime)) {
            return $scope.globalData.currentTime;
        } else {
            var t = new Date();
            var today = (t.getMonth() + 1) + "-" + (t.getDate()) + "-" + t.getFullYear();
            return today;
        }
    }

    $scope.getGlobalDataValue = function (key) {
        if (angular.isDefined($scope.globalData) && angular.isDefined($scope.globalData[key])) {
            return $scope.globalData[key];
        }
        return null;
    }
    // formService
    /** Redundant function : used dataManipulationService.mergeData
     $scope.mergeData = function (oldData, newData) {
	        dataManipulationService.mergeData(oldData,newData);
	    }
     **/

    $scope.oldrevision = function () {
        if (angular.isUndefined($scope.versions) || angular.isUndefined($scope.versions.versionArray) || $scope.versions.versionArray.length === 0) {
            return;
        }
        var versionObject = $scope.versions.versionArray.pop();

        if (!$scope.isShowPage) {
            $scope.data = versionObject.data;
            $scope.globalData = versionObject.globalData;
            $scope.myJson.data = versionObject.data;
        }

        if ($scope.globalData.dynamicFormId) {
            let response = window.sarc.channelBroadcast("reactDynamicForms", {actionType: "undo"}, `dfSubscriptions_${$scope.globalData.dynamicFormId}`);
            if (response[0].res) {
                $scope.data = response[0].res.cData;
                $scope.globalData = response[0].res.globalData;
                $scope.myJson.data = response[0].res.cData;
            }
        }

        if (!$scope.isShowPage) {
            $scope.correctTheOptionValues();
            if (angular.isDefined(versionObject.validity)) {
                $scope.validity = versionObject.validity;
            } else {
                $scope.validity = undefined;
            }
            $scope.errors = versionObject.errors;
            $("#newlyAppendedForm_" + versionObject.version).find("input,textarea,select").attr("disabled", "true");
            $("#newlyAppendedForm_" + versionObject.version).hide();
            for (i in versionObject.htmlComponents) {
                if (!versionObject.htmlComponents.hasOwnProperty(i)) {
                    continue;
                }
                $(i).html(versionObject.htmlComponents[i]);
                $compile(i)($scope);
            }
        } else {
            $scope.selectedButton = '';
            $scope.validity = undefined;
            $scope.errors = {};
        }

        $scope.undoDisable--;
        $scope.noCmntAdValTriggered = false;

        if (versionObject.timeLineFeedScope && versionObject.timeLineFeedScope != -1)
            $scope.setTimelineFeedDataScope(versionObject.timeLineFeedScope);
        else if(versionObject.commentDataScope && versionObject.commentDataScope != -1) 
            $scope.setCommDataScope(versionObject.commentDataScope)
        else if($scope.commentDataScope && $scope.commentDataScope != -1) 
            $scope.initializeCommunicationSec();

        $scope.$applyAsync();
        
        if ($scope.isShowPage) {
            $scope.undoDisable = 0;
            $('#ajaxcalloading').addClass('always_visible');
            setTimeout(function() {
                if (typeof window.executePartialRefresh === 'function') {
                    window.executePartialRefresh(false, true);
                }
            }, 0);
        }
    }


    $scope.correctTheOptionValues = function () {
        $("select[optionsModel]").each(function () {
            var dataModelString = $(this).attr("ng-model");
            var optionsModelString = $(this).attr("optionsModel");
            var dataModelObject;
            var optionsModelObject;
            if (angular.isDefined(dataModelString) && angular.isDefined(optionsModelString) && dataModelString !== null && optionsModelString !== null) {
                dataModelString = dataModelString.split(".");
                var datasuffix = dataModelString[dataModelString.length - 1];
                dataModelString.splice(dataModelString.length - 1, 1);
                dataModelString = dataModelString.join(".");
                dataModelObject = showPageService.getModelfromString.call($scope, dataModelString);
                optionsModelObject = showPageService.getModelfromString.call($scope, optionsModelString);
                if (dataModelObject !== null && optionsModelObject !== null && angular.isDefined(dataModelObject[datasuffix])) {
                    // console.log(dataModelString, dataModelObject);
                    // console.log(optionsModelString, optionsModelObject);
                    if (angular.isArray(dataModelObject[datasuffix])) {
                        var tempObj = [];
                        for (var i = 0; i < dataModelObject[datasuffix].length; i++) {
                            for (var j = 0; j < optionsModelObject.length; j++) {
                                if (dataModelObject[datasuffix][i].id === optionsModelObject[j].id) {
                                    tempObj.push(optionsModelObject[j]);
                                    break;
                                }
                            }
                        }
                        dataModelObject[datasuffix] = tempObj;
                    } else if (angular.isObject(dataModelObject[datasuffix])) {
                        for (var i = 0; i < optionsModelObject.length; i++) {
                            if (optionsModelObject[i].id === dataModelObject[datasuffix].id) {
                                dataModelObject[datasuffix] = optionsModelObject[i];
                            }
                        }
                    }
                }
            }
        });
    }
    // Correct here itself
    $scope.clearVal = function (modelLoc, valName, isSingleSelect) {
        // var errorDiv = $("<span class='noMatching'><div
        // class='noMatchingMessageHolder'>No matching
        // entry</div></span>").hide();
        // if (false && isSingleSelect) {
        //     if (!angular.isObject(modelLoc[valName][0])) {
        //         modelLoc[valName][0] = "";
        //     }
        // } else
        if (angular.isUndefined(modelLoc[valName])) {
            modelLoc[valName] = null;
        }
    }

    $scope.openCustomDialog = function (templateId, model, formId, type, isSelect) {
        // putting the html content in template cache to be accessed by ngDialog
        // $templateCache.put(templateId, $templateCache.get(templateId));

        var tempModel = model;
        $rootScope.stakeHoldersAllowedTypes = model.userType;
        $scope.modalInstance = $modal.open({
            templateUrl: templateId,
            size: "375px",
            backdrop: "static",
            keyboard: true,
            modalFade: true,
            controller: 'dialogController',
            windowClass: 'addUser sirion2Newuser'
        });
        $scope.alertBoxes.push($scope.modalInstance);
        var index = $scope.alertBoxes.length - 1;
        $scope.modalInstance.opened.then(function () {
            $scope.shouldIShowFieldErrorsVar = false;
        })
        $scope.modalInstance = null;

        $scope.alertBoxes[index].result.then(function (selectedItem) {
            if (angular.isDefined(selectedItem)) {
                var newObject = {};
                for (i in selectedItem) {
                    if (selectedItem.hasOwnProperty(i)) {
                        newObject[i] = selectedItem[i].values;
                        selectedItem[i].values = "";
                    }
                }
                if (!angular.isDefined(model.options)) {
                    model.options = {
                        "data": []
                    };
                }
                model.options.data.push(newObject);
                $scope.onSelectPart(newObject, model, "", model, (type == "multi"), "tempValue", isSelect);

            }else {
                if($rootScope.data.adHocUsers) {
                    $rootScope.data.adHocUsers = {};
                }
            }
        });
    };
    $scope.openDialog = function (templateId) {
        // putting the html content in template cache to be accessed by ngDialog
        $templateCache.put(templateId, $("#" + templateId).contents().html());
        $scope.modalInstance = $modal.open({
            templateUrl: templateId
            // controller: 'dialogController'
        });
        $scope.alertBoxes.push($scope.modalInstance);
        $scope.modalInstance = null;

    };

    $scope.openDialogForDocumentVersioning = function(postData, element,isFromGlobalUploadCdr, showContractUpload){
        if(postData && postData[0].error){
            Toaster.create(postData[0].error,{iconClass:"icon-Information_filled"});
        }
        else if(globalUploadButtonActive != "" && postData.length>1){
            Toaster.create(intl_msg[23562],{iconClass:"icon-Information_filled"});
        }
        else {
            var docVersioningData = {};
            docVersioningData["filesData"] = postData;
            /*var templateStr = "<div></div>"
            $("#documentVersioningDialog").empty();
            $("#documentVersioningDialog").html(templateStr);
            $("#documentVersioningDialog").dialog("open");
            */
            var globalUploadCdrScope = $('.contractDocUploadDir').scope();
            var sc = isFromGlobalUploadCdr ? globalUploadCdrScope : $scope;
            if (showContractUpload && isFromGlobalUploadCdr) {
                sc.prevFileData = (sc.fileData || []).map(a => JSON.parse(JSON.stringify(a)));
            }
            documentVersioningService.showDocumentVersioning(docVersioningData, element, sc,isFromGlobalUploadCdr, $scope.globalData.dynamicFormId, $scope.createCloneOfScope);
            if (showContractUpload) {
                $http.get($scope.appBaseApiUrl + '/cdr/doc-feature-field/mapping').then(function(response) {
                    $scope.openCdrPropertiesModal(sc, response.data, true);
                });
            }
        }
        $scope.fileExt = function (file){
            if(file){
                var iconExtension =  'icon-' + file.substring(file.lastIndexOf(".") + 1).toLowerCase();
                return iconExtension
            }
        }
    };

    $scope.openCdrPropertiesModal = function(scope, docFeatureFieldMap = {}, skipFileDataSnapshot) {
        var sc = $('.contractDocUploadDir').scope();
        if (!skipFileDataSnapshot) {
            sc.prevFileData = sc.fileData.map(a => JSON.parse(JSON.stringify(a)));
        }
        const checkBoxFieldNameMap = {
            'triggerDeviation': 'isAllTrackDeviInstancesSelected',
            'extractMetadata': 'isAllExtractMetaDataInstancesSelected'
        };
        Object.keys(checkBoxFieldNameMap).forEach(function (field) {
            if(_.has(docFeatureFieldMap, field)) {
                const fieldID = docFeatureFieldMap[field]['fieldId'];
                const fieldValue = $scope.data['dyn' + fieldID]['values'];
                sc[checkBoxFieldNameMap[field]].value = fieldValue;
            }
            sc.fileData.forEach(function (file) { file[field] = sc[checkBoxFieldNameMap[field]].value });
        });
        sc.prevIsAllTrackDeviInstancesSelected = sc.isAllTrackDeviInstancesSelected.value;
        sc.prevCheckBoxCountTrackDevi = sc.checkBoxCountTrackDevi;
        sc.prevIsAllExtractMetaDataInstancesSelected =  sc.isAllExtractMetaDataInstancesSelected.value;
        sc.prevCheckBoxCountExtract = sc.checkBoxCountExtract;
        sc.prevIsAllShareWithSupplierInstancesSelected =  sc.isAllShareWithSupplierInstancesSelected.value
        sc.prevCheckBoxCountShareWithSupplier = sc.checkBoxCountShareWithSupplier;

        $scope.modalInstance = $modal.open({
            templateUrl: $rootScope.createHtmlUrl("ui2.0/directiveTemplates/contractDocUpload.html"),
            modal:true,
            size: "lg",
            backdrop:"static",
            keyboard  : false,
            scope:scope,
            windowClass: "clonepopup upload_document_dialog saveFPDialog"
        });
    }

    $scope.closeCdrPropertiesModal = function() {
        $scope.modalInstance.close();
    }

    $scope.cancelCdrPropertiesModal = function() {
        var sc = $('.contractDocUploadDir').scope();
        sc.fileData = sc.prevFileData.map(a => JSON.parse(JSON.stringify(a)));
        sc.isAllTrackDeviInstancesSelected.value =  sc.prevIsAllTrackDeviInstancesSelected;
        sc.checkBoxCountTrackDevi = sc.prevCheckBoxCountTrackDevi;
        sc.isAllExtractMetaDataInstancesSelected.value = sc.prevIsAllExtractMetaDataInstancesSelected;
        sc.checkBoxCountExtract = sc.prevCheckBoxCountExtract;
        sc.isAllShareWithSupplierInstancesSelected.value = sc.prevIsAllShareWithSupplierInstancesSelected;
        sc.checkBoxCountShareWithSupplier = sc.prevCheckBoxCountShareWithSupplier;
        $scope.modalInstance.close();
        window.sarc.channelBroadcast("reactDynamicForms", {
            actionType: "updateDocList",
            files: sc.fileData
        }, `dfSubscriptions_${$scope.globalData.dynamicFormId}`);
    }

    // Func to open upload-Doc Modal
    $scope.uploadDocumentModal = function() {
        $scope.uploadDocumentModalInstance  = $modal.open({
            templateUrl: $rootScope.createHtmlUrl("ui2.0/uploadDocumentTemplate.html"),
            size: "lg",
            backdrop: "static",
            keyboard: false,
            scope:$scope,
            windowClass: "clonepopup upload_document_dialog",
        });
    }
    $scope.openCloseModalDialogueBox = function (e){
        documentVersioningService.removeDocumentDialog.call($scope, e);
    }
    $scope.submitFunctionalityDialogueBox = function (e){
        documentVersioningService.submitDocumentVersioningData.call($scope,e);
    }
    $scope.populateColumnsWithSameData = function (columnName, fileData) {
        const colNameToFileDataPropsMap = {
            'Type': 'templateTypeId',
            'Document Tags': 'documentTags',
            'Document Status': 'documentStatusId',
            'Classification': 'selectedclassification'
        };
        const fileDataPropVal = colNameToFileDataPropsMap[columnName];
        const valueToPopulate = fileData[0][fileDataPropVal];
        fileData.forEach(file => file[fileDataPropVal] = JSON.parse(JSON.stringify(valueToPopulate)));
    }
    $scope.validateExternalId = function(item) {
        if (!item.externalId) {
            item.externalIdInvalid = false;
            return;
        }
        
        item.externalIdInvalid = !SirionUtils.validIDFieldcheck({
            id: item.externalId, 
            type: 'externalId'
        });
    };
    $scope.addTag = function (e){
        documentVersioningService.addTag(e,$scope);
    }
    $scope.deleteDocumentTag = (e, option, openDialog) => {
        documentVersioningService.deleteDocumentTag(e, option, openDialog);
    }
    $scope.onSelectPart = function (item, model, label, parentModel, multipleValues, tempValue, isSelect) {
        var repeat = false;
        var values = "values";

        if ($scope.isIE() == 8 && angular.isUndefined(item)) {
            item = parentModel[tempValue];
        }

        if (parentModel[values] != null && parentModel[values].length > 0) {
            for (i = 0; i < parentModel[values].length; i++) {
                if (angular.isUndefined(item)) {
                    item = parentModel[tempValue];
                }
                if (parentModel[values][i] != undefined && parentModel[values][i].id && parentModel[values][i].id == item.id) {
                    repeat = true;
                    break;
                }
            }
        }
        if (repeat && multipleValues) {
            const args = {
                popupType: 'alert',
                str: intl_msg[6555],
                heading: "ALERT",
                yesCbFn: cancelString,
                yesName: intl_msg[24184]
            }
            SirionUtils.openSirionDialogs(args);
            if (angular.isDefined(tempValue) && angular.isDefined(parentModel[tempValue])) {
                parentModel[tempValue] = null;
            }
        } else {
            var newObject = (isSelect) ? item : angular.copy(item);
            if (multipleValues) {
                if (parentModel.values == null || !(parentModel.values instanceof Array)) {
                    parentModel[values] = [];
                }
                parentModel[values].push(newObject);
                if (angular.isDefined(tempValue) && angular.isDefined(parentModel[tempValue])) {
                    parentModel[tempValue] = null;
                }
            } else {
                parentModel[values] = [newObject];
            }
        }

    }
    $scope.removeElement = function (index, parentArray) {

        if (index > -1 && index < parentArray.length) {
            parentArray.splice(index, 1);
        }
    }

    $scope.getObjectSize = function(obj){
        if(typeof obj == "object" && obj && Object.keys(obj).length>0)
            return true;
        else
            return false;

    };
    $scope.showUserInfo = function(e,fieldInfo, parentArray,type){
        $(".showUserInfoDiv").remove();
        var ele;
        if(type && type=="nonEdit"){
            ele = angular.element('<div class="showUserInfoDiv nonEditInfo"></div>');
        }
        else{
            if ($rootScope.metadatasearchPage || $rootScope.bulkedit) {
                return;
            }else{
                ele = angular.element('<div class="showUserInfoDiv"></div>');
            }
        }
        if(parentArray.name){
            var infoHeader = angular.element("<div class='infoHeader'></div>");
            infoHeader.append('<div  class="display_inline_block initials"><letter-avatar initials="'+globalFunc.getUserInitials(parentArray.name)+'" round-shape="true" auto-color="true" width="40"></letter-avatar></div>');
            infoHeader.append('<div class="display_inline_block nameInfoDiv"><div class="userNameDiv">'+parentArray.name+'</div><div class="userDesDiv">'+(parentArray.email || parentArray.properties.email || parentArray.properties.Email)+'</div></div>');

            ele.append(infoHeader);
        }
        var ulEle = angular.element('<ul></ul>')
        if(parentArray.properties && Object.keys(parentArray.properties).length) {
            angular.forEach(parentArray.properties, function (a, b) {
                if (a != "User Department")
                    ulEle.append("<li><span class = 'fieldName'>" + b + " : </span><span class='fieldValue'>" + a + "</span></li>");
                else
                    ulEle.append("<li><span class = 'fieldName'>" + b + " : </span><span class='fieldValue'>" + a.join() + "</span></li>");
            });
            ele.append(ulEle);
            $("body").append(ele);
            var leftOffset ;
            if(type && type=="nonEdit") {
                if ($(e.target).offset().left < ele.width()) {
                    leftOffset = $(e.target).offset().left + $(e.target).width();
                } else if ($(e.target).offset().left > ele.width()) {
                    leftOffset = $(e.target).offset().left - ele.width();
                }
            }else{
                if ($(e.target).offset().left < ele.width()) {
                    leftOffset = $(e.target).offset().left + $(e.target).outerWidth() +5;
                } else if ($(e.target).offset().left > ele.width()) {
                    leftOffset = $(e.target).offset().left - ele.width();
                }

            }
            if(leftOffset < $(e.target).closest('.jx-parentForm').offset().left){
                if(($(e.target).offset().left + $(e.target).outerWidth()+ele.width())<$(e.target).closest('.jx-parentForm').offset().left+$(e.target).closest('.jx-parentForm').outerWidth()){
                    leftOffset = $(e.target).offset().left + $(e.target).outerWidth();
                }else{
                    leftOffset = $(e.target).closest('.jx-parentForm').offset().left+5;
                }


            }else if((leftOffset+ele.width()) > $(e.target).closest('.jx-parentForm').outerWidth()){
                leftOffset = $(e.target).closest('.jx-parentForm').outerWidth() - ele.outerWidth()+$(e.target).closest('.jx-parentForm').offset().left;
            }
            ele.css({"left": leftOffset+ 'px'});
            $compile($(".showUserInfoDiv").contents())($scope);

        }

    };

    $scope.openContractsBulkEditModal = (field) => {
        $scope.createContractsBulkEditModalInstance  = $modal.open({
            templateUrl: $rootScope.createHtmlUrl("ui2.0/contractsBulkEditTemplate.html"),
            size: "md",
            backdrop: "static",
            keyboard: false,
            scope:$scope,
            rootScope:$rootScope,
            windowClass: "clonepopup create_delegation_dialog bulk_edit_dialog",
        });

    }

    $scope.changeBulkDocStatus = () => {
        let contractDocTableScope = $('#table_3910').scope();
        let endpoint = "/contractDocument/performBulkActionStatus";
        let dataToPost = {
            "fromStatus": $scope.fromBulkStatusId,
            "toStatus": $scope.toBulkStatusId,
            "entityId": parseInt($routeParams.entityId),
            "entityTypeId": 160,
            "documentFileIds": contractDocTableScope.selectedCheckBoxes
        }
        $http.post(endpoint, dataToPost).then(function (resp) {
            startLoader();
            if (resp.status == 200) {
                let filterMap = {
                    "entityTypeId": 160,
                    "offset": 0,
                    "size": 20,
                    "orderByColumnName": "id",
                    "orderDirection": "asc",
                    "filterJson": {}
                }
                $rootScope.$broadcast("refreshData", {filterMap});
                $rootScope.$emit("deselectSelections");
                entityFactory.updateTabListingOnRequest(425);
                delete $rootScope.toBulkStatusId;
                delete $rootScope.fromBulkStatusId;
                $rootScope.isBulkStatus = false;
                Toaster.create('Details updated successfully!', {iconClass: "icon-Success_Executed_Done"});
            } else {
                Toaster.create(resp.error, {iconClass: "icon-Information_filled"});
            }

        }, function (err) {
            stopLoader();
        })
    }

    $scope.docPropsUpdated = function (dataURL, dataExist,fieldId) {
        let tableScope = $rootScope.tableScopeMapper[fieldId]
        tableScope.$broadcast("refreshData", {dataURL: (appName + dataURL)});
        entityFactory.updateTabListingOnRequest(425);
        tableScope.rmContractDoc();
        $rootScope.previousDocId=null;
    };

    $scope.fetchUpdatedRowData = function (resp) {
        startLoader();
        if (resp.status == 200 && !_.get(resp.data,'header.response.errorMessage')) {
            let filterMap = {
                "entityTypeId": 160,
                "offset": 0,
                "size": 20,
                "orderByColumnName": "id",
                "orderDirection": "asc",
                "filterJson": {}
            }
            $rootScope.$broadcast("refreshData", {filterMap});
            $rootScope.$emit("deselectSelections");
            entityFactory.updateTabListingOnRequest(425);
            delete $rootScope.toBulkStatusId;
            delete $rootScope.fromBulkStatusId;
            $rootScope.isBulkStatus = false;
            Toaster.create('Details updated successfully!', {iconClass: "icon-Success_Executed_Done"});
        } else {
            let errorMessage = resp.error || _.get(resp.data,'header.response.errorMessage')
            Toaster.create(errorMessage, {iconClass: "icon-Information_filled"});
            stopLoader();
        }
    };

    $scope.deleteItem = function (elem, template, isFromCDEdit, elmToBeDeleted, targetArea) {
        // $scope.confirmAlertDialog(str, heading , yesCbFn ,noCbFn, field );
        var field = {};
        field.elem = $(elem).attr('id');
        field.template = template;
        if (isFromCDEdit && elmToBeDeleted){
            field.isFromCDEdit = isFromCDEdit;
            field.elmToBeDeleted = elmToBeDeleted;
            field.targetArea = targetArea;
        }else {
            field.isFromCDEdit = true;
            field.targetArea = angular.element(elem).data('targetarea');
            if (field.targetArea == 'withinelem') {
                field.elmToBeDeleted = angular.element(elem).closest('.jx-childElm').data('cid');
            }
        }
        if(angular.element(".modal-dialog").length > 0){
            $scope.deleteFileTrue(field);
        } else {
            const args = {
                popupType: 'confirm',
                str: intl_msg[6440],
                heading: intl_msg[24153],
                yesCbFn: "deleteFileTrue",
                noCbFn: "deleteFileFalse",
                field: JSON.stringify(field),
            }
            SirionUtils.openSirionDialogs(args);
        }
    };

    $scope.resetFileProperties = function (evt,object) {
        if(evt === undefined){
            return;
        }
        evt.stopPropagation();
        var jsonObj = JSON.parse(unescape(object));
        var _id = jsonObj.filekey != null ? jsonObj.filekey : jsonObj.id;
        var querySelectorId = "fileProperties_"+_id;
        var parentDivElem =  "filePropertiesTempplate_"+_id;
        $scope.setCurrentSelectedRowId(_id);
        var isNewUpload = jsonObj.id == null ? true :false;
        $scope.setCurrentRowStatus(isNewUpload);
        if(!$( "."+parentDivElem).hasClass( "active" )){
            angular.element(document.querySelector("."+parentDivElem)).addClass("active");
        }
        if($( "#"+querySelectorId).hasClass( "displayNone" )){
            angular.element(document.querySelector("#"+querySelectorId)).removeClass("displayNone");
            angular.element(document.querySelector("#"+querySelectorId)).addClass("displayBlock");
            angular.element(document.querySelector("#jx-treeDoc-"+_id)).find('.list-hover').addClass("outerLi");
            angular.element(document.querySelector("#jx-treeDoc-"+_id)).find('.list-hover').find(".hover-icons").addClass("settingDiv");
        }
        else{
            angular.element(document.querySelector("#"+querySelectorId)).removeClass("displayBlock");
            angular.element(document.querySelector("#"+querySelectorId)).addClass("displayNone");
            return;
        }
        $scope.closeIfAnyPeerOpen(docTreeService.contractDocuments,_id);
        var selectedArr = SirionUtils.findInArray(docTreeService.contractDocuments,_id);
        if(!selectedArr.customNumbering){
            angular.element('#'+querySelectorId).find('.jx-cnfieldDD').hide();
        }else{
            angular.element('#'+querySelectorId).find('.jx-cnfieldDD').removeClass('ng-hide').show();
        }
        docTreeService.setFilePropertiesDropDown(selectedArr);
        docTreeService.disableAEentities.call($scope,querySelectorId,jsonObj.metadataAutoExtract, isNewUpload);
        var liHeight =  $("#"+'jx-treeDoc-' + _id).outerHeight();

        //SirionUtils.openDropDownUpwards(parentDivElem,querySelectorId,liHeight);
    };

    $scope.closeIfAnyPeerOpen = function(_contractDocs,_currentDocId){
        var docIds =  _.map(_contractDocs, 'id');
        for( var i=0; i < docIds.length ;i++ ){
            var selector = "fileProperties_"+docIds[i];
            if($( "#"+selector) && $( "#"+selector).hasClass( "displayBlock" )  && docIds[i] != _currentDocId){
                angular.element(document.querySelector("#"+selector)).removeClass("displayBlock");
                angular.element(document.querySelector("#"+selector)).addClass("displayNone");
            }
        }
    };


    $scope.closeFileProperties = function (evt, object) {
        var jsonObj = JSON.parse(unescape(object));
        var _id = jsonObj.filekey != null ? jsonObj.filekey : jsonObj.id;
        var querySelectorId = "fileProperties_" + _id;
        if(!angular.element(document.querySelector("#" + querySelectorId)) ||
            angular.element(document.querySelector("#" + querySelectorId)).length == 0 )
        {
            return;
        }
        $scope.setCurrentSelectedRowId($scope.getCurrentSelectedRowId());
        var isNewUpload = jsonObj.id == null ? true :false;
        $scope.setCurrentRowStatus(isNewUpload);
        angular.element(document.querySelector("#" + querySelectorId)).removeClass("displayBlock active");
        angular.element(document.querySelector("#" + querySelectorId)).addClass("displayNone");
        angular.element(document.querySelector("#jx-treeDoc-"+_id)).find('.list-hover').removeClass("outerLi");
        angular.element(document.querySelector("#jx-treeDoc-"+_id)).find('.list-hover').find(".hover-icons").removeClass("settingDiv");
        var parentDivElem =  "filePropertiesTempplate_"+_id;
        if($( "."+parentDivElem).hasClass( "active" )){
            angular.element(document.querySelector("."+parentDivElem)).removeClass("active");
        }
    };
    $scope.updateContractDocObj = function (e,row,args) {

        return docTreeService.updateContractDocObj(e,row,args,$scope.getCurrentSelectedRowId(),$scope.getCurrentRowStatus());
    };

    $scope.isCheckBoxDisabled = function (row) {

        return docTreeService.isCheckBoxDisabled(row);
    };

    $scope.setCurrentSelectedRowId = function (id) {

        $scope.currentRowId = id;
    };

    $scope.getCurrentSelectedRowId = function () {

        return $scope.currentRowId;
    };

    $scope.setCurrentRowStatus = function (_flag) {

        $scope.isNewUpload = _flag;
    };

    $scope.getCurrentRowStatus = function () {

        return $scope.isNewUpload;
    };
    $scope.docEditBack = function(_val,_e){
        if(!docTreeService._compareJSON()){
            $scope.diffInJson = true;
            var confirmMessage = intl_msg[28882]
            $scope.callDocEditMsgBox(confirmMessage);
        }
        else{
            docTreeService.toggleDocEditTemplate(false);
        }

    }

    $scope.callDocEditMsgBox = function(confirmMessage){
        var _customeClass ={close:"docEditPromptClose"};
        var warnMSG = intl_msg[29214]||"Warning";
        const args = {
            popupType: 'confirm',
            str: confirmMessage,
            heading: warnMSG,
            yesCbFn: "backNegitiveBtn",
            noCbFn: "backPositiveBtn",
            yesName: intl_msg[24184],
            noName: intl_msg[23731],
            rmvCloseBtn: false,
            _customClass: _customeClass
        }
        SirionUtils.openSirionDialogs(args);
    }

    $scope.toggleAllReqFields = function(e){
        var toggleChecked  = e ? angular.element(e.target).prop('checked') :  angular.element("#reqFieldsToggle").prop('checked');
        if(toggleChecked && !$scope.globalData.dynamicFormId){
            $scope.formFieldGroups = showPage2DataTransformationService.createGroupOfFields($scope.layout.fields[_.findIndex($scope.layout.fields,function(o){return o.type=="basic"})].fields);
            showPage2DataTransformationService.hideNonReqFields($scope, $scope.formFieldGroups);
        }else{
            $('.hidden-nrf').removeClass('hidden');
        }
        const lengthToRemove = angular.element(".label-height .errorClass .errorClass").length;
        $scope.fieldErrorLength = angular.element(".dynamic-form").find(".errorClass:visible").length - lengthToRemove;
        $scope.currentErrorElemIndex = 1;
        showPageService.scrollToErrorElem($scope,"");
        $scope.errorSolvedLength = 0;
        if($scope.fieldErrorLength > 0){
            $(".fieldError-ribbon").addClass("active");
        }
    }
    $scope.$on("checkEditDocJson", function(evt,data){
        if(data.entityName === "tblcontracts" || data.action === "logout")
        {
            if(!docTreeService._compareJSON()){
                evt.preventDefault();
            }
        }
        else{
            return;
        }
    });

    var updateWFstepValidation =  $scope.$on('updateWFstepValidation',function(evt,data){
        $scope.skipWFStepPopup = data;
    });

    $scope.$on("editDocPrompt", function(evt,data){

        if((data._toParams && data._toParams.entityName === "tblcontracts") || (data && (data["action"] == "logout" )))
        {
            var confirmMessage = intl_msg[28882];
            $scope.callDocEditMsgBox(confirmMessage);
            if(!docEditNeedSave){
                docEditNeedSave = true;
            }
            if(data._toState && data._toState.$$route && data._toState.$$route.controller != "showPageController"){
                /*******Account Page Controller************/
                $scope.originalHashLoc =data._toState.$$route.originalPath.replace(":id",data._toState.params["id"]).replace(":type",data._toState.params["type"]);
            }
            else if(data.action && data["action"] == "logout" && data._toState){
                /*******Logout************/
                $scope.originalHashLoc =data._toState.originalPath;
            }
            else if(data._toState.$$route.controller == "showPageController"){
                /******URL Mannually Changed************/
                $scope.originalHashLoc =undefined;
                $scope.locationReload = undefined;
            }
            else{
                /******Browser Refresh************/
                $scope.originalHashLoc =undefined;
                $scope.locationReload = true;
            }
        }
    });

    $scope.backPositiveBtn = function(){
        $timeout(function(){$(".modal-dialog .modal-header .docEditPromptClose").click();},0);
        return;
    };

    $scope.backNegitiveBtn = function (_val, _e) {
        docTreeService.contractDocuments = JSON.parse(JSON.stringify(docTreeService.contractDocumentsCopy));
        $timeout(function () {
            $(".modal-dialog .modal-header .docEditPromptClose").click();
        }, 0);
        if ($scope.originalHashLoc) {
            if($scope.originalHashLoc == "/logout"){
                window.location.href = window.location.origin + $scope.originalHashLoc;
            }
            else{window.location.hash = $scope.originalHashLoc;}

        }
        else if($scope.originalHashLoc == undefined && $scope.locationReload){
            window.location.reload();
        }
        else {
            if($scope.diffInJson) {
                delete $scope.diffInJson;
                docTreeService.updateDocListInReact($scope,docTreeService.contractDocuments);
            }
            docTreeService.toggleDocEditTemplate(false);
        }
        angular.element('.jx-rootElm').find('.child-doc-list').remove();
        return;
    };

    $scope.isFileActionVisible = function () {
        return docTreeService.showfileaction;
    }




    $scope.$watch('docTreeService.contractDocuments', function (newValue, oldValue, scope) {
        //Do anything with $scope.letters
        if(docTreeService.contractDocuments && newValue && oldValue && newValue.length != oldValue.length &&
            docTreeService.contractDocumentsCopy.length!=docTreeService.contractDocuments.length){
            docEditNeedSave = true;
        }
    }, true);
    $scope.$watch('data', function(_newValue, _oldValue, scope){
        var flag = false;

        var newValue = angular.copy(_newValue);
        var oldValue = angular.copy(_oldValue);

        if(oldValue && oldValue.dynamicMetadata)
            oldValue = _.extend(oldValue, oldValue.dynamicMetadata);
        if(newValue && newValue.dynamicMetadata)
            newValue = _.extend(newValue, newValue.dynamicMetadata);
        if(oldValue && oldValue.stakeHolders && oldValue.stakeHolders.values)
            oldValue = _.extend(oldValue, oldValue.stakeHolders.values);
        if(newValue && newValue.stakeHolders && newValue.stakeHolders.values)
            newValue = _.extend(newValue, newValue.stakeHolders.values);


        ($scope.fieldErrorLength > 0) && _.map(oldValue,function(item){
            if(item.name && item.name.startsWith('rg_')){
                var elem = $("[name="+item.name+"]").closest('span.label-height');
            } else {
                var elem = $("#elem_" + item.id);
            }
            var errorElem = elem.find(".errorClass");
            if( newValue[item.name] && newValue[item.name].values && newValue[item.name].values  != item.values){
                flag = true;
                if(errorElem.length > 0 && ((!_.isObject(newValue[item.name].values) && newValue[item.name].values) || !_.isEmpty(newValue[item.name].values) ) &&( _.has($scope.errors.fieldErrors, [item.name]) ||  _.has($scope.errors.fieldErrors, 'dynamicMetadata.'+item.name ) ||  _.has($scope.errors.fieldErrors, 'stakeHolders.values.'+item.name))) {
                    if( _.has($scope.errors.fieldErrors, [item.name])) {
                        $scope.errors.fieldErrors[item.name].message = null;
                    } else if( _.has($scope.errors.fieldErrors, 'dynamicMetadata.'+item.name ) || (scope.errors.fieldErrors.dynamicMetadata && $scope.errors.fieldErrors.dynamicMetadata[item.name])){
                        $scope.errors.fieldErrors['dynamicMetadata.'+item.name].message = null;
                        if($scope.errors.fieldErrors.dynamicMetadata[item.name])
                            $scope.errors.fieldErrors.dynamicMetadata[item.name].message = null;
                    }  else if( _.has($scope.errors.fieldErrors, 'stakeHolders.values.'+item.name ) || ($scope.errors.fieldErrors.stakeHolders && $scope.errors.fieldErrors.stakeHolders.values && $scope.errors.fieldErrors.stakeHolders.values[item.name]) ){
                        $scope.errors.fieldErrors['stakeHolders.values.'+item.name].message = null;
                        if($scope.errors.fieldErrors.stakeHolders.values[item.name])
                            $scope.errors.fieldErrors.stakeHolders.values[item.name].message = null;
                    }

                }
            }
        })
        $timeout(function () {
            const lengthToRemove = angular.element(".label-height .errorClass .errorClass").length;
            const hiddenErrorFields  = angular.element(".dynamic-form").find(".errorClass").length - lengthToRemove;
            if($("#reqFieldsToggle").prop("checked") && $scope.fieldErrorLength == 0 && hiddenErrorFields > 0){
                $scope.toggleAllReqFields();
            }else if(!$scope.aeDocShowPage){
                $scope.changeErrorCount(null,null, true);
            }

        });
    },true)


    $scope.deleteFileTrue = async function (field) {
        if(_.has($scope.uploadingDocumentData, 'entityId'))
            await $scope.handleDocumentUpload($scope.uploadingDocumentData);

        if (field.hasOwnProperty('isFromCDEdit') && field.isFromCDEdit) {
            docTreeService.deleteContractFiles(field);
            $scope.cancel(true);
        } else {
            elem = field.elem;
            template = field.template;
            var count = 0;
            $("#" + elem).closest("div." + template + "_appended").attr("fileAction", "3");
            $("#" + elem).parents("div:first").hide();
            $scope.cancel();
        }

    }
    $scope.deleteFileFalse = function (field) {
        $scope.cancel(true);
    };

    $scope.sendHierarchyTrue = function (d) {
        BU.sendHierarchyBulkAction(true);
        $scope.cancel();
    }
    $scope.sendHierarchyFalse = function (d) {
        BU.sendHierarchyBulkAction(false);
        $scope.cancel();
    }
    $scope.$watch("data.contractingEntity.values", function (newValue, oldValue) {
        newValue = "pp";
    });

    // Think

    // Think
    // called on change of file element or on click on browse button.....
    $scope.uploadContractDocIE = function (elem) {
        var fileName = elem.value.split('\\').pop();
        var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
        $scope.jqueryElem = $(elem).parent();
        var isDulicate = false;

        if (VALIDEXTENSIONS.indexOf(fileExt) == -1) {
            const args = {
                popupType: 'alert',
                str: intl_msg[24177] + " " + fileName + " " + intl_msg[24178],
                heading: intl_msg[24153],
                yesCbFn: cancelString,
                yesName: intl_msg[24184]
            }
            SirionUtils.openSirionDialogs(args);
            return false;
        } else if ($rootScope.alertBoxes.length == 0) {
            const args = {
                popupType: 'alert',
                str: UPLOADINPROGRESSMESSAGE,
                heading: intl_msg[24153]
            }
            SirionUtils.openSirionDialogs(args);
        }

        $(elem).parents().find(".fileNameSpan:visible").each(function () {
            if (!$scope.globalData.allowDuplicateDocument && $(this).text() == fileName) { // false
                // -because
                // duplicate
                // file
                // is
                // allowed
                setTimeout(function () {
                    if ($rootScope.alertBoxes.length > 0) {
                        modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                        modalToClose.close();
                    }
                    if (modalToClose) {
                        modalToClose.result.then(function () {
                            $rootScope.alertBoxes.pop();
                            const args = {
                                popupType: 'alert',
                                str: intl_msg[24180],
                                heading: intl_msg[24153],
                                yesCbFn: cancelString,
                                yesName: intl_msg[24184]
                            }
                            SirionUtils.openSirionDialogs(args);
                        });
                    }
                }, 500);
                $(elem).val("");
                isDulicate = true;
            }
        });
        if (isDulicate) {
            return;
        }
        const args = {
            popupType: 'alert',
            heading: intl_msg[24153],
            yesCbFn: cancelString,
            yesName: intl_msg[24184]
        }
        try {
            $scope.files = elem.files;
            if ((fileSize = entityFactory.calculateFilesSize($scope.files)) >= $rootScope.gMaxFileUploadSize) {
                args.str = intl_msg[6554] + parseInt($rootScope.gMaxFileUploadSize / 1000000) + " MB. Currently it is " + parseInt(fileSize / 1000000) + " MB";
                SirionUtils.openSirionDialogs(args);
            }
        } catch (e) {
            return false;
        }

        if (false && !$rootScope.gAllowedontractDocumentFileTypes[(fileExt)]) {
            args.str = intl_msg[24177]+" " + fileName + " "+intl_msg[24178];
            SirionUtils.openSirionDialogs(args);
            return false;
        } else {
            if (fileName && fileName.length >= $rootScope.gMaxFileLength) {
                args.str = fileName + intl_msg[6560] + $rootScope.gMaxFileLength + ".";
                SirionUtils.openSirionDialogs(args);
                // continue;// Skip this file and continue adding other files
            } else {
                var fileKey = formService.getFileKey(fileName); // to be sent
                // from client
                // every time
                // you upload
                // new file,
                // replace
                // file...
                var parentFileID = null; // to push as parentId in a file object
                // to make the parent-child r/ship..
                var fileID = null; // to be sent as id in case of replace and to
                // be used in edit page...
                $scope.fileElem = angular.element(elem);
                var templateDiv = $($scope.fileElem).closest("div." + $scope.fileElem.attr("template") + "_appended");
                $scope.myTemplate = $('.' + $scope.fileElem.attr("template")).html();
                var divToAppend = angular.element('<div></div>');
                if (templateDiv && templateDiv.length > 0) {
                    if (templateDiv.attr("id") && (templateDiv.attr("id") !== null) && (templateDiv.attr("id") !== "null")) {
                        if (templateDiv.attr("id").toString().trim().length > 0) {
                            divToAppend.attr("parentId", templateDiv.attr("id"));
                            parentFileID = templateDiv.attr("id");
                        }
                    } else if (templateDiv.attr("key") && (templateDiv.attr("key") !== null) && (templateDiv.attr("key") !== "null")) {
                        if (templateDiv.attr("key").toString().trim().length > 0) {
                            divToAppend.attr("parentId", templateDiv.attr("key"));
                            parentFileID = templateDiv.attr("key");
                        }
                    }
                }
                var actionTable = angular.element("<table></table>");
                var sFileName = fileName;
                var arrayOfNamesSplitted = sFileName.split('.');
                arrayOfNamesSplitted.splice((arrayOfNamesSplitted.length - 1), 1);
                var sFileNameWithoutExt = escapeHtml(arrayOfNamesSplitted.join("."));
                const reverseCharMap = {"&amp;": "&","&quot;": '"',"&#39;": "'"};
                sFileNameWithoutExt = window.unescapeHtml(sFileNameWithoutExt,reverseCharMap); // Safe for database storage
                var sFileExtension = sFileName.split('.')[sFileName.split('.').length - 1].toLowerCase();
                // var iFileSize = $scope.files[0].size;
                divToAppend.attr("id", fileID).attr("key", fileKey).attr("fileName", sFileNameWithoutExt).attr("fileExtension", sFileExtension).attr("fileAction", "1").attr("class", $scope.fileElem.attr("template") + "_appended").attr("ng-model", $scope.fileElem.attr("ng-model"));
                divToAppend.append($scope.myTemplate);
                if (searchableExtensions.indexOf(sFileExtension) == -1) {
                    $(divToAppend).find("input[name='search']").attr("disabled", "disabled");
                }
                if (viewerExtensions.indexOf(sFileExtension) == -1) {
                    $(divToAppend).find("input[name='viewerAvailable']").attr("disabled", "disabled");
                }
                if (fileKey == null)
                    var btnId = fileID;
                else
                    var btnId = fileKey;
                var ss = angular.element('<input id="cancel_' + btnId + '" type="button"  class="upload-delete"></input>');

                $(ss).on("click", function () {
                    // console.log("file :",$scope.fileElem.attr("template"));
                    $scope.deleteItem(this, $scope.fileElem.attr("template"));
                });
                var action = angular.element(elem).attr("action");
                var template = $scope.fileElem.attr("template");
                var replaceElement = angular.element("<input></input>").attr("title", intl_msg[25545]).attr("name", "documentFileData")
                    .attr({
                        "type": "file",
                        "onchange": "angular.element(this).scope().replaceContractDoc(this, '" + fileKey +
                            "', '" + fileID + "', '" + sFileNameWithoutExt + "', '" + sFileExtension + "','" + action + "', '" + template + "', '" + parentFileID + "')"
                    });
                var myelem = angular.element("<div class='replaceDoc'><span><button class='replace-icon' title='"+intl_msg[25545]+"'></button></span></div>");
                myelem.append(replaceElement.attr("style", "position:absolute;opacity:0;"));

                var actionTableRow = angular.element("<tr></tr>");
                var fileNameElem = angular.element('<span class="fileNameSpan" id="fileNameSpan">' + sFileName + '</span>');
                actionTableRow.append(angular.element("<td></td>").append(fileNameElem));
                var myTd = actionTableRow.append(angular.element("<td></td>").append(ss));
                // actionTableRow.append(angular.element("<td></td>").append(ss));
                $(actionTable).append(actionTableRow);
                $(divToAppend).prepend(actionTable);
                $scope.$applyAsync();
                // iframe error handling
                var formWrapperString = '<form action="' +
                    appName + angular.element(elem).attr("action") +
                    '" enctype="multipart/form-data" encoding="multipart/form-data"  method="POST" style="display:none"></form>';
                var formWrapper = $(formWrapperString);
                formWrapper.attr('target', 'ajaxIframe_' + fileKey);
                $('body').append(
                    '<iframe id="ajaxIframe_' + fileKey + '" name="ajaxIframe_' + fileKey + '" style="display:none"/>');
                $(elem).after($(elem).clone());
                formWrapper.append('<input type="hidden" name="key" value="' + fileKey + '"/>');
                formWrapper.append('<input type="hidden" name="name" value="' +
                    fileName.substring(0, fileName.lastIndexOf('.')) + '"/>');
                formWrapper.append('<input type="hidden" name="extension" value="' +
                    fileName.substring(fileName.lastIndexOf('.') + 1) + '"/>');
                formWrapper.append('<input type="hidden" name="relationId" value="' +
                    $scope.currentRelationId + '"/>');
                formWrapper.append(elem);
                globalFunctions.appendCSRFField(formWrapper);
                $('body').append(formWrapper);
                formWrapper.submit();
                $("iframe[name='ajaxIframe_" + fileKey + "']").load(function () {
                    if ($("iframe[name='ajaxIframe_" + fileKey + "']").contents().text() == "error") {
                        args.str = intl_msg[6499];
                        SirionUtils.openSirionDialogs(args);
                    }
                    else if ($("iframe[name='ajaxIframe_" + fileKey + "']").contents().text() == "extensionError") {
                        args.str = intl_msg[24170];
                        SirionUtils.openSirionDialogs(args);
                    }
                    else if ($("iframe[name='ajaxIframe_" + fileKey + "']").contents().text() == "virus") {
                        args.str = intl_msg[6500];
                        SirionUtils.openSirionDialogs(args);
                    }
                    else if ($("iframe[name='ajaxIframe_" + fileKey + "']").contents().text() == "virusCheckFailed") {
                        args.str = intl_msg[27946];
                        SirionUtils.openSirionDialogs(args);
                    } else if ($("iframe[name='ajaxIframe_" + fileKey + "']").contents().text().indexOf("totalNumberOfPages") > -1) {
                        var strObj = $("iframe[name='ajaxIframe_" + fileKey + "']").contents().text().split("=");
                        if (strObj && strObj[1]) {
                            $(divToAppend).find("input[name=totalPages]").val(strObj[1]);
                            $(divToAppend).find("label.customPageNumbering").hide();
                        }
                        ($scope.jqueryElem).append(divToAppend);
                        $($scope.fileElem).val("");
                    } else if ($("iframe[name='ajaxIframe_" + fileKey + "']").contents().text() != "") {
                        args.str = intl_msg[6552];
                        SirionUtils.openSirionDialogs(args);
                    } else {
                        ($scope.jqueryElem).append(divToAppend);
                    }
                    if ($rootScope.alertBoxes.length > 0) {
                        modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                        modalToClose.close();
                        $rootScope.alertBoxes.pop();
                    }
                });

            } // end if statement on file name lenght
        } // end else statement of file extension check
        return false;
    };
    // formService (data)
    $scope.correctOptionAddresses = function (fieldModel, valueField, optionsLocation, optionField, fieldToWatchFor) {
        valueField = showPageService.getModelfromString.call(fieldModel, valueField);
        optionsLocation = showPageService.getModelfromString.call(fieldModel, optionsLocation);
        if (optionsLocation === null || angular.isUndefined(optionsLocation[fieldToWatchFor])) {
            return;
        }
        optionsLocation = optionsLocation[fieldToWatchFor];
        optionField = showPageService.getModelfromString.call(optionsLocation, optionField);

        if (valueField === null || optionField === null) {
            // console.log("unable to get value or options model");
            return;
        }

        $scope.correctOptionAddressesRecursive(valueField, optionField, fieldToWatchFor);
        // console.log(fieldModel, valueField, optionField, fieldToWatchFor);
    }
    // formService (data)
    $scope.correctOptionAddressesRecursive = function (value, options, field) {
        if (angular.isDefined(value[field]) && value[field] != null) {
            for (var i = 0; i < options.length; i++) {
                if (options[i].id === value[field].id) {
                    value[field] = options[i];
                    break;
                }
            }
        } else if (angular.isObject(value)) {
            for (i in value) {
                if (value.hasOwnProperty(i)) {
                    if (angular.isObject(value[i]) || angular.isArray(value[i])) {
                        $scope.correctOptionAddressesRecursive(value[i], options, field);
                    }
                }
            }
        } else if (angular.isArray(value)) {
            for (var i = 0; i < value.length; i++) {
                if (angular.isObject(value[i]) || angular.isArray(value[i])) {
                    $scope.correctOptionAddressesRecursive(value[i], options, field);
                }
            }
        }
    }
    // formService (data)
    $scope.getUniqueArray = function (arr) {
        if (!angular.isArray(arr)) {
            return null;
        }
        var dups = {};
        return arr.filter(function (el) {
            var hash = el.valueOf();
            var isDup = dups[hash];
            dups[hash] = true;
            return !isDup;
        });
    }
    // formService
    var fi;
    $scope.getIfFieldsEditable = function (field) {
        fi = field;
        var editable = false;
        if (fi.displayMode != null && fi.displayMode != "display") {
            return true;
        } else if (fi.fields != null && fi.fields != undefined) {
            var ff = fi.fields;
            for (var i = 0; i < ff.length; i++) {
                if (ff[i] != null) {
                    editable = editable || $scope.getIfFieldsEditable(ff[i]);
                    if (editable) {
                        return true;
                    }
                }
            }
        }
        return editable;

    }
    // formService(data)
    $scope.isNotEmpty = function (obj) {
        if (angular.isObject(obj)) {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop))
                    return true;
            }
            return false;
        } else if (angular.isArray(obj)) {
            return (obj.length > 0);
        } else {
            return obj !== "";
        }
    }

    // to show the files selecetd on edit page..............
    $scope.appendContractFileUploadDivOnEdit = function (elem, dataArray) {
        $scope.fileElem = angular.element(elem);
        $scope.myTemplate = $('.' + $scope.fileElem.attr("template")).html();
        if (dataArray != undefined)
            entityFactory.sortArrayByKey(dataArray, "parentId"); // sort array of
        // contract
        // documents so
        // that we can
        // show child
        // docs under
        // parent if
        // order from
        // server is not
        // ok
        var template = $scope.fileElem.attr("template");
        /* $scope.myTemplate = newElem.html(); */
        angular.forEach(dataArray, function (v, k) {
            var myHTMLTemplate = $($scope.myTemplate).clone(true);
            var divToAppend = angular.element('<div></div>');
            var fileID = v.id;
            var fileKey = null;
            var parentFileID = v.parentId;
            var fileExtension = (v.extension != "link") ? v.extension : "";
            var dOt = (v.extension != "link") ? "." : "";

            $(divToAppend).prepend('<span id="fileNameSpan">' + v.name + dOt + fileExtension + '</span>');
            divToAppend.attr("id", fileID).attr("parentId", parentFileID).attr("fileExtension", fileExtension).attr("fileName", v.name).attr("class", $scope.fileElem.attr("template") + "_appended").addClass("uploadedDocumentOnEdit").attr("ng-model", $scope.fileElem.attr("ng-model"));
            if (!fileExtension) {
                divToAppend.addClass("linkUploadBox");
            }

            if ((!$scope.globalData.hasAutoExtractEntitiesPermission) || (fileExtension && !["doc", "dot", "docx", "docm", "dotx", "dotm", "docb"].includes(fileExtension))) {
                myHTMLTemplate.find("#elem_12146").parent().hide();
            }

            if (fileKey == null)
                var btnId = fileID;
            else
                var btnId = fileKey;
            var ss = angular.element('<input id="cancel_' + btnId + '" type="button" class="upload-delete"></input>');
            $(ss).on("click", function () {
                // console.log("f :",template);
                $scope.deleteItem(this, template);
            });
            var action = angular.element(elem).attr("action");
            var replaceElement = angular.element("<input></input>").attr("name", "documentFileData").attr({
                "type": "file",
                "onchange": "angular.element(this).scope().replaceContractDoc(this, '" + fileKey + "', '" + fileID + "', '" + v.name + "', '" + fileExtension + "', '" + action + "', '" + $scope.fileElem.attr("template") + "','" + parentFileID + "')"
            });
            var myelem = angular.element("<div class='replaceDoc'><span><button class='replace-icon' title='"+intl_msg[25545]+"'></button></span></div>");
            myelem.append(replaceElement.attr("style", "position:absolute;opacity:0;"));

            /* ***************************************************** */
            var actionTable = angular.element("<table></table>");
            var actionTableRow = angular.element("<tr></tr>");
            var myTd = actionTableRow.append(angular.element("<td></td>").append(ss));
            $(actionTable).append(actionTableRow);
            $(divToAppend).prepend(actionTable);
            /* ***************************************************** */
            // console.log("tpl",myHTMLTemplate);
            var disableCustomNumbering = false;
            $(myHTMLTemplate).find("input[type=checkbox]").each(function (v1, k1) {
                $(this).prop('checked', v[$(this).prop("name")]);
                if(v.autoExtract && $(k1).attr("ng-model") == "data.autoExtract.values"){
                    if(v.autoExtractionStatus && v.autoExtractionStatus !== 3){
                        $(this).attr("disabled","disabled");
                    }
                }
                $(this).on("click", function () {
                    divToAppend.attr("fileAction", "2");
                });
                if ($(this).prop("name") == "search" && searchableExtensions.indexOf(v.extension) == -1) {
                    $(this).attr("disabled", "disabled");
                }
                if ($(this).prop("name") == "viewerAvailable" && viewerExtensions.indexOf(v.extension) == -1) {
                    $(this).attr("disabled", "disabled");
                }
                if ($(this).prop("name") == "customNumbering") {
                    if (v[$(this).prop("name")] == false || v["totalPages"] == null) {
                        disableCustomNumbering = true;
                    }
                    if (v["totalPages"] == null) {
                        $(this).attr("disabled", "disabled");
                    }
                    if (v["referenced"] && v["totalPages"] > 0) {
                        disableCustomNumbering = false;
                        $(this).attr("disabled", "disabled");
                    }
                }
            });
            $(myHTMLTemplate).each(function () {
                if ($(this).hasClass("customPageNumbering")) {
                    if (disableCustomNumbering) {
                        $(this).hide();
                    }
                    if (v["referenced"]) {
                        $(this).find("input[type=number]").attr("disabled", "disabled");
                    }
                    var elemtName = $(this).find("input[type=number]").attr("name");
                    if (v[elemtName] >= 0)
                        $(this).find("input[name=" + elemtName + "]").val(v[elemtName]);
                }
            });
            divToAppend.append(myHTMLTemplate);
            if (angular.isDefined(parentFileID) && (parentFileID !== null) && (parentFileID !== "null") && (parentFileID.toString().trim().length > 0)) {
                // var parentDiv =
                // $("div."+$scope.fileElem.attr("template")).closest("div#"+parentFileID);
                // var parentDiv =
                // $("div."+$scope.fileElem.attr("template")).parent().closest("div."+$scope.fileElem.attr("template")+"_appended");
                var parentDiv = $("div." + $scope.fileElem.attr("template") + "_appended").parent().parent().find("div#" + parentFileID);
                if (parentDiv.length > 0) {
                    myArray = (parentDiv).find('input[type="file"]');
                    var cc = 1;
                    myArray.each(function (v, k) {
                        // console.log(" thisd ",$(this).attr("name"),$(this).attr("ng-model"));
                        if (angular.isDefined($(this).attr("ng-model")) && (cc <= 1)) {
                            cc++;
                            $(this).parent().append(divToAppend);
                        }
                    });
                }
            } else {

                $("div." + $scope.fileElem.attr("template")).parent().parent().append(divToAppend);
            }
        });

    };
    /*** Function moved to showPageService.js
     $scope.checkForApiAndGetData = function (model) {
        model = model.split(".");
        var tempModel = $scope;
        for (i = 0; i < model.length; i++) {
            if (angular.isDefined(tempModel[model[i]])) {
                tempModel = tempModel[model[i]];
            } else {
                // console.log("undefined: "+ model);
                return;
            }
        }
        if (angular.isDefined(tempModel["api"]) && tempModel["api"] != null && tempModel["api"].trim().length > 0 && !tempModel["autoComplete"]) {
            var getData = entityFactory.getDataJson(tempModel["api"], "GET");
            getData.then(function (data) {
                tempModel.data = data.data;
            })
        }
    };*/
    // formService (data)
    $scope.checkModel = function (definitelyPresent, wholeModelString, dataStructure) {
        var tempModel = definitelyPresent;
        //console.log($scope.data.question.values);
        wholeModelString = wholeModelString.split(".");
        for (var i = 1; i < wholeModelString.length; i++) {
            if (angular.isUndefined(tempModel[wholeModelString[i]]) || tempModel[wholeModelString[i]] == null) {
                if (i == wholeModelString.length - 1) {
                    if (dataStructure === 'array') {
                        tempModel[wholeModelString[i]] = [];
                    } else if (dataStructure === 'object') {
                        tempModel[wholeModelString[i]] = {};
                    }
                } else {
                    tempModel[wholeModelString[i]] = {};
                }
            }
            tempModel = tempModel[wholeModelString[i]];
        }
        return true;
    };

    $scope.addDataToDynamicModel = function (dm, tempObj) {

        var tObj = angular.copy(tempObj);
        for (var k in tObj) {
            tObj[k]['tempName'] = tObj[k]['name'] + '_' + randomString(5);
        }
        dm.push(tObj);
        showPageService.preventLabelClick();
    };


    // formService
    $scope.checkMouseClick = function (e) {
        if (e.type == 'keypress' || (e.clientX == 0 && e.clientY == 0 && e.pageX == 0 && e.pageY == 0)) {
            return true;
        }
        var x = e.offsetX == undefined ? e.pageX - $(e.target).offset().left : e.offsetX;
        var y = e.offsetY == undefined ? e.pageY - $(e.target).offset().top : e.offsetY;
        return ((x >= 0) && (x <= e.currentTarget.clientWidth) && (y >= 0) && (y <= e.currentTarget.clientHeight));
    }

    $scope.getDateObject = function (strDate) {
        var dateArr = strDate.split((strDate.indexOf("-") > -1) ? "-" : "/");
        return new Date(parseInt(dateArr[2]), parseInt(dateArr[0]) - 1, parseInt(dateArr[1]));
    }

    $scope.checkFieldType = function (field, e){
        if(!field || !e){
            return;
        }
        if(field.id ==7412 && field.name =="agreementType"){
            $scope.selectChangeConfirm(e,true);
        }
    }

    $scope.changeSourceTypeFields = function (contractList, dependentModel, currentModel, fieldData) {
        if(currentModel.indexOf("contractParentEntityType") > -1){
            if(!$scope.data.contractParentEntityType.values || $scope.data.contractParentEntityType.values.id == 1){
                $scope.showSourceNameTitle = false;
                if($scope.data.contractParent && $scope.data.contractParent.options){
                    $scope.data.contractParent.options.data = [];
                    $scope.data.contractParent.values = null;
                }
            } else if($scope.data.contractSupplier && $scope.data.contractSupplier.values && ($scope.data.contractSupplier.values.id || $scope.data.contractSupplier.values.length)){
                var methodType = 'get';
                var postBody = {};
                angular.element("[name="+currentModel.split(".")[1]+"]").removeClass("errorClass");
                if($scope.data.contractSupplier.values.id) {
                    var url = $scope.appBaseApiUrl + "/entities?entityTypeId="+$scope.data.contractParentEntityType.values.id+"&relationId="+$scope.data.contractSupplier.values.id;
                }
                else if($scope.data.contractSupplier.values.length) {
                    var url = $scope.appBaseApiUrl + "/entities?entityTypeId=" + $scope.data.contractParentEntityType.values.id + "&relationId=" + $scope.data.contractSupplier.values[0].id;
                    methodType = 'post';
                    postBody["relationIds"] = $scope.data.contractSupplier && $scope.data.contractSupplier.values.map(function (obj) {
                        return obj.id
                    });
                }
                if(_.has($scope.data,"entityTypeId.values") && $scope.data.entityTypeId.values == 160
                    && _.has($scope.data,"customer.values.id")){
                    url += "&customerId=" + $scope.data.customer.values.id;
                    url += "&pageEntityTypeId=" + $scope.data.entityTypeId.values;
                }
                if($scope.data.contractParent && $scope.data.contractParent.options && $scope.data.contractParent.options.autoComplete){
                    $scope.showFreeFormContract = true;
                    $scope.showSourceNameTitle = true;
                } else if (url && url.indexOf("undefined") > -1){
                    console.log("Exception : Incorrect /entities API URL");
                    return false;
                } else {
                    $http({
                        method: methodType,
                        url: url,
                        data: postBody
                    }).then(function (response){
                        var scope = angular.element(".dynamic-form").scope();
                        $scope.data.contractParent.options = {'data':{}};
                        if(response.data && response.data.options && response.data.options.data && response.data.options.data.length > 0){
                            $scope.data.contractParent.options.data = response.data.options.data;
                        }
                        scope.showFreeFormContract = true;
                        scope.showSourceNameTitle = true;
                    })
                }
            }
            else
            {
                console.log("Warning : contractSupplier id null");
            }
        } else if ($scope.data.parentEntityType && $scope.data.parentEntityType.values && $scope.data.parentEntityType.values.id && $scope.data.parentEntityType.values.id != 1) {
            $scope.showSourceNameTitle = true;
            var url;
            if($scope.data.supplier.values.id)
                url = $scope.appBaseApiUrl + "/entities?entityTypeId=" + $scope.data.parentEntityType.values.id + "&relationId=" + $scope.data.supplier.values.id;
            else if($scope.data.supplier.values.length) {
                url = $scope.appBaseApiUrl + "/entities?entityTypeId=" + $scope.data.parentEntityType.values.id + "&relationId=" + $scope.data.supplier.values[0].id;
                $scope.newEntityCall = true;
            }
            else
                return;
            if(_.has($scope.contractFromCDRData,"sourceEntityTypeId") && $scope.contractFromCDRData.sourceEntityTypeId == 160
                && _.has($scope.data,"customer.values.id")){
                url += "&customerId=" + $scope.data.customer.values.id;
            }
            if($scope.newEntityCall &&fieldData && (fieldData.name == "contracts" || (fieldData.name == "parentEntityType")) ) {
                var postBody = {};
                if(fieldData.name == "contracts")
                    postBody["relationIds"] = showPageService.getOnlyFieldIds.call($scope,fieldData.dependentField || fieldData.dependentFields,);
                else {
                    postBody["relationIds"] = showPageService.getOnlyFieldIds.call($scope,fieldData.groupBy);
                }
                $http.post(url,postBody).then(function (response) {
                    if (response.data && response.data.options && response.data.options.data) {
                        if (!$scope.data.contracts.options) {
                            $scope.data.contracts.options = {};
                            $scope.data.contracts.options.data = [];
                        }
                        $scope.data.contracts.options.data = response.data.options.data;
                        if (response.data.options.data.length == 0)
                            Toaster.create($scope.data.popUpMessageForValidSourceType,{iconClass:"icon-Information_filled"});
                    }

                });
            } else {
                $http.get(url).then(function (response) {
                    if (response.data && response.data.options && response.data.options.data) {
                        if($scope.data.contracts.values) {
                            delete $scope.data.contracts.values;
                        }
                        if (!$scope.data.contracts.options) {
                            $scope.data.contracts.options = {};
                            $scope.data.contracts.options.data = [];
                        }
                        $scope.data.contracts.options.data = response.data.options.data;
                        if (response.data.options.data.length == 0)
                            Toaster.create($scope.data.popUpMessageForValidSourceType,{iconClass:"icon-Information_filled"});
                    }

                });
            }
        } else {
            $scope.showSourceNameTitle = false;
            if ($scope.data.contracts && $scope.data.contracts.options) {
                $scope.data.contracts.options.data = [];
                $scope.data.contracts.values = null;
            }
        }
        $scope.$broadcast("updateValue", {
            "showFreeFormContract": $scope.showFreeFormContract,
            "showSourceNameTitle": $scope.showSourceNameTitle
        });
    }

    $scope.changeContractFields = function (contractList, dependentModel, currentModel) {
        if ($scope.data && ($scope.data.supplier && $scope.data.supplier.values && ($scope.data.supplier.values.id ||  $scope.data.supplier.values.length) )) {
            $scope.showFreeFormContract = true;
            $scope.showSourceNameTitle = true;
        } else
            $scope.showFreeFormContract = false;
        $scope.$broadcast("updateValue", {
            "showFreeFormContract": $scope.showFreeFormContract,
            "showSourceNameTitle": $scope.showSourceNameTitle
        });
        if ($scope.data.parentEntityType && $scope.data.parentEntityType.values)
            $scope.data.parentEntityType.values = null;
        if ($scope.data.contracts && $scope.data.contracts.values)
            $scope.data.contracts.values = null;
    }
    $scope.emptyDependentChildValue = function(type) {
        clearTimeout($scope._clearTimer);
        $scope._clearTimer = setTimeout(() => {
            if($rootScope.fieldMapper2 &&  $rootScope.fieldMapper2[type]) {
                _.forEach($rootScope.fieldMapper2[type],key => {
                    if(key.indexOf('stakeHolders') > -1)
                        _.set($scope.data,key,[]);
                    else _.set($scope.data,key,null);
                })
            }
        },1000)
    }
    $scope.getDynamicData = function (theDataModel, dynamicValues, modelPrefix, field) {
        dynamicValues = JSON.parse(dynamicValues);
        for (var i = 0; i < dynamicValues.length; i++) {
            var queryObject = {};
            dynamicValues[i].nickName = (angular.isDefined(dynamicValues[i].nickName)) ? dynamicValues[i].nickName : theDataModel.name;
            queryObject[dynamicValues[i].nickName] = theDataModel.values ? theDataModel.values.id : "";
            if(!theDataModel.values.id)
                queryObject[dynamicValues[i].nickName] = theDataModel.values.length>0 ? theDataModel.values[0].id : "";
            if (angular.isDefined(dynamicValues[i]["additionalRequiredValues"])) {
                for (var j = 0; j < dynamicValues[i]["additionalRequiredValues"].length; j++) {
                    var additionalField = dynamicValues[i]["additionalRequiredValues"][j];
                    var tempGFieldModel = showPageService.getGFieldModel('', additionalField.model, "", "data");
                    var modelData = showPageService.getModelfromString.call($scope, tempGFieldModel);
                    var additionalFieldName = (angular.isDefined(additionalField.nickName)) ? additionalField.nickName : modelData.name;
                    queryObject[additionalFieldName] = modelData.values ? modelData.values.id : "";
                    if(!modelData.values.id)
                        queryObject[additionalFieldName] = modelData.values.length>0 ? modelData.values[0].id : "";
                }
            }
            if (dynamicValues[i].chooseGlobalEntityId) {
                queryObject.entityTypeId = $scope.globalData.entityTypeId;
                try {
                    $scope.data.sourceTitle.options.data = [];
                    $scope.data.sourceTitle.values = undefined;
                } catch (e) {
                    console.log("error");
                }
            }

            var model = dynamicValues[i]["model"];
            if($scope.data[model] && $scope.data[model].options && $scope.data[model].options.autoComplete){
                return true;
            }else{
                if( (model === 'parentEntityType'||model==="contractParentEntityType") && dynamicValues[i]["api"] === "/entitytypes" && field && field.properties && (field.properties.multiple || model==="contractParentEntityType")) {
                    var postBody = {};
                    postBody["entityTypeId"] = queryObject.entityTypeId || 5;
                    if(model==="contractParentEntityType")
                        postBody["entityTypeId"] = 160;
                    if(!theDataModel.values.id)
                        postBody["relationIds"] = theDataModel.values.map(function(obj){return obj.id});
                    else
                        postBody["relationIds"] = [theDataModel.values.id];
                    var apiData = entityFactory.getJson("/v1" + dynamicValues[i]["api"], "post", null , postBody , false);
                    $scope.newEntityCall = true;
                } else {
                    if(!$scope.globalData.entityTypeId)
                        return;
                    var apiData = entityFactory.getDataJson(dynamicValues[i]["api"], dynamicValues[i]["method"], queryObject);
                }
                (function (apiData, model) {
                    apiData.then(function (data) {
                        stopLoader();
                        if (data.data && data.data.options && data.data.options.data && data.data.options.data.length) {
                            $(".parentEntityTypeError").hide();
                            if (data.data.options.data[0].parentName) {
                                data.data.options.data = data.data.options.data.sort(function (a, b) {
                                    if (a.parentName.toLowerCase() == b.parentName.toLowerCase() && a.name.toLowerCase() == b.name.toLowerCase())
                                        return 0;
                                    else if (a.parentName.toLowerCase() == b.parentName.toLowerCase() && a.name.toLowerCase() > b.name.toLowerCase())
                                        return 1;
                                    else if (a.parentName.toLowerCase() == b.parentName.toLowerCase() && a.name.toLowerCase() < b.name.toLowerCase())
                                        return -1;
                                    else if (a.parentName.toLowerCase() > b.parentName.toLowerCase())
                                        return 1;
                                    else if (a.parentName.toLowerCase() < b.parentName.toLowerCase())
                                        return -1;
                                    else
                                        return (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1;
                                });
                            } else {
                                data.data.options.data = data.data.options.data.sort(function (a, b) {
                                    if (a.name.toLowerCase() == b.name.toLowerCase())
                                        return 0;
                                    else
                                        return (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1;
                                });
                            }
                        }
                        else if(data.config && data.config.url.indexOf("/entitytypes")!=-1 && data.data && data.data.options && data.data.options.data.length==0){
                            if($("select[name='parentEntityType']").length>0 && $(".parentEntityTypeError").length==0) {
                                $("select[name='parentEntityType']").after("<span class='parentEntityTypeError' style='color: red;margin-left:                          11px;'>"+intl_msg[28652]+"</span>");
                            }
                            else{
                                $(".parentEntityTypeError").show();
                            }
                        }
                        var responseData = data.data || data;
                        if (responseData.body && responseData.body == null) {
                            responseData.options = {
                                "data": []
                            };
                        } else {
                            // console.log(responseData);
                            model = (modelPrefix + "." + model).split(".");
                            var tempModel = $scope;
                            var error = false;
                            for (var j = 0; j < model.length && !error; j++) {
                                if (j == model.length - 1) {
                                    tempModel[model[j]] = responseData;
                                } else if (angular.isDefined(tempModel[model[j]])) {
                                    tempModel = tempModel[model[j]];
                                } else {
                                    error = true;
                                }
                            }
                            if (error) {
                                // console.log("error while setting data dynamically");
                            }
                        }
                        if(field && (field.name == "supplier") && !field.autoComplete) {
                            $scope.changeContractFields();
                        }
                        if( field && field.name == "contractSupplier" && !field.autoComplete) {
                            $scope.data[dynamicValues[0]["model"]].options = responseData.options;
                        }
                        if(!$scope.$$phase && !$rootScope.$$phase) {
                            $scope.$applyAsync();
                        }
                    });
                })(apiData, model);
            }

        }

    }

    // formService(dataService)
    /*** Function moved to showPageService.js
     $scope.getModelfromString = function (modelString, baseObj) {
        if (angular.isDefined(baseObj)) {
        return dataManipulationService.getModelfromString(modelString,baseObj)
        } else{
        return dataManipulationService.getModelfromString(modelString,$scope);
        }
    }*/
    // formService
    $scope.getLabel = function (model, defaultLabel, mappings) {
        defaultLabel = unescape(defaultLabel);
        if (angular.isUndefined(model) || angular.isArray(model)) {
            return defaultLabel;
        }
        var a;
        if (angular.isObject(model) && angular.isDefined(model.id)) {
            a = model.id;
        } else {
            a = model;
        }
        if ($rootScope.metadatasearchPage && angular.isDefined(mappings[a])) {
            if (defaultLabel.indexOf("Min.") > -1) {
                return "Min. " + mappings[a];
            } else if (defaultLabel.indexOf("Max.") > -1) {
                return "Max. " + mappings[a];
            }
        }
        if (angular.isDefined(mappings[a])) {
            return mappings[a];
        } else {
            return defaultLabel;
        }
    }
    // formService (dataService)
    /*** Function moved to showPageService.js
     $scope.getGFieldModel = function (model, name, modelType, ngModel) {
        var gFieldModel;
        if (modelType === 'relative') {
            gFieldModel = (angular.isDefined(model) && (model).toString().trim().length > 0)
                ? (model + "." + name)
                : (name);
        } else {
            if (angular.isDefined(name) && (name).toString().trim().length > 0) {
                gFieldModel = (angular.isDefined(model) && (model).toString().trim().length > 0)
                    ? (ngModel + '.' + model + "." + name)
                    : (ngModel + '.' + name);
            } else {
                gFieldModel = (angular.isDefined(model) && (model).toString().trim().length > 0)
                    ? (ngModel + '.' + model)
                    : (ngModel);
            }

        }
        return gFieldModel;
    }*/
    // for ie 8 only
    $scope.validateIEEight = function () {
        var eachCompleted = false;
        var spanCount = $("span.redStar").length;
        var count = 0;
        var err = false;
        $("span.redStar").each(function (a, b) {
            count++;
            if (angular.isDefined($(this).next().find("input[type='text']").val()) && $(this).next().find("input[type='text']").val().trim() == '') {
                $(this).next().find("input[type='text']").addClass("errorClass");
                err = true;

            }

            if (angular.isDefined($(this).next().find("input[type='number']").val()) && $(this).next().find("input[type='number']").val().trim() == '') {
                $(this).next().find("input[type='number']").addClass("errorClass");
                err = true;
            }

            if ($(this).next().find("select :selected").val() == '' && $(this).next().find("select :selected").text() != "") {
                $(this).next().find("select").addClass("errorClass");
                err = true;
            }

            if (count == spanCount) {
                eachCompleted = true;
            }

        });
        if (err == true) {
            const args = {
                popupType: 'alert',
                str: intl_msg[6561],
                heading: "ERROR",
                yesCbFn: cancelString,
                yesName: intl_msg[24184],
            }
            SirionUtils.openSirionDialogs(args);
            return false;
        }
        if (eachCompleted == true) {
            return true;
        }

        return true;
    }
    /*** following function moved to showPageService.js , setVadlidity renamed to setValidity
     $scope.setVadlidity = function (name, isValid) {
            if (!angular.isDefined($scope.validity)) {
                $scope.validity = {};
                validFields = 0;
            }
            $scope.validity[name] = isValid;
            $scope.getFormValidity(false);
        }

     $scope.getFormValidity = function (submitting) {
            if (angular.isDefined(submitting) && submitting) {
                $scope.validity = {};
                $("[validation]").each(
                    function () {
                        if ($(this).attr("disabled") != "disabled") {
                            angular.element($(this)).setDirty;
                            // $scope.setVadlidity($(this).attr("name"),
                            // ($scope.validity.isFormValid ? true : false));

                            $(this).blur();
                        }
                    }
                );
            }
            if (angular.isUndefined($scope.validity)) {
                return false;
            }
            $scope.validity.isFormValid = true;
            for (var i in $scope.validity) {
                if(!$scope.validity.hasOwnProperty(i))
                    continue;
                  if(i=="documentFileData"){
              		$("[name='documentFileData']").parent().find("button").removeClass("errorClass");
              	}
                  if(!$scope.validity[i] && ['undefined'].indexOf(i)==-1){
                  	if(i=="documentFileData"){
                  		$("[name='documentFileData']").parent().find("button").addClass("errorClass");
                  	}
                    $scope.validity.isFormValid = false;
                    break;
                  }
                }
            return $scope.validity.isFormValid;
        }*/
    // formService(data)
    $scope.setValue = function (modelString, value, baseObj) {
        if (angular.isDefined(baseObj)) {
            return dataManipulationService.setValue(modelString, value, baseObj)
        } else {
            return dataManipulationService.setValue(modelString, value, $scope);
        }
    }

    $scope.initErrors = function () {
        if (!angular.isDefined($scope.errors)) {
            // console.log("none of the fields have errors");
            return;
        }
    }

    $scope.onLoadInvoiceDynamicBlocks2 = function (primeData) {
        primeData = JSON.parse(primeData);
        var obj = {};
        if (primeData.additionalRequiredValues) {
            for (var k in primeData.additionalRequiredValues) {
                if (primeData.additionalRequiredValues[k].nickName) {
                    var key = angular.copy(primeData.additionalRequiredValues[k].nickName);
                    var val = angular.copy($scope.data[primeData.additionalRequiredValues[k].model].values);
                    obj[key] = val;
                }

            }
        }
        var optionUrl = primeData.api;
        var data2;
        if ($scope.data[primeData.model].values) {
            data2 = JSON.parse($scope.data[primeData.model].values);
        }
        // console.log("data2", data2);
        var getInvoiceOptions = entityFactory.getDataJson(optionUrl, 'GET', obj);
        getInvoiceOptions.then(function (data1) {
            dropdowsJson = data1.data.options.data;
            // assing client currency to its scope variable.........
            if (angular.isDefined(dropdowsJson.clientCurrency)) {
                $scope.clientCurrency = dropdowsJson.clientCurrency;
            }

            var invoice = data2; // '${tblInvoice.dynamicData}';
            data1.editable = primeData.editable;
            $scope.bansal = data1;

            // loadFunctionServicesOnChangeContract(parentDiv, sourceDropDown,
            // contractDropDownValuesObj, ".servicesDropDown",
            // ".functionsDropDown", "functions", "services");
            // loadFunctionServicesOnChangeContract(parametersObj);
            // populateInvoiceDynamicDivData(invoice, "contractDropDown", dropdowsJson);
            // });


        });
    };

    $scope.isIE = function () {
        var myNav = navigator.userAgent.toLowerCase();
        return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
    };
    $scope.isIE11 = function(){
        return !!window.MSInputMethodContext && !!document.documentMode;
    };

    // openAlertBox(heading, str, yes , yesCb , no , noCb);
    // formService (+callback)


    $scope.redirectToListing = function () {
        var rUrl = url;
        $location.path(rUrl);
    }

    $scope.openAlertBox = function (heading, str, yes, yesCb, no, noCb, url, modalScope, closeCallBack, rmvCloseBtn, isfirstTabSpecificEntity) {
        // console.log(str, yes, yesCb, no, noCb);
        var classIcon = "success-icon";
        var popupClass = "sirionconfirmPopup", crossBtn;
        heading = heading.toLowerCase();
        if (heading == intl_msg[24153].toLowerCase()) {
            classIcon = "success-icon";
            popupClass = "sirionsucessPopup";
        } else if (heading == "error" || heading == "alert") {
            classIcon = "alertdialog-icon error";
        }

        if(heading == "error"){
            heading = intl_msg[24167];
            popupClass = "sirionerrorPopup";
        }
        if(heading == "alert"){
            heading = intl_msg[24168];
            popupClass = "sirionconfirmPopup";
        }
        if(heading == "confirmation"){
            popupClass = "sirionconfirmPopup";
        }
        if(heading == "message"){
            classIcon = "success-icon";
            popupClass = "sirionsucessPopup";
            heading = intl_msg[24169]
        }
        if (yesCb == "navigateTo") {
            crossBtn = "navigateTo";
        }else if(yesCb =='refreshUrl'){
            crossBtn = "refreshUrl";
        }else if(yesCb =='goToPreviousPage') {
            crossBtn = "goToPreviousPage";
        } else {
            crossBtn = "cancel";
        }
        if (rmvCloseBtn) {
            var tempElement = angular.element('<div><div class="modal-header">' + heading + '</div><div class="modal-body"><span class="' + classIcon + '">' + str + '</span></div>');
        } else {
            var tempElement = angular.element('<div><div class="modal-header">' + heading + ' <span class="icon-close" ng-click="' + crossBtn + '()"></span></div><div class="modal-body"><span class="' + classIcon + '">' + str + '</span></div>');
        }
        var footerElem = angular.element('<div class="modal-footer"></div>');
        var yesBtn, noBtn;
        if (yes && yesCb) {
            if (url) {
                var fullUrl = appName + "#" + url;
                if (url == "/listRenderer/list/273") {
                    fullUrl = "#/listRender/273";
                } else if (url == "/listRenderer/list/271") {
                    fullUrl = "#/listRender/271";
                }
                yesBtn = angular.element('<a class="anchorBtn" ng-href=' + fullUrl + '>' + yes + '</a>');
                footerElem.append(yesBtn);
            } else if(isfirstTabSpecificEntity){
                yesBtn = angular.element('<a class="anchorBtn" href="javascript:void(0)" onclick="window.history.back();">' + yes + '</a>');
                footerElem.append(yesBtn);
            }
            else if (str == 'Please configure workflow for Contract Template.') {
                yesBtn = angular.element('<a class="anchorBtn" ng-href="#/listRender/273">' + yes + '</a>');
                footerElem.append(yesBtn);
            } else if (str == 'Please configure workflow for Clause.') {
                yesBtn = angular.element('<a class="anchorBtn" ng-href="#/listRender/271">' + yes + '</a>');
                footerElem.append(yesBtn);
            } else {
                if(yesCb.indexOf("(true)") > -1 ){
                    var yesBtnString = yesCb
                }else{
                    if(commonUtil.checkForAnimationOnClose($scope.jsonApi)){
                        var yesBtnString = yesCb + '(null,true)';
                    }else{
                        var yesBtnString = yesCb + '()';
                    }
                }
                yesBtn = angular.element('<button ng-click="' + yesBtnString + '">' + yes + '</button>');
                footerElem.append(yesBtn);
            }
        }
        if (no && noCb) {
            noBtn = angular.element('<button ng-click="' + noCb + '()">' + no + '</button>');
            footerElem.append(noBtn);
        }

        if (yes && (typeof yesCb == "undefined" || !yesCb )) {
            yesBtn = angular.element('<button>' + yes + '</button>');
            footerElem.append(yesBtn);
            //   yesBtn.attr('ng-click', yesCbFn + '(' + field + ')');
        }
        tempElement.append(footerElem);


        $scope.modalInstance = $modal.open({
            template: tempElement,
            size: "375px",
            backdrop: "static",
            keyboard: false,
            modalFade: true,
            scope: modalScope ? modalScope : $rootScope,
            // draggable : true,
            // resizeable : false,
            windowClass: "modal-alert " + popupClass
            // controller:
        });
        if (closeCallBack) {
            $scope.modalInstance.result.then(function () {
                closeCallBack();
            });
        }
        $scope.alertBoxes.push($scope.modalInstance);
        $scope.modalInstance = null;
        stopLoader();
    };

    $rootScope.basicCnfTrue = function (field) {
        // var field = JSON.parse(field);
        if (angular.isDefined(field.properties["onClick"]["success"]) && (field.properties["onClick"]["success"].toString().trim().length > 0)) {
            switch (field.properties["onClick"]["success"]) {
                case "commentBox":
                    $scope.openCommentDialog(field.openCommentDialogVar.temp, field.openCommentDialogVar.modal);
                    break;
                case "closePopUp":
                    if ($scope.isCdrCreateExternalContactFlow && $scope.isCdrCreateExternalContactFlow()) {
                        $scope.handleCdrCreateExternalContactCancel();
                        break;
                    }
                    // alert("in if of close");
                    // code to close the poup....
                    if ($scope.currentOuterPopup && ($scope.currentOuterPopup !== null)) {
                        $($scope.currentOuterPopup).dialog("close");
                        $scope.applyBasePageJson();
                        // alert("in if of close");
                    }
                    // $scope.cancelNgPopUp();
                    if ($rootScope.myModelInstance) {
                        $rootScope.myModelInstance.close();
                        $rootScope.myModelInstance = null;
                        $scope.modalInstances.forEach(function (d) {
                            var modalToClose = angular.copy(d);
                            modalToClose.close();
                        });
                        $scope.modalInstances = [];

                        $scope.applyBasePageJson();
                        // alert("in else of close");
                    }
                    $scope.cancel();
                    // $scope.cancel();
                    break;
                case "directNonAjax":
                    if ($scope.isCdrCreateExternalContactFlow && $scope.isCdrCreateExternalContactFlow()) {
                        $scope.handleCdrCreateExternalContactCancel();
                        break;
                    }
                    $location.path(urlFactory.convertUrlfromAPI(field.api, false));
                    // if (!$scope.$$phase) {
                        $scope.$applyAsync();
                    // }
                    break;
                case "notification":
                    const args = {
                        popupType: 'alert',
                        str: "noti-msg-3",
                        heading: intl_msg[24153],
                        yesCbFn: cancelString,
                        yesName: 'yes',
                    }
                    SirionUtils.openSirionDialogs(args);
                    break;
            }


        } else if(field.properties && field.properties.captcha && field.properties.onClick && field.properties.onClick['name'] == "submitData") {
            if(SirionUtils.confirmCaptcha()) {
                if ($rootScope.alertBoxes.length > 0) {
                    let modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                    modalToClose.close();
                }
                $showPageBtnClickService.submitData.call(this, field, true);
            }
        }
    }
    $rootScope.basicCnfFalse = function (field) {
        // var field= JSON.parse(field);
        if ($scope.modalInstance) {
            $scope.modalInstance.close();
        }
        if (angular.isDefined(field.properties["onClick"]["error"]) && (field.properties["onClick"]["error"].toString().trim().length > 0)) {
            switch (field.properties["onClick"]["success"]) {
                case "commentBox":
                    $scope.openCommentDialog(field.openCommentDialogVar.temp, field.openCommentDialogVar.modal);
                    break;
                case "closePopUp":
                    // console.log(" pp :",controllerScope.currentOuterPopup);
                    // code to close the poup....
                    $($scope.currentOuterPopup).dialog("close");
                    $scope.applyBasePageJson();
                    break;
                case "directNonAjax":
                    if ($scope.isCdrCreateExternalContactFlow && $scope.isCdrCreateExternalContactFlow()) {
                        $scope.handleCdrCreateExternalContactCancel();
                        break;
                    }
                    $location.path(urlFactory.convertUrlfromAPI(field.api, false));
                    // if (!$scope.$$phase) {
                        $scope.$applyAsync();
                    // }
                    break;
                case "notification":
                    const args = {
                        popupType: 'alert',
                        str: "noti-msg-4",
                        heading: intl_msg[24153],
                        yesCbFn: cancelString,
                        yesName: 'yes',
                    }
                    SirionUtils.openSirionDialogs(args);
                    break;
            }
        } else if(field.properties && field.properties.captcha && field.properties.onClick && field.properties.onClick['name'] == "submitData"){
            $scope.cancel();
        }
    }
    $rootScope.confirmCnfTrue = function (field) {
        $scope.cancel();
        let animateIcon = false;
        if ($rootScope.bulkedit || (field.api && field.api.indexOf("/commentAttachments/bulkSave") > -1)) {
            animateIcon = true;
        }
        $showPageBtnClickService.handleSubmitData(field, $scope, animateIcon);
    }
    $rootScope.deleteCnfTrue = function (field) {
        if(SirionUtils.confirmCaptcha()){
            $scope.cancel();
            if (field.properties["onClick"]["success"] === "commentBox") {
                $scope.openCommentDialog(field.openCommentDialogVar.temp, field.openCommentDialogVar.modal);
            } else {
                // window.location.href = field.api;
                var serverResponse = $scope.submitData(field.api, $scope.data, "POST");
                serverResponse.then(function (data) {
                    $scope.responsePopUp(data,null,field);
                    //$rootScope.$emit("updateTasks");
                });

            }
        }
    }
    $rootScope.confirmCnfFalse = function (field) {
        $scope.cancel();
    }

    $rootScope.deleteCnfFalse = function (field) {
        $scope.cancel();
        if ((field.properties["onClick"]["successOnBoth"])) {
                if ((angular.isDefined(field.properties["onClick"]["success"]))) {
                    switch (field.properties["onClick"]["success"]) {
                        case "commentBox":
                            $scope.openCommentDialog(field.openCommentDialogVar.temp, field.openCommentDialogVar.modal);
                            break;
                        case "directAjax":
                            document.createElement('tabset');
                            document.createElement('tab');
                            document.createElement('dynamic-form');
                            document.createElement('my-table');
                            document.createElement('ng-form');
                            $scope.submitData(field.api, $scope.data, field.requestType, true);
                            ($("#kk").html('<div tabset=""><div tabset=""  ng-repeat="tab in layout.fields track by $index" heading="{{tab.label}}"><div data-ng-switch="tab.type"><form data-ng-switch-when="basic" ng-if="header.response.type == basic"><div id="mainForm"><div dynamic-form-new=""  template="tab.fields" ng-model="data" ><!-- rt --></div></div><div class="submit"><div dynamic-form-new=""  class="col-md-12" template="tab.actions" ng-model="data" ><!-- fdjsf --></div></div></form><form data-ng-switch-when="basic" ng-if="header.response.type == popup " showinpopup=""></form><form data-ng-switch-when="tabular" ><div ng-repeat="field in tab.fields"><div id="tabs-inner-sec" ><p>{{field.label}}</p><table my-table=""  option="{{field.fields[0]}}"><!-- some comment should be there --></table></div></div></form></div></div></div>'));
                            $compile("#kk")($scope);
                            break;
                        case "directNonAjax":
                            if ($scope.isCdrCreateExternalContactFlow && $scope.isCdrCreateExternalContactFlow()) {
                                $scope.handleCdrCreateExternalContactCancel();
                                break;
                            }
                            $location.path(urlFactory.convertUrlfromAPI(field.api, false));
                            // if (!$scope.$$phase) {
                            $scope.$applyAsync();
                            // }
                            break;
                        case "closeParent":
                            $(field.properties["onClick"]["success"]["popUpId"]).hide();
                            break;
                        default:
                    }
                }
            }

    }
    $rootScope.cnfTrue = function (field) {

        $scope.cancel();
        var hierarchyData = {}; // that is to be sent in the case of
        // basicConfirmation with successOnBoth...
        hierarchyData.values = true;
        // Also push this object into scope data(data to be post)
        $scope.data && ($scope.data["hierarchyData"] = hierarchyData);
        switch (field.properties["onClick"]["success"]) {
            case "commentBox":
                $scope.openCommentDialog('commentBox' + gFieldModel.replace(/\./g, "_"), commentForm);
                break;
            case "submitData":
                $scope.submitData(field.api, $scope.data, field.requestType, true);
                break;
            case "closePopUp":
                if ($scope.isCdrCreateExternalContactFlow && $scope.isCdrCreateExternalContactFlow()) {
                    $scope.handleCdrCreateExternalContactCancel();
                    break;
                }
                $scope.supplierCreationTitle = '';
                if($scope.showlineItemCommentBox){
                    $scope.showlineItemCommentBox=false;
                    $scope.showlineItemPopup.visible=false;
                    $rootScope.showPagePermissionObj.showPageBulkAction=false;
                }
                if($rootScope.showPagePermissionObj.showPageBulkAction == true ){
                    if($scope.showBulkActionDialog.visible == true){
                        $scope.showBulkActionDialog.visible = false;
                    }
                    $rootScope.cancelPp();
                }
                else if ($scope.currentOuterPopup && ($scope.currentOuterPopup !== null)) {
                    // alert("under close if");
                    $($scope.currentOuterPopup).dialog("close");
                    $scope.applyBasePageJson();
                } else if(_.get($scope.showBulkAmendmentDialog,"visible")) {
                    $rootScope.myModelInstance && $rootScope.myModelInstance.close();
                } else {
                    // alert("under close else");
                    if ($scope.myModelInstance) {
                        $scope.myModelInstance.close();

                        $scope.myModelInstance.closed.then(function () {
                            $scope.modalInstances = [];
                            $scope.applyBasePageJson();
                        });
                    }
                    if($scope.rawDataCommentBox){
                        $scope.rawDataCommentBox=false;
                        $scope.showRawDataPopup.visible=false;
                    }
                    if($scope.showlineItemCommentBox){
                        $scope.showlineItemCommentBox=false;
                        $scope.showlineItemPopup.visible=false;
                    }
                }
                if($scope.fromSupplierDropdown){
                    $scope.closeSupplierModal();
                }
                break;
            case "directNonAjax":
                if ($scope.isCdrCreateExternalContactFlow && $scope.isCdrCreateExternalContactFlow()) {
                    $scope.handleCdrCreateExternalContactCancel();
                    return;
                }
                sessionStorage.removeItem('wf_id');
                delete $rootScope.createForWorkflowId;
                var isDefCreateToList = false;
                if ($scope.isStakeHolderInlineEdit) {
                    $scope.closeExternalContactModal();
                    return;
                }
                if($rootScope.createTemplateStructure && docTreeService.showPlaybook){
                    docTreeService.showPlaybook = false;
                    $scope.forceHideRightSec = false;
                    $rootScope.hideCommentToggle = true;
                }
                if(field && field.api && field.api.indexOf("/listRender/271")!= -1 && $rootScope.preSignature.crudPage
                    && window.location.href.indexOf("create/tblclause?isDefinition=true")!=-1){
                    isDefCreateToList=true;
                    field.api = "listRender/361";
                }
                if(field.api.indexOf('show')>-1 || field.api.indexOf('update')>-1 ){
                    $location.path(urlFactory.convertUrlfromAPI(field.api, false)+'').search({});
                }else{
                    $location.path(urlFactory.convertUrlfromAPI(field.api, false)).search({});
                }
                isDefCreateToList?$location.url($location.path()):angular.noop();
                // if (!$scope.$$phase) {
                    $scope.$applyAsync();
                // }
                break;
            case "notification":
                document.createElement('tabset');
                document.createElement('tab');
                document.createElement('dynamic-form');
                document.createElement('my-table');
                const args = {
                    popupType: 'alert',
                    str: "noti-msg-5",
                    heading: intl_msg[24153],
                    yesCbFn: 'cancel',
                    yesName: 'yes',
                }
                SirionUtils.openSirionDialogs(args);
                break;
        }
    }

    $scope.closeSupplierModal = ()=> {
        window.__supplierOwnedModalClose = true;
        window.sarc.channelBroadcast("reactDynamicForms", {
            actionType: "newlyCreatedSupplierDetails",
            payload: []
        }, `dfSubscriptions_${$scope.globalData.dynamicFormId}`);
        setTimeout(()=>{
            $scope.applyBasePageJson();
            $timeout(function () {
                delete window.__supplierOwnedModalClose;
            }, 1000);
        },300);
        $scope.supplierCreationTitle = '';
        if($rootScope.myModelInstance) {
            $rootScope.myModelInstance.close();
            $rootScope.myModelInstance = null;
        }
        $scope.isSupplierInlineEdit = false;
        $scope.fromSupplierDropdown = false;
    }

    $scope.closeExternalContactModal = ()=> {
        window.sarc.channelBroadcast("reactDynamicForms", {
            actionType: "newlyCreatedExternalContactDetails",
            payload: $scope.stakeHolderBBDetails
        }, `dfSubscriptions_${$scope.globalData.dynamicFormId}`);
        $scope.fromExternalUser = false;
        $scope.dynamicPageTitle = '';
        if($rootScope.myModelInstance) {
            $rootScope.myModelInstance.close();
            $rootScope.myModelInstance = null;
        }
        $scope.stakeHolderBBDetails = {};
        setTimeout(()=>{
            $scope.applyBasePageJson();
            $scope.setTimelineFeedDataScope(2);
        },500);
    }

    $rootScope.cnfFalse = function (field) {
        $scope.cancel();
    }
    $rootScope.successOnBothTrue = function (field) {
        var hierarchyData = {};
        hierarchyData.values = true;
        $scope.data["hierarchyData"] = hierarchyData;
        $scope.successOnBoth(field);
    }
    $rootScope.resetCloneCLIState = function () {
        $scope.isCloneCLIFrom = false;
        $scope.cancel();
    }
    $rootScope.successOnBothFalse = function (field) {
        var hierarchyData = {};
        hierarchyData.values = false;
        $scope.data["hierarchyData"] = hierarchyData;
        $scope.successOnBoth(field);
    }
    $rootScope.nextNotification = function () {
        var modalToClose;
        var field = $rootScope.parametersForNextDialog.field;
        if ($scope.alertBoxes.length > 0) {
            modalToClose = $scope.alertBoxes[$scope.alertBoxes.length - 1];
            modalToClose.close();
        }
        const args = {
            popupType: 'confirm',
            str: field.properties["onClick"]["message"],
            heading: field.properties["onClick"]["title"],
            yesCbFn: "successOnBothTrue",
            noCbFn: "successOnBothFalse",
            field: JSON.stringify(field),
        }
        SirionUtils.openSirionDialogs(args);
    }
    $rootScope.successOnBoth = function (field) {
        if(SirionUtils.confirmCaptcha() == false){
            return;
        }
        $scope.cancel();
        switch (field.properties["onClick"]["success"]) {
            case "commentBox":
                $scope.openCommentDialog('commentBox' + gFieldModel.replace(/\./g, "_"), commentForm);
                break;
            case "submitData":
                $scope.submitData(field.api, $scope.data, field.requestType, true);
                break;
            case "closePopUp":
                if ($scope.isCdrCreateExternalContactFlow && $scope.isCdrCreateExternalContactFlow()) {
                    $scope.handleCdrCreateExternalContactCancel();
                    break;
                }
                if ($scope.currentOuterPopup && ($scope.currentOuterPopup !== null)) {
                    // alert("under close if");
                    $($scope.currentOuterPopup).dialog("close");
                    $scope.applyBasePageJson();
                } else {
                    // alert("under close else");
                    if ($scope.myModelInstance) {
                        $scope.myModelInstance.close();
                        $scope.myModelInstance = null;
                        $scope.myModelInstance.result.then(function () {
                            $scope.modalInstances = [];
                            $scope.applyBasePageJson();
                        });
                    }
                }
                break;
            case "directNonAjax":
                if ($scope.isCdrCreateExternalContactFlow && $scope.isCdrCreateExternalContactFlow()) {
                    $scope.handleCdrCreateExternalContactCancel();
                    break;
                }
                $location.path(urlFactory.convertUrlfromAPI(field.api, false));
                // if (!$scope.$$phase) {
                    $scope.$applyAsync();
                // }
                break;
            case "notification":
                document.createElement('tabset');
                document.createElement('tab');
                document.createElement('dynamic-form');
                document.createElement('my-table');
                const args = {
                    popupType: 'alert',
                    str: "noti-msg-5",
                    heading: intl_msg[24153],
                    yesCbFn: 'cancel',
                    yesName: 'yes',
                }
                SirionUtils.openSirionDialogs(args);
                break;
        }
    }
    $rootScope.delFile = function (obj) {
        var d = obj;
        try {
            if (typeof  obj == 'string'){
                obj = JSON.parse(obj);
                d = obj.id;
            }

        } catch (e){

        }
        $("#scheduleForm .adv-textbox .singleFileUpload").fadeIn();
        if(obj.modelToRemove){SirionUtils.setValueOfNDepth($scope,obj.modelToRemove,null)}
        // extracting fileId/ docId from node
        const docId = $('#' + d)[0].attributes.file.nodeValue;
        // removing the deleted files from payload.
        $scope.nonDeletedFiles = _.remove(_.get($scope,'modiFiedData.comment.commentDocuments.values'),(doc)=>{
            return doc.key !== docId;
        });
        $("#" + d).remove();
        showPageService.setValueOfenableAddComment.call($scope);
        $scope.cancel();
    }
    $rootScope.notDelFile = function (d) {
        $scope.cancel();
    };
    $rootScope.notDelFile = function (d) {
        $scope.cancel();
    };

    $rootScope.removeDP = function (event, model) {
        if (event.keyCode == 8|| event.keyCode == 46) {
            var obj = event.target || event.srcElement;
            obj.value = "";
        }
    };

    $rootScope.getDateOptions = function (ngModelCntrl, timepicker) {
        var formatDate;
        if (timepicker == "true") {
            timepicker = true;
            formatDate = convertToJquiDateFormat($scope.globalData.datetimeFormatToShow);
        } else {
            timepicker = false;
            formatDate = convertToJquiDateFormat($scope.globalData.dateFormatToShow);
        }
        var updateModel = function (dateText) {
            $scope.$apply(function () {
                ngModelCntrl.$setViewValue(dateText);
            });
        };
        var options = {
            changeYear: true,
            dateFormat: formatDate,
            autoClose: true,
            controlType: 'select',
            timeFormat: (timepicker ? $scope.timeFormatForPicker : ""),
            showTimepicker: timepicker,
            onSelect: function (dateText) {
                updateModel(dateText);
                $(this).blur();
                if (window["newDatePickerObj"] && window["DP_jQuery_" + window["newDatePickerObj"]])
                    window["DP_jQuery_" + window["newDatePickerObj"]].datepicker._hideDatepicker();
            },
            showButtonPanel: timepicker
        };
        var cDate = $scope.getCurrentDate();
        cDate = cDate.split("-");
        var currDate;
        if (cDate.length < 2) {
            currDate = new Date();
        } else {
            currDate = new Date(parseInt(cDate[2]), parseInt(cDate[0]) - 1, parseInt(cDate[1]));
        }
        options.defaultDate = currDate;
        return options;
    }
    // formService (data)
    /*** Function to open work flow step dialog ****/
    $scope.workflowStepsDialog = function(fields,btnInfo,isServerSideValidation){
        var naField = false;
        fields.forEach(function(field,index){
            if(formService.isNotApplicableForWfPopupField(field) ){
                naField = true;
            }
        })
        if(naField && isServerSideValidation)return;
        $scope.wfFields = fields;
        $scope.wfsModalOpen = false;
        $scope.btnInfo = btnInfo;
        $scope.shouldIShowFieldErrorsVar = false;
        //$scope.validity = {};
        //$scope.errors = {}; /*  changes done for SIR-188225 */
        $scope.workflowStepsvalidation = true;

        if(angular.element('#jx-wfFields').length){
            $scope.olderModalPresence = true;
            $scope.modalInstance.close();
        }
        var modalTemplate = angular.element('<div class="modal-container"><div class="modal-header"><span>{{data.shortCodeId.values}} {{data.name.values}} </span></div></div>')
        modalTemplate.append(angular.element("<div class='modal-body'><form id='jx-wfFields'><span id='error_noti_span'>"+intl_msg[29089]+"</span><div class = 'fieldForm redesign' dynamic-form-new='' template='wfFields' ng-model='data'></div></form></div>"));

        var footerBtn = angular.element('<div/>',{'class':'modal-footer submit'})
            .append(angular.element('<a/>',{'text':intl_msg[23731],'ng-click':'closeWorkFlowStepDialog()','href':'javascript:void(0)','class':'submit-buttons'}))
            .append(angular.element('<a/>',{'title':'{{btnInfo.label}}','ng-if':'!btnInfo.properties.showCondition','ng-hide':'btnInfo.hideWorkflowButton || undoDisable && selectedButton!= btnInfo.label','data-clientValidation':"{{btnInfo.clientValidation}}",'data-specificFieldValidation':'{{btnInfo.properties.onClick.specificFieldValidation}}','data-dontTouchThisButton':'{{btnInfo.properties.dontTouchThisButton}}','ng-click':'btnClick($event,btnInfo)','text':'{{btnInfo.label}}','href':'javascript:void(0)','class':'submit-buttons okBtn'}));

        modalTemplate.append(footerBtn);
        var modalInstance = $modal.open({
            template: modalTemplate,
            size: "lg",
            backdrop: "static",
            keyboard: false,
            scope:$scope,
            windowClass: "workflowStepPopup sirion2Newuser"
        });
        modalInstance.opened.then(function () {
            $scope.shouldIShowFieldErrorsVar = false;
            $scope.wfsModalOpen = true;
            showPageService.preventLabelClick();
        });
        modalInstance.closed.then(function () {
            if($scope.olderModalPresence){
                $scope.olderModalPresence = false;
            }else{
                $scope.wfFields = '';
                $scope.btnInfo = '';
                $scope.shouldIShowFieldErrorsVar = false;
                $scope.validity = {};
                $scope.errors = {};
                $scope.workflowStepsvalidation = false;
                if($scope.showInWorkspace){
                    if($scope.showMoreBtnDD){
                        $scope.showMoreBtnDD=false;
                    }
                    $scope.workFlowButtons=null;
                    $scope.wfsModalOpen = false;
                    $timeout(function(){angular.element($scope.workSpaceViewListData.currentElement).click();},0);
                }else{
                    $route.reload();
                }

            }

        });
        // $scope.modalInstance = null;
        $scope.closeWorkFlowStepDialog = function(){
            modalInstance.close();
        }
    };

    $scope.confirmAlertDialog = function (str, heading, yesCbFn, noCbFn, field, yesName, noName, rmvCloseBtn, type,_customClass,onlyYesButton) {
        var yesBtn, noBtn;
        heading = heading.toLowerCase();
        if(heading=="confirmation"){
            heading = intl_msg[25772];
        }
        if (window.entityURLdata && window.entityURLdata.indexOf("/contracttemplate/new") > -1 && yesCbFn && yesCbFn == "delFile") {
            //do nothing
        } else if (window.entityURLdata && (window.entityURLdata.indexOf("/contracttemplate/clone") > -1 || window.entityURLdata.indexOf("/contracttemplate/new") > -1 || window.entityURLdata.indexOf("/clause/new") > -1 || window.entityURLdata.indexOf("/clause/clone") > -1)) {
            var fieldJson = $.parseJSON(field);
            if (fieldJson.api && fieldJson.api.indexOf("listRenderer/list")) {
                fieldJson.api = fieldJson.api.replace('listRenderer/list', 'listRender');
            }
            field = JSON.stringify(fieldJson);
        }
        if(type=="button") {
            var tempElement = formService.ButtonWorkFlowMessage(rmvCloseBtn,heading,str);
        }
        else {
            if (rmvCloseBtn) {
                var tempElement = angular.element('<div><div class="modal-header rmvCloseBtn">' + heading + '</div><div class="modal-body"><span class="success-icon">' + str + '</span></div>');
            } else {
                var tempElement = angular.element('<div><div class="modal-header">' + heading + '<span class="'+(_customClass?_customClass.close:"")+' icon-close" ng-click="cancel(true)"></span></div><div class="modal-body"><span class="success-icon">' + str + '</span></div>');
            }
        }
        var footerElem = angular.element('<div class="modal-footer"></div>');
        var yesCustomClass =  _customClass?_customClass.yes:"";
        var noCustomClass =    _customClass?_customClass.no:"";
        if (field && field.indexOf(":") == -1) {
            var yesLabel = yesName ? yesName : intl_msg[25815];
            var noLabel = noName ? noName : intl_msg[25816];
            yesBtn = angular.element('<button class="'+yesCustomClass+'"  ng-click="' + yesCbFn + '(\'' + field + '\')">' + yesLabel + '</button>');
            noBtn = angular.element('<button class="'+noCustomClass+'" ng-click="' + noCbFn + '(\'' + field + '\')">' + noLabel + '</button>');
        } else {
            var yesLabel = yesName ? yesName : intl_msg[25815];
            if( typeof onlyYesButton == "undefined" ){
                var noLabel = noName ? noName : intl_msg[25816];
                noBtn = angular.element('<button class="'+noCustomClass+'">' + noLabel + '</button>');
                noBtn.attr('ng-click', noCbFn + '(' + field + ')');
            }
            yesBtn = angular.element('<button class="'+yesCustomClass+'">' + yesLabel + '</button>');
            yesBtn.attr('ng-click', yesCbFn + '(' + field + ')');

        }
        footerElem.append(yesBtn);
        footerElem.append(noBtn);
        tempElement.append(footerElem);
        var fieldJ = null;
        if($.type(field) == 'string'){
            try {
                fieldJ = JSON.parse(field);
            } catch(e){
                fieldJ = {};
            }
        }
        if (fieldJ && fieldJ.name && fieldJ.name.toLowerCase() == "cancel" || (_.has(fieldJ, "properties.onClick.success") && fieldJ.properties.onClick.success == "closePopUp")) {
            var popupClass = " sirionconfirmPopup";
        } else if (fieldJ && fieldJ.name && fieldJ.name.toLowerCase() == "success") {
            var popupClass = " sirionsucessPopup";
        } else {
            var popupClass = " sirionerrorPopup";
        }

        $scope.modalInstance = $modal.open({
            template: tempElement,
            size: "375px",
            backdrop: "static",
            keyboard: false,
            scope:$scope,
            windowClass: "modal-alert "+popupClass
        });

        $scope.alertBoxes.push($scope.modalInstance);
        $scope.modalInstance = null;
        return;
    };


    $("#angularPopUpHtml, #showdialog, #mainContainer").scroll(function () {
        if ($('textarea').hasClass('expand')) {
            $('textarea').removeClass('expand');
        }
        if ($(".ui-datepicker").is(":visible")) {
            $(".ui-datepicker").css("display", "none");
        }
    });
    // formService
    var elemToAppend = "";
    $scope.validateClause = function (record, that) {

        if ($("#angularPopUpHtml").length > 0) {
            elemToAppend = "#angularPopUpHtml ";
        } else if ($scope.currentOuterPopup === "showdialog") {
            elemToAppend = "#showdialog ";
        } else if ($scope.currentOuterPopup === "#showdialog") {
            elemToAppend = "#showdialog ";
        }

        var chkData = that.attr("rel");
        var checkEntryInTab = false;
        // $scope.chkId = Number($(that).attr("id"));//
        $scope.categorydata = chkData.split(",");
        if ($(that).is(":checked")) {
            chkClick = $(that);
            if (!$scope.data.clauseCategoryTableData.values.length) {
                $scope.data.clauseCategoryTableData.values = [];
                $scope.categoryDataInd = 0;
                $scope.addOrUpdateClause($scope.categorydata, "new");
                return;
            }
            for (var t = 0; t < $scope.data.clauseCategoryTableData.values.length; t++) {
                if ($scope.data.clauseCategoryTableData.values[t] &&
                    $scope.data.clauseCategoryTableData.values[t]["clauseCategory"] &&
                    $scope.data.clauseCategoryTableData.values[t]["clauseCategory"].id == $scope.categorydata[2]) {
                    $scope.categoryDataInd = t;
                    if ($scope.data.clauseCategoryTableData.values[t]["clause"]) {
                        const args = {
                            popupType: 'confirm',
                            str: intl_msg[23563],
                            heading: intl_msg[25772],
                            yesCbFn: "addOrUpdateClause",
                            noCbFn: "removeAndUpdateClause",
                            field: JSON.stringify(record),
                        }
                        SirionUtils.openSirionDialogs(args);
                        checkEntryInTab = true;
                    } else {
                        $scope.addOrUpdateClause($scope.categorydata, "update");
                        return
                    }
                } else if (checkEntryInTab == false && t == $scope.data.clauseCategoryTableData.values.length - 1) {
                    $scope.addOrUpdateClause($scope.categorydata, "new");
                    return;
                } else {
                    checkEntryInTab = false
                }
            }
        } else {
            $scope.removeAndUpdateClause(null, $scope.categorydata);
        }
    };
    $scope.orderVal = 1;
    $scope.addOrUpdateClause = function (a, type) {
        var modalToClose;
        if ($rootScope.alertBoxes.length > 0) {
            modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
            modalToClose.close();
        }
        if (modalToClose) {
            modalToClose.result.then(function () {
                $rootScope.alertBoxes.pop();
            });
        }
        var a = $scope.categorydata;
        var t = {};
        var ordrArr = [];

        // add unique values
        function odr(r) {
            ordrArr = [];
            $("input[name='order']").each(function () {
                if ($(this).val()) {
                    ordrArr.push(Number($(this).val()));
                }

            })
            if (ordrArr.indexOf(r) > -1) {
                odr(r + 1);
            } else {
                $scope.orderVal = r;
                return r;
            }
        }

        t.clauseCategory = {
            "id": a[2],
            "name": a[3]
        };
        t.clause = {
            "id": a[0],
            "name": a[1]
        };
        if (type == "new") {
            var y = odr($scope.orderVal)
            t.order = y ? y : $scope.orderVal; // model value
            if (!($scope.data.clauseCategoryTableData.values[0] && $scope.data.clauseCategoryTableData.values[0].clauseCategory)) {
                $scope.data.clauseCategoryTableData.values[0] = t;
            } else {
                $scope.data.clauseCategoryTableData.values.push(t);
            }
        } else if (type == "update") {
            t.clause = {
                "id": a[0],
                "name": a[1]
            };
            $scope.data.clauseCategoryTableData.values[$scope.categoryDataInd].clause = t.clause;
        } else {
            t.clause = {
                "id": a[0],
                "name": a[1]
            };
            var f = $scope.data.clauseCategoryTableData.values[$scope.categoryDataInd].clause.id;
            if (a[0] == f) {
                return;
            }
            if (elemToAppend != "") {
                $(elemToAppend).find("#chkid_" + f).removeAttr("checked");
            } else {
                $("#chkid_" + f).removeAttr("checked");
            }
            // $scope.checkBoxInd[$scope.categorydata[2]] = $scope.chkId;
            $scope.data.clauseCategoryTableData.values[$scope.categoryDataInd].clause = t.clause;
        }
        // if (!$scope.$$phase) {
        $scope.$applyAsync();
        // }
    };
    $scope.removeAndUpdateClause = function (b, rec) {
        if (b != null && typeof (b) == "object") {
            var modalToClose;
            if ($rootScope.alertBoxes.length > 0) {
                modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                modalToClose.close();
            }
            if (modalToClose) {
                modalToClose.result.then(function () {
                    $rootScope.alertBoxes.pop();
                });
            }
            chkClick.removeAttr("checked");
            return;
        }
        var r;
        var ts = $scope.showColifTs;
        if (b != null) {
            rec[2] = $(rec)[0].item.clauseCategory.id;
            if (elemToAppend != "") {
                if ($(rec)[0].item.clause) {
                    $(elemToAppend).find("#chkid_" + $(rec)[0].item.clause.id).removeAttr("checked");
                }
            } else {
                if ($(rec)[0].item.clause) {
                    $("#chkid_" + $(rec)[0].item.clause.id).removeAttr("checked");
                }
            }
        }
        angular.forEach($scope.data.clauseCategoryTableData.values, function (v, i) {
            if (v.clauseCategory.id == rec[2]) {
                r = i; // $scope.data.clauseCategoryTableData.values[i];
                return;
            }
        })
        if (ts) {
            $scope.data.clauseCategoryTableData.values[r].clause = "";
            // $scope.data.clauseCategoryTableData.values[r].order="";
        } else {
            if ($scope.data.clauseCategoryTableData.values.length == 1) {
                $scope.data.clauseCategoryTableData.values[0].clauseCategory = {}
                $scope.data.clauseCategoryTableData.values[0].clause = {}
                $scope.data.clauseCategoryTableData.values[0].order = ""
                delete $scope.data.clauseCategoryTableData.values[0];
            } else {
                $scope.data.clauseCategoryTableData.values.splice(r, 1);
            }
        }
        // if (!$scope.$$phase) {
            $scope.$applyAsync();
        // }
    };
    $scope.$watch('data.clauseCategoryTableData.values', function (newVal, oldVal) {

    })
    // $(document).on("blur","[checkUnique='true']",function(){
    // $scope.validateOrder($(this));
    // });
    $scope.validateUniqueColumnValue = function (that) {
        var c = 0;
        var t;
        /*
         * if(that){ valTovalid = that.val(); }else{
         */
        valTovalid = "";
        // }
        var gt = [];
        $("[checkUnique='true']").each(function () {
            if (gt.indexOf($(this).attr("name")) < 0) {
                gt.push($(this).attr("name"))
            }
        });
        var parentClass = that.attr("rel");
        for (var k = 0; k < gt.length; k++) {
            $("." + parentClass).find("[checkUnique='true']").each(function () {
                if ($(this).attr("name") == gt[k]) {
                    if ($(this).val() == valTovalid) {
                        c++;
                        if (c > 1)
                            $(this).val("").addClass("errorClass");
                             $scope.changeErrorCount();
                    }
                }
            })
        }
        const args = {
            popupType: 'alert',
            heading: intl_msg[24153],
            yesCbFn: cancelString,
            yesName: intl_msg[24184],
        }
        if ($scope.mandatoryField && !($scope.data.clauseCategoryTableData.values && $scope.data.clauseCategoryTableData.values[0].catgory)) {
            args.str = $scope.mandatoryField;
            SirionUtils.openSirionDialogs(args);
            return true;
        }
        if (c > 1) {
            args.str = intl_msg[24183];
            SirionUtils.openSirionDialogs(args);
            return true;
        }
        return false;
    };

    $scope.recordValidataion = function (data, fieldName, fieldToCheck) {
        // data=[]&= data.clausecategory.values
        for (var k = 0; k < data.length; k++) {
            if (data[k][fieldName] == true) {
                if (!data[k][fieldToCheck]) {
                    const args = {
                        popupType: 'alert',
                        str: intl_msg[24190] + " " + fieldToCheck + " " + intl_msg[24190] + " " + fieldName + " ",
                        heading: intl_msg[24153],
                        yesCbFn: cancelString,
                        yesName: intl_msg[24184],
                    }
                    SirionUtils.openSirionDialogs(args);
                    return true;
                }
            }
        }
        return false;
    }
    $scope.submitQueryFunc = function (sc, id, type) {
        var scope = $rootScope["tableScopeMapper"][sc.field.id];
        var checkedBoxes = scope.selectedCheckBoxes;
        var request = scope.field.fields[id].properties.requestType;
        var apiURL = scope.field.fields[id].properties.api;
        var commentLabel = scope.field.fields[id].label;
        var count;
        if (scope.getTotalListDataCount() != scope.getSelectedCheckBoxLength()) {
            count = scope.getSelectedCheckBoxLength();
        }
        else {
            count = scope.getTotalListDataCount();
        }

        var dataToPost = {},
            childSlaId = "";

        if (scope.data && scope.data.comment && scope.data.comment.comments) {
            scope.data.comment.comments.values = "";
        }
        if (scope.data && scope.data.comment && scope.data.comment.actualDate && scope.data.comment.actualDate.values) {
            delete scope.data.comment.actualDate.values;
        }
        if (scope.data && scope.data.comment && scope.data.comment.requestedBy && scope.data.comment.requestedBy.values) {
            delete scope.data.comment.requestedBy.values;
        }
        if (scope.data && scope.data.comment && scope.data.comment.changeRequest && scope.data.comment.changeRequest.values) {
            delete scope.data.comment.changeRequest.values;
        }
        if (scope.data && scope.data.comment && scope.data.comment.privateCommunication) {
            scope.data.comment.privateCommunication.values = false;
        }

        if (scope.data && scope.data.id && scope.data.id.values) {
            childSlaId = scope.data.id.values;
        }
        if (type == 2) {
            if (checkedBoxes.length == 0 && selAllBoxes == false) {
                Toaster.create(intl_msg[23564],{iconClass:"icon-Information_filled"});
                return;
            }
        }
        /*
         * else if (type == 0 && $(".textareaQuery textarea").val() == "") {
         * alertDialog("Please enter some query!"); return; }
         */
        if (request == "get" || request == "GET") {
            dataToPost = {
                objectIds: values,
                size: 1,
                childSlaId: childSlaId
            };
            var promise = requestData("GET", apiURL, dataToPost);
        } else {
            startLoader();
            fltrQuery = $("#elasticSearchFilter textarea").val().replace(/\n/g, "");

            dataToPost = {
                filterQuery: fltrQuery,
                childSlaId: childSlaId
            };

            if (type == 2) {
                var values = [];

                if ($("input#selectAllCheck:checked").length == 1) {
                    dataToPost.selectAll = true;
                    if (ignoredChecked.length != 0) {
                        $.each(ignoredChecked, function (a, b) {
                            values.push(b);
                        });
                    }
                } else {
                    if (checkedBoxes.length != 0) {
                        $.each(checkedBoxes, function (a, b) {
                            values.push(b);
                        });
                    }
                }
                dataToPost.objectIds = values;
            } else if (type == 0) {
                dataToPost.offset = 0;
                dataToPost.size = 1;
            }
            if (apiURL == "/sldetails/globallist") {
                var promise = requestData("POST", apiURL, dataToPost);
                showPageBulkActionService.filerRawDataQuerySuccess(promise, scope, type);
                return;//Exit of filter query search.
            }
        }


        var formUrl = "/commentAttachments/form/" + scope.data.entityTypeId.values + '/' + scope.data.id.values;
        $scope.showRawDataPopup.visible=true;
        $window.jsonApi = formUrl;
        $scope.$applyAsync();
        $rootScope.showPageBulkActionData["rawData"] = {};
        $rootScope.showPageBulkActionData["rawData"]["api"] = apiURL;
        $rootScope.showPageBulkActionData["rawData"]["dataToPost"] = showPageBulkActionService.parseRawDataToResponseStructureFormat(dataToPost);
        $rootScope.showPageBulkActionData["rawData"]["commentLabel"] = commentLabel;
        $rootScope.showPageBulkActionData["rawData"]["count"] = count;
        $rootScope.showPageBulkActionData["rawData"]["fieldId"] = sc.field.id;
        $rootScope.showPageBulkActionData["rawData"]["type"] = type;
    }

    $scope.changeVisibility = function (a) {
        $scope.showOptionConditn = !$scope.showOptionConditn;
        $("#elem_" + a).closest("div").find(".coveringParent").hide();
        $("#elem_" + a).closest(".coveringParent").show();
        // set ng-show variable
        // empty other value
        // if (!$scope.$$phase) {
            $scope.$applyAsync();
        // }
    }
    $scope.buttonRedirectCDR = function (e,shortId, id, isEditable, clauseAssembly) {
        if( $(e.currentTarget).hasClass("ng-hide") || (e.clientX == 0 && e.clientY == 0) ){
            return;
        }
        $rootScope.mappedTemplateListCDR = [];
        $rootScope.globalCdrTemplateList = {};
        if ($scope.data.mappedContractTemplates && $scope.data.mappedContractTemplates.values && $scope.data.mappedContractTemplates.values.length > 0) {
            if (isEditable) {
                var apiUrl = addtStamp(appName + "/tblcdr/findMappedContractTemplate?entityId=" + $scope.data.id.values + "&entityTypeId=" + $scope.data.entityTypeId.values);
                $http.get(apiUrl).then(function (response) {
                    // API to get the updated mappedContractTemplates data with validation and validationRules

                    var mappedContractTemplatesObject = [];
                    if (response.data && response.data.data && response.data.data.mappedContractTemplates) {
                        mappedContractTemplatesObject = response.data.data.mappedContractTemplates;
                    }
                    var templateMap = {};
                    angular.forEach(mappedContractTemplatesObject, function (templ) {
                        templ.checked = 1;
                        templateMap[templ.id] = templ;
                        if (templ.mappedContractTemplates && templ.mappedContractTemplates.length > 0) {
                            $scope.updateCheckedProp(templ.mappedContractTemplates);
                        }
                    });
                    $rootScope.copyTemplateList = mappedContractTemplatesObject;
                    $rootScope.copyTemplateMap = templateMap;
                    $rootScope.copyTemplateDateFormat = response.data.data.dateFormatToShow;
                    $scope.redirectToTemplateSuggPage(shortId, id, clauseAssembly);
                });
            } else {
                $scope.getMappedTemplateList($scope.data.mappedContractTemplates.values);
                $scope.redirectToTemplateSuggPage(shortId, id, clauseAssembly);
            }
        } else {
            $scope.getMappedTemplateList($scope.data.mappedContractTemplates.values);
            $scope.redirectToTemplateSuggPage(shortId, id, clauseAssembly);
        }
    }

    $scope.redirectToExtractedData = function(typeid,id){
        let entityTypeName = null;
        if(numToURLPartMapping[typeid]) {
            entityTypeName = NumToURLPartMapping[typeid].replace("tbl","");
        }
        window.location.href = '#/autoExtraction/'+entityTypeName+'/'+id;
    }

    $scope.redirectToTemplateSuggPage = function (shortId, id, clauseAssembly) {
        //  Function to add existing mappedContractTemplates data to global cdr object and redirect to template suggestion page

        if($scope.data.mappedContractTemplates && $scope.data.mappedContractTemplates.values && $scope.data.mappedContractTemplates.values.length > 0){
            $rootScope.globalCdrTemplateList = angular.copy($scope.data.mappedContractTemplates.values);
        }
        var url = "";
        if(clauseAssembly){
            if(!_.has($scope.data, "agreementType.values.id")){
                Toaster.create(intl_msg[30117] || "Please Select Agreement Type",{iconClass:"icon-Information_filled"});
               return;
            }
            var mapper = {160:"cdr",61:'contracts'};
            url = "#/clauseAssembly/"+mapper[$scope.data.entityTypeId.values]+"/"+id+"/"+$scope.data.agreementType.values.id;
        } else if(shortId.indexOf("CO") > -1){
            url = '#/templateWizard/contracts/'+id;
        } else if(shortId.indexOf("CDR") > -1) {
            url  = '#/templateWizard/cdr/'+id;
        }
        window.location.href = url;
    }

    $scope.updateCheckedProp = function (template) {
        angular.forEach(template, function (templ) {
            templ.checked = 1;
            if (templ.mappedContractTemplates && templ.mappedContractTemplates.length > 0) {
                $scope.updateCheckedProp(templ.mappedContractTemplates);
            }
        });
    }
    $scope.getMappedTemplateList = function (templates) {
        angular.forEach(templates, function (templ) {
            $rootScope.mappedTemplateListCDR.push(templ.id);
            if (templ.mappedContractTemplates && templ.mappedContractTemplates.length > 0) {
                $scope.getMappedTemplateList(templ.mappedContractTemplates);
            }
        });
    }
    $scope.showTagsDefTab = function (tab, event) {
        clampElem($(".clauseHeader, .coveringParent:first-child .tagdetailValue .content-left"),2);
        const sc = $('[show-clause-definition]').scope();
        $scope.showTagTabOnClause = true;
        if($('[show-clause-definition]').length && sc) {
            sc.activeTab = tab;
            sc.autoScrollTags();
        }
    }

    $scope.hideTagsDefTab = function (event) {
        $scope.showTagTabOnClause = false;
    }

    $scope.toggleTemplatePanel = function(event){
        $scope.showTagTabOnTemplate = !$scope.showTagTabOnTemplate
        $scope.timeLineFeedScope = undefined;
        $scope.expandLeftSection = true;
        $scope.commentDataScope =-1;
        $scope.timeLineFeedSecActive = false;
    }

    $scope.clauseTagPermission = false;
    $scope.clauseDefinitionsPermission = false;
    var updateTagsDefnCountEvt = $scope.$on('updateTagsDefnCount',
        function (event, tagsCount, definitionCount, clauseTagPermission, clauseDefinitionsPermission, clauseLabel, defnLabel) {
            $rootScope.tagsCount = tagsCount;

            $scope.definitionCount = definitionCount;
            $scope.clauseTagPermission = clauseTagPermission;
            $scope.clauseDefinitionsPermission = clauseDefinitionsPermission;
            $scope.clauseLabel = clauseLabel;
            $scope.defnLabel = defnLabel;
        }
    );
    var updateTagsCountEvt = $scope.$on('updateTagsCount', function (event, permission, label) {
        $scope.clauseTagPermission = permission;
        $scope.clauseLabel = label;
    });
    var updateDefnCountEvt = $scope.$on('updateDefnCount', function (event, permission, label) {
        $scope.clauseDefinitionsPermission = permission;
        $scope.defnLabel = label;
    });

    /***** SIR-58381 -Docusign integration changes ********/
    $scope.selectedDocForSign = [];
    /* selectedDocForSign : variable to store selected documents */
    $scope.selectedUserForSign = [];
    /* selectedUserForSign : variable to store selected users for signature */
    $scope.storedUserIdForSign = [];
    /* listener function of "updateSelectedDoc" event ==> sets the selected doc */
    var updateSelectedDocEvt = $scope.$on('updateSelectedDoc', function (event, args) {
        var temp = args.selectedDoc;
        if (temp == 'clearSelectedDoc') {
            var deselectedDocuments = args.deselectedElements;
            for (var k = 0; k < deselectedDocuments.length; k++) {
                var deleteIndex = _.findIndex($scope.selectedDocForSign, function (o) {
                    return o.documentId == deselectedDocuments[k].documentId;
                })

                if (deleteIndex > -1) {
                    $scope.selectedDocForSign.splice(deleteIndex, 1);
                }
            }
        } else if(args.checked && angular.isArray(temp)){
            for(var i=0;i<temp.length;i++){
                if( _.findIndex($scope.selectedDocForSign,function(o){
                        return o.documentId == temp[i].documentId;
                    })== -1)
                    $scope.selectedDocForSign.push(temp[i]);
            }
        } else if (args.checked && _.findIndex($scope.selectedDocForSign, function (o) {
                return o.documentId == temp.documentId
            }) == -1) {
            $scope.selectedDocForSign.push(args.selectedDoc);
        } else if (!args.checked) {
            _.remove($scope.selectedDocForSign, function (o) {
                return o.documentId == temp.documentId
            });
        }
        if (angular.element('.jx-docCheckbox:checked').length == angular.element('.jx-docCheckbox').length) {
            angular.element('#jx-selectAllDocForSign').prop('checked', true);
        } else {
            angular.element('#jx-selectAllDocForSign').prop('checked', false);
        }

    });
    /*** $scope.enableDocCheckbox ==> function to be called on click of send for signature button ,
     * enables checkbox for documnets, show document selection bar ****/
    $scope.enableDocCheckbox = function () {
        if (!$scope.DocusignEnabled)
            $scope.DocusignEnabled = true;
        angular.element('#jx-sendForSign').hide();
        angular.element('.jx-docCheckbox').show();
        angular.element('#jx-selectAllDocDiv').show();
        angular.element('#jx-selectAllDocForSign').show();
        angular.element(".documentVersion").addClass("shiftVersion");
        angular.element('.jx-sendForSignBar').show();
        angular.element('.jx-docForSign').addClass('withCheckbox');
        $(".withoutCheckBoxDocusign").css('margin-left', "10px");
        if ($scope.selectedDocForSign.length > 0) {
            docuSignService.setCheckboxStatusForDocusign($scope.selectedDocForSign, angular.element('.jx-docCheckbox'));
        }
    };
    /*** $scope.cancelDocSelection==> function to be called on cancel,
     * disables checkbox for documnets, hide document selection bar ****/
    $scope.cancelDocSelection = function () {
        angular.element('#jx-sendForSign').show();
        angular.element('.jx-docCheckbox').prop('checked', false).hide();
        angular.element('#jx-selectAllDocDiv').hide();
        angular.element('#jx-selectAllDocForSign').hide();
        angular.element(".documentVersion").removeClass("shiftVersion");
        angular.element('#jx-selectAllDocForSign').prop('checked', false);
        angular.element('.jx-sendForSignBar').hide();
        angular.element('.jx-docForSign').removeClass('withCheckbox');
        $(".withoutCheckBoxDocusign").css('margin-left', "0px");
        $scope.selectedDocForSign = [];
        $scope.selectedUserForSign = [];
        $scope.storedUserIdForSign = [];
        $scope.DocusignEnabled = false;
    };

    /*** $scope.changeStatusOfSelectedDoc ==> function to select , unselect the documents from send for signature bar ***/
    $scope.changeStatusOfSelectedDoc = function (docid) {
        var docusignTableScope = this;
        this.$parent.showMaxLimitError = false;
        this.$parent.maxLimitErrorMsg = "";

        var removedElement = _.remove($scope.selectedDocForSign, function (o) {
            return o.documentId == docid
        });
        angular.element('.jx-docCheckbox[data-docid="' + docid + '"]').prop('checked', false);
        $scope.$emit('updateSelectedDoc', { selectedDoc: 'clearSelectedDoc',deselectedElements:removedElement});

    };
    /*** $scope.removeReceipient ==> function to remove the selected users ****/
    $scope.removeReceipient = function (recId) {
        _.remove($scope.selectedUserForSign, function (o) {
            return o.userId == recId || o.recipientEmail == recId
        });
        _.remove($scope.storedUserIdForSign, function (o) {
            return o.id == recId
        });
    }

    /*** $scope.addEmailToUserList ==> function to add email id to selectedUserForSign list ,
     * if user has not been selected from autocomplete dropdown ***/
    $scope.addEmailToUserList = function (e) {
        if(e) {
            angular.element(e.target).removeClass('errorClass');
            angular.element(e.target).closest('.label-height').find('.errorSpan').addClass('hidden').find('li').html('');
            if (e.type == 'blur' || (e.type == "keyup" && e.which == 13)) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (angular.element(e.target).val().trim() && re.test(angular.element(e.target).val().trim()) && $scope.selectedUserForSign.length < 20) {
                    $scope.selectedUserForSign.push({
                        "recipientEmail": angular.element(e.target).val().trim()
                    });
                    angular.element(e.target).val('');
                } else if (angular.element(e.target).val().trim() && !re.test(angular.element(e.target).val().trim())) {
                    angular.element(e.target).addClass('errorClass');
                    angular.element(e.target).closest('.label-height').find('.errorSpan').removeClass('hidden').find('li').html(intl_msg[25546]);
                } else if ($scope.selectedUserForSign.length == 20) {
                    angular.element(e.target).addClass('errorClass');
                    angular.element(e.target).closest('.label-height').find('.errorSpan').removeClass('hidden').find('li').html(intl_msg[25547]);
                }

            } else {
                return;
            }
        }
    }

    /*** $scope.getSignatureOf ==> function to be called on click of get signature of button in send for signature bar open the modal ***/
    $scope.getSignatureOf = function () {
        $scope.modalInstance = $modal.open({
            templateUrl: $rootScope.createHtmlUrl("docusignModal.html"),
            scope: $scope,
            backdrop: "static",
            keyboard: true,
            windowClass: 'docusignModal',
            modalFade: true
        });
        $scope.showConsentMessage = false;
        $scope.showSelectedDocInPopup = false;
        $scope.showhideSelectedDocInPopup = function () {
            $scope.showSelectedDocInPopup = !$scope.showSelectedDocInPopup
        };
        /**
         * Code has been written in  sendSignatureDirective.js
         * * $scope.sendForSignature ==> function to be called on click of send button in docusign  modal ***/

        /*** $scope.closeDocusignModal ==> function to close the docusign modal ***/
        $scope.closeDocusignModal = function () {
            $scope.modalInstance.dismiss('cancel');
            ;
        }
        /*** called after the popup has been closed ***/
        $scope.modalInstance.result.then(function (result) {
            },
            function (result) {
                $scope.modalInstance = undefined;
                $scope.cancelDocSelection();
            });
    };
    $scope.selectChangeConfirm = function (e,isElm) {
        var el = isElm?e:angular.element(e.target);
        var prevValue = el.attr('data-prev');
        var fieldName = el.attr('ng-model').split('.')[1];
        if(el.attr('data-field-to-reset'))
            var fieldToResetArray = JSON.parse(el.attr('data-field-to-reset'));
        var isConfirmed = false;
        if (prevValue && $scope.data.templateStructure && $scope.data.templateStructure.values && $scope.data.templateStructure.values.id) {
            const args = {
                popupType: 'confirm',
                str: intl_msg[23252],
                heading: intl_msg[25772],
                yesCbFn: function () {
                    fieldToResetArray.forEach(function (item, index) {
                        $scope.data[item].values = null;
                    })
                    $scope.$applyAsync();
                    prevValue = $scope.data[fieldName].values ? JSON.stringify($scope.data[fieldName].values) : '';
                    el.attr('data-prev', prevValue);
                    isConfirmed = true;
                    $rootScope.$emit("empty selected clauses");
                    $rootScope.$emit("empty selected attachments");
                    $rootScope.$emit("empty selected style");
                    $scope.preSignature.mandatoryCategoriesCount = 0;
                    if (el.val() == undefined || el.val() == "") {
                        dataManipulationService.toggleTabNavigation(false);
                    }
                },
                noCbFn: function () {
                    setTimeout(function () {
                        if (!isConfirmed) {
                            $scope.data[fieldName].values = JSON.parse(prevValue);
                            $scope.$applyAsync();
                        }
                    }, 300)
                }
            }
            SirionUtils.openSirionDialogs(args);
        } else {
            prevValue = $scope.data[fieldName].values ? JSON.stringify($scope.data[fieldName].values) : '';
            el.attr('data-prev', prevValue);
            if ($scope.data[fieldName] && $.isEmptyObject($scope.data[fieldName].values)) {
                dataManipulationService.toggleTabNavigation(false);
            } else {
                dataManipulationService.toggleTabNavigation(true);
            }
        }
        if(e){
            $(e.target).blur();
        }
    };
    /***$scope.bindAutoCompleteToUserList ==> bind autocomplete function to input user list ***/
    $scope.bindAutoCompleteToUserList = function (e) {
        angular.element(e.target).removeClass('errorClass');
        angular.element(e.target).closest('.label-height').find('.errorSpan').addClass('hidden').find('li').html('');
        if ($('#jx-getUserList').data('uiAutocomplete')) {
            $('#jx-getUserList').autocomplete("destroy");
        }
        var apiUrl = updateAutoCompleteURLforCustomFields(appName+"/options/3", 1);
        $("#jx-getUserList").autocomplete({
            source: function (request, response) {
                if (request.term.trim()) {
                    $.ajax({
                        url: apiUrl,
                        dataType: "json",
                        type: 'get',
                        data: {
                            query: request.term.trim()
                        },
                        success: function (data) {
                            var autoData = data.data;
                            autoData.forEach(function (d) {
                                d.label = d.name;
                                d.value = d.name;
                                if (d.name.indexOf("Inactive") != -1) {
                                    autoData.delete(d);
                                }
                            });
                            autoData = _.differenceBy(autoData, $scope.storedUserIdForSign, "id");
                            response(autoData);
                        }
                    }).fail(function (jqXHR, textStatus, errorThrown) {
                        window.systemWarning(textStatus + ': ' + errorThrown);
                    });
                }
            },
            minLength: 1,
            select: function (event, ui) {
                event.stopImmediatePropagation();
                if (_.findIndex($scope.selectedUserForSign, function (o) {
                        return o.userId == ui.item.id
                    }) == -1 && $scope.selectedUserForSign.length < 20) {
                    $scope.selectedUserForSign.push({
                        'userId': ui.item.id,
                        'name': ui.item.value
                    });
                    $scope.storedUserIdForSign.push({
                        'id': ui.item.id
                    });
                } else if ($scope.selectedUserForSign.length == 20) {
                    angular.element(e.target).addClass('errorClass');
                    angular.element(e.target).closest('.label-height').find('.errorSpan').removeClass('hidden').find('li').html(intl_msg[25547]);
                }
                $(this).val('');
                $timeout(function () {
                    $scope.$applyAsync();
                }, 10);

                return false;


            }
        });

    }

    $scope.openBulkActionForm = function(){
        // console.log("Here I am");
        // $rootScope.searchableFields = true;
        // $rootScope.fieldHierarchy = {
        //     "fields": []
        // };
        // $rootScope.fieldMapper = {};
        // $rootScope.bulkedit = true;
        $scope.jsonApi = null;
        $scope.configOptionFromServer();
        $scope.hideAdditionalCommentFields = false;
    }
    $scope.openInvoiceUploadForm = function(){
        $scope.jsonApi = null;
        $scope.configOptionFromServer();
        $scope.hideAdditionalCommentFields = false;
    }
    $scope.openRawDataPopup=function(){
        $scope.jsonApi = null;
        if($scope.showlineItemPopup.visible){
            $scope.showlineItemCommentBox=true;
        }
        if($scope.showRawDataPopup.visible) {
            $scope.rawDataCommentBox = true;
        }
        $scope.configOptionFromServer();
    }

    $scope.switchView = function (e) {
        if (!angular.element('#jx-switchView').prop('checked')) {
            $location.path('/' + $routeParams.action + '/' + $routeParams.entityName + '/' + $routeParams.entityId + '/newpage');
        }
    };
    $scope.resetOptionsPageRef = function () {
        if ($scope.data && $scope.data.pageReference && $scope.data.pageReference.values) {
            for (var i = 0; i < $scope.data.pageReference.values.length; i++) {
                $scope.data.pageReference.values[i].contractReference = null;
                $scope.data.pageReference.values[i].clause = null;
                $scope.data.pageReference.values[i].pageNumber = null;
            }
            if ($scope.data.bulkEditReferenceActionType && $scope.data.bulkEditReferenceActionType.values && $scope.data.bulkEditReferenceActionType.values.id != 3) {
                $scope.data.existingPageReferences.values = [];
                var element = angular.element('[fieldname="existingPageReferences"]');
                element.closest("span").find(".showSelected").remove();
                if (element.data("fieldData")) {
                    element.data("fieldData").selectedVals = []
                }
            }
        }
    }

    $scope.clickThis = function (id) {
        if ($scope.SingleFileDelMsg || $(".massEmailForm").is(":visible")) {
            const args = {
                popupType: 'confirm',
                str: intl_msg[6436],
                heading: intl_msg[25772],
                yesCbFn: "delFile",
                noCbFn: "notDelFile",
                field: id,
            }
            SirionUtils.openSirionDialogs(args);
        } else {
            //SIR-69055 : Didn't removed if else condition.
            $scope.delFile(id);
            // $scope.confirmAlertDialog(intl_msg[6436], "CONFIRMATION", "delFile", "notDelFile", id);
        }
    };
    $scope.closeProperties = function(evt,fileKey){
        if($scope.attachmentProps != undefined){
            $scope.attachmentProps[fileKey] = false;
        }
        if(evt && evt.target){
            angular.element(evt.target).closest('.jx-fileListSpan').removeClass('activeSpan');
        }
        if($('#'+fileKey).length){
            $('#'+fileKey).removeClass('activeSpan');
        }
        $scope.lastOpenFileKey = undefined;
    };

    $scope.openProperties = function (evt,fileKey){
        if($scope.lastOpenFileKey && fileKey != $scope.lastOpenFileKey ){
            $scope.closeProperties(null,$scope.lastOpenFileKey)
        }
        $scope.lastOpenFileKey = fileKey;
        if(evt === undefined || evt.target.id != "icon-Gear-Settings-line"){
            return;
        }
        evt.stopPropagation();
        if($scope.attachmentProps == undefined ){
            $scope.attachmentProps = {};
        }
        if(evt && evt.target){
            angular.element(evt.target).closest('.jx-fileListSpan').addClass('activeSpan');
        }
        $scope.attachmentProps[fileKey] = true;
    };

    $scope.isVisible = function(evt,fileKey){
        if($scope.attachmentProps == undefined ){
            $scope.attachmentProps = {};
            return false;
        }
        else{
            return $scope.attachmentProps[fileKey];
        }

    }

    $scope.updateDocObj = function(objArgs,evt){
        var el = evt.target.nodeName!="LI"?$(evt.target).parent("li").find("input"):$(evt.target).find("input");
        el.toggleClass(objArgs);
        evt.target.nodeName!="INPUT"?el.prop("checked",!el.prop("checked")):angular.noop();
    }

    $scope.populateSummaryPreloadLayout = function (response) {
        // Function to create show page process data object from data.
        return dataManipulationService.populateSummaryLayoutData(response);
    };

    $scope.closeCommentFormPopup = function(){
        $scope.showRawDataPopup.visible=false;
        $scope.rawDataCommentBox=false;
        $scope.showlineItemCommentBox=false;
        $scope.showlineItemPopup.visible=false;
    };

    $scope.fetchNextWorkFlowStep = function(e){
        if ($rootScope.mobileView) {
            stopLoader();
        }
        $(e.target).addClass("disabled");
        var url = addtStamp(appName + '/workflow/action/owner/'+$scope.data.entityTypeId.values+'/'+$scope.data.id.values);
        $http.get(url).then(function (res) {
            $(e.target).removeClass("disabled");
            $scope.nextWFSPopup=$modal.open({
                templateUrl: $rootScope.createHtmlUrl("ui2.0/nextWorkFlowStepPopup.html"),
                modal: true,
                size: "lg",
                keyboard: false,
                backdrop: "static",
                windowClass: "nWFSPopup",
                modalFade: true,
                scope:$scope
            });
            $scope.nwfStepInfo = res.data;
            $scope.nwfStepInfo = _.sortBy($scope.nwfStepInfo,'task_id');
            $scope.mappedCountOfWf = _.countBy($scope.nwfStepInfo,'task_id');
            stopLoader();
        });
        $scope.getListOfUsers = function(arr1,arr2){
            return arr1.concat(arr2);
        };
        $scope.checkForExistence = function(i){
            if($scope.nwfStepInfo[i-1] && ($scope.nwfStepInfo[i].task_id == $scope.nwfStepInfo[i-1].task_id)){
                return true;
            }else{
                return false;
            }
        };
        $scope.showMoreWFOwners = false;
    };

    $scope.getOptionsForDep = function(optionObj,parentObj){
        if(parentObj && parentObj.id) {
            return _.filter(optionObj, function (o) {
                return o.parentId == parentObj.id
            });
        }else{
            return null;
        }
    };
    $scope.fKey = 70;
    $scope.f3Key = 114;
    $scope.shouldEnableGlobalHeader = function(pageType,data){
        const shouldGloablHeader = ((pageType=='create'|| pageType=='clone') && ([67, 61]).indexOf(data.entityTypeId?.values) > -1) || (data && data.entityTypeId && ([3,160,139].indexOf(data.entityTypeId?.values) == -1) && pageType=='globalCreate') || (pageType=='create' && ([160,67, 325]).indexOf(data.entityTypeId?.values) > -1 || $scope.showContractUploadStepper)
        if(shouldGloablHeader && !$scope.exceptionalInNewUx.pageWithoutGeneralTab)
            return true;
        else
            return false;
    };

    // Check if tabs are supposed to be hidden
    $scope.areTabsHidden = function(pageType,data){
        if(data && data.entityTypeId &&
            (pageType=='create' && ([325, 67]).indexOf(data.entityTypeId.values) > -1) ||
            (pageType=='globalCreate' && ([111, 67].indexOf(data.entityTypeId.values) > -1)) ||
            (pageType=='clone' && ([67]).indexOf(data.entityTypeId.values) > -1) ||
             $scope.fromSupplierDropdown)
            return true;
        else
            return false;
    };
    $scope.resetDelegationTable = function(){
        console.log('changed');
        //delegationService.loadDelTableData();
    }

    $scope.closeDelegationPopup = function(){
        $scope.myModelInstance.close();
        $scope.myModelInstance = null;
    }

    $scope.creditCalculateChanged = false;
    $scope.creditItemSelected = function(){
        let tableId = $scope.tableScopeMapper &&  _.keys($scope.tableScopeMapper);
        let aCount,bCount;
        if(tableId.length) {
            let currentSelection = $scope.tableScopeMapper[tableId[0]].selectedCheckBoxes;
            if (currentSelection.length !== $scope.originalCreditSelected?.length ) {
                $scope.creditCalculateChanged = true;
                return;
            }
            const uniqueValues = new Set([...currentSelection, ...$scope.originalCreditSelected]);
            for (const v of uniqueValues) {
                aCount = currentSelection.filter(e => e === v).length;
                bCount = $scope.originalCreditSelected.filter(e => e === v).length;
                if(aCount != bCount) break;
            }
            $scope.creditCalculateChanged = aCount != bCount;
        }
    };

    function keyDownHandler(e) {
        if (e.keyCode === $scope.f3Key || ( ( e.ctrlKey || e.metaKey) && e.keyCode === $scope.fKey)) {
            var alreadyOpenedLen = angular.element('.jx-headerCaret:visible').closest('fieldset.open').length;
            var totalFieldsetLen = angular.element('.jx-headerCaret:visible').closest('fieldset').length;
            if( totalFieldsetLen != alreadyOpenedLen ){
                var myElement = angular.element( document.querySelector( '.jx-toggleAllGroups' ) );
                /********************************Edit Page*************************/
                if(myElement.length == 0 ){
                    myElement = angular.element( document.querySelector( '.toggleBtn' ) );
                }
                myElement.click();
            }
        }
    }

    $document.on('keydown', keyDownHandler);
    /*$scope.$on('$destroy', function () {
        $document.off('keydown', keyDownHandler);
    });*/


    $scope.saveCalculateCredit = function(save){
        let str;
        let tableId = Object.keys($scope.tableScopeMapper);
        if (save) {
            if(tableId.length){
                str = SirionUtils.getCreditCalculateString($scope.tableScopeMapper[tableId[0]].getSelectedCheckBoxLength());
            }
            $scope.calculateAnchorCallback(str);
            $scope.setselectedLeftTabIdx(0);
            $scope.creditCalculateChanged = false;
        }else{
            const args = {
                popupType: 'confirm',
                str: 'Unsaved changes will be lost. Are you sure you want to close this panel?',
                heading: 'Confirmation',
                yesCbFn: function () {
                    str = SirionUtils.getCreditCalculateString($scope.originalCreditSelected.length);
                    $scope.calculateAnchorCallback(str);
                    $scope.setselectedLeftTabIdx(0);
                    $scope.creditCalculateChanged = false;
                    $scope.updateCheckBoxes($scope.tableScopeMapper[tableId[0]]);
                },
                noCb: 'cancel',
            }
            if(_.isEqual($scope.selectedCheckBoxes.sort(), $scope.originalCreditSelected.sort())){
                $scope.setselectedLeftTabIdx(0);
            }else{
                SirionUtils.openSirionDialogs(args);
            }
        }
    }

    $scope.updateCheckBoxes = function(scope){
        $(".dataTables_scroll").find(".masterSlaListJson").each(function () {
            if($scope.originalCreditSelected.includes($(this).val()) && !$(this).prop('checked')){
                $(this).prop('checked',true);
            }else if(!$scope.originalCreditSelected.includes($(this).val()) && $(this).prop('checked')){
                $(this).prop('checked',false);
            }
            $scope.selectedCheckBoxes = [...$scope.originalCreditSelected];
        })
    }

    $scope.initFieldUserTagging = function (event, leaveFocus) {
        var element = angular.element(event.currentTarget);
        if(leaveFocus){
            element.removeClass("focus");
            if(element[0].childNodes.length ==1 && element[0].childNodes[0].nodeName == 'BR' ){
                element.empty();
            }
        } else {
            element.addClass("focus");
        }
        if(!element.hasClass("initialized")) {
            var apiUrl = element.attr("data-api-url");
            var finalUrl = updateAutoCompleteURLforCustomFields(apiUrl, 1);
            const isComment = SirionUtils.isCommunicationCommentField(element);
            if(isComment) {
                finalUrl += '&isCommunication=true'
            }
            var at_config = {
                at: "@",
                callbacks: {
                    remoteFilter: function (query, callback) {
                        $.getJSON(finalUrl, {query: query, onlyUsers: true}, function (result) {
                            $.each(result.data, function (i, obj) {
                                if (
                                    obj.idTypes && obj.idTypes.length > 0) {
                                    obj.group = '<span class="icon-usergroup"></span>';
                                    obj.isgroup = true;
                                } else {
                                    obj.group = "";
                                    obj.isgroup = false;
                                }
                                obj.uid = "<span data-uid='"+obj.id+"' data-urg='"+obj.isgroup+"'></span>";
                            })
                            callback(result.data);
                        });
                    }
                },
                insertTpl: '${group} ${name} ${uid}',
                displayTpl: "<li>${group} ${name}</li>",
                limit: 200
            }
            element.atwho(at_config).addClass("initialized skip_global_purify");
        }
    }

    $scope.refreshRoute = function(){
        showPageService.refreshRoute($scope,$route,SirionUtils);
    }


    $scope.selectTile = function(tab){
        $scope.$broadcast("tileSelect", tab);
    }
    $scope.getTileCount = function(tab){
        return $scope.showPageTileService.getTileCount(tab);
    }
    var checkLinkedFields = function(cData){
        var data = angular.copy(cData);
        data = _.extend(data, data.dynamicMetadata);
        $scope.linkedFieldsGroup = $scope.globalData.linkedFields;
        var populatedData = [];
        var fieldIds = [];
        var success = true;
        $scope.errors ? $scope.errors.genericErrors = [] : null;
        if($rootScope.bulkedit && $rootScope.fieldHierarchy && checkedVal) {
            $rootScope.fieldHierarchy.fields.forEach(function (d) {
                if (d.childShown) {
                    fieldIds = $.merge(fieldIds, d.childShown)
                }
                try {
                    d.childShown.forEach(function (d1) {
                        var id = "#elem_" + d1;
                        $('[ng-model][ng-show = "' + $(id).find('[ng-model]').attr("ng-model") + '"]:visible').map(function (e, d) {
                            fieldIds.push(Number(($(d).closest(".label-height").attr("id").split("_")[1])));
                        })
                    });
                } catch (e) {
                }

            });
            if (data.entityTypeId && data.entityTypeId.values == 12 && fieldIds.indexOf(312) > -1) {
                fieldIds.push(313, 314, 12233, 12234);
            }
        }
        _.forEach(fieldIds, function(fieldId){
            const item = _.find(data, dataObj => dataObj && dataObj.id && dataObj.id == fieldId);
            item && populatedData.push(item);
        });
        populatedData = _.filter(populatedData,function (d) {
            return !_.isEmpty(d.values) || ($rootScope.bulkRequiredFldMapper[d.id])
        })
        _.forEach($scope.linkedFieldsGroup, function(_linkedFieldsGroups) {
            if(_.intersection(fieldIds, _linkedFieldsGroups).length == _linkedFieldsGroups.length) {

                var valuesArray = _.filter(populatedData, function(field){
                    return field && (_.indexOf(_linkedFieldsGroups, field.id) > -1);
                });
                valuesArray = valuesArray.map(function(field){
                    return field.values? field.values: null;
                });
                if(areAllNull(valuesArray) || areAllPopulated(valuesArray)){
                }else{
                    var fieldString = '';
                    _.forEach(_linkedFieldsGroups,function (fieldId) {
                        fieldString += searchableFieldService.getSelectedFields()[fieldId]+', ';
                    });
                    fieldString = fieldString.trim().slice(0, -1);
                    var intl = intl_msg[29350] ? intl_msg[29350] : '';
                    intl = intl.replace( "%S", "%s");
                    var msg = intl ? intl.replace( "%s", fieldString) : "Dependent fields "+fieldString+ " can not be partially updated.";
                    $scope.errors.genericErrors.push({
                        "message": msg,
                        "type": null
                    });
                    success = false;
                }
            }
        });
        return success;
    }
    var areAllNull = function(array){
        return _.every(array, function(arrayItem){
            arrayItem = (typeof arrayItem === "object" || arrayItem == null) ? arrayItem : arrayItem + '';
            return _.isEmpty(arrayItem);
        })
    };
    var areAllPopulated = function(array){
        return _.every(array, function(arrayItem){
            arrayItem = (typeof arrayItem === "object" || arrayItem == null) ? arrayItem : arrayItem + '';
            return !_.isEmpty(arrayItem);
        })
    };

    $scope.showDetailsTab = function(btn){
        var idx = _.findIndex(showPage2DataTransformationService.returnObj.leftTabInfo,function(o){
            return o.id == btn.properties.targetTab;
        });
        var detailsTab;
        var statusFilter = {
            'filterId': btn.properties.filterId,
            'statusIds': btn.properties.statusId,
            'triggerDetailsTab': true
        };
        if(idx > -1) {
             detailsTab = showPage2DataTransformationService.returnObj.leftTabInfo[idx];
            $scope.$broadcast('openDetailsTab', {'idx': idx, 'selectedTab': detailsTab, 'statusFilter': statusFilter});
        }else{
            detailsTab = _.filter(showPage2DataTransformationService.returnObj.leftTabList,function(o){
                return o.id == btn.properties.targetTab;
            })[0];
            $scope.$broadcast('openDeatilsTabFromDD', {'selectedTab': detailsTab, 'statusFilter': statusFilter});

        }
    }

    $scope.revalidateInvoice = function(){
        const args = {
            popupType: 'confirm',
            str: intl_msg[24161],
            heading: intl_msg[25772],
            yesCbFn: "confirmValidate",
            yesName: intl_msg[24184],
            noCbFn: cancelString,
            noName: intl_msg[23731]
        }
        SirionUtils.openSirionDialogs(args);
    }

    $scope.confirmValidate = function(){
        $scope.cancel();
        var dataToPost = formService.populateDataWithKeys($scope.invoiceValidationStatusBtn.params);
        startLoader();
        var promiseValidate = entityFactory.getJson($scope.invoiceValidationStatusBtn.api, "POST", "", dataToPost, false);
        promiseValidate.success(function (d) {
            stopLoader();
            if (d && d.header && d.header.response) {
                if(d.header.response.status == "success"){
                    $scope.validateButton = null;
                    Toaster.create(intl_msg[24160]);
                    angular.element("#jx-revalidateInvoice").hide();
                    angular.element('#jx-invalidInvoiceStatusNotification').hide();
                } else if(d.header.response.status == "applicationError"){
                    Toaster.create(d.header.response.errorMessage,{iconClass:"icon-Information_filled"});
                }
            }else{
                toggleServerErrorNotification(true);
            }
        });
    }

    $scope.toggleSelectDDbox = function ($event){
        $('.selectDDbox').css('left', $event.currentTarget.offsetLeft - 35).toggle();
        if($(".dropdown-menu:hover").length == 0){
            $(".dropdown-menu").hide();
            $(".dropdown-toggle").removeClass("active");
        }
    }

    $scope.openCommSection = function(){
        let component= document.getElementsByClassName('expandedTables')[0];
        window.sarc.channelBroadcast("reactDynamicForms", {
            actionType: "expandTables",
            value: false
        },`dfSubscriptions_${$scope.globalData.dynamicFormId}`);
        if(component){
            component.classList.remove('expandedTables');
        }
        if(!$scope.mobileView){
            return;
        }
        else{
            if(SirionUtils.isEmpty($scope.prevComment)){
                $scope.prevComment = undefined;
            }
            $scope.commPopUp=$modal.open({
                templateUrl: $rootScope.createHtmlUrl("ui2.0/mobileCommunicationPanel.html"),
                modal: true,
                size: "lg",
                keyboard: false,
                backdrop: "static",
                windowClass: "nWFSPopup communicationPanel",
                scope:$scope
            });
            $scope.commPopUp.opened.then(function () {
                if(!SirionUtils.isEmpty($scope.prevComment)){
                    setTimeout(function () {
                        $scope.data.comment.comments.values = $scope.prevComment;
                        // if(!$scope.$$phase){
                            $scope.$applyAsync();
                        // }
                    },0);
                }
            });
            $scope.commPopUp.closed.then(function(){
                $scope.prevComment  = $scope.data.comment.comments.values;
            },function(){
                $scope.prevComment  = $scope.data.comment.comments.values;
            });
        }
    };

    $scope.handlePopUpClose = function(){
        $scope.commPopUp && $scope.commPopUp.close();
    };
    $scope.scrollToErrorElem = function(button){
        $scope.errorBtnClick = true;
        showPageService.scrollToErrorElem($scope,button);
    }
    $scope.openSelectDdBox = function (e) {
        $scope.$broadcast('closeMsDD');
        $('.selectDDbox').css('left', e.currentTarget.offsetLeft - 25).toggle();
        document.getElementsByClassName('searchTextDropDown')[0].focus();
    }
    $scope.changeErrorCount = function (totalErrorElm, currentElm, isWorkflowAction) {
        showPageService.changeErrorCount.call($scope, totalErrorElm, currentElm, isWorkflowAction);
    }
    $scope.handlePropValues = function(data){
        for(var prop in data){
            if ($scope[prop] != undefined)
                $scope[prop] = data[prop];
        }
    }

    $scope.getSpecificExtractionData = function(fieldId,type) {
        const timelineModalEl = angular.element(".modal.takesOne");
        const prevFieldId = timelineModalEl.find('specific-extraction-data').attr('fieldid');
        if(fieldId == prevFieldId){
            return;
        }
        if(timelineModalEl.length){
            $scope.timelinePopup.close();
            $scope.timelinePopup.closed.then(function(){
                delete $scope.timelinePopup;
                addTimeLinePopupModal(fieldId,type);
            });
        }else{
            addTimeLinePopupModal(fieldId,type);
        }
    };

    function addTimeLinePopupModal(fieldId,fieldtype){
        $scope.timelinePopup=$modal.open({
            template: '<specific-extraction-data fieldid="'+fieldId + '" fieldtype="'+ fieldtype +'"></specific-extraction-data>',
            modal: true,
            size: "lg",
            keyboard: false,
            backdrop: false,
            windowClass: "timelinePopup takesOne",
            scope:$scope
        });
        $scope.timelinePopup.result.then(function(){
            delete $scope.timelinePopup;
        });
        $scope.timelinePopup.rendered.then(function(){
            $(".modal.takesOne").draggable({ cancel: '.modal-body' })
        });
    }

    var cleanup = $rootScope.$on('updateContractDoc',function(e,data){
        setContractDocumentsData($scope.docTreeService.contractDocuments,data);
        setContractDocumentsData($scope.data.contractDocuments.values,data);
        $scope.docTreeService.contractDocumentsCopy = $scope.data.contractDocuments.values;
    });

    setContractDocumentsData = (contractData,data) => {
        var docIndex = contractData.findIndex(doc => doc.id == data.id);
        if (docIndex !== -1) {
            contractData[docIndex] = {
                ...contractData[docIndex],
                name: data.name,
                extension: data.extension,
                externalId: data.externalId
            };
        }
    }

    openCompareWindow = () => {
        const reqUrl = addtStamp('/tblclause/getAllVersion/' + $scope.data.id.values, true);

        // Get all versions for current Clause
        $http.get(reqUrl).then(function (resp) {
            // Prepare data to open Doc modal in Compare inly mode
            showPageService.prepareCompareModalData.call($scope, resp);

            // Open modal in Compare mode
            showPageService.openModalInCompareMode.call($scope);

        }, function errorCallback(error) {
            console.error('Data cannot be loaded due to: ' + error);
        });
    }

    $scope.RDFSubscriptions = {value: false, init: function () {
        window.sarc.channelInstall('reactDynamicForms')
        window.sarc.channelSubscription('reactDynamicForms', function(args){
            let actionType = args.actionType;
            let payload = args.payload;
            const cliTableUpdate = (payload) => {
                var sc = $('.clause-library-container').scope();
                _.forEach(sc.selectedClauses, clause => {
                    if (clause.templateType && (clause.templateType === payload.templateId && Number(clause.tableId) === Number(payload.tableId))) {
                        if(payload.updateNumbering)
                            clause.numbering = payload.value;
                        else if(payload.updateName) {
                            clause.tableName = payload.value;
                        }
                    }

                })
                sc.selectedClauses = SirionUtils.updateSelectedClauseIndex.call(sc,sc.selectedClauses);
                $scope.$apply();
            }
            if(actionType == "getEntityApi") {
                const urlName = NumToURLPartMapping[$scope.data.entityTypeId.values];
                const entity = entityFactory.entityNameMapper.find(entityMap => entityMap.urlName == urlName);
                return {actionType, payload : entity.apiName};
            }
            if(actionType == "moveToLevel") {
                let sc = $(".templateCEpageBreadcrumb").scope(),
                    handlerOnActive = sc.fuel.levels[payload.level].handlerOnActivate;
                payload.handlerOnActive = handlerOnActive;
                $rootScope.$broadcast("moveToLevel",payload);
            }
            if (actionType == "toggleEditButton") {
                $scope.showEditButton.enabled = (payload.value >= 1) ? false : true;
            }
            if(actionType == "hideLineItemTab"){
                $rootScope.$broadcast("modifyLevels",payload);
            }
            if(actionType == "openSpecifiedTab"){
                showPageService.openSpecifiedTab(payload,$scope);
            }
            if(actionType == "openCompareWindow"){
                openCompareWindow();
            }
            if(actionType=="routeReload"){
                $route.reload();
            }
            if(actionType=="rootSupplierId"){
                localListingRelationId = payload.value;
            }
            if(actionType == "showDetailsTab"){
                $scope.showDetailsTab(payload);
            }
            if(actionType == "updateDataFromReact"){
                if(payload.type == "updateMandatoryCatCount") {
                    $rootScope.preSignature.mandatoryCategoriesCount = payload.value;
                }
                else if(payload.type == 'updateSelMandatoryClauseCatCount') {
                    $rootScope.preSignature.selectedMandatoryCategories = payload.value;
                }
            }
            if(actionType == "btnClick"){
                $scope.btnClick(payload.event, payload.button);
            }
            if(actionType == "toggleExpectedLanguage") {
                showPageService.toggleExpectedLanguage($scope);
            }
            if(actionType == 'updateTemplateMap'){
                $rootScope.copyTemplateList = payload.mappedContractTemplatesObject;
                $rootScope.copyTemplateMap = payload.templateMap;
                $rootScope.copyTemplateDateFormat = payload.dateFormatToShowForEdit;
            }
            if(actionType == "toggleTabNav"){
                dataManipulationService.toggleTabNavigation(payload.flag,payload.specialObject);
            }
            if(actionType == "resetClauses"){
                $rootScope.$emit("empty selected clauses");
                $rootScope.$emit("empty selected attachments");
                $rootScope.$emit("empty selected style");
                $rootScope.$broadcast("modifyLevels",{checked:false});
                $scope.preSignature.mandatoryCategoriesCount = 0;
                $rootScope.preSignature.selectedMandatoryCategories = 0;
            }
            if(actionType == "hideCommentAndShowDocument"){
                $scope.hideCommentAndShowDocument(payload.name);
                return {actionType:actionType,payload: $scope.documentOpenWithForm};
            }
            if (actionType == "bulkNovation") {
                $rootScope.docTree=payload.dataToSend;
                $rootScope.bulkNovation=true;
                $scope.responsePopUp(payload.resp,false,payload.btn,true)
            }
            if(actionType == "createExternalContact"){
                if(!$scope.RDFSubscriptions.value) {
                    $scope.RDFSubscriptions.value = true;
                    $scope.RDFSubscriptions.init();
                }
                $scope.openCdrCreateExternalContactModal(payload);
            }
            if(actionType == "openExternalContactSupplierSelect"){
                externalContactService.openExternalContactSupplierSelect(payload);
            }
            if(actionType == "deleteDataOfUserRoleGroup"){
                $scope.fromExternalUser = false;
                $scope.openExternalContactFromCdrCreate = false;
                $scope.dataOfnewExtarnalContract = null;
                $scope.dataOfUserRoleGroup = null;
                $scope.openFromUserRoleGroup = false;
                if($scope.timeLineFeedSecActive){
                    const feedType = $scope.timeLineFeedScope;
                    $scope.timeLineFeedScope = -1;
                    $scope.setTimelineFeedDataScope(feedType);
                } else if ($scope.commentDataScope == 1){
                    $scope.commentDataScope = -1;
                    $scope.setCommDataScope(1);
                } else if ($scope.commentDataScope == 3){
                    $scope.commentDataScope = -1;
                    $scope.setCommDataScope(3);
                }
            }
            if(actionType=="compileDocViewer"){
                let sc = $scope.$new();
                $compile($(payload.selector))(sc);
                var viewerScope = $(payload.selector).scope();
                if (viewerScope) {
                    viewerScope.collapsible = true;
                }
                if (viewerScope && !viewerScope.$$phase) {
                    viewerScope.$apply();
                }
            }
            if(actionType=="compilePdfJsViewer"){
                $scope.loadPdfJsViewer();
            }
            if(actionType == "switchTab") {
                let tableId = $scope.tableScopeMapper && _.keys($scope.tableScopeMapper);
                if(tableId.length){
                    $scope.originalCreditSelected = [...$scope.tableScopeMapper[tableId[0]].selectedCheckBoxes];
                }
                const {id,detailTabShow,nonEditable,fModel, calculateAnchorCallback} = payload;
                if(calculateAnchorCallback){
                    $scope.calculateAnchorCallback = calculateAnchorCallback;
                }
                var elementFound = _.find($scope.showPageTabInfo1,function(d){ return d.id == id; });
                if(!elementFound){
                    var elementToAdd  = _.find(showPage2DataTransformationService.returnObj.allleftTabInfo,function(d){ return d.id == id;});
                    elementToAdd && $scope.showPageTabInfo1.push(elementToAdd);
                }
                dataManipulationService.showHideTab($scope.showPageTabInfo1,id,detailTabShow,nonEditable);
                $scope.$emit("calculateCreditEarnBack");
                $scope.$root.checkboxUpdated = function(arr) {
                    if (arr && angular.isArray(arr)) {
                        var temp = [];
                        arr.forEach(function (d) {
                            temp.push({"id": Number(d), "name": "filler"});
                        });
                        $scope.data[fModel].values = temp;
                    }
                }
                $scope.$root.backButtonToCSLActive = id;
            }
            if(actionType == "renderActionButtons") {
                let value = payload.values;
                if(value && value.layoutActions) {
                    if($scope.selectedButton && value.layoutActions) {
                        const isSelectedButtonStillValid = value.layoutActions.some(function(action) {
                            return action.label === $scope.selectedButton;
                        });
                        
                        if(!isSelectedButtonStillValid) {
                            $scope.selectedButton = '';
                        }
                    }
                    // Reorder layoutActions so selectedButton is first (shown as primary) before rendering
                    if ($scope.selectedButton && value.layoutActions && value.layoutActions.length > 1) {
                        var selectedIdx = value.layoutActions.findIndex(function(btn) {
                            return btn.label === $scope.selectedButton;
                        });
                        if (selectedIdx > 0) {
                            var selectedBtn = value.layoutActions.splice(selectedIdx, 1)[0];
                            value.layoutActions.unshift(selectedBtn);
                        }
                    }
                    $scope._renderActionButtons($scope, value.layoutActions, showPage2DataTransformationService);
                    $scope.$applyAsync();
                    stopLoader();
                }
                if($rootScope.invoiceName && $rootScope.invoiceName.values)
                    $rootScope.invoiceName = $rootScope.invoiceName.values;
                showPageService.showInvoiceCopyToolTip(true);
                if (!$scope.expandLeftSection) {
                    $rootScope.commentListScope.$broadcast('updateComment', true, true);
                }
            }
            if(actionType == "renderCreateLinks") {
                showPageService.renderCreateLinkOptions.call($scope, payload.values);
            }
            if(actionType == "globalCdrTemplateList"){
                $rootScope.globalCdrTemplateList = angular.copy($scope.data.mappedContractTemplates.values);
            }
            if(actionType == "validateComments"){
                dataManipulationService.fetchTextAreaValues($scope.data, window.htmlEditorList,null,$scope);
            }
            if(actionType == 'ModifyRequest'){
                let _users = payload.card.recipientSigningStatuses;
                let _docs = payload.card.docuSignDocuments;
                const docuSign =  (payload.card.signType ==1) ? true :false
                let docuSignToSirionMapper = {
                    'SignHere' : {name: "Signature",icon : 'icon-Initiate-Signature'},
                    'Company' : {name: "Company",icon : 'icon-Company'},
                    'DateSigned' :{name: "Date Signed",icon : 'icon-calendar'},
                    'EmailAddress':{name: "Email",icon : 'icon-Mass-Mails'},
                    'FullName':{name: "Name",icon : 'icon-Profile'},
                    'InitialHere':{name: "Initial",icon : 'icon-Initials'},
                    'Text':{name: "Text",icon : 'icon-Text_Box'},
                    'Title':{name: "Title",icon : 'icon-Title'}
                };
                docuSignService.changeTextPlaceholderToOriginal(_users)
                let getIndexOfDocumnet = (docId) => {
                    let index = 0;
                    _docs.map((d,i)=>{
                        if(d.documentId ==docId){
                            index  = i;
                        }
                    })
                    return index;
                }
                let getPlaceholderInFormat = (p,dId,sId ,sName,s,docuSign) => {
                    let mappedValue= docuSignToSirionMapper[p.tabType];
                    let placeholder;
                    if(!mappedValue) {
                        placeholder = _.cloneDeep(p);
                        placeholder.stakeholder = s;
                        placeholder.skipVisibilityInViewer = true;
                    }else placeholder = {type : mappedValue.name , icon : mappedValue.icon , dataImg : '',stakeholder : s};

                    if(p.tabType == "Text"){
                        placeholder.TextAreaValue = p.textTabValue
                    }
                    if(p.tabType ==  "Company" || p.tabType == "Title" || p.tabType == "Text"){
                        if(p.readOnly){
                            placeholder.RO = true
                        }else{
                            placeholder.RF =  true
                        }
                    }

                    if (docuSign && (p.tabType == "SignHere" ||  p.tabType == "Text" || p.tabType == "InitialHere")  && !p.required && !p.readOnly) {
                        placeholder.RF = false;
                        placeholder.RO = false
                        placeholder.OF = true
                    }

                    placeholder['highLightId'] = showPageService.getHighlightId();
                    placeholder['containers'] = [
                        {
                            dataImg : "" ,
                            itemPlaced : mappedValue ? mappedValue.name : "",
                            pageno : p.pageNumber,
                            height : 0 ,
                            width : 0,
                            left : p.xposition,
                            top : p.yposition ,
                            sendTopValue : p.ypositionPercentage,
                            docID : p.documentID,
                            xPercentage :p.xpositionPercentage,
                            yPercentage :p.ypositionPercentage
                        }];
                    placeholder['cssProperties'] = {
                        defaultFontSize : 14 ,
                        height:22 ,
                        top : 5 ,
                        left : {},
                        allWidth : {},
                    };
                    let i = getIndexOfDocumnet(dId);
                    if(!(_docs[i]['placeHolder'])){
                        _docs[i]['placeHolder'] = [];
                    }
                    _docs[i]['placeHolder'].push(placeholder);
                    const stakeholder ={id  : sId , name : sName  , Initials :  globalFunc.getUserInitials(sName)};
                    if(!(_docs[i]['stakeholder'])){
                        _docs[i]['stakeholder'] = [];
                        _docs[i]['stakeholder'].push(stakeholder);
                    }else{
                        let addStakeholder = true
                        _docs[i]['stakeholder'].forEach(s=>{
                            if(s.id == sId){
                                addStakeholder =false;
                            }
                        })
                        if(addStakeholder){
                            _docs[i]['stakeholder'].push(stakeholder);
                        }
                    }
                };
                _docs.map(d=>{
                    d.documentName = d.name;
                    delete d.name;
                    d.documentType = (d.documentType == 2) ? 'DRAFT' : 'ATTACHMENT';
                    d.type = d.fileExtension && d.fileExtension.trim();
                    delete d.fileExtension;
                    delete d.reqId;
                    delete d.requestType;
                    delete d.referenceId;
                    d.selected = false;
                    d.version = null;
                    d.stakeholder = [];
                    d.canModify = true;
                });
                _users.map((u)=>{
                    delete u.deliveredOn;
                    delete u.lastUpdatedOn;
                    delete u.recipientId;
                    delete u.signedOn
                    u.roleText = u.role;
                    u.role = u.recipientRole;
                    u.email = u.recipientEmail;
                    //delete u.recipientRole
                    u.sirion = false;
                    u.src = '';
                    u.userInitials = globalFunc.getUserInitials(u.name);
                    u.signed = false;
                    u.tab = {};
                    u.canModify = true;
                    u.disableClick = u.signingStatus ==  "COMPLETED" ? true : false
                    u.disableIcons = true;
                    if(u.role == "Signer")
                        u.tabStatuses.map(tab =>{
                            getPlaceholderInFormat(tab ,tab.documentID ,u.id ,u.name,JSON.parse(JSON.stringify(u)),docuSign);
                        });
                });
                $rootScope.modifyRequest = {
                    _docs ,
                    _users,
                    signingCompleting:payload.card.signingCompleting,
                    signRequestId:payload.card.signRequestId,
                    signOrder : payload.card.preserveSigningOrder
                };
                $rootScope.modifyRequestMade = true;
                const entiyId = $rootScope.data.id.values,
                    entiyTypeId = $rootScope.data.entityTypeId.values;
                $rootScope.accountIntegrationId = payload.card.integrationId;
                $rootScope.accountSignType = payload.card.signType;
                $rootScope.accountName = payload.card.name;
                window.location.href = ('#/sendSignature/'+ entiyTypeId + '/' + entiyId + '?signAccountId='+$rootScope.accountIntegrationId);
                $timeout(()=>$rootScope.$broadcast("track session time on modify",true),100);
            }

            if(actionType == "viewExtractedData"){
                return {
                    actionType,
                    payload: {
                        enableExtractedData:$scope.enableExtractedData,
                        enableAEContractShowDuplicateDocs:$scope.enableAEContractShowDuplicateDocs
                    }
                }
            }
            if(actionType == "addNewComment"){
                $scope.fromScope = 'feeds';
                $scope.oldTimeLineFeedScope = $scope.timeLineFeedScope;
                $scope.doNotCloseCommentBox = payload.flag;
                $scope.setCommDataScope(1, false, false, payload.commentHighlightProps);
                payload.flag && setTimeout(() => {
                    var sc = $('.communicationPanel').scope();
                    sc?.toggleShowCommentBox();
                })
            }
            if(actionType == "switchToTimeline"){
                $scope.setTimelineFeedDataScope(2);
            }
            if(actionType == "sendReminder") {
                if (!$scope.hasCommunicationTab) {
                    return;
                }
                $scope.oldTimeLineFeedScope = $scope.timeLineFeedScope;
                $scope.fromScope='feeds';
                $scope.setCommDataScope(1);
            }
            if(actionType == "loadSelectedTemplate"){
                $scope.showVersionLabel = true;
                $scope.currentVersionNum = payload.templateVersionNumber + '.0';
                if(payload.isIntermediate){
                    $scope.loadVersionTemplate('');
                    $scope.showIntermediateIcon = true;
                    $scope.intermediateVersion = 1;
                }else {
                    $scope.showIntermediateIcon = false;
                    $scope.loadVersionTemplate(payload.templateVersionNumber);
                }
                if(payload.showVersionDropdown){
                    $scope.selectedTemplateVersion = $scope.firstVersionOption;
                    $scope.showVersionDropdown = true;
                    $scope.showVersionLabel = false;
                }
            }
            if(actionType == "updateAutoCompleteURLforCustomFields"){
                let URL = updateAutoCompleteURLforCustomFields(payload.URL,payload.pageType);
                if(URL && URL.indexOf('?') == -1)
                    URL = URL + '?';
                return {actionType:actionType,payload: URL};
            }
            if(actionType == "submitComment") {
                const { mouseEvent } = payload;
                startLoader();
                $scope.commentFromReact = true;
                window.highlightComment = false;
                if ($scope.globalData.isAutoExtractionPage) {
                    $scope.submitData($scope.saveCommentButton.api, $scope.data, "post", true, false, $scope.saveCommentButton, true);
                } else {
                    $scope.btnClick(mouseEvent,$scope.saveCommentButton);
                }
            }
            if(actionType == "inheritFile") {
                $rootScope.commentListScope.openInheritModal(payload.inheritFileFieldObj);
            }
            if(actionType == "moveToTree") {
                $rootScope.commentListScope.openMoveToTreeModal(payload.moveToTreeFieldObj);
            }
            if(actionType == "communicationDownload") {
                $scope.downloadCommentData(payload);
            }
            if(actionType == "communicationAttachmentDownload") {
                $scope.downloadCommentAttachmentData(payload);
            }
            if(actionType == "sendToSign") {
                const {userAccounts} = payload || {};
                $rootScope.callFromCommunication = true;
                $scope.openSendToSigModal(payload.sendForSigFieldObj,payload.flag,null,userAccounts[0]);
            }
            if(actionType == "updateFeedData"){
                showPageService.fetchFeedsData($scope);
            }
            if (actionType == "openReactCommentPopup") {
                let isSingleUpdate = payload.propsToPass.isSingleUpdate,
                    keyToUpdate = payload.propsToPass.key,
                    isDelete = payload.propsToPass.isDelete,
                    scopeData = payload.propsToPass.scope;
            }
            if (actionType == "commentAndAttachmentBulkCreatePopup" || actionType == "commentAndAttachmentBulkUpdatePopup") {
                let scopeData = payload.propsToPass.scope;
                let uploadedFiles = {files: payload.uploadedFiles};
                let isBulkCreate = true;
                if (actionType == "commentAndAttachmentBulkUpdatePopup")
                    isBulkCreate = false;
                contractLineItemService.uploadBulkFile.call(scopeData, uploadedFiles, isBulkCreate);
            }
            if(actionType == "deleteComment" && !$rootScope.aeDocShowPage && !$scope.showWorkspaceView){
                $scope.renderActionbuttons()
            }
            if(actionType == 'updatedContractTemplateLockInfo'){
                $scope.fromTagsOutlineComp = true;
            }
            if(actionType == "fetchUpdatedRows"){
                $scope.fetchUpdatedRowData(payload);
            }
            if(actionType == "updatedDocProps"){
                $scope.docPropsUpdated(payload.dataURL, payload.dataExist, payload.fieldId);
                $scope.getTagMetadataToUpdate();
            }
            if(actionType == "unmountReactComponent" && payload.unmountPoint) {
                const unmountAt = document.querySelectorAll(payload.unmountPoint)[0];
                if(unmountAt){
                    window.reactComponents && window.reactComponents.unmountDynamicComponent(unmountAt);
                }
            }
            if(actionType == "refreshMyTableData"){
                 if (_.get($scope.tagsToUpdate, "discrepancy.documentTagDiscrepancyDetails")) {
                    $scope.tagsToUpdate.discrepancy.documentTagDiscrepancyDetails = [];
                }
                $rootScope.$broadcast("refreshData");
            }
            if(actionType == 'submitData'){
                let field = $scope.wfFields;
                let data = $scope.data;
                $location.search('wfId', null);
                if(payload?.fromNewEsignature){
                    $scope.fromNewEsignature = payload.fromNewEsignature;
                    $scope.newEsignatureSignType = payload.signType
                    $scope.newEsignRedirectionUrl = payload.redirectionUrl;
                }
                $scope.submitData(field.api, data, field.requestType, true, false, field)

            }
            if(actionType == "addParentFieldValues"){
                if (payload.fieldId) {
                    const field = {
                        "parentFieldId": payload.fieldId,
                        "parentFieldOptionId": _.get($scope.data, `${payload.fieldName}.values.id`) || null
                    };
                    if ($scope.sendForDigitalSignature) {
                        $rootScope.parentFldIds.unshift(field);
                    } else {
                        $rootScope.parentFldIds.push(field);
                    }
                }
            }
            if(actionType == "checkSendForDigitalSignature") {
                $scope.checkSendForDigitalSignature(payload.shouldTriggerEsignFlow);
            }
            if(actionType == "initiateEsignUserAuthFlow") {
                $scope.esignUserAuthFlow();
            }
            if(actionType == "titleUpdate") {
                $scope.applyScope($scope);
            }
            if(actionType == 'sendForSignature'){
                const _payload = {calledFromContractDocument :true};
                Object.assign(_payload,payload)
                $rootScope.$emit("openSendForSig", _payload);
            }
            if(actionType == 'upload_file') {
                if (payload.showContractUpload) {
                    $scope.documentContractUpload(payload.inputRef, null, payload.files, payload.showContractUpload);
                } else {
                    docTreeService.fromRightSecDocUpload = true;
                    $scope.uploadContractDoc(payload.inputRef, payload.files, true);
                }
            }
            if (actionType == 'update_contractlist') {
                if (payload.showContractUpload)
                    $('.contractDocUploadDir').scope().fileData = payload.files;
                else {
                    docTreeService.fromRightSecDocUpload = true;
                    docTreeService.contractDocuments = payload.files;
                }
            }
            if(actionType == 'toggleUploadDocPage') {
                $scope.showUploadDocuments = true;
                $scope.forceHideRightSec = false;
                $scope.expandLeftSection = false;
                const tableSc = $(".importFromCdr [my-table]").eq(1).scope();
                if (!payload.showContractUpload || $scope.fromSupplierDropdown) {
                    if (tableSc && tableSc.tableServerData && tableSc.tableServerData.length > 0) {
                        docTreeService.attachSelectedDocRowsInDocuments($scope);
                    }
                    docTreeService.getTreeJson();
                }
            }
            if(actionType == "updateDraftMetadata") {
                const sc = $('.contractDocUploadDir').scope();
                sc && (sc.metaData = payload.metaData);
            }
            if (actionType == 'openPropertiesModal') {
                if (payload.showContractUpload)
                    $scope.openCdrPropertiesModal($('.contractDocUploadDir').scope());
                else
                docTreeService.openFilePropertiesModal(false, docTreeService.contractDocuments);
            }
            if(actionType == "loadPdfForFeedDocument") {
                const {documentFileId,id} = payload.document.properties || {};
                $scope.cdrPreviewDataLoaded(payload.document.name,id,documentFileId);
            }
            if(actionType == "openShareWithCounterParty") {
                $scope.shareWithCounterParty();
            }
            if(actionType == "multiESignature") {
                const selectedAccount = Object.assign({},payload);
                $rootScope.$emit("openSendForSig", {selectedAccount});
            }
            if(actionType == "uploadCustomFile") {
                window.globalUploadButtonActive = payload.documentId || "";
                $scope.feedDraftUploadData = {
                    draftMetadata: payload.draftMetaData,
                    hasDocumentTagEditAccess: payload.hasDocumentTagEditAccess,
                }
                if(payload.fromDropZone) {
                    $scope.feedDraftUploadData.files = payload.files;
                }
                $scope.documentContractUpload(payload.elem);
            }
            if(actionType == "openMultiEsigAccountList") {
                $rootScope.$emit("clickAccountList");
            }
            if(actionType == "refreshContractDocTabData" && $rootScope.contractDocTabDataUrl) {
                $scope.$broadcast("refreshData", {dataURL: (appName + $rootScope.contractDocTabDataUrl)});
            }
            if(actionType == "setSignatureAccountsList") {
                $rootScope.signatureAccountsList = payload.signatureAccountsList;
            }
            if(actionType == "getMultiAccountReqInfo") {
                return {
                    actionType,
                    payload: {
                        parentFldIds:$rootScope.parentFldIds,
                    }
                }
            }

            if(actionType == 'contractCardFiltering'){
                $scope.$broadcast("contractCardFiltering", payload.deviationStatus, payload.documentFileIds);
            }
            if(actionType == "metadata-updated") {
                window.sarc.channelBroadcast("generateFirstDraft", {
                    actionType:'fetchCardDetails'
                }, 'generateFirstDraftSubscription')
                $rootScope.showDocVariationReviewBtn = false;
                $scope.$apply();
            }
            if(actionType == "updateDocVariationReviewBtn") {
                $rootScope.showDocVariationReviewBtn = payload.showDocVariationReviewBtn;
                $rootScope.$applyAsync();
            }
            if(actionType == 'mountCliTemplatePopup'){
                var sc = $("[line-Item-Details]").scope();
                cliCommonService.mountCliTemplatePopup(sc,'contract-template-popup');
            }

            // if (actionType == 'addTemplateInClauseSection') {
            //     var sc = $('.clause-library-container').scope();
            //     payload.tables.map((table, i) => {
            //         let obj = {
            //             columnSequence: {},
            //             heading: true,
            //             numbering: table.tableNumbering,
            //             header: payload.templateName,
            //             templateType: payload.templateId,
            //             tableName: table.tableName,
            //             lineItem: true
            //         }
            //         table.tableColumns.map((itm, ind) => obj.columnSequence[ind + 1] = itm.columnName);
            //         table.tableNumbering && table.tableNumbering == 'yes' && (obj.numbering = true);
            //         sc.selectedClauses.push(obj);
            //         sc.selectedClauses = SirionUtils.updateSelectedClauseIndex(sc.selectedClauses);
            //         $scope.$apply();
            //     })
            // }
            if (actionType == 'addTemplateInClauseSection') {
                var sc = $('.clause-library-container').scope();
                let obj = {
                    columnSequence: {},
                    heading: true,
                    numbering: payload.tableNumbering,
                    header: payload.templateName,
                    templateType: payload.templateId,
                    tableName: payload.tableName,
                    tableId: Number(payload.tableId),
                    lineItem: true,
                    filterQuery: ''
                }
                payload.tableColumns.map((itm, ind) => obj.columnSequence[ind + 1] = itm.columnName);
                payload.tableNumbering && table.tableNumbering == 'yes' && (obj.numbering = true);
                sc.selectedClauses.push(obj);
                sc.selectedClauses = SirionUtils.updateSelectedClauseIndex.call(sc,sc.selectedClauses);
                $scope.$apply();
            }
            if (actionType == 'removeTemplateInClauseSection') {
                var sc = $('.clause-library-container').scope();
                _.forEach(sc.selectedClauses, (clause, index) => {
                    if (clause.templateType && (clause.templateType === payload.activeTemplateId && Number(clause.tableId) === Number(payload.activeTableId))) {
                        sc.selectedClauses.splice(index, 1);
                        return false;
                    }
                })
                sc.selectedClauses = SirionUtils.updateSelectedClauseIndex.call(sc,sc.selectedClauses);
                $scope.$apply();
            }
            if (actionType == 'updateLineItemTemplateNumbering') {
                payload.updateNumbering = true;
                cliTableUpdate(payload);
            }
            if (actionType == 'updateLineItemTemplateName') {
                payload.updateName = true;
                cliTableUpdate(payload);
            }
            if(actionType == "openSupplierModal"){
                let supplierKey = $scope.data['suppliers'] ? 'suppliers' : $scope.data['supplier'] ? 'supplier' : '';
                if(!$.isEmptyObject(olderScope)) {
                    if(olderScope.data.hasOwnProperty(supplierKey) && olderScope.data?.[supplierKey]?.values) {
                        olderScope.data[supplierKey].values = _.cloneDeep($scope.data[supplierKey].values);
                    }
                }
                $scope.plusIconReq(payload.jspApi, payload.label, payload, null, null, null, null, true);
                $scope.iconClassName = $rootScope.NumToSPClassNameMapping['1']
            }
            if (actionType == 'updateNextWFStepBtnStatus') {
                updateNextWFStepBtnStatusInRightSection();
            }
            if (actionType == 'clearDefinationCount') {
                $rootScope.definitionsCount = 0;
                SirionUtils.openReactModalFromAngular('#dm-line-item', null, 'resetData', "LineItemDetails", 'lineItemDetailsChannel', 'lineItemDetailsChannelSubscription');
            }
            if(actionType == 'openOnlineEditor'){
                const {entityId, entityTypeId, documentFileId, documentName} = payload;
                listService.openOnlineEditor(null, null, entityId, entityTypeId, null, documentFileId, documentName);
                if(!$scope.$$phase){
                    $scope.$apply();
                }
            }
            if(actionType == 'openEditor') {
                const {documentFileId, documentName, entityId, shortCodeId} = payload;
                listService.openEditor(documentFileId, documentName, entityId, shortCodeId);
                if(!$scope.$$phase){
                    $scope.$apply();
                }
            }
            if(actionType == 'loadAeMetadata') {
                const {fieldId,type} = payload;
                $scope.getSpecificExtractionData(fieldId,type);
            }
            if(actionType == 'resizeEditWindow'){
                let component = document.getElementsByClassName('left-sec active-index-0')[0];
                if(payload){
                    component?.classList.remove('expandedTables');
                    $scope.tableExpanded = false;
                }else{
                    component?.classList.add('expandedTables');
                    $scope.tableExpanded = true;
                    if($scope.commentDataScope && !$scope.isCreateRoute){
                        $scope.setCommDataScope($scope.commentDataScope);
                    }
                }
                window.sarc.channelBroadcast("reactDynamicForms", {
                    actionType: "expandTables",
                    value: !payload
                },`dfSubscriptions_${$scope.globalData.dynamicFormId}`);
            }
            if(actionType == 'updatePlayBookData'){
                const {playbookClauseCategories} = payload;
                if(_.get($scope,'data.playbookClauseCategories')){
                    let populatedCategories = playbookClauseCategories.filter(c => !_.isEmpty(c.playbookRules[0].riskCategory))
                    $scope.data.playbookClauseCategories.values = populatedCategories;
                }
            }
            if(actionType == 'handleRedirectionFromShortId'){
                const {shortCodeId, getProjectName} = payload;
                showPageService.handleRedirectionFromShortCodeId(shortCodeId,'show',null,getProjectName);
                return;
            }
            if(actionType == 'updateProjectData'){
                const { baseClauseTextData } = payload;
                if(_.get($scope,'data.baseClauseTexts')){
                    $scope.data.baseClauseTexts.values = baseClauseTextData;
                }
            }
            if(actionType == 'updateFieldData'){
                const { projectFields } = payload;
                if(_.get($scope,'data.projectFields')){
                    $scope.data.projectFields.values = projectFields;
                }
            }
            if(actionType == 'showPlaybookBreadCrumb') {
                $scope.showPlaybookBreadCrumb = true;
            }
            if(actionType == 'initDownloadDrs'){
                listService.downloadInit(payload.event, payload.file)
            }
            if(actionType == "openSignatureFeedCard"){
                if(payload?.fromAdobeSign){
                    $scope.signatories = false;
                }
                if(payload?.showEsignIcon){
                    $scope.showEsignIcon = true;
                }
                // Checking E-sign status for e-signature feed card section like [NA, In Progress, Complete]
                // Checking if entity is CR(63) & WOR(80)
                else if($scope.eSignStatusIds['showPageAPI'].includes($scope?.data?.eSignatureStatus?.values?.id) || $scope.eSignStatusIds['eSignAPI'].includes($scope.RealTimeESignStatusCode) || [63,80].includes($scope.data?.entityTypeId?.values)){
                    $scope.setSignatoriesDataScope(true,null,true)
                }
            }
            if(actionType == 'MeetingMinuteFileUpload'){
                var sc = $('[meeting-details]').scope();
                sc.uploadMeetingFile(payload.inputRef,payload.fileToSend);

            }
            if(actionType == "MeetingMinuteFileDelete"){
                var sc = $('[meeting-details]').scope();
                let item=payload.item;
                item["documentId"]=item["docId"];
                delete item["docId"];
                sc.deleteFile(item,payload.event,payload.bool);
            }
            if(actionType == "setRealTimeEsignatureStatus"){
                $scope.RealTimeESignStatusCode = payload.dSignStatusCode;
            }
            // UI-40261
            if(actionType == "openDocTree"){
                $scope.openDocTree();
                window.sarc.channelBroadcast("docTreeChannel", { actionType: actionType, value: args.value }, 'docTreeChannelSubscription')
            }
            if(actionType == "openReactDynamicForm"){
                $scope.responsePopUp(payload,false,$scope.wfFields)
            }
            if(actionType == "openDiscrepancyReviewModal"){
                $scope.getTagMetadataToUpdate(true, payload.entityId);
            }
            if(actionType == "docUploadLink"){
                docTreeService.uploadFileLink(payload)
            }
            if(actionType === 'updateFeedFromSSE'){
                const {action, channel, subscription} = payload;
                window.sarc.channelBroadcast(channel, {
                    actionType : action
                }, subscription)
            }
            if(actionType === 'updateTabFromSSE'){
                const targetTabId = mapTableIdToTabId[payload.id];
                // Special handling for clause analytics tab - to re-initialise directive
                if(!payload.fromFullRefresh && payload.id != 3505){
                    $scope.highlightedTabsMap[targetTabId] = true;
                    $timeout(function() {
                        $scope.highlightedTabsMap[targetTabId] = false;
                    }, 2000);
                }
                if(payload.id === 4284){
                    SirionUtils.resetMTab(0, '.contractClauseTab')
                    setTimeout(()=>{
                        SirionUtils.resetMTab(payload.id, '.contractClauseTab')
                    },100)
                } else {
                    if(payload.id == 3910){
                        $scope.getHeadContractDoc();
                    }
                    const table = document.querySelector(`#table_${payload.id}_wrapper table`);
                    if (table) {
                        let option = table.getAttribute('option');
                        if (option) {
                            option = JSON.parse(option);
                            console.log(option)
                            option[0].isSSERefresh = true;
                            $(table).scope().$broadcast("refreshData", option[0])
                        }
                    }
                }
            }
        }, "reactToAngular");
    }};
    $scope.tableExpanded=false;
    $scope.collapseTable = function() {
        $scope.tableExpanded = false;
        window.sarc.channelBroadcast("reactDynamicForms", {
            actionType: "expandTables",
            value: false
        },`dfSubscriptions_${$scope.globalData.dynamicFormId}`);
    }
    function updateNextWFStepBtnStatusInRightSection() {
        window.sarc.channelBroadcast("timelineFeeds", {
            actionType: "showNextWFStepBtn",
            value: $scope.showNextWFStepBtn
        },`timelineFeedsSubscription`);
    }

    var pdfJsPermissionFlagsCleanup = () => {
        delete window.pdfJsPermissionFlags.hasDownloadBtn
        delete window.pdfJsPermissionFlags.closeBtn
    }

    $scope.$on("$destroy",function(e){
        cleanup();
        if(!$scope.showPageModalOpen)
            window.sarc.channelUnsubscription('reactDynamicForms', "reactToAngular");
        delete $scope.showPageModalOpen;
        delete $rootScope.updatedFieldsArray;
        delete $rootScope.invoiceCopyActionBtns;
        delete $rootScope.invoiceName;
        delete $rootScope.fromDocViewer;
        //since the docTreeService.uploadDocLayout variable should re-initialize when we change showPage of an entity.
        if(docTreeService?.uploadDocLayout)
            docTreeService.uploadDocLayout = "";

        if($rootScope.bulkedit) {
            window.sarc.channelUnsubscription('reactDynamicForms', `dfSubscriptions_${$scope.globalData?.dynamicFormId}`);
        }
        delete window.downloadDocument;
        pdfJsPermissionFlagsCleanup();
        window.sarc.channelUnsubscription('muiCliEvents', "muiCliEventsChannel");
        window.sarc.channelUninstall('wfButtonsReady');
        window.sarc.channelUnsubscription('dataFromReactMeetingNote', "dataFromReactMeetingNoteSubscription");
        delete window.metadataModified;
        delete window.isSSETriggered;
        clearTimeout(window.pendingSSERefreshTimer);
        delete window.pendingSSERefreshTimer;
        delete window.pendingSSERefreshIsFull;
        document.getElementById('simple-snackbar')?.remove();
        var modalPortal = document.querySelector('.modal_tag_discrepancy');
        if (modalPortal) {
            modalPortal.remove();
        }
    });

    $rootScope.asyncInvoiceCopyGeneration = function (){
        $rootScope.cancel();
        refreshDataForInvoiceCopy();
    }

    function refreshDataForInvoiceCopy() {
        const invoiceShowPageReqUrl = '/baseInvoice/show/' + $scope.data.id.values + '?version=2.0';
        const fieldsToUpdate = ['invoiceCopyName','comment'];
        $http.get(invoiceShowPageReqUrl).then(function (resp) {
            angular.forEach(fieldsToUpdate, function (val) {
                $scope.data[val] =  resp.data.body.data[val];
            });
            $scope.renderActionbuttons(null, true);
            showPageService.updateCommentAndFeeds.call($scope);
        });
    }

    $scope.invoiceBtnClickHandler = function (event, callFromBanner) {
        if(!callFromBanner){
            const targetEl = angular.element(event.target);
            if(targetEl.hasClass('disabled')){
                return;
            }
        }

        // Multiple || Single item
        const api = (this.item) ? this.item.api : $scope.invoiceBtnArr[0].api;
        $scope.jsonApi =  $window.jsonApi = (callFromBanner) ? $scope.invoiceRegenerateBanner.api : api;
        // Generate invoice copy
        const msg = intl_msg[31028] || 'This action would replace existing invoice copy. Are you sure you want to upload a new invoice copy.';
        if($scope.jsonApi.indexOf('/invoice-copy/generate?invoiceId=') > -1){
            const args = {
                popupType: 'confirm',
                str: msg,
                heading: intl_msg[25772],
                yesCbFn: function () {
                    $rootScope.isInvoiceViewerActive = false;
                    // Init Modal
                    var modalToClose;
                    const args = {
                        popupType:'alert',
                        str: intl_msg[31029] || "Please wait. Generating Invoice Copy…",
                        heading: intl_msg[24153],
                        hideLoader: true,
                        hideBtn: true,
                        rmvCloseBtn: true
                    }
                    SirionUtils.openSirionDialogs(args);
                    if ($scope.alertBoxes.length > 0) {
                        modalToClose = $scope.alertBoxes[$scope.alertBoxes.length - 1];
                    }
                    $http.get(addtStamp($scope.jsonApi)).then(function (resp) {
                            SirionUtils.openSirionDialogs({}); //closing new popup after API success
                            args.yesCbFn = "asyncInvoiceCopyGeneration";
                            args.yesName = intl_msg[24184];
                            if(!resp.status == 200){
                                const errorMsg = (resp.data && resp.data.description) || 'Something went wrong.';
                                args.str = errorMsg;
                                SirionUtils.openSirionDialogs(args);
                            } else{
                                const asyncReqMessage = resp.data && resp.data.message;
                                if(asyncReqMessage){
                                    // ASYNC Request(Show popup)
                                    args.str = asyncReqMessage;
                                    SirionUtils.openSirionDialogs(args);
                                }else{
                                    // SYNC request
                                    /* TODO: Download File OR show Tooltip */
                                    refreshDataForInvoiceCopy();
                                }
                            }
                    }, function errorCallback(error) {
                        console.error('Data cannot be loaded due to: ' + error);
                    });
                },
                noCbFn: function () {
                    return false;
                }
            }
            SirionUtils.openSirionDialogs(args);
        }
        // Upload invoice copy
        else{
            if($rootScope.invoiceBtns && $rootScope.invoiceBtns.length - 1 > 0) {
                const args = {
                    popupType: 'confirm',
                    str: msg,
                    heading: intl_msg[25772],
                    yesCbFn: function () {
                        $scope.showInvoiceUploadDialog = {visible: true}
                    },
                    noCbFn: function () {
                        return false;
                    }
                }
                SirionUtils.openSirionDialogs(args);
            }else {
                $scope.showInvoiceUploadDialog = {visible:true}
            }
        }
    }
    $scope.removeDialogContainer = function() {
        $scope.showInvoiceUploadDialog && ($scope.showInvoiceUploadDialog.visible = false);
        if($scope.showBulkEditDialog || $scope.showCreateDialog){
            checkedVal = [];
            $("#cr").dataTable().fnDraw();
        }
        $rootScope.myModelInstance && $rootScope.myModelInstance.close();
        $rootScope.myModelInstance = null;
    }
    $scope.chooseUploadOption = (eve) => {
        if (eve && eve.defaultValue) {
            $scope.radioButtonValue = eve.defaultValue;
            const domElm = document.getElementsByClassName('jx-fileListDiv')[0];
            domElm && (domElm.innerHTML = '');
        }
    };
    $scope.renderActionbuttons = function(localScope, refreshPageVars) {
        var scope = localScope?localScope:$scope;
        var jsonUrlOpts = $location.path().split("/");
        let actnGETUrl = apiVersioning.getApiDynamicVersion("actions") + urlToCodeMapper[jsonUrlOpts[2]] + "/" + jsonUrlOpts[3];
        var getActions = entityFactory.getJson(actnGETUrl, "GET");
        getActions.then(function (value) {

            if(value && value.layoutActions) {
                scope._renderActionButtons(scope, value.layoutActions, showPage2DataTransformationService);
                stopLoader();
            }
            if(refreshPageVars){
                showPageService.showInvoiceCopyToolTip(true);
                if(!$scope.expandLeftSection){
                    $rootScope.commentListScope.$broadcast('updateComment', true, true);
                }
            }
        });
    }

    $scope.invoiceDllClickHandler = function(url) {
        let urls = ['/download/communicationdocument','/commentAttachment/delete'];
        if(url.indexOf(urls[0]) > -1) {
            $window.location = $rootScope.appBaseApiUrl + url;
            angular.element("body").click()
        }
        else if(url.indexOf(urls[1]) > -1) {
            showPageService.deleteInvoiceCopy(url);
        }
    }
    $scope.closeViewer = function() {
        if($rootScope.isInvoiceViewerActive) {
            $rootScope.isInvoiceViewerActive = false;
            // re-open right section if it was in opened state before.
            $scope.openRightSection();
        }
    }
    $scope.loadInvoiceContentHandler = function (showDocument = false) {
        if($rootScope.isInvoiceViewerActive) {
            return;
        }
        $scope.fixToggleStates();
        const invoiceToolTip = angular.element(".dataDescTip_Info.bounce_Me");
        showPageService.showToolTip(invoiceToolTip, false);
        $rootScope.isInvoiceViewerActive = showDocument;
        var url = "/baseInvoice/getInvoiceCopyViewerLink/";
        $timeout(function () {
            var element = $(".invoiceViewer");
            if(element && element.length)
                showPageService.loadInvoiceContent($scope,url,element,$scope.data.id.values, showDocument)
        },0)
    }

    $scope.setInvoiceDocIcons = function (name) {
        $timeout(function () {
            var element = document.getElementById("invoiceDocIcon");
            var classes = element ? element.className.split(" ") : [];
            var c1 = classes.filter(function (x) {
                return (x.indexOf("icon-")!=-1)
            });
            if(name && typeof name === "string") {
                c1.forEach(function (x) {
                    element.classList.remove(x);
                })
                var a = name.split("."),
                    lastIndex = a.length -1;
                if(a[lastIndex]=="pdf")
                    a[lastIndex] = "PDF"
                var cls = "icon-"+a[lastIndex];
                angular.element(".inv_Copy_Action").find(".invoice-doc-icon").addClass(cls);
            }
        },0)
    }

    $scope.preventRestrictedChars = (event) => {
        let value = event.currentTarget.value;
        if(value && ["=","@"].indexOf(value[0]) > -1 ) {
            $(event.currentTarget).val('')
            event.preventDefault();
        }
    }

    //=================== pdfJsViewer Handling ====================================

    function getIframeRef() {
        let iframe = document.getElementsByClassName('iframe_contract_template')[0];
        if(iframe)
            return document.getElementsByClassName('iframe_contract_template')[0].contentWindow;

        return null;

    }

    window.setPdfJsPermissions();

    $scope.handleUploadSectionVisibility = (val) => {
        if($scope.pageType != 'show' && val && val !== -1) {
            $scope.timeLineFeedScope = -1;
            $scope.expandLeftSection = false;
            $scope.commentDataScope = -1;
            $scope.tagsOutlineFeedScope = -1;
            $scope.versionHistoryFeedScope = -1;
            $scope.signatories = false;
            $scope.updateRightSectionState('handleUploadSectionVisibility',val);
        } else {
            $scope.expandLeftSection = true;
        }
    }

    $scope.fixToggleStates = () => {
        // persisting previous right section state before its reset.
        let isRightSecActive = localStorage.getItem('isRightSectionActive')
        if($scope.timeLineFeedScope && $scope.timeLineFeedScope != -1) {
            $scope.setTimelineFeedDataScope(-1);
            // updating right section's state with its previous state after reset
            localStorage.setItem('isRightSectionActive', isRightSecActive);
        }
        else if($scope.commentDataScope && $scope.commentDataScope != -1) {
            $scope.setCommDataScope(-1);
            localStorage.setItem('isRightSectionActive', isRightSecActive);
        }
    }

    $scope.fetchDownloadFunctionalityForMira = function(payload){
        let {parentEntityId, entityId} = payload;
        $scope.documentId = entityId;
        showPageService.getContractDownloadPermission($scope, parentEntityId, entityId);
    }
    $scope.loadPdfJsViewer = function(documentdata) {
        if ($scope.previewTab && $scope.previewTab.isActive) {
            $scope.previewTab.isActive = false;
        }
        window.pdfJsPermissionFlags.isPdfStream = true;
        window.setPdfJsPermissions(_.get($scope.data,"entityTypeId.values"));
        !$scope.showCommentPanelInRightSec && $scope.fixToggleStates();
        if(!window.documentScope) {
            window.documentScope = {};
        }
        if (documentdata) {
            $scope.loadPdfJsInside = true
            var data = $scope.data[documentdata]["values"];
            data.loadLists = true;
            data.allowCopy = true;
            $scope.documentFileId = data.fileId;
            let documentObj = _.get($scope.data,documentdata);
            data.parentEntityTypeId = 61  // Need to be hardcoded              // _.get($scope.data,"parentEntityTypeId.values");
            data.parentEntityId = _.get(documentObj,"values.contractId");
            try {
                data.entityId = _.get(documentObj,"values.itemId");
                data.entityTypeId = 23;
            } catch(e){}

            $scope.shouldPageUpdate = true;
            window.docViewerParams = data;
            $scope.documentOpenWithForm = false;
        }else {
            window.docViewerParams.entityId = window.docViewerParams.documentId;
            const currentUrl = window.location.hash;
            if(currentUrl.includes('/ask-sirion')){
                window.docViewerParams.parentEntityTypeId = window.docViewerParams.entityTypeId;
                window.docViewerParams.parentEntityId = window.docViewerParams.entityId;
            }
            if(window.docViewerParams.parentEntityTypeId == 160){
                window.docViewerParams.entityTypeId = 78;
                if(!window.docViewerParams.auditLogDocumentId){
                    window.docViewerParams.auditLogDocumentId = window.docViewerParams.documentId;
                }
                if(window.docViewerParams.fileId){
                    window.docViewerParams.entityId = window.docViewerParams.fileId;
                }
            } else {
                window.docViewerParams.entityTypeId = 23;
            }

            if(!$scope.miraSummaryView)
                $scope.documentOpenWithForm = true;
            $scope.shouldPageUpdate = false;
        }
        if(SirionUtils.getParameterValueFromURL(window.location.href,"mergeDir")) {
            window.docViewerParams.mergeDir = true;
        }
        const currentUrl = window.location.hash;
        if(["/show/tblcontracts/", "/show/tblcontractdocuments/"].some(url => currentUrl.includes(url))){
            let {parentEntityId, entityId} = window.docViewerParams;
            if(currentUrl.includes("/show/tblcontracts/")){
                parentEntityId = $scope.data.id.values;
            }
            showPageService.getContractDownloadPermission($scope, parentEntityId, entityId);
        }

        let iframe = getIframeRef();
        if(!iframe || $scope.documentOpenWithForm)
            $(".left-sec.left-sec-docviewer").hide();

        $scope.fetchReqData = !!documentdata;13584

        $timeout(()=>{
            let _attrs = {
                scope: $scope,
                url: '',
                fetchReqData: !!documentdata
            }
            $scope.loadTemplateContent(_attrs);
        },0)

        var loadDocumentViewerOption = function loadDocumentViewerOption() {
            var apiurl = '/documentviewerstream/references';
            $http.get(apiurl).then(function (response) {
                window.documentScope.references = response.data;
            });
        };
        $ocLazyLoad.load(getFileNamesWithVersion(["src/scripts/dev/docviewer/docviewer.js", "src/scripts/jquery/jquery.Jcrop.min.js", "src/styles/jquery.Jcrop.css"])).then(function () {
            // loadDocumentView(documentScope);
            loadDocumentViewerOption();
        });
    }

    $scope.loadTemplateContent = function(attrs) {
        var {scope, url,fetchReqData} = attrs
        stopLoader();
        startLoader();
        if(!$rootScope.documentPageCordinates){
            $rootScope.documentPageCordinates = {};
        }

        let {parentEntityTypeId,parentEntityId,entityTypeId,entityId,auditLogDocumentId} = window.docViewerParams,
            showPageEntityTypeId = _.get(scope.data,"entityTypeId.values"),
            pageReferenceId = window.docViewerParams.pageReferenceId,
            additionalSuffix = '';

        /*
        * 12 : Obligations
        * 13 : Child Obligations
        * 14 : Service Levels
        * 15 : Child Service Levels
        * 16 : Interpretation
        * 63 : Change Request
        * 80 : Work Order Requests
        * */

        if([12,13,14,15,16,63,80].indexOf(showPageEntityTypeId) > -1 && pageReferenceId) {
            additionalSuffix = '&pageReferenceId='+ pageReferenceId;
        }


        // Build URL for document viewer
        const basePath = parentEntityTypeId + '/' + parentEntityId + '/' + entityTypeId + '/' + entityId;
        let docApiUrl = "";
        if(parentEntityTypeId == 160){
            // CDR: strictly follow pattern without allowDynamicConversion or extra params
            let urlSuffix = basePath;
            urlSuffix += "?auditLogDocumentId=" + (auditLogDocumentId || '');
            docApiUrl = "/documentviewerstream/check/" + urlSuffix + "&_t=" + new Date().getTime();
        } else {
            let urlSuffix = basePath + "?allowDynamicConversion=true" + additionalSuffix;
            if(auditLogDocumentId) {
                urlSuffix += "&auditLogDocumentId=" + auditLogDocumentId;
            }
            $scope.OriginalCheckRequired && (urlSuffix += "&checkOriginal=true");
            docApiUrl = "/documentviewerstream/check/" + urlSuffix + "&_t="+ new Date().getTime();
        }

        return $http.get(docApiUrl).then(function (response) {
            stopLoader();
            if (_.has(response,'data.data') && response.data.data!= null) {
                $rootScope.documentPageCordinates.bottom = false;
                $rootScope.tabListDataLoaded = false;
                $rootScope.pdfDataLoading = false;
                scope.renderPdfJsViewer(scope, response.data);
            }else {
                scope.renderPdfJsViewer(scope, response.data);
            }
        });
    }

    $scope.renderPdfJsViewer = function (scope,response) {
        $scope.expandDocTree = false;
        if($scope.showDocTree && !$scope.mergeDir) {
            $scope.togglePropValue('showDocTree');
            $scope.togglePropValue('hideDocTree',true);
            $scope.togglePropValue('doctreeFullSize',false);
            $scope.togglePropValue('tabFullWidth',true)
        }
        if($scope.mergeDir){
            setTimeout( ()=> angular.element(".doc-tree").click() ,100);
        }

        let eleSelector =  "#pdfJsContainer";
        $(eleSelector).closest(".left-sec.left-sec-docviewer.pdfviewer").show();
        $(eleSelector).addClass("contractTemplateContent");
        if($scope.miraSummaryView) {
            $(eleSelector).addClass("miraPdfViewer");
        }

        if(!response.data) {
            var noDataHtml;
            if(response.error) {
                noDataHtml = "<div class='noTemplate'><div class=\"noDataToDisplay\"><div class=\"no-data-image\">  <video style='height: 160px;' id=\"docViewerNoData\"   muted=\"true\" preload=\"auto\" autoplay loop><source src=\"src/images/mp4/doc-viewer.mp4\"  type=\"video/mp4\"></video><span class=\"no-data-text\">"+response.error[0].message+"</span></div></div>";
            }else {
                noDataHtml = "<div class='noTemplate'><div class=\"noDataToDisplay\"><div class=\"no-data-image\">  <video style='height: 160px;' id=\"docViewerNoData\"   muted=\"true\" preload=\"auto\" autoplay loop><source src=\"src/images/mp4/doc-viewer.mp4\"  type=\"video/mp4\"></video><span class=\"no-data-text\"></span></div></div>";
            }
            $(".contractTemplateContent").html('');
            $(".contractTemplateContent").append($(noDataHtml));
            return
        }
        if(response.data.hasDocumentAccess){
            window.docViewerParams.hasDocumentAccess = response.data.hasDocumentAccess;
        }
        var iframeHtml = "";
        if($scope.mergeDir){
            response.data.documentURL = '/documentviewerstream/document/'+$scope.mergeDir;
        }
        var arr = response.data.documentURL.split("?");

        var viewerUrl ='';
        $scope.OriginalCheckRequired && (response.data.documentURL += "?checkOriginal%3Dtrue");
        const combinator = $scope.OriginalCheckRequired ? '%26' : "?";
        viewerUrl = `src/views/${pdfViewerFolder}/web/viewer.html?file=` + window.location.origin + response.data.documentURL;
        if(arr.length >1 && response.data.documentURL.indexOf('?')>-1){
            viewerUrl = `src/views/${pdfViewerFolder}/web/viewer.html?file=` + window.location.origin + arr[0]  +"%3F" + arr[1].replace("=","%3D") + "%26_t%3D" + new Date().getTime()    ;
        } else {
            viewerUrl = viewerUrl + combinator +"_t%3D"+ new Date().getTime()
        }
        iframeHtml = '<iframe id="pdfJs" allowfullscreen="true " src = "' + viewerUrl + '" class="iframe_contract_template" scrolling="no" border="0" height="100%" width="100%"></iframe>';

        $(".contractTemplateContent").html('');
        $(".contractTemplateContent").append($(iframeHtml));

        setTimeout(function () {
            if ($("iframe.templateDocContentIframe").is(":visible")) {
                resizeIframe($("iframe.templateDocContentIframe")[0]);
            } else {
                resizeIframe($(".iframe_contract_template")[0]);
            }
            if(response.contractLineItem) {
                let lessHeight = $('.doc_preview_panel .doc_info').height() || 0;
                $("#pdfJsContainer").height(($('.doc_preview_panel').height() - lessHeight) + 'px');
            }else {
                $("#pdfJsContainer").height($(".tab:visible").height());
            }

            try {
                angular.element(".iframe_contract_template").contents().find("body").width("100%");
                $rootScope.adjustScreenSize();
            } catch (ex) {}

        }, 500);

        stopLoader();
    }

    var updateHighlightObject = function (pageNo,callbackFn,argsArray) {
        let iframeElement = getIframeRef();
        if(!pageNo && !iframeElement)
            return;
        $scope.page = pageNo || iframeElement.getCurrentPageNo();
        $scope.documentId = docViewerParams.documentId || docViewerParams.itemId;
        var url = "/tblcontractdocuments/getentities/" + $scope.documentId + "/" + $scope.page;
        var nameMapper = {
            "obligations": "OB",
            "cob": "COB",
            "interpretations": "IP",
            "csl": "CSL",
            "sl": "SL",
            "cr": "CR",
            "wor":"WOR"
        };
        //@todo Commenting this code to prevent this api call : /tblcontractdocuments/getentities (Pending on product : Ravi Verma)
        if( $scope.page) {
            window.documentScope.highlightObject = null;
            var promise = requestData("get", url);
            promise.success(function (res) {
                for (var i in res) {
                    if( res[i] && res[i].length){
                        res[i].forEach(function (d, j) {
                            d["info"]["entityCode"] = nameMapper[i];
                        });
                    }
                }
                window.documentScope.highlightObject = res;
                $scope.showAutoExtractionResultTile && $scope.showAutoExtractionResultTile(res.ae);
                if (angular.isDefined(callbackFn) && typeof callbackFn == "function") {
                    if(argsArray)
                        callbackFn(argsArray[0], argsArray[1], argsArray[2], argsArray[3]);
                    else callbackFn(true);
                }
            })
        }
    }

    window.updatePage = (pageNo) => {
        return new Promise( (resolutionFunc,rejectionFunc) => {
            if($scope.shouldPageUpdate) {
                if(documentScope.viewPageList) {
                    $scope.$broadcast("updatePage", pageNo, documentScope.viewPageList,resolutionFunc,null,true);
                }
                else updateHighlightObject(pageNo,resolutionFunc);
            }else {
                window.docViewerParams && updateHighlightObject(pageNo);
                resolutionFunc(true);
            }
        });
    }


    var updatePg= $scope.$on("updatePage", function($event, data = 1,sendPage,callbackFn,argsArray,isUpdateHighlight) {
        let iframeElement = getIframeRef();
        if(!data && !iframeElement)
            return;
        $scope.page = data || iframeElement.getCurrentPageNo();
        $scope.documentId = docViewerParams.documentId || docViewerParams.itemId;
        var refreshed = {};
        $(".jx-tableInTabs").each(function() {
            var scopeTemp = $(this).scope();
            var filterData = {};
            if(scopeTemp.field && scopeTemp.field.id == 2072 && typeof listId != "undefined"){
                scopeTemp.field.hiddenTable = true;
            }
            if(scopeTemp.deferredInstance) {
                scopeTemp.deferredInstance.resolve("Initiated");
                scopeTemp.deferredInstance.promise.then(function () {
                    scopeTemp.deferred && scopeTemp.deferred.promise.then(function () {
                        if (angular.isDefined(scopeTemp.metaData) && angular.isArray(scopeTemp.metaData.filterMetadatas)) {
                            if (scopeTemp.metaData.queryName != "contractDocument.selectDocumentHistory") {
                                $rootScope.highlightPermission[scopeTemp.metaData.entityTypeId] = true;
                                $rootScope.highlightPermission[scopeTemp.metaData.entityTypeId + 'titleValue'] = commonUtil.parseDocViewerTooltip(scopeTemp.layout.fields, scopeTemp.metaData.entityTypeId);
                            }
                            if (!scopeTemp.metaData.integrationSystem &&scopeTemp.metaData.entityTypeId == 13 && !scopeTemp.otherListName) {
                                scopeTemp.field.hiddenTable = true;
                                $rootScope.otherListName = scopeTemp.field.label;
                            }
                            if (!$scope.$$phase) {
                                $scope.$apply();
                            }
                            $(".roundBox.inner").hide();
                            scopeTemp.metaData.filterMetadatas.forEach(function (filter) {
                                if (filter.queryName != "pageNumber" || (filter.queryName == "pageNumber" && sendPage)){
                                    filterData[filter.id] = {
                                        "filterId": "" + filter.id,
                                        "filterName": "" + filter.queryName
                                    };
                                }
                                if(filterData[filter.id]) {
                                    filterData[filter.id].multiselectValues = {};
                                    filterData[filter.id].multiselectValues.SELECTEDDATA = [];
                                    if ((filter.queryName == "pageNumber" && sendPage) || filter.queryName == "pageReference") {
                                        filterData[filter.id].multiselectValues.SELECTEDDATA.push({
                                            id: "" + $scope.page
                                        })
                                    } else if (filter.queryName == "references") {
                                        filterData[filter.id].multiselectValues.SELECTEDDATA.push({
                                            id: "" + $scope.documentId
                                        })
                                    }
                                }
                            });
                            scopeTemp.filterData = filterData;
                            if (!scopeTemp.dataTable && scopeTemp.deferred && scopeTemp.deferred.promise) {
                                scopeTemp.deferred.promise.then(function () {
                                    scopeTemp.$broadcast("initializeTable");
                                });
                            } else if (scopeTemp.dataTable) {
                                if (!refreshed[scopeTemp.metaData.id]) {
                                    scopeTemp.$broadcast("refreshData");
                                }
                                refreshed[scopeTemp.metaData.id] = true;
                            }
                        }
                    });
                });
            }

        })
        isUpdateHighlight && updateHighlightObject(data,callbackFn,argsArray);
    })

    window.copyCoordinatesToClipboard = function($data){
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(JSON.stringify($data)).select();
        document.execCommand("copy");
        $temp.remove();
    }

    //=================== pdfJsViewer End ====================================


    $scope.moveDocumentOpenModal = (attrs) => {
        let {docName,docId} = attrs;
        $scope.moveDocumentData = {
            docName,
            docId
        }
        $scope.moveDocumentDialogInstance  = $modal.open({
            templateUrl: $rootScope.createHtmlUrl("ui2.0/moveDocumentTemplate.html"),
            size: "lg",
            backdrop: "static",
            keyboard: false,
            scope:$scope,
            windowClass: "clonepopup move_document_dialog",
        });
    }

    var toggleView = () => {
        $scope.togglePropValue('expandLeftSection');
        $scope.togglePropValue('doctreeFullSize', false);
        $scope.togglePropValue('tabFullWidth',true);
        $scope.togglePropValue('leftSecTransition');
    }

    const mountOnlyCommunicationTab = (mountAt,propsToPass) => {
        const _props = {
            bulkPage: $rootScope.bulkedit,
            props:{
                data:$scope.data,
                globalData: $scope.globalData,
                layoutData:$scope.layoutData
            },
            globalData: $scope.globalData,
            state: {
                cData: $scope.data,
                additionalData:{}
            }
        }

        Object.assign(_props,propsToPass);

        if(!$scope.RDFSubscriptions.value) {
            $scope.RDFSubscriptions.value = true;
            $scope.RDFSubscriptions.init();
        }
        if(_.get($scope.showPage2DataTransformationService,"returnObj.rightTabInfo.length")) {
            let commTabList =_.filter($scope.showPage2DataTransformationService.returnObj.rightTabInfo,x=>x.type == "communicationTab");
            if(_.get(commTabList,"[0].fields.length")) {
                _props["props"]["communicationTab"] = commTabList[0].fields[0];
                _props["props"]["communicationTools"] = commTabList[0].fields.slice(1);
            }
        }
        window.reactComponents.mountDynamicComponent(mountAt,"CommunicationTab",_props);
    }

    $scope.updateRightSectionState = function (funcCall, funcValue) {
        let returnObj = showPage2DataTransformationService.returnObj;
        if(returnObj.leftTabInfo === null){
            // determining whether the general tab opens, i.e. (fresh / redirect showpagepage load). The selected tab is then reset to be general.
            returnObj.selectedTabObj = undefined;
        }
        let selectedTab = returnObj.selectedTabObj;
        showPageService.updateRightSectionState(funcCall,funcValue,selectedTab);
    }

    $scope.initializeCommunicationSec = (showCommentPanelInRightSec, commentHighlightProps) => {
        let mountAt = '#communicationTab-sec';
        const propsToPass = {
            commentDataScope:$scope.commentDataScope,
            fromScope: $scope.fromScope,
            drsEnabled: $scope.drsEnabled,
            drsObject: $rootScope.drsObject,
            validationError: $scope.noCmntAdValTriggered,
            hasCommentBtn: !!$scope.saveCommentButton,
            commentHighlightProps
        }

        if (showCommentPanelInRightSec) {
            $scope.commentProps = JSON.parse(JSON.stringify(propsToPass));
            return;
        }
        if (commentHighlightProps) {
            if (window.highlightComment == undefined) {
                window.highlightComment = true;
            } else {
                window.highlightComment = false;
            }
        }
        if($scope.commentDataScope && !($(mountAt).children().length)) {
            if($scope.globalData.dynamicFormId) {
                const _props = {
                    actionType: "mountCommunicationTab",
                    mountAt
                }
                Object.assign(_props,propsToPass);
                window.sarc.channelBroadcast("reactDynamicForms", _props,`dfSubscriptions_${$scope.globalData.dynamicFormId}`);
            }else {
                mountOnlyCommunicationTab(mountAt,propsToPass);
            }
        }else {
            if($scope.commentDataScope===1) propsToPass.scrollToBottom = true;
            window.sarc.channelBroadcast("communicationChannel", {
                actionType: 'commentScopeUpdate',
                value: propsToPass
            }, 'communicationChannel')
        }
    }

    $scope.initalizeEsignSection = function () {
        let mountAt = '#eSignFeed-sec';
        const propsToPass = {
            showPageId : $scope.data.id.values,
            entityTypeId : $scope.data.entityTypeId.values,
            timeStamp : $scope.globalData.datetimeFormatToShow,
            launchViewEnabled: $scope.launchViewEnabled,
            timeZone: $scope?.layoutData?.headerBar?.userData?.currTimeZoneString || null,
            integrationId: $scope.integrationId,
            closeModal : function(){
                return;
            }
        }
        if(!($(mountAt).children().length)) {
            if($scope.globalData.dynamicFormId) {
                const _props = {
                    actionType: "mountEsignTab",
                    mountAt
                }
                Object.assign(_props,propsToPass);
                window.sarc.channelBroadcast("reactDynamicForms", _props,`dfSubscriptions_${$scope.globalData.dynamicFormId}`);
            }
        }
    }

    $scope.setCommDataScope = function(val,isActive = false, showCommentPanelInRightSec, commentHighlightProps){
        showPageService.setPreviewTab(isActive,$scope);
        if ($rootScope.hideCommentToggle && !$scope.docTreeService.showPlaybook) val = 1;
        var isExpandFalse = document.getElementsByClassName('expandNew');
        if(!$scope.doNotCloseCommentBox) {
            $scope.showCommentBox = false;
        }

        if (!$scope.commentDataScope || (isExpandFalse.length > 0 && !($scope.isStepperOnCRUD() || $scope.exceptionalInNewUx.crudPage))) {
            $scope.commentDataScope = val;
            !$rootScope.aeDocShowPage && toggleView();
            $scope.updateRightSectionState('setCommDataScope', val);
            $rootScope.$emit("update comment data scope",val)
        } else if (val == $scope.commentDataScope) {
            $scope.oldCommentDataValue = $scope.commentDataScope;
            if(!$scope.isCreateClone && $scope.commentDataScopeCopy && $scope.commentDataScopeCopy !== -1) {
                $scope.commentDataScope = $scope.commentDataScopeCopy;
                delete $scope.commentDataScopeCopy;
                $timeout(()=> $scope.expandLeftSection = false,100)
            }
            else $scope.commentDataScope = null
            $scope.updateRightSectionState(0);
            !$rootScope.aeDocShowPage && toggleView();
        }else if(val == -1) {
            $scope.commentDataScope = val;
            $scope.updateRightSectionState('setCommDataScope', val);
        } else {
            $scope.commentDataScope = val;
            $scope.updateRightSectionState('setCommDataScope', val);
        }
        if(!$scope.commentDataScope || $scope.commentDataScope == -1) {
            $scope.expandLeftSection = true
        }
        $scope.initializeCommunicationSec(showCommentPanelInRightSec, commentHighlightProps);
        if($scope.noCmntAdValTriggered && $scope.expandLeftSection && ($scope.commentDataScope !== -1 && $scope.commentDataScope)) {
            $scope.expandLeftSection = false;
        }
        if($scope.timeLineFeedScope && $scope.timeLineFeedScope != -1){
            delete $scope.oldCommentDataScope;
            delete $scope.oldTagsOutlineFeedScope
            delete $scope.oldCommentDataValue;
            delete  $scope.oldTagsOutlineValue;
        }

        if($('.communicationPanel').length) {
            setTimeout(()=>{
                $('.communicationPanel').scrollTop(0);
            },10)
        }
        const errorDiv = document.getElementById("jx-errorListDiv");
        const container = document.querySelector(".content_container");

        if (errorDiv && container) {
            const isVisible = errorDiv.offsetParent !== null;
            if (isVisible) {
                container.classList.add("error-list-visible");
            }else {
                container.classList.remove("error-list-visible");
            }
        }

        $scope.timeLineFeedSecActive = false;
        $scope.timeLineFeedScope = undefined;
        $scope.tagsOutineSecActive = false;
        $scope.versionHistorySecActive = false;
        $scope.tagsOutlineFeedScope = undefined;
        $scope.versionHistoryFeedScope = undefined;
        $scope.signatoriesSecActive = false;
        $scope.eSignFeedSecActive = false;
        $scope.signatories = false;
        $scope.miraDocSecActive = false;
        $scope.docTreeService.showPlaybook && $scope.togglePropValue('forceHideRightSec')
        $scope.doNotCloseCommentBox && setTimeout(()=>{$scope.doNotCloseCommentBox = false},3000);
    }

    $scope.timeLineFeedSecActive = false;
    $scope.tagsOutineSecActive = false;
    $scope.versionHistorySecActive = false;
    $scope.timeLineFeedScope ;
    $scope.tagsOutlineFeedScope;
    $scope.versionHistoryFeedScope;
    $scope.signatoriesSecActive = false;
    $scope.eSignFeedSecActive = false;
    $scope.signatories = false;

    $scope.setSignatoriesDataScope = (val, timer=10, fromEsign = false) => {
        showPageService.setPreviewTab(false, $scope);
        if((angular.isUndefined($scope.timeLineFeedScope) || $scope.timeLineFeedScope==-1 )
            && (!$scope.commentDataScope || $scope.commentDataScope == -1)
            && (angular.isUndefined($scope.tagsOutlineFeedScope) || $scope.tagsOutlineFeedScope==-1 )
            && (angular.isUndefined($scope.versionHistoryFeedScope) || $scope.versionHistoryFeedScope==-1 )
            && !$scope.signatories) {
            toggleView();
            $scope.updateRightSectionState('setSignatoriesDataScope',val);
        }
        if($scope.signatories && (!$scope.commentDataScope || $scope.commentDataScope == -1)
            && (angular.isUndefined($scope.timeLineFeedScope) || $scope.timeLineFeedScope==-1 )) {
            $scope.signatoriesSecActive = !$scope.signatoriesSecActive;
            $scope.timeLineFeedScope = -1;
            $scope.commentDataScope = -1;
            $scope.signatories = false;
            $scope.miraDocSecActive = false;
            toggleView();
            $scope.expandLeftSection = true
            $scope.updateRightSectionState(0);
            return;
        }
        else $scope.signatoriesSecActive = true;

        $scope.signatories = val
        $scope.miraDocSecActive = false;
        $scope.commentDataScope = $scope.tagsOutlineFeedScope = $scope.timeLineFeedScope = $scope.versionHistoryFeedScope = -1;
        $scope.timeLineFeedSecActive = $scope.tagsOutineSecActive = false;
        if(!$scope.signatories) {
            $scope.expandLeftSection = true
            return;
        }
        $scope.updateRightSectionState('setSignatoriesDataScope',val);
        var propsToPass = {
            signatories: val,
            cData: $scope.data
        };
        let isEsignComponentMounted = false;
        if(document.getElementById('eSignFeed-sec').children.length) {
            isEsignComponentMounted = true;
            $scope.signatoriesSecActive = false;
            $scope.eSignFeedSecActive = false;
            window.reactComponents.unmountDynamicComponent(document.getElementById("eSignFeed-sec"));
        }
        if($scope.signatories && !fromEsign && !isEsignComponentMounted) {
            let mountAt = '#signatories-sec';
            var counter = 0;
            var interval = setInterval(()=>{
                if($(mountAt).length) {
                    clearInterval(interval);
                    if(!$(mountAt).children().length)
                        window.reactComponents.mountDynamicComponent(mountAt,"Signatories",propsToPass);
                    else {
                        if($('.timeline-container .content').length)
                            $('.timeline-container .content').scrollTop(0)
                        window.sarc.channelBroadcast("signatories",{
                            actionType:'abc',
                            value: val
                        },'signatoriesSubscription')
                    }
                }
            },timer)
        }else if(fromEsign || isEsignComponentMounted) {
            sessionStorage.setItem("redireactFromEmbedded",true);
            $scope.signatoriesSecActive = false;
            $scope.eSignFeedSecActive = true;
            $scope.initalizeEsignSection();
        }
    }

    $scope.setMiraDocRepoScope = (val) => {
        if(!$rootScope.enableChatBot) {
            return;
        }
        const isCollapsed = $scope.isRightSecCollapsed();
        if((isCollapsed && val) || (!isCollapsed &&!val)) {
            toggleView();
        }
        $scope.updateRightSectionState('setMiraDocRepoScope',val);
        $scope.timeLineFeedScope = -1;
        $scope.timeLineFeedSecActive = false;
        $scope.commentDataScope = -1;
        $scope.tagsOutlineFeedScope = -1;
        $scope.signatories = false;
        $scope.miraDocSecActive = val;
        if(!$scope.miraDocSecActive) {
            $scope.expandLeftSection = true;
        }
        const propsToPass = {
            entityId: $scope.data.id.values,
            entityTypeId: $scope.data.entityTypeId.values,
            contractName: $scope.data.name.values,
            useIbmWatsonForTTMD: $scope.useIbmWatsonForTTMD
        };
        let mountAt = '#mira-doc-repo';
        const interval = setInterval(()=>{
            if($(mountAt).length) {
                clearInterval(interval);
                if(!$(mountAt).children().length)
                   window.reactComponents.mountDynamicComponent(mountAt,"MiraDocRepo",propsToPass);
                else {
                    window.sarc.channelBroadcast("miraDocRepo",{
                        actionType:'updateActiveSession',
                        activeSessions: $scope.miraScope.activeSessions
                    },'miraDocRepoSubscription')
                }
            }
        },100)
    }

    $scope.setTimelineFeedDataScope = (val,initialLoad=false,timer=10,isActive = false) => {
        $scope.fromScope='';
        showPageService.setPreviewTab(isActive,$scope);
        if((angular.isUndefined($scope.timeLineFeedScope) || $scope.timeLineFeedScope==-1 )
            && (!$scope.commentDataScope || $scope.commentDataScope == -1)
            && (angular.isUndefined($scope.tagsOutlineFeedScope) || $scope.tagsOutlineFeedScope==-1 )
            && (angular.isUndefined($scope.versionHistoryFeedScope) || $scope.versionHistoryFeedScope==-1 )
            && !$scope.signatories) {
            toggleView();
            // storing value to toggle rightsection if doctree is closed
            $scope.updateRightSectionState('setTimelineFeedDataScope',val);
        }
        if(angular.isDefined($scope.timeLineFeedScope) &&  $scope.timeLineFeedScope == val && (!$scope.commentDataScope || $scope.commentDataScope == -1) && (!$scope.tagsOutlineFeedScope || $scope.tagsOutlineFeedScope == -1) && !$scope.signatories) {
            $scope.oldTimeLineFeedValue = $scope.timeLineFeedScope;
            $scope.timeLineFeedSecActive = ($scope.timeLineFeedScope == -1 || !$scope.timeLineFeedScope) ? false : !$scope.timeLineFeedScope;
            $scope.timeLineFeedScope = -1;
            $scope.commentDataScope = -1;
            $scope.miraDocSecActive = false;
            $scope.tagsOutlineFeedScope = -1;
            $scope.versionHistoryFeedScope = -1;
            $scope.signatories = false;
            toggleView();
            $scope.expandLeftSection = true;
            if($scope.showUploadSection) {
                $scope.updateRightSectionState('handleUploadSectionVisibility',true);
            }else {
                $scope.updateRightSectionState(0);
            }
            return;
        }
        else {
            $scope.timeLineFeedSecActive = (val == -1 ||  !val) ? false : true ;
            $scope.tagsOutineSecActive = false;
            $scope.versionHistorySecActive = false;
            $scope.signatoriesSecActive = false;
        }

        if($scope.commentDataScope && $scope.commentDataScope != -1){
            delete $scope.oldTimeLineFeedScope;

        }
        $scope.updateRightSectionState('setTimelineFeedDataScope',val);
        $scope.timeLineFeedScope = val
        $scope.commentDataScope = -1;
        $scope.miraDocSecActive = false;
        $scope.tagsOutlineFeedScope = -1;
        $scope.versionHistoryFeedScope = -1;
        $scope.signatories = false;
        if($scope.timeLineFeedScope == -1) {
            $scope.expandLeftSection = true
            return;
        }
        var propsToPass = {
            "timelineFeedScope": val,
            "feedsResponse": $scope.feedsResponse,
            "cdrCrudListingPage": $rootScope.preSignature.cdrCrudListingPage,
            "showWorkspaceView": $scope.showWorkspaceView,
            "workSpaceCurrentListUrl": $scope.workSpaceCurrentListUrl,
            "hasCommunicationTab": !!$scope.hasCommunicationTab
        };
        let mountAt = '#timeline-sec';
        var counter = 0;
        var interval = setInterval(()=>{
            if($(mountAt).length) {
                if($scope.timelineInitialLoad) {
                    delete $scope.timelineInitialLoad;
                    const node = document.querySelectorAll(mountAt)[0];
                    node && window.reactComponents && window.reactComponents.unmountDynamicComponent(node);
                }
                propsToPass["showNextWFStepBtn"] = $scope.showNextWFStepBtn;
                propsToPass["showContractTemplateSaveButton"] = !!$rootScope.preSignature.showContractTemplateSaveButton;
                clearInterval(interval);
                if(!$(mountAt).children().length)
                    !$scope.permissionDenied && window.reactComponents.mountDynamicComponent(mountAt,"TimelineFeeds",propsToPass);
                else {
                    if($('.tagsOutline-container .content').length)
                        $('.tagsOutline-container .content').scrollTop(0)
                    window.sarc.channelBroadcast("timelineFeeds",{
                        actionType:'timelineFeedScopeUpdate',
                        value: val,
                        showNextWFStepBtn: $scope.showNextWFStepBtn,
                        allowToUpdateStatus: !!$rootScope.preSignature?.showContractTemplateSaveButton
                    },'timelineFeedsSubscription')
                }
                delete $scope.permissionDenied;
            }
        },timer)
    }
    $scope.setTagsOutlineDataScope = (val,timer=10,isActive = false) => {
        showPageService.setPreviewTab(isActive,$scope);
        let jsonUrlOpts = $location.path().split("/");
        $scope.templateID = jsonUrlOpts[3];
        if((angular.isUndefined($scope.tagsOutlineFeedScope) || $scope.tagsOutlineFeedScope==-1 )
            && (!$scope.commentDataScope || $scope.commentDataScope == -1)
            && (!$scope.timeLineFeedScope || $scope.timeLineFeedScope == -1) && !$scope.signatories) {
            toggleView();
            $scope.updateRightSectionState('setTagsOutlineDataScope',val);
        }
        if(angular.isDefined($scope.tagsOutlineFeedScope) &&  $scope.tagsOutlineFeedScope == val && (!$scope.commentDataScope || $scope.commentDataScope == -1) && (!$scope.timeLineFeedScope || $scope.timeLineFeedScope == -1)) {
            $scope.oldTagsOutlineValue = $scope.tagsOutlineFeedScope;
            $scope.loadInitialComponent(true);
            $scope.tagsOutineSecActive = !$scope.tagsOutineSecActive;
            $scope.timeLineFeedScope = $scope.commentDataScope = $scope.tagsOutlineFeedScope = $scope.versionHistoryFeedScope = -1;
            $scope.miraDocSecActive = false;
            $scope.signatories = false;
            toggleView();
            $scope.expandLeftSection = true;
            $scope.updateRightSectionState(0);
            return;
        }
        else {
            $scope.tagsOutineSecActive = true;
            $scope.timeLineFeedSecActive = $scope.versionHistorySecActive = $scope.signatoriesSecActive = false;
        }

        $scope.tagsOutlineFeedScope = val;
        $scope.miraDocSecActive = false;
        $scope.commentDataScope = $scope.timeLineFeedScope = $scope.versionHistoryFeedScope = -1;
        $scope.signatories = false;

        if($scope.tagsOutlineFeedScope == -1) {
            $scope.expandLeftSection = true
            return;
        }
        $scope.updateRightSectionState('setTagsOutlineDataScope',val);
        var propsToPass = {
            "tagsOutlineFeedScope": val,
            "templateID": $scope.templateID,
            "showVersionDropdown" :$scope.showVersionDropdown,
            "templateName": $scope.templateName,
            "currentTemplateVersionNumber": $scope.currentTemplateVersionNumber,
            "cData": $scope.data

            // "feedsResponse": $scope.feedsResponse
        };
        let mountAt = '#tagsOutline-sec';
        var counter = 0;
        var interval = setInterval(()=>{
            if($(mountAt).length) {
                clearInterval(interval);
                if(!$(mountAt).children().length)
                    window.reactComponents.mountDynamicComponent(mountAt,"TemplateVersion",propsToPass);
                else {
                    if($('.tagsOutline-container .content').length)
                        $('.tagsOutline-container .content').scrollTop(0)
                    window.sarc.channelBroadcast("tagsOutlineFeed",{
                        actionType:'tagsOutlineScopeUpdate',
                        value: val,
                        templateID: $scope.templateID,
                        showVersionDropdown :$scope.showVersionDropdown,
                        templateName: $scope.templateName,
                        currentTemplateVersionNumber: $scope.currentTemplateVersionNumber
                    },'tagsOutlineFeedsSubscription')
                    $scope.loadInitialComponent(false);
                }
            }
        },timer)
    }
    $scope.loadVersionTemplate = function (val) {
        if(typeof val == "object" && !!val){
            if(val.name.includes('intermediate')){
                val = ''
                $scope.showIntermediateIcon = true;
                $scope.intermediateVersion = 1; //added to avoid space on right side in showpage
            } else {
                $scope.showIntermediateIcon = false;
                val = val.value && val.value.substr(1, 5).trim().split('.');
                val = val && val[0];
            }
        }
        element = angular.element('#tabs-inner-sec');
        $scope.versionNumber = val;
        if(!$scope.versionNumber){
            $scope.showIntermediateIcon = true;
        }
            let attrs = {
                scope: $scope,
                url: '/tblcontracttemplate/templatePages',
                element,
                templateId: $scope.templateID,
                offset: 1,
                limit:100,
                outlineData:[],
                tagData:[],
                postTags:false
            }
            showPageService.loadTemplateContent(attrs);
    }
    $scope.loadInitialComponent = function(showVersionDropdown){
        if($scope.tagsOutlineFeedScope == 2){
            window.sarc.channelBroadcast("loadInitialTemplate",{
                actionType:'loadTemplate',
                value: $scope.currentTemplateVersionNumber,
                isIntermediate: $scope.showVersionDropdown,
                showVersionDropdown: showVersionDropdown
            },'VersionHistoryAccordianSubscription')
        }
    }
    $scope.$on("pdfViewerLoaded",function(data){
        $scope.isPdfViewerLoaded = true;
    });
    $scope.dragAndDropFileUpload = function(event){
        formService.buttonMapper[3910] && formService.buttonMapper[3910].forEach(d => {
            if(d.properties.buttonType == 'upload'){
                d.active = true;
            }
        });
        formService.buttonMapper[3908] && formService.buttonMapper[3908].forEach(d => {
            if(d.properties.buttonType == 'upload'){
                d.active = true;
            }
        });
        window.globalUploadButtonActive = "";
        $('.uploadFileCustom:visible').click();
    }
    var updatecontractDocumentTabUpload =  $scope.$on('updatecontractDocumentTabUpload',function(e, data){
        $scope.contractDocumentTabUpload = data;
    });
    $scope.unSetDataScope = function(){
        $scope.timeLineFeedScope = undefined;
        $scope.commentDataScope = undefined;
        $scope.tagsOutlineFeedScope = undefined;
        $scope.signatories = false
    }

    $scope.cdrPreviewDataLoaded = function(...selectedDocument) {
       if(!selectedDocument.length) return;
        if ($scope.documentOpenWithForm) {
            $scope.closeDocViewer();
        }
        $scope.previewTab.isActive = true;
        window.pdfJsPermissionFlags.hasDownloadBtn = true;
        $scope.parentEntityTypeId = 160; // to be constant
        $scope.entityTypeId = 78; //to be constant
       if(selectedDocument[0].loadLatestDoc){
           let latestDoc = $scope.headContractDocument[0];
           $scope.auditLogDocumentId = latestDoc.documentId;
           $scope.entityId = latestDoc.documentFileId;
           $scope.selectedHeadDocument = latestDoc;
           $scope.headContractDocument.forEach(el => el.active = false);
           $scope.selectedHeadDocument.active = true;
       } else {
           $scope.headContractDocument.forEach(el => el.active = false);
           $scope.selectedHeadDocument = $scope.headContractDocument.filter(el => el.documentFileId == selectedDocument[2])[0] || $scope.selectedHeadDocument;
           if(!$scope.selectedHeadDocument)$scope.selectedHeadDocument = {};
           $scope.selectedHeadDocument.active = true;
           $scope.auditLogDocumentId = selectedDocument[1];
           $scope.entityId = selectedDocument[2];
           if(selectedDocument[3] && selectedDocument[3].loadSubDoc){
                $scope.selectedSubDocument = $scope.setSelectedSubDocument(selectedDocument);
                $scope.subContractDocument.forEach(el => el.active = false);
                $scope.selectedSubDocument.active = true;
           }
       }
        $scope.expandLeftSection = true;
        $timeout(function () {
            if($('.tab').hasClass('no-template'))  $('.tab').removeClass('no-template');
            !!$('.noTemplate').length && $('.noTemplate').remove();
            const element = $('.showPagePreviewDoc');
            let attrs = {
                scope: $scope,
                url:'show/tblcdr',
                cdrId: $scope.cdrId,
                element,
                offset: 1,
                limit:100,
                outlineData:[],
                tagData:[],
                postTags:false
            }
            showPageService.loadTemplateContent(attrs);
        },500);

        $scope.setselectedLeftTabIdx(0);
        $scope.unSetDataScope();
        (selectedDocument.length <= 3 || selectedDocument[0].loadLatestDoc) && $scope.getSubContractDoc($scope.entityId, $scope.auditLogDocumentId, selectedDocument);
        $timeout(function () {
            $scope.$broadcast('updateTabLength');
        },200);
    }

     $scope.closePreviewViewer = function(){
         $scope.previewTab.isActive = false;
         $scope.openRightSection();
         $scope.expandLeftSection = true;
     }
     $scope.$on('unsetPreviewViewerActive', function($event, data){
         $scope.previewTab.isActive = data;
     })
    $scope.getTagMetadataToUpdate = (shouldOpenModal = false, entityId = null) => {
        var jsonUrlOpts = $location.path().split("/");
        $scope.cdrId = jsonUrlOpts[3] || entityId;
        $scope.tagsMetadata = [];
        if(!$scope.cdrId) return false; 

        const apiUrl = addtStamp("/clauseTag/document/v2/variations/" + $scope.cdrId,true);
        $http.get($scope.appBaseApiUrl + apiUrl).then(function (res) {
            if(!_.isEmpty(res.data)) {
                $scope.tagsToUpdate = res.data;
                if(shouldOpenModal) {
                    $scope.shareWithContractDoc();
                }
            }
        }).catch(e => {
            window.systemWarning(e);
        });

    }

     $scope.getHeadContractDoc = function(workspaceCdrId = null){
        const jsonUrlOpts = $location.path().split("/");
        var cdrEntityTypeId = 160;
        const cdrId = jsonUrlOpts[3] || workspaceCdrId;
         $scope.cdrId = cdrId;
         if(cdrId) {
             var apiUrl = addtStamp("/tblcdr/getDocumentHeadVersion/" + cdrId + "/" + cdrEntityTypeId);
             var headContractDocPromise = entityFactory.getJson(apiUrl, "GET");
             headContractDocPromise.success(function (response) {
                 $scope.headContractDocument = $scope.preProcessData(response, false);
                 if ($scope.headContractDocument.length) {
                     $scope.previewTab.hasContractDocument = true;
                 } else {
                     $scope.previewTab.hasContractDocument = false;
                 }
                 $timeout(function () {
                     $scope.$broadcast('updateTabLength', 100);
                 });
             });
         }
     }
    $scope.getSubContractDoc = function(documentFileId,documentId, selectedDocument){
        var apiUrl = "/tblcdr/getDocumentSubVersion/" + documentId + "/"+ documentFileId;
        var subContractDocPromise = entityFactory.getJson(apiUrl, "GET");
        subContractDocPromise.success(function(response){
            $scope.subContractDocument = $scope.preProcessData(response, true);
            if(selectedDocument?.[0].loadLatestDoc){
                $scope.selectedSubDocument = $scope.subContractDocument[0];
            }else{
                $scope.selectedSubDocument = $scope.setSelectedSubDocument(selectedDocument);
            }
            $scope.selectedSubDocument.active = true;
        });
    }

    $scope.setSelectedSubDocument = (selectedDocument) =>{
        return $scope.subContractDocument.filter(el => el.documentFileId == selectedDocument[2])[0];
    }

    $scope.preProcessData = function(res,isSubDoc){
        return res.map(el => {
            const versionDocName = el.version + (isSubDoc ? '' : ' ' + el.documentName);
            el["versionDocName"] = versionDocName;
            el["active"] = false;
            return el;
        });
    }
    $scope.toggleOriginalDocument=function(flag){
        $scope.OriginalCheckRequired = flag;
        if(parent.window.location.href.indexOf("tblcontractdocuments") > -1)
            var prop = "documentViewer";

        $scope.loadPdfJsViewer(prop);
    }
    $scope.manageCTStepperActivationState = function () {
        formService.manageCTStepperActivationState($scope);
    }
    window.downloadDocument = function(data,versionNumber){
        if($scope.previewTab 
            && $scope.entityTypeId === 78 
            && $scope.aeDocShowPage === false
        ){ // CDR Document Viewer download — resolve best available version via backend API
            var cdrEntityId = $scope.cdrId || _.get($scope, 'data.id.values');
            var documentFileId = $scope.entityId || $scope.documentFileId;
            if (!cdrEntityId || !documentFileId) {
                Toaster.create(intl_msg[23503] || "Error in processing the request. Please try again later!", {iconClass: "icon-Information_filled"});
                return;
            }
            var apiUrl = addtStamp("/document-info/cdr/download-link/" + cdrEntityId + "/" + documentFileId, true);
            var promise = requestData("GET", apiUrl, "", false);
            promise.success(function(response) {
                if (response.errorMessage && response.errorMessage.trim()) {
                    Toaster.create(response.errorMessage, {iconClass: "icon-Information_filled"});
                    return;
                }
                if (response.link) {
                    if (response.warningMessage) {
                        Toaster.create(response.warningMessage);
                    }
                    if (response.link.indexOf("http://") === 0 || response.link.indexOf("https://") === 0) {
                        window.open(response.link, "_self");
                    } else {
                        commonUtil.dynamicallyClickAnchor(response.link);
                    }
                } else {
                    Toaster.create(intl_msg[48288] || "Failed to download document(s).", {iconClass: "icon-Information_filled"});
                }
            });
            promise.fail(function() {
                Toaster.create(intl_msg[48288] || "Failed to download document(s).", {iconClass: "icon-Information_filled"});
            });
            return;
        } else if($scope.previewTab &&  $scope.previewTab.isActive || $scope.aeDocShowPage) {
            let endpoint = `/download/communicationdocument?id=${$scope.auditLogDocumentId}&entityTypeId=${$scope.entityTypeId}&entityType.id=${$scope.parentEntityTypeId}&fileId=${$scope.entityId}`;
            if($scope.aeDocShowPage)
                endpoint = "/metadataautoextraction/downloadDocument/"+$scope.docId;
            endpoint = addtStamp(endpoint, true);
            if(window.sessionStorage.getItem('drsEnabled') && !['docx','dox','doc'].includes(_.get($scope.selectedHeadDocument,'extension'))){
                let fileObj={
                    downloadLink:endpoint,
                    id: $scope.auditLogDocumentId,
                    entityTypeId:$scope.aeDocShowPage ? $scope.entityTypeId : $scope.parentEntityTypeId,
                    documentId: $scope.entityId,
                    fileName:$scope.aeDocShowPage ? $scope.data.fileName.values : `${$scope?.selectedHeadDocument?.documentName}.${$scope?.selectedHeadDocument?.extension}`,
                    fileString: SirionUtils.getDrsString(_.get($scope.selectedHeadDocument,"extension"),false, $scope.aeDocShowPage)
                }
                listService.downloadInit(null, fileObj);
            }else{
                window.open(endpoint,"_self");
            }
        } else if($scope.fromContract){
            const documentId = SirionUtils.getParameterByName('docId');
            const endpoint = `/download/contractdocument/${$scope.documentId || documentId}`;
            commonUtil.dynamicallyClickAnchor(addtStamp(endpoint));
        }
        else if($scope.isClauseShowPage) {
            const el = document.querySelector('.downloadDocClauses');
            el && el.click();
            return false;
        }
        if(versionNumber && !$scope.showIntermediateIcon && data.link.indexOf('?versionNumber') == -1){
            data.link +=  "?versionNumber=" + versionNumber
        }
        if(data) {
            let url = addtStamp(data.link, true);
            if(data.isZip) {
                fileService.downloadClauseZip(url);
            }else  {
                window.open(url,"_self");
            }
        }
    };
    $scope.callShareWithCounterParty = function (valueOfClose, wfId, requestId, fromAddNewExternalSupplierPopup){
        if(valueOfClose === "close"){
            $scope.dataOfnewExtarnalContract = null;
        }
        if($scope.isStakeHolderInlineEdit){
            $scope.isStakeHolderInlineEdit = false;
            $scope.hideCrossModalButton = false;
            return;
        } 
        startLoader();
        $scope.applyBasePageJson();
        setTimeout(()=>{
            $('[data-mtab-id=3909]').click();
            $scope.shareWithCounterParty(wfId,requestId,null,fromAddNewExternalSupplierPopup);
            stopLoader();
        },500);
    }
    $scope.callNewExtInStakeholderList = function(){
        let data = {
            email:$scope.dataOfnewExtarnalContract.emailId,
            name:$scope.dataOfnewExtarnalContract.name,
            id:$scope.dataOfnewExtarnalContract.id,
            previousStakeHolder: $scope.previousStakeHolder,
            indexOfUserDoc:$scope.indexOfUserDoc,
            externalContact: true,
        }
        if(_.get($scope.dataOfSendForSignature,"fromType") === "edit Name Email in Send For Signature" ){
            window.sarc.channelBroadcast("reactFormsForSendSignature", {
                payload:data,
                actionType:"editUserNameEmail",
            },"reactToAngular");
            return;
        }
        window.sarc.channelBroadcast("reactFormsForSendSignature", {
            payload:data,
            actionType:"addExternalContactInStakeholdersList",
        },"reactToAngular");
    }
    $scope.openSendToSigModal = function (fieldObj, calledFromContractDocument,reqId, selectedAccount, wfId, wfRequestId, ...parms) {
        $scope.sendForSigFieldObj ={
            'id': 12425,
            'modalTitle': intl_msg[31579] || "Send For Signature"
        };
        $scope.accountIntegrationId  = selectedAccount.integrationId;
        $scope.accountName = selectedAccount.name;
        var showPageId =  $scope.data.id.values;
        var parentEntityId = $scope.data.entityTypeId.values;
        $scope.sendForSigFieldObj['fields'] =[];
        var fields = {
            'id': 12425,
            'name': "sendForSignature",
            'label': "sendForSignature",
            'type': "text",
            'layoutURL': "/listRenderer/list/436/defaultUserListMetaData/",
            'orderSeq': 100,
            'properties': {hideFieldFromView: true},
            'displayMode': "editable",
            'dataURL': "/listRenderer/list/436/tablistdata/" + parentEntityId +'/'+ showPageId,
            'dynamicField': false,
            'autoComplete': false,
            'enableListView': false,
            'bulkEditable': false,
            'multiEntitySupport': false,
        };
        fieldObj ={ 'id': 12425,
            'modalTitle': intl_msg[31579] || "Send For Signature"};
        fieldObj['fields'] = fields
        $scope.sendForSigFieldObj['fields'].push(fields);
        if(calledFromContractDocument){
            $scope.docuSigndocumentType = "DRAFT";
            $scope.sendForSigFieldObj.fields[0].layoutURL = $scope.sendForSigFieldObj.fields[0].layoutURL.replace("/436/", "/482/");
            $scope.sendForSigFieldObj.fields[0].dataURL = $scope.sendForSigFieldObj.fields[0].dataURL.replace("/436/", "/482/");
            $rootScope['calledFromContractDocument'] =true;
        }else{
            $scope.docuSigndocumentType = "ATTACHMENT";
            $scope.sendForSigFieldObj.fields[0].layoutURL =  $scope.sendForSigFieldObj.fields[0].layoutURL.replace("/482/", "/436/");
            $scope.sendForSigFieldObj.fields[0].dataURL = $scope.sendForSigFieldObj.fields[0].dataURL.replace("/482/", "/436/");
        }
        if(! $scope.sendForSigFieldObj["modalTitle"] ){
            $scope.sendForSigFieldObj["modalTitle"] = "";
        }
        $scope.sendForSigFieldObj.properties = {};
        $scope.sendForSigFieldObj.modalTitle = intl_msg[31579] || "Send For Signature";
        $rootScope.sendForSigFieldObj =$scope.sendForSigFieldObj;
        var url =  '/sendSignature/'+ parentEntityId + '/' + showPageId;
        if($rootScope['calledFromContractDocument']){
            url = SirionUtils.addParameterToUrl(url,'contractDocument',true)
        }
        if($scope.accountIntegrationId) {
            url = SirionUtils.addParameterToUrl(url,'signAccountId',$scope.accountIntegrationId);
        }
        if(wfId && wfRequestId){
            url+= url.includes('?') ? '&' : '?';
            url += 'wfId='+wfId+'&requestId='+wfRequestId
        }
        window.location.hash = url;

        if(!calledFromContractDocument && !$rootScope.callFromCommunication) {
            $scope.sendForSigModal = $modal.open({
                template: '<send-signature dirFor="sendToSig" reqId="'+reqId+'"></send-signature>',
                modal: true,
                size: "lg",
                keyboard: false,
                backdrop: "static",
                windowClass: "sendToSigModal",
                scope:$scope
            });
        }
        delete $rootScope.callFromCommunication;

    };
    var openSendForSig = $rootScope.$on('openSendForSig',function(e, data, calledFromContractDocument, ...parms){
        $scope.openSendToSigModal({},true, null,data.selectedAccount, data.wfId, data.wfReqId, ...parms)
    });

    //@todo - will make this function Generic because same function we are using listService file for assignForReview
    $scope.newSelectFilePopUp = (wfId, wfReqId, field)=> {
        if ($scope.launchViewEnabled) {
            $scope.wfFields = field;
            let url = window.location.href;
            if (wfId && wfReqId) {
                url = SirionUtils.addParameterToUrl(url,'wfId', wfId);
                url = SirionUtils.addParameterToUrl(url,'requestId', wfReqId);
            }
            window.location.href = url;
            let propsToPass = {
                pass: "eSignature",
                entityId: $scope.data.id.values,
                entityTypeId: $scope.data.entityTypeId.values,
                parentFieldIds: $rootScope.parentFldIds,
                wfId,
                wfReqId,
                integrationId: $scope.integrationId,
            }

            const mountAt = '#bulk_side_window';
            let interval = setInterval(() => {
                if ($(mountAt).length) {
                    clearInterval(interval);
                    if (!$(mountAt).children().length) {
                        window.reactComponents.mountDynamicComponent(mountAt, "BulkSideWindow", propsToPass);
                    }
                }
            })
        } else {
            window.reactComponents.unmountDynamicComponent(document.getElementById("bulk_side_window"));
        }
    }
    $scope.selectESignAccount = function(wfId, wfReqId){
        let propsToPass={
            entityId : $scope.data.id.values || Number(window.location.hash.split('?')[0].split('/').slice(-1)),
            entityTypeId : $scope.data.entityTypeId.values,
            parentFieldIds :$rootScope.parentFldIds,
            wfId,
            wfReqId
        }
        let mountAt = '#accountSelectionModal';
        let interval = setInterval(() => {
            if ($(mountAt).length) {
                clearInterval(interval);
                if (!$(mountAt).children().length) {
                    propsToPass.openModal = true;
                    window.reactComponents.mountDynamicComponent(mountAt, "AccountSelectionModal",propsToPass);
                }
                else {
                    window.sarc.channelBroadcast("accountSelectionModal", {
                        actionType:'openModal',
                        payload:propsToPass
                    }, 'accountSelectionSubscription')
                }
            }
        }, 10)
    };
    var openESignAccountSelector = $rootScope.$on('clickAccountList',function(e, data){
        if($scope.docuSignErrorMessage){
            Toaster.create($scope.docuSignErrorMessage,{iconClass:"icon-Information_filled"});
            return;
        }
        if($scope.docuSignRedirectUri){
            window.location.href = $scope.docuSignRedirectUri;
        } else {
            const {wfId,wfReqId,field} = data || {};
            $scope.launchViewEnabled ? $scope.newSelectFilePopUp(wfId, wfReqId, field) : $scope.selectESignAccount(wfId, wfReqId, field);
        }
    })
    $scope.isRightSecCollapsed = function () {
        return (
            ($scope.commentDataScope == -1 || !$scope.commentDataScope) &&
            ($scope.timeLineFeedScope == -1 || !$scope.timeLineFeedScope) &&
            ($scope.tagsOutlineFeedScope == -1 || !$scope.tagsOutlineFeedScope) &&
            ($scope.signatories == -1 || !$scope.signatories) && !$scope.miraDocSecActive
        )
    }
    $scope.$watch("[timeLineFeedScope,commentDataScope,tagsOutlineFeedScope,signatories,preSignature.crudPage,showInWorkspace,expandLeftSection,miraDocSecActive]", function (newValue, oldValue) {
        delete $scope.forceHideRightSec;
        $scope.rightSecAbsolutePanel = _.get($scope.preSignature,"crudPage") || $scope.showInWorkspace || $scope.isNewCrudPage;
        let forceHideRightSec = $scope.isRightSecCollapsed();

        const selectedTab = $scope.showPage2DataTransformationService?.returnObj?.selectedTabObj;

        if(forceHideRightSec && selectedTab?.type?.includes('tabular')) {
            $scope.$broadcast('updateTabLength');
        }

        if ($scope.showUploadDocuments && !$scope.isCreateRoute) {
            if (!forceHideRightSec ) {
                document.getElementById('dynamic-form-right-container').style.display = 'none';
            } else {
                document.getElementById('dynamic-form-right-container').style.display = 'block';
            }
        }

        if(forceHideRightSec && $scope.showUploadDocuments) {
            if(selectedTab.type.includes('basic')) {
                $scope.updateRightSectionState('handleUploadSectionVisibility',true);
            }else {
                $scope.updateRightSectionState(0);
            }
        }
        if ($rootScope.hideCommentToggle || ($scope.showUploadDocuments && selectedTab.type.includes('basic'))){
            forceHideRightSec = false;
        }
        $scope.forceHideRightPanel = forceHideRightSec;
        if ($scope.rightSecAbsolutePanel) {
            $scope.forceHideRightSec = forceHideRightSec;
            $scope.expandLeftSection = $scope.forceHideRightSec;
        } else if ($scope.showDocTree) {
            $scope.forceHideRightSec = true;
            $scope.expandLeftSection = true;
        } else if (!forceHideRightSec) {
            $scope.expandLeftSection = false;
        }
    });

    // This function will return true/false based on the conditions
    $scope.isStepperOnCRUD = () => (
        (
            [160,67,61,325].indexOf(Number($scope.data?.entityTypeId?.values)) > -1 &&
            (
                docTreeService.cdrToContractPorting ||
                (
                    ['create','clone','globalCreate'].includes($scope.pageType) &&
                    (docTreeService.contractToCdrPorting)
                )

            )
        ) ||( $scope.pageType=='globalCreate' && $scope.createHeaderStageTwo ) ||
        ['create','globalCreate','clone'].includes($scope.pageType) && [325,67].includes(Number($scope.data?.entityTypeId?.values))
    )

    var  openLinkLanguageModal = $scope.$on("openLinkLanguageModal", function(evt,data){
            var propsToPass = {
                isModalOpen : true,
                clauseCategory: $scope.clauseCategory,
                clauseId : $scope.clauseId
            };
           showPageService.openLinkClauseModal(propsToPass);
    });

    var mountPlaybook = $rootScope.$on("mountPlaybookComponent", function (e, id, flag, isReset) {
        let mountAt = '#playbook-main';
        $scope.forceHideRightSec = false;
        $scope.setCommDataScope(-1,false,$scope.showCommentPanelInRightSec);
        let propsToPass = $scope.playbook;
        let interval = setInterval(() => {
            if ($(mountAt).length) {
                clearInterval(interval);
                if (!$(mountAt).children().length) {
                    window.reactComponents.mountDynamicComponent(mountAt, "Playbook",propsToPass);
                }
            }
        }, 10)
    });

    var fixCommentSectionAndInitialize = $rootScope.$on("fixCommentSectionAndInitialize", function(e,obj){
        for(let key in obj){
            $scope[key] = obj[key];
        }
        $scope.setCommDataScope(-1,false,$scope.showCommentPanelInRightSec)
    })

    $scope.shortCodeIdPresent = function(){
        const showEditPage = ['show', 'update'].includes($scope.routeParams?.action);
        const shortCodeId = $scope.routeParams?.hasOwnProperty('entityId') && /[a-zA-Z]/.test($scope.routeParams.entityId) && $scope.routeParams.entityId;
        return showEditPage && shortCodeId;
    }

    $scope.docTreeInit = function(){
        if(!$scope.doNotOpenDocTreeByDefault && $scope.pageType == 'show' && (!SirionUtils.getParameterValueFromURL(window.location.href,'docId') && !SirionUtils.getParameterValueFromURL(window.location.href,'aeDocId'))) setTimeout(()=>$scope.openDocTree(),500)
    }
    $scope.toggleExpectedLanguage = function() {
        startLoader();
        const mountAt = "#expectedLanguageModal";
        let languageUrl = addtStamp("/metadataautoextraction/project-languages?projectId="+$scope.data.id.values,true);
        $http.get(languageUrl).then(function(res){
            stopLoader();
            if(res.data.responseCode == '200' && !_.isEmpty(res.data.response)) {
                let languageData = res.data.response;
                let sortedLanguages = languageData.sort((a, b) => (b.selected - a.selected));

                let propsToPass = {
                    languages: sortedLanguages,
                    projectId: $scope.data.id.values,
                    projectName: $scope.data.name.values
                };
                window.reactComponents.mountDynamicComponent(mountAt, "ExpectedLanguageModal", propsToPass);
            } else {
                Toaster.create('Some error occurred',{iconClass:"icon-Information_filled"});
            }
        })
    }
    $scope.toggleSupplierDropDown = function () {
        $scope.showSupplierDD = !$scope.showSupplierDD;
    }
    $scope.closeSupplierDropDown = function () {
        $scope.showSupplierDD = false;
    }
    $scope.changeSupplier = function(item) {
        $scope.selectedSupplier= item;
        window.sarc.channelBroadcast("docTreeChannel", {actionType: "handleRootSupplier", value: item}, `docTreeChannelSubscription`);
        if (item && item.id && SirionUtils && SirionUtils.addParameterToUrl) {
            var newUrl = SirionUtils.addParameterToUrl(window.location.href, 'supplierId', item.id);
            if (newUrl !== window.location.href) {
                window.history.replaceState(null, "", newUrl);
            }
        }
    }
    $scope.openDocTree = function(){
        $scope.togglePropValue('expandDocTree');
        if($scope.pageType == 'show'){
            if(!$scope.miraSummaryView){
                $scope.miraDocSecActive = false;
            }
            $scope.togglePropValue('showDocTree',true);
        }else{
            $scope.togglePropValue('showDocTree');
        }
        $scope.togglePropValue('hideDocTree',false);
        $scope.togglePropValue('tabFullWidth',false);
        $scope.togglePropValue('leftSecTransition',false);
        $scope.resizeDocTreeOnLoad()
    }
    $scope.sanitizeAmp = function(fileName){
        return commonUtil.ampToAmpersand(fileName)
    }

    $scope.goToNormalView = () => {
        $scope.miraDocSecActive = false;
        $scope.miraSummaryView = false;
        $scope.setMiraDocRepoScope(true);
    }
    $scope.goToMiraSummaryView = () => $scope.miraSummaryView = true;
    $scope.miraScope.toggleDocDrpDown = (state) => {
        $scope.miraScope.docsDrpDwn.open = state;
    }
    $scope.loadDocumentInViewer = (docInfo) => {
        $scope.selectedDocInMiraView = docInfo;
        window.docViewerParams = docInfo.data;
        window.docViewerParams.documentName = docInfo.name;
        $scope.loadPdfJsViewer();
        $scope.miraScope.toggleDocDrpDown(false);
    }
    $scope.loadDocumentForMira = (item) => {
        window.docViewerParams = item.data;
        $scope.loadPdfJsViewer();
    }
    $scope.openPerformancePage = () => {
        if($scope.miraScope.selectedDocInMiraView) {
            const url = $scope.miraScope.selectedDocInMiraView.treeNode.a_attr.href;
            const {parentEntityId,documentId} = $scope.miraScope.selectedDocInMiraView.data;
            const key = $scope.routeParams.entityId + '_' + documentId;
            sessionStorage.setItem(key,JSON.stringify($scope.miraScope.selectedDocInMiraView));
            window.location.href = url;
        }
    }

    $scope.$watch('hasMiraPermission', function (newVal, oldVal) {
        $scope.miraSummaryView = false;
        if($scope.hasMiraPermission) {
            // $scope.showDocTree = false;
        }
    })

    let showPageMainWrapperNode = null;

    function updateElementsHeightDynamically() {
        showPageMainWrapperNode = document.querySelector('.content_container.showpage');
        if (!showPageMainWrapperNode) {
            return;
        }
        requestAnimationFrame(() => {
            let totalHeightToBeSubtracted = 0;
            const errorListNodes = showPageMainWrapperNode.querySelectorAll('.errorListDiv');
            for (let i = 0; i < errorListNodes.length; i++) {
                const styles = window.getComputedStyle(errorListNodes[i]);
                totalHeightToBeSubtracted += errorListNodes[i].offsetHeight + parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
            }
            const elementsToCalculateHeight = ['#stepper_wrapper', ':scope > .title-sec'];
            for (let i = 0; i < elementsToCalculateHeight.length; i++) {
                const elementNode = showPageMainWrapperNode.querySelector(elementsToCalculateHeight[i]);
                if (elementNode) {
                    const styles = window.getComputedStyle(elementNode);
                    totalHeightToBeSubtracted += elementNode.offsetHeight + parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
                }
            }
            const offsetValue = `${totalHeightToBeSubtracted}px`;
            showPageMainWrapperNode.classList.add('dynamic-height-offset');
            showPageMainWrapperNode.style.setProperty('--dynamic-height-offset', offsetValue);

            const leftSecs = showPageMainWrapperNode.querySelectorAll('.left-sec');
            for (let i = 0; i < leftSecs.length; i++) {
                if (leftSecs[i].closest('.title-sec')) {
                    continue;
                }
                leftSecs[i].style.setProperty('height', `calc(100% - ${offsetValue})`, 'important');
            }
            const rightSec = showPageMainWrapperNode.querySelector('#right-sec');
            if (rightSec) {
                rightSec.style.setProperty('height', `calc(100% - ${offsetValue})`, 'important');
            }
        });
    }
    $scope.$watchGroup([
        'hideErrorListDiv',
        'errors.genericErrors.length',
        'errors.warnings',
        'isWorkflowProgressbarLoaded'
    ], function () {
        $timeout(updateElementsHeightDynamically);
    });

    const launchDocWithMira = (docInfo) => {
        if(docInfo) {
            $scope.miraSummaryView = true;
            if(!docInfo.a_attr) {
                const href = getDynHref(docInfo.treeNode)
                docInfo.treeNode.a_attr = {href};
            }
            window.resetChatInstance();
            setTimeout(() => {
                window.sarc.channelBroadcast("askMira",{actionType:'initAskMira',element: 'mira_root'},'askMiraSubscription');
            },100)

            window.docViewerParams = {...docInfo.data,documentName:docInfo.name} ;
            const updatedUrl = SirionUtils.addParameterToUrl(window.location.href,['docId','aeDocId'],[window.docViewerParams.documentId,docInfo.treeNode.aeDocumentId]);
            window.history.replaceState(null, null, updatedUrl);
            $scope.loadPdfJsInside = true;
            $scope.loadPdfJsViewer();
        }
    }


    setTimeout(function () {
        window.sarc.channelInstall('showPageChannel')
        window.sarc.channelSubscription('showPageChannel', function(args){
            let actionType = args.actionType;
            let payload = args.payload;
            if(actionType == "exportTreeData") {
                $scope.miraScope.docsForMiraViewer = _.reduce(payload, (acc, val) => {
                    if(val.viewerAvailable) {
                        acc.push({
                            name: unescapeHtml(val.name?.replace(/&amp;/g, "&")),
                            data: {
                                parentEntityTypeId: $scope.entityTypeIdJS,
                                parentEntityId: $scope.entityId || $scope.data.id.values,
                                documentId: val.entityId,
                            },
                            downloadUrl: val.downloadUrl,
                            extension: val.extension,
                            treeNode: val
                        })
                    }
                    return acc;
                }, []);
                if(window.docViewerParams?.documentId) {
                    return ;
                }

                const documentId = SirionUtils.getParameterValueFromURL(window.location.href,'docId');
                if(documentId)
                    $scope.miraScope.selectedDocInMiraView = $scope.miraScope.docsForMiraViewer.find(doc => doc.data.documentId == documentId);

                if(!$scope.miraScope.selectedDocInMiraView) {
                    const docFromCache = sessionStorage.getItem($scope.entityId+"_"+docId);
                    if(docFromCache) {
                        $scope.miraScope.selectedDocInMiraView = JSON.parse(docFromCache);
                    }else {
                        $scope.miraSummaryView = false;
                    }
                }

                launchDocWithMira($scope.miraScope.selectedDocInMiraView);
            }
            if(actionType == "goToNormalView") {
                $scope.goToNormalView();
            }
            if(actionType == "updateDocTreeData") {
                $scope.docTreeParent = payload;
            }
            if(actionType == "openDocForMira") {
                $scope.miraSummaryView = true;
                if(payload.fromMiraDoc){
                    $scope.miraDocSecActive = true;
                }
                const preservePreviousChatBotInstance = !!window.SirionUtils.getParameterValueFromURL(window.location.href, 'docId') && window.docViewerParams?.documentId == payload.entityId && window.documentSummaryText && $scope.docOpenFromTreeOrMira;
                if(preservePreviousChatBotInstance) {
                    $scope.docOpenFromTreeOrMira = false;
                    return;
                }
                $scope.docOpenFromTreeOrMira = false
                window.sarc.channelBroadcast("askMira",{actionType:'destroyAskMiraAndReset'},'askMiraSubscription');
                if(!payload.aeDocumentId) {
                    const document = $scope.miraScope.docsForMiraViewer?.find(doc => doc.data.documentId == payload.entityId);
                    if(document) {
                        payload.aeDocumentId = document.treeNode.aeDocumentId
                    }
                }

                $scope.miraScope.selectedDocInMiraView = {
                    name: payload.name,
                    data: {
                        parentEntityTypeId: $scope.entityTypeIdJS,
                        parentEntityId: $scope.entityId || $scope.data.id.values,
                        documentId: payload.entityId,
                    },
                    downloadUrl: payload.downloadUrl,
                    extension: payload.extension,
                    treeNode: payload
                }
                launchDocWithMira($scope.miraScope.selectedDocInMiraView);
            }
            if(actionType == "goToNormalView") {
                $scope.goToNormalView();
            }
            if(actionType == "uploadDocument") {
                docTreeService.toggleDocEditTemplate(true);
                docTreeService.getTreeJson();
            }
            if(actionType == "citationHighlight") {
                const {pageNumber,coordinates,highLightId} = payload
                SirionUtils.highlightCitations(pageNumber,coordinates,highLightId);
            }
            if(actionType == "changeDocTreeFilterRendered"){
                showPageService.retObj.docTreeFilterRendered = false;
            }
            if(actionType == "removePermission") {
                $scope.hasMiraPermission = false;
                window.sarc.channelBroadcast("updateMiraChatBotState", {actionType: "removeMira"}, `updateMiraChatBotStateSubscription`)
            }
            if(actionType == "docTreeSupplierData"){
                $scope.selectedSupplier = payload;
                $scope.$apply();
            }
            if(actionType == "docDownloadfromMira") {
                $scope.fetchDownloadFunctionalityForMira(payload);
            }
        }, "showPageChannelSubscription");
        const docId = SirionUtils.getParameterValueFromURL(window.location.href,'docId');
        const aeDocId = SirionUtils.getParameterValueFromURL(window.location.href,'aeDocId')
        if(docId && aeDocId && $scope.hasMiraPermission) {
            $scope.miraSummaryView = true;
            $scope.$apply();
        }
        if($scope.hasTimeLineFeed) {
            $scope.getFeedApiList();
        }
    },0)
    
    $scope.getFeedApiList = () => {
        const jsonUrlOpts = getUrlOpts();
        let entityId = jsonUrlOpts[3],
            entityTypeId = urlToCodeMapper[jsonUrlOpts[2]],
            getData = true
        if (entityTypeId == 160) {
            showPageService.getFeedCardList.call($scope,{entityId,entityTypeId,getData}).then(res => {
                if(res) {
                    const card = _.find(res, (card) => card.type == "GENERATE_FIRST_DRAFT") || [];
                    let showDocVariationReviewBtn = _.filter(card?.data?.buttons, (btn) => {
                        if(btn.properties.buttonType == 7) {
                            return true;
                        } else return false;
                    });
                    let documentTagsEnabled = card?.data?.properties?.properties?.documentTagsEnabled;
                    $scope.isDocumentTagsEnabled = documentTagsEnabled;
                    $rootScope.showDocVariationReviewBtn = showDocVariationReviewBtn.length > 0;
                }
            });
        }
    }

    $scope.handleDocumentUpload = async (payload) => {
            if (!payload.entityId) {
                return;
            }
            $scope.parentId = null;
            const jsonUrl = `/contracts/show/${payload.showPageUrl && payload.extension != 'link' ? payload.entityId : payload.parentContractEntityId}`;

            if(!payload.showPageUrl)
                $scope.parentId = payload.entityId;
            
            startLoader();
            try {
                const data = await entityFactory.getJson(jsonUrl, "GET");
                if(_.has(data, 'header.response.errorMessage')){
                    Toaster.create(data.header.response.errorMessage ,{iconClass:"icon-Information_filled"});
                    return false;
                }
                // Set properties
                if (_.has(data, 'body.globalData') && $scope.pageType != "delegationCreate") {
                    docTreeService.hasAutoExtractEntitiesPermission = data.body.globalData.hasAutoExtractEntitiesPermission;
                    docTreeService.hasMetadataAutoExtractPermission = data.body.globalData.hasMetadataAutoExtractPermission;
                }
                docTreeService.pageType = $scope.pageType;
                if (isCreate) {
                    data.header.response.type = "popUp";
                }
                if (_.has(data, 'body.data.contractDocuments') && ["clone","globalCreate","show","edit","create"].indexOf($scope.pageType) > -1) {
                    docTreeService.contractDocuments = data.body.data.contractDocuments.values;
                    if(docTreeService.contractDocuments != undefined ){
                        docTreeService.contractDocumentsCopy = JSON.parse(JSON.stringify(docTreeService.contractDocuments));
                    }
                    docTreeService.selectedContract = data.body.data.name;
                    docTreeService.selectedContractId = data.body.data.id.values;
                    docTreeService.supplierId = (data.body.data.supplier.values && data.body.data.supplier.values.id)? data.body.data.supplier.values.id : data.body.data.relations.values[0].id;
                    docTreeService.otherContract = (data.body.data.documentType && data.body.data.documentType.values.id == 76 ? true : false);
                    if ($scope.pageType == 'edit') {
                        $scope.documentEditPermission = true;
                    }
                    if(_.has(data, "body.data.relations.values") && data.body.data.relations.values.length > 0){
                        docTreeService.multiSupplierIds = data.body.data.relations.values.map((obj)=>{
                            return obj.id
                        });
                    }
                }
                docTreeService.uploadScope = $scope;
            } catch (error) {
                console.error('Error fetching contract data:', error);
            } finally {
                stopLoader();
        }
    }

    // Channel subscriptions for doctree edit
    window.sarc.channelInstall('docTreeChannel');
    window.sarc.channelSubscription('docTreeChannel', ({action, payload, event}) => {
        if (payload.entityId) {
            $scope.$applyAsync(() => {
                $scope.uploadingDocumentData = payload;
                switch(action) {
                    case 'edit':
                        docTreeService.getTreeJson();
                        docTreeService.triggerFileUpload(event);
                        break;
                    case 'delete':
                        $scope.deleteItem(null, undefined, true, payload.entityId, (payload.showPageUrl && payload.extension != 'link')  && 'contractMenu');
                        break;
                    case 'show_properties':
                        docTreeService.getTreeJson(true).then(() => {
                            return $scope.handleDocumentUpload(payload);
                        }).then(() => {
                            docTreeService.openFilePropertiesModal(undefined, undefined, [payload.entityId]);
                        }).catch(error => {
                            console.error('Error in show_properties flow:', error);
                        });
                        break;
                    case 'upload_link':
                        $scope.handleDocumentUpload(payload).then(() => {
                            const propsToPass = {docService:docTreeService}
                            const mountAt = '#docTreeUploadLinkModal';
                            let interval = setInterval(() => {
                                if ($(mountAt).length) {
                                    clearInterval(interval);
                                    if (!$(mountAt).children().length)
                                        window.reactComponents.mountDynamicComponent(mountAt, "DocUploadLinkModal",propsToPass);
                                    else {
                                        window.sarc.channelBroadcast("docTreeUploadLinkModal", {
                                            actionType:'openModal',
                                            payload:propsToPass
                                        }, 'docTreeUploadLinkSubscription')
                                    }
                                }
                            }, 200)
                        });
                        break;
                    default:
                        break;
                }
            });
        }
    }, `docTreeUpdateSubscription`);

    $scope.mountWorkFlowComponent = (response) => {
        $scope.stepperComponentData = response;
        const propsToPass = {
            ...response,
            isCommentBoxAllowed: !!(response.isCommentBoxAllowed && $scope.hasCommunicationTab)
        };
        let mountAt = '#stepper_wrapper';
        let interval = setInterval(() => {
            if ($(mountAt).length) {
                clearInterval(interval);
                if (!$(mountAt).children().length) {
                    window.reactComponents.mountDynamicComponent(mountAt, "StepperComponent",propsToPass);
                } else {
                    window.sarc.channelBroadcast("updateProgressbarData", {
                        actionType: 'updateProgressbar',
                        payload: propsToPass
                    }, 'updateProgressbarDataSubscription')
                }
                $timeout(updateElementsHeightDynamically, 100);
            }
        }, 100)
    }
    $scope.getWorkflowProgressBarData = () => {
        const jsonUrlOpts = getUrlOpts();

        // Find entity type at position 1 or 2, and entity ID at position 3
        const entityType = jsonUrlOpts[2] && urlToCodeMapper[jsonUrlOpts[2]] ? jsonUrlOpts[2] :
                          jsonUrlOpts[1] && urlToCodeMapper[jsonUrlOpts[1]] ? jsonUrlOpts[1] : null;
        const entityId = jsonUrlOpts[3];

        if (entityType && entityId) {
            const getProgressBar = entityFactory.getJson(`/wf2/progress-bar/${urlToCodeMapper[entityType]}/${entityId}`, "GET");
            getProgressBar.then((response) => {
                if(_.isEmpty(response?.stages) && $('#stepper_wrapper').length) {
                    $scope.isWorkflowCompleted = false;
                    $scope.isWorkflowProgressbarLoaded = false;
                    $scope.applyScope($scope);
                    window.reactComponents.unmountDynamicComponent(document.getElementById("stepper_wrapper"));
                }
                if (!response?.header?.response?.status === "applicationError" || !_.isEmpty(response?.stages)) {
                    $scope.isWorkflowCompleted = response.isWorkflowCompleted
                    $scope.isWorkflowProgressbarLoaded = true;
                    $scope.applyScope($scope);
                    $scope.mountWorkFlowComponent(response)
                }
            })
        }
    }
   
    $scope.mountStatusInfoProgressBar = (messages) => {
        let mountAt = '#status_info_progressbar';
        const propsToPass = {
            messages: messages,
            show: $scope.showStatusInfoProgressBar,
        };
        let interval = setInterval(() => {
            if (!$(mountAt).length) return;

            const snackbar = document.getElementById('simple-snackbar');
            const isSyncingCountdownVisible = !!(snackbar && snackbar.classList && snackbar.classList.contains('countdown'));
            const isSyncingActive = !!window.syncingCountdownActive;

            if (propsToPass.show && (isSyncingCountdownVisible || isSyncingActive)) {
                return;
            }

            clearInterval(interval);
            if (!$(mountAt).children().length) {
                window.reactComponents.mountDynamicComponent(mountAt, "StatusInfoProgressBar", propsToPass);
            } else {
                window.sarc.channelBroadcast("updateStatusInfoProgressBar", {
                    actionType: 'StatusInfoProgressBar',
                    payload: propsToPass
                }, 'StatusInfoProgressBarSubscription');
            }
        }, 10);
    };

    $scope.getWopiEnabled = () => {
        $http({
            method: 'GET',
            url: addtStamp("/online/editor/editor-options?entityId=" + SirionUtils.getEntityIdFromUrl()),
            cache: false
        }).then(function(response) {
            $scope.wopiEnabledEntity  = response.data;
        });
    }
    
}
]);
